export default [
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "NICHOLAS VESAKHA",
        jenjang: "S1 Reguler",
        prodi: "Sistem Informasi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ADHINATA MOHAMMAD YUDHO NEGORO",
        jenjang: "S1 Reguler",
        prodi: "Teknik Elektro"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "NAILA SUHA BASSAMAH",
        jenjang: "S1 Reguler",
        prodi: "Teknik Lingkungan"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "NI PUTU EKA PUJAGITA",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Filsafat"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MARISA SHARON ROMAULI SIANTURI",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Keperawatan"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "RAISA ALYA MAISANDRA",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Keperawatan"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "SYARAH AZZAHRA",
        jenjang: "S1 Reguler",
        prodi: "Bahasa dan Kebudayaan Korea"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "NAILA ALYSSIA RINALDI",
        jenjang: "S1 Reguler",
        prodi: "Studi Gizi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MARIMBY SOFIA PUTERI BUDHI",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Keperawatan"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "TRISHA RUMONDANG ZEFANYA SIREGAR",
        jenjang: "D4",
        prodi: "Terapi Okupasi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "TALITHA FAIZA AULIA",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Aktuaria"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "QANITA FEYZA ANDANI",
        jenjang: "S1 Reguler",
        prodi: "Arsitektur Interior"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "NISYYAH AZZAHRA",
        jenjang: "S1 Reguler",
        prodi: "Sistem Informasi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "AURA RATU NABILA",
        jenjang: "S1 Reguler",
        prodi: "Kesehatan Lingkungan"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "GALUH ESFAND HAIDAR",
        jenjang: "S1 Reguler",
        prodi: "Matematika"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MUHAMMAD DAFFA ILHAM KHADAFI",
        jenjang: "S1 Reguler",
        prodi: "Teknik Sipil"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "SYAHLA AULIA",
        jenjang: "S1 Reguler",
        prodi: "Farmasi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "FADEL ATTILA HARUBIANADI",
        jenjang: "S1 Reguler",
        prodi: "Teknik Sipil"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "AISYAH MARDHIYAH WIDAD",
        jenjang: "S1 Reguler",
        prodi: "Psikologi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "AGNES OKTAVIANI SILABAN",
        jenjang: "S1 Reguler",
        prodi: "Teknik Elektro"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ARSHA PERMANA HARYOKO",
        jenjang: "S1 Reguler",
        prodi: "Teknik Elektro"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MUHAMMAD FAUZAN",
        jenjang: "S1 Reguler",
        prodi: "Fisika"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "RIZQILLAH DAFA PRASETYA",
        jenjang: "S1 Reguler",
        prodi: "Teknik Industri"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "SALSABILA ALYA RAMADHANIE PUTRI SUCIPTO",
        jenjang: "S1 Reguler",
        prodi: "Kesehatan Masyarakat"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "DINDA DYAH ALYA CINTARI",
        jenjang: "S1 Reguler",
        prodi: "Pendidikan Dokter"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "IRNA ADELIA",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Hubungan Internasional"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "KHAYRU RAFAMANDA PRANANTA",
        jenjang: "S1 Reguler",
        prodi: "Sistem Informasi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "AFRA GHAISANI CHANDRA SYAHBUNAN",
        jenjang: "S1 Reguler",
        prodi: "Farmasi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MUHAMMAD RANNANTA",
        jenjang: "S1 Reguler",
        prodi: "Teknik Lingkungan"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MUHAMMAD HANDI PRABASWARA",
        jenjang: "S1 Reguler",
        prodi: "Geografi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "FADHILLAH AKMAL ARIANDI",
        jenjang: "S1 Reguler",
        prodi: "Teknik Perkapalan"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "DHIA AMALINA",
        jenjang: "S1 Reguler",
        prodi: "Keselamatan & Kesehatan Kerja"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "FEBINADIA SALSABILA",
        jenjang: "S1 Reguler",
        prodi: "Statistika"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ANGELITA",
        jenjang: "S1 Reguler",
        prodi: "Teknik Mesin"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MUHAMMAD JAFIER IRHAB",
        jenjang: "S1 Reguler",
        prodi: "Farmasi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "SYIFA SYAMILA",
        jenjang: "S1 Reguler",
        prodi: "Geografi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "WEDYA PRITHA ALLAYYA",
        jenjang: "D4",
        prodi: "Fisioterapi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "NOVITA GRACE WIJAYA",
        jenjang: "S1 Reguler",
        prodi: "Teknik Metalurgi & Material"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "VAZHA KHAYRI",
        jenjang: "S1 Reguler",
        prodi: "Sistem Informasi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "RIVANSYAH SYAPUTRA",
        jenjang: "S1 Reguler",
        prodi: "Fisika"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "HAFSHAH NAURAH ZAHRA",
        jenjang: "S1 Reguler",
        prodi: "Kimia"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "NANDANA WIDHIWIPATI GHALY LAKSANA",
        jenjang: "S1 Reguler",
        prodi: "Arsitektur"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "KHOIRUNISA SALSA BILA PUTRI",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Keperawatan"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "DANIEL HOMBARDO PURBA",
        jenjang: "S1 Reguler",
        prodi: "Matematika"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "AZAHRA SAUSAN",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Administrasi Fiskal"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MARIZKA ZUHRA MAAHIRA NATHIN",
        jenjang: "S1 Reguler",
        prodi: "Teknik Biomedik"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "YUSUF BUDI RAHARJO",
        jenjang: "S1 Reguler",
        prodi: "Geofisika"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ALVARO SUWARDANA",
        jenjang: "Vokasi",
        prodi: "Administrasi Perkantoran"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MARVEL ANDERSON WIDJAJA",
        jenjang: "S1 Reguler",
        prodi: "Pendidikan Dokter Gigi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "AMBERLEY VIDYA PUTRI",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Komputer"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "RENA LEVANA RADJAWANE",
        jenjang: "S1 Reguler",
        prodi: "Matematika"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "RATIH AYU WARDANI",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Kesejahteraan Sosial"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "FAUZAN RIZKY RAMADHAN",
        jenjang: "S1 Reguler",
        prodi: "Matematika"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MUHAMMAD RIFQI ILHAM",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Komputer"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "AJENG FATIHA NUGROHO",
        jenjang: "S1 Reguler",
        prodi: "Sastra Rusia"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ALIQA PUTRI SANTOSA",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Aktuaria"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "REXY ADRIAN FERNANDO",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Komputer"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "FATHAN MAWLA ITZWA",
        jenjang: "S1 Reguler",
        prodi: "Teknik Komputer"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "KANIA MEIDINA",
        jenjang: "S1 Reguler",
        prodi: "Geografi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "RAMA ADHIF ZULFIKAR",
        jenjang: "S1 Reguler",
        prodi: "Geografi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "M. MUSTOFAH BISRI",
        jenjang: "Vokasi",
        prodi: "Administrasi Rumah Sakit"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "AISYAH DWI FADNIL",
        jenjang: "S1 Reguler",
        prodi: "Statistika"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "NAKEISHA WIJAYA",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Hubungan Internasional"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ABIGAIL CHRISTANTILLEAN DE'IDWAN",
        jenjang: "S1 Reguler",
        prodi: "Kimia"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ZAHRA AGNIA WIDIYASWARI",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Keperawatan"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MUHAMMAD FAZA MUTTAQI",
        jenjang: "S1 Reguler",
        prodi: "Kimia"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MUSRIFAH FEBRIANTI",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Keperawatan"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "DANISWARA SATYA WIYONO",
        jenjang: "S1 Reguler",
        prodi: "Teknik Industri"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ANDI  HAKIM HIMAWAN",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Komputer"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "FARRAS SYAFIQ ULUMUDDIN",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Komputer"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MUTHIA IZZATUL HUSNA SATRIADI",
        jenjang: "S1 Reguler",
        prodi: "Biologi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ZAHIR",
        jenjang: "S1 Reguler",
        prodi: "Teknik Komputer"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ALEXIUS CHRISTHOPER WIJAYA",
        jenjang: "S1 Reguler",
        prodi: "Sistem Informasi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "RAFIF FADHILAH SUSANTO",
        jenjang: "S1 Reguler",
        prodi: "Geofisika"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ARKANAUFA MAULIDANI AL GHIFARI",
        jenjang: "S1 Reguler",
        prodi: "Pendidikan Dokter Gigi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "REFAN ADITIA PUTRA",
        jenjang: "S1 Reguler",
        prodi: "Kimia"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "NAILA AZIZAH",
        jenjang: "S1 Reguler",
        prodi: "Pendidikan Dokter"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "FAISHOL FUAD YAHYA",
        jenjang: "S1 Reguler",
        prodi: "Geofisika"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "RIDHO KHOIRI NOVRAKLI",
        jenjang: "S1 Reguler",
        prodi: "Fisika"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "INAS AMATULLAH",
        jenjang: "S1 Reguler",
        prodi: "Sastra Arab"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "AMABELLA TJAHJADI",
        jenjang: "S1 Reguler",
        prodi: "Matematika"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ZALFA RAJABI",
        jenjang: "S1 Reguler",
        prodi: "Geografi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "KERIN ZALFA NAZIRA",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Keperawatan"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "NAASYA KHAIRANI",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Hukum"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "FARAH DYAH AJININGTYAS",
        jenjang: "S1 Reguler",
        prodi: "Kesehatan Masyarakat"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "FABILLIAN OCTAREANO",
        jenjang: "S1 Reguler",
        prodi: "Arkeologi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "NOVELITA LA FITRI SEKARJATI",
        jenjang: "S1 Reguler",
        prodi: "Biologi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ANASYA NUMA IDELLIE PUTRI KRESNAWAN",
        jenjang: "S1 Reguler",
        prodi: "Statistika"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "SILGEA BUSAINA HERIANTO",
        jenjang: "D4",
        prodi: "Fisioterapi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "AURELIA SALSABILA",
        jenjang: "S1 Reguler",
        prodi: "Farmasi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "FATIMAH ALZAHRA SALSABILA",
        jenjang: "S1 Reguler",
        prodi: "Teknik Biomedik"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "SANIYAH NURIYAH ANGGRAENI",
        jenjang: "S1 Reguler",
        prodi: "Teknik Sipil"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "BARETHA INDAH KIRANA",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Keperawatan"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "TEUKU MUHAMMAD RIDHA IKRAMSYAH",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Aktuaria"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "SYIFA MUSTIKA NAZILA ZAHRA",
        jenjang: "S1 Reguler",
        prodi: "Teknik Metalurgi & Material"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "FAYLA SARAH ATHIRA",
        jenjang: "S1 Reguler",
        prodi: "Farmasi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "GILBERT MIKHAEL SARAGIH",
        jenjang: "S1 Reguler",
        prodi: "Fisika"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "EVANDRA GHASSAN SYAHBANA",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Administrasi Negara"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ABDURRAHMAN AMMAR ABQARY",
        jenjang: "S1 Reguler",
        prodi: "Sistem Informasi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MEZI AULIA SIJA",
        jenjang: "S1 Reguler",
        prodi: "Pendidikan Dokter"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "VALENTINO RICHARD ALAMSYAH",
        jenjang: "S1 Reguler",
        prodi: "Fisika"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "AINI FARENDY",
        jenjang: "S1 Reguler",
        prodi: "Kesehatan Lingkungan"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "KADEK ASRI PURNAMA DEWI",
        jenjang: "S1 Reguler",
        prodi: "Fisika"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MYLOVE FATHIMAH",
        jenjang: "S1 Reguler",
        prodi: "Keselamatan & Kesehatan Kerja"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "RANIA NURAINI MAWADDAH AFIFI",
        jenjang: "S1 Reguler",
        prodi: "Pendidikan Dokter Gigi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "DENA RESTI",
        jenjang: "S1 Reguler",
        prodi: "Fisika"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MARCHA KHAIRUNNISA",
        jenjang: "S1 Reguler",
        prodi: "Geografi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "CARISSA PUTRI NABIGHA",
        jenjang: "D4",
        prodi: "Terapi Okupasi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "SAKHA FAIZ DARMADI",
        jenjang: "S1 Reguler",
        prodi: "Farmasi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "RAYQHA SALSABILA VENDTARY",
        jenjang: "S1 Reguler",
        prodi: "Psikologi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "NASHIRA LAKSISTA JASMIJN",
        jenjang: "S1 Reguler",
        prodi: "Teknik Metalurgi & Material"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "M ALVARREL BAHRI PRATAMA",
        jenjang: "S1 Reguler",
        prodi: "Teknik Lingkungan"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "NAZWA NUR FARIDA",
        jenjang: "S1 Reguler",
        prodi: "Kesehatan Masyarakat"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "AZMI AZIZ SYAHPUTRA",
        jenjang: "S1 Reguler",
        prodi: "Teknik Elektro"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "DENIZA PUTRIA FINA FEHUT BESAN",
        jenjang: "S1 Reguler",
        prodi: "Pendidikan Dokter"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "FARIQ ZAHID DZULQOWWY",
        jenjang: "S1 Reguler",
        prodi: "Fisika"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "VAREL IBRAHIM MOVIC",
        jenjang: "S1 Reguler",
        prodi: "Teknik Sipil"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "NASHILA AZHAURA LAING",
        jenjang: "S1 Reguler",
        prodi: "Kimia"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ABIGAIL NAMARATONGGI PASARIBU",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Komputer"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MULIA KHAERUNNISA",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Keperawatan"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MATTHEW ALVAEL MARRUNG",
        jenjang: "S1 Reguler",
        prodi: "Fisika"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "AMEYFIA SANIYA",
        jenjang: "S1 Reguler",
        prodi: "Sastra Rusia"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MUHAMMAD FASYA SUPARDAN",
        jenjang: "S1 Reguler",
        prodi: "Teknik Sipil"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "SAYED SHAHIBBUL AULIA",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Filsafat"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "BRAMESTI AHMAD SYUHADA",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Sejarah"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "KEIRA DWINOVA",
        jenjang: "Vokasi",
        prodi: "Administrasi Rumah Sakit"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "JEREMY HASUDUNGAN POHAN SIMANJUNTAK",
        jenjang: "D4",
        prodi: "Manajemen Bisnis Pariwisata"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MUHAMMAD UMAR NASRUDIN",
        jenjang: "S1 Reguler",
        prodi: "Teknik Mesin"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "NAFIAH RAIHANAH DWIANTI",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Keperawatan"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "CHELSI FREDERIKA MATONDANG",
        jenjang: "Vokasi",
        prodi: "Administrasi Rumah Sakit"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "NAILA ALESSANDRIA",
        jenjang: "S1 Reguler",
        prodi: "Biologi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "HIZBA MUHAMMAD HUSNA",
        jenjang: "Vokasi",
        prodi: "Periklanan Kreatif"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "AURIDHA KANZAN LABIBA",
        jenjang: "S1 Reguler",
        prodi: "Farmasi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "PRADIPTA ARYA WIBAWA",
        jenjang: "S1 Reguler",
        prodi: "Pendidikan Dokter"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ASHYA NASYWA KANANEFA",
        jenjang: "S1 Reguler",
        prodi: "Pendidikan Dokter Gigi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MUHAMMAD AFRIZAL SYARIF",
        jenjang: "S1 Reguler",
        prodi: "Teknik Elektro"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MUHAMMAD RAZKA FALTASYAH",
        jenjang: "S1 Reguler",
        prodi: "Sistem Informasi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "FERESYTHEGILBA KRESNO DEWARATRI",
        jenjang: "S1 Reguler",
        prodi: "Kesehatan Masyarakat"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "RAISSA KIRANA ANINDITA",
        jenjang: "S1 Reguler",
        prodi: "Pendidikan Dokter"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MUHAMMAD ALWIN PRIMA",
        jenjang: "S1 Reguler",
        prodi: "Pendidikan Dokter Gigi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "TROYA RIANDRA ALACHJAR",
        jenjang: "S1 Reguler",
        prodi: "Teknik Komputer"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "GABRIELA AUDREY YOUNG",
        jenjang: "S1 Reguler",
        prodi: "Biologi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "RIVENNDY BENEDICTUS KARO KARO",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Aktuaria"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "INDIRA NABILAH ROKHMAD",
        jenjang: "Vokasi",
        prodi: "Administrasi Keuangan dan Perbankan \t"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "RETNO SUGIYANTI",
        jenjang: "S1 Reguler",
        prodi: "Sastra Daerah untuk Sastra Jawa"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MUHAMMAD ATHIF DHAIFULLAH",
        jenjang: "Vokasi",
        prodi: "Administrasi Asuransi dan Aktuaria \t"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "FEBRIYANTI",
        jenjang: "S1 Reguler",
        prodi: "Sistem Informasi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "RAISSA RIZKIA DEWI",
        jenjang: "S1 Reguler",
        prodi: "Pendidikan Dokter"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "NURUL QOMARIYAH",
        jenjang: "S1 Reguler",
        prodi: "Sastra Daerah untuk Sastra Jawa"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "DOMINIQUE SAMANTHA SUNIADJI",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Aktuaria"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "JIHAN ARISA TANJUNG",
        jenjang: "S1 Reguler",
        prodi: "Kesehatan Lingkungan"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "NUR AFIFAH FAUZAN",
        jenjang: "S1 Reguler",
        prodi: "Kesehatan Masyarakat"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MUHAMMAD GHANI WIRA SAMUDERA",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Perpustakaan"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MEYLINA PUTRI RAHMAWATI",
        jenjang: "S1 Reguler",
        prodi: "Bahasa dan Kebudayaan Korea"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "KAYLA PUTU ABHINAYA WIRYA",
        jenjang: "S1 Reguler",
        prodi: "Psikologi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ELZAADIWIJAYA MARKUSUMA",
        jenjang: "S1 Reguler",
        prodi: "Fisika"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "GHAZIYA HALIMOVA",
        jenjang: "S1 Reguler",
        prodi: "Sastra Indonesia"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MADE SHANDY KRISNANDA",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Komputer"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "RAIHANA AUNI ZAKIA",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Komputer"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ADELIA RENATA FRISCO",
        jenjang: "S1 Reguler",
        prodi: "Statistika"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "FAKHRI RASHIF IBRAHIM",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Ekonomi Islam"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "RAFIE RYAN MUMTAZ",
        jenjang: "S1 Reguler",
        prodi: "Sastra Rusia"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ALIFIA SAFA RAMADHANI",
        jenjang: "S1 Reguler",
        prodi: "Biologi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ARIELA CLEVA AURELA",
        jenjang: "S1 Reguler",
        prodi: "Statistika"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "LAURELL ZOHHA NAFISA SULAIMAN",
        jenjang: "S1 Reguler",
        prodi: "Farmasi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "AMANDA DAVINA PUTRIYANSYAH",
        jenjang: "S1 Reguler",
        prodi: "Arsitektur"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "SABITAH NASYIAH TALITHA",
        jenjang: "S1 Reguler",
        prodi: "Kesehatan Lingkungan"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MUHAMMAD LEVY RABINDRA FUAD",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Administrasi Fiskal"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "RAISA RANIA",
        jenjang: "S1 Reguler",
        prodi: "Geografi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "HELENA JESSIE DEANDREA SOH",
        jenjang: "S1 Reguler",
        prodi: "Kimia"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "RAFA RAHARDIAN MAHESA YOGA",
        jenjang: "S1 Reguler",
        prodi: "Pendidikan Dokter Gigi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "FADHILA AZIZUN NABILA",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Keperawatan"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "SHALSA ZAKIA PUTRI",
        jenjang: "S1 Reguler",
        prodi: "Biologi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "KALISYA DIANDRA NOKTULA",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Keperawatan"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ASSYLA ZALFA MAUDILLA",
        jenjang: "S1 Reguler",
        prodi: "Teknik Sipil"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ALIF FITRIADI",
        jenjang: "S1 Reguler",
        prodi: "Farmasi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "YEMIMA BUNGA EJA",
        jenjang: "S1 Reguler",
        prodi: "Fisika"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MUHAMMAD FATTAN DWIYUSKA KURNIANTO",
        jenjang: "S1 Reguler",
        prodi: "Teknik Perkapalan"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "CERYSCA EVANGELINE WIJAYA",
        jenjang: "S1 Reguler",
        prodi: "Pendidikan Dokter Gigi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ESTRELITA VALERIA",
        jenjang: "S1 Reguler",
        prodi: "Arsitektur Interior"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "SHOFIA RAIHANA",
        jenjang: "S1 Reguler",
        prodi: "Teknik Lingkungan"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ALLEGRIA BLANDINA JUBILATE SIRAIT",
        jenjang: "S1 Reguler",
        prodi: "Teknik Industri"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MOHAMMAD HABIB SEPTO HASBULLOH",
        jenjang: "Vokasi",
        prodi: "Administrasi Rumah Sakit"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ANDRINI FITRI HAPSARI",
        jenjang: "S1 Reguler",
        prodi: "Farmasi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "DAVA ADITYA PUTRANTO",
        jenjang: "S1 Reguler",
        prodi: "Arsitektur Interior"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "NASYA AMMARA DIANDRA",
        jenjang: "S1 Reguler",
        prodi: "Kimia"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "RAIHAN A. RAHMAN HRP",
        jenjang: "D4",
        prodi: "Fisioterapi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "BAGUS ANGGORO SETYA DIANTO",
        jenjang: "S1 Reguler",
        prodi: "Geografi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "HANDARU NUSWANTORO",
        jenjang: "S1 Reguler",
        prodi: "Fisika"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "WAFFA NAJMYL HADZQI FAIRUZI",
        jenjang: "S1 Reguler",
        prodi: "Teknik Elektro"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "NASYWA ALMIRA",
        jenjang: "S1 Reguler",
        prodi: "Biologi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MAURA THALITA CHAIRINNISWA",
        jenjang: "D4",
        prodi: "Terapi Okupasi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "SYAFIRA EKA KHURINAIN",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Keperawatan"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "NAYARA AYESHA AZHARI",
        jenjang: "S1 Reguler",
        prodi: "Kesehatan Lingkungan"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "SAHIRA HAWA AL QUDSI",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Keperawatan"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "NABILAH DINA NOVIANTI",
        jenjang: "S1 Reguler",
        prodi: "Fisika"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "RAISHA RANIA LESTARI",
        jenjang: "S1 Reguler",
        prodi: "Teknik Biomedik"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "SYAHZANAN RIZKIA PUTRI",
        jenjang: "S1 Reguler",
        prodi: "Pendidikan Dokter"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ALMAAS NAZHIFA AZZAHRA",
        jenjang: "S1 Reguler",
        prodi: "Geografi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "JASMINE MAHIRA AYU GIFFARI",
        jenjang: "S1 Reguler",
        prodi: "Studi Gizi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "DEIRA AISYA REFANI",
        jenjang: "S1 Reguler",
        prodi: "Farmasi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "AN NADIYA NUR AINI",
        jenjang: "S1 Reguler",
        prodi: "Kesehatan Lingkungan"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ABELYVIA TORI REBECCA SILALAHI",
        jenjang: "S1 Reguler",
        prodi: "Sistem Informasi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "JAHRA NABILA",
        jenjang: "S1 Reguler",
        prodi: "Sastra Cina"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "RIYAN ADIT KHAERUDIN",
        jenjang: "S1 Reguler",
        prodi: "Teknik Elektro"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "QANITHA ZULAEKA JASMINE",
        jenjang: "S1 Reguler",
        prodi: "Farmasi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ROMAN ZIKRI QAYYUM",
        jenjang: "S1 Reguler",
        prodi: "Keselamatan & Kesehatan Kerja"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "GERALDUS CATUR GIGIH WAHYUDI",
        jenjang: "S1 Reguler",
        prodi: "Sistem Informasi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "RAHMAT TRI ANANTO",
        jenjang: "S1 Reguler",
        prodi: "Fisika"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ALDIN AFSDY SYAH ZAIDHAN",
        jenjang: "S1 Reguler",
        prodi: "Fisika"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "RIZQA NURUL ANNISA JANNATI",
        jenjang: "S1 Reguler",
        prodi: "Kesehatan Masyarakat"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ZAKI SEPTIYONO SAPUTRA",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Keperawatan"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "HAIKAL KRISHNA KUSUMA WIJAYA",
        jenjang: "S1 Reguler",
        prodi: "Fisika"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "CHARLIE WIJAYA",
        jenjang: "S1 Reguler",
        prodi: "Teknik Elektro"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "DHANIA FALISHA",
        jenjang: "S1 Reguler",
        prodi: "Kesehatan Lingkungan"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "JAWARIQI JAENURI",
        jenjang: "D4",
        prodi: "Fisioterapi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "SHAVIRA ANDHINI PERBOWO",
        jenjang: "S1 Reguler",
        prodi: "Keselamatan & Kesehatan Kerja"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "LENTERA FIRDAUSY RADIX",
        jenjang: "S1 Reguler",
        prodi: "Geologi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "HANZHOLAH RANTISI",
        jenjang: "S1 Reguler",
        prodi: "Teknik Elektro"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ANAK AGUNG AYU ANANDHITA KUSUMA",
        jenjang: "S1 Reguler",
        prodi: "Teknik Metalurgi & Material"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "KETUT KRISNADANA NUGRAHA",
        jenjang: "S1 Reguler",
        prodi: "Fisika"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "DOROTHEA ZEFANYA DEWANDA",
        jenjang: "S1 Reguler",
        prodi: "Keselamatan & Kesehatan Kerja"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MUHAMMAD MAFTUH ASYROFI",
        jenjang: "S1 Reguler",
        prodi: "Teknik Sipil"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MUHAMMAD BINTANG ARDIWIJAYA",
        jenjang: "S1 Reguler",
        prodi: "Matematika"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "FREYA WINETTA IMELDA HUTABARAT",
        jenjang: "S1 Reguler",
        prodi: "Studi Gizi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ARIFA AYU WULANDARI",
        jenjang: "S1 Reguler",
        prodi: "Arsitektur"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "EDWIN DANIEL",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Aktuaria"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MUHAMMAD FARREL RAJENDRA",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Komputer"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "HALWA MIYA QOTHRUNNADA",
        jenjang: "S1 Reguler",
        prodi: "Kesehatan Masyarakat"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "SASYA AQILA",
        jenjang: "S1 Reguler",
        prodi: "Kesehatan Masyarakat"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "FARREL FARAIDH KHAIZAN",
        jenjang: "S1 Reguler",
        prodi: "Teknik Elektro"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ZHAFIRAH NAURA NURULRAHMAH",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Administrasi Fiskal"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "AKHTAR EIJAZ PUTRANTO",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Komputer"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ALIYAH ISHAQ PUTRI",
        jenjang: "S1 Reguler",
        prodi: "Teknik Industri"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ZAHRA ALIYAH SOEDHARMONO",
        jenjang: "S1 Reguler",
        prodi: "Teknik Mesin"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ARMELLE KAITLYN HUANG",
        jenjang: "S1 Reguler",
        prodi: "Studi Gizi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "BAKHRUL ULUM",
        jenjang: "S1 Reguler",
        prodi: "Keselamatan & Kesehatan Kerja"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "HARDY PERDANA KESUMA",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Aktuaria"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "Z ARSY ALAM SIN",
        jenjang: "S1 Reguler",
        prodi: "Sistem Informasi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ZEROUN KANISIUS",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Aktuaria"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "LILIANA SHABRINA",
        jenjang: "S1 Reguler",
        prodi: "Kriminologi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "DEWA GEDE INDRA SATYADANA",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Keperawatan"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "REVANIA BANDASO TULAKTONDOK",
        jenjang: "S1 Reguler",
        prodi: "Bahasa dan Kebudayaan Korea"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "PUTRI RAYYISHA NABILA ANANTA",
        jenjang: "S1 Reguler",
        prodi: "Pendidikan Dokter"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "NURUL KHALIZA",
        jenjang: "S1 Reguler",
        prodi: "Keselamatan & Kesehatan Kerja"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "NATAN HARUM PANOGU SILALAHI",
        jenjang: "S1 Reguler",
        prodi: "Sistem Informasi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "NI KOMANG SHISTA SHRIMAYA",
        jenjang: "S1 Reguler",
        prodi: "Antropologi Sosial"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ADHARA LUNA RAMADHANI",
        jenjang: "S1 Reguler",
        prodi: "Biologi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MUHAMMAD RIZKY",
        jenjang: "S1 Reguler",
        prodi: "Teknik Elektro"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "DONATA FATAHILLAH",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Keperawatan"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MADHAN SCHABANI TRIANTO",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Administrasi Niaga"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "FAKHREZA ARIFIYO PRATAMA",
        jenjang: "S1 Reguler",
        prodi: "Geografi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "QAIS ISMAIL",
        jenjang: "S1 Reguler",
        prodi: "Teknik Komputer"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "NAJWA AZIZAH EKA FEBRIYANTI",
        jenjang: "S1 Reguler",
        prodi: "Pendidikan Dokter"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "SALMAN ANDHIKA RACHMAT",
        jenjang: "S1 Reguler",
        prodi: "Keselamatan & Kesehatan Kerja"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "NAILA MAZAYA FITRIANA",
        jenjang: "S1 Reguler",
        prodi: "Kesehatan Lingkungan"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ARDIAN NURROHMAT",
        jenjang: "S1 Reguler",
        prodi: "Geologi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "HASNA ALIYA RAMADHANI",
        jenjang: "Vokasi",
        prodi: "Administrasi Rumah Sakit"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "NAJWA PUTRI AURELLIA",
        jenjang: "D4",
        prodi: "Fisioterapi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "FREDERICUS TERTHYREXA JODIMARLO",
        jenjang: "S1 Reguler",
        prodi: "Teknik Metalurgi & Material"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "WILFRED SIHOMBING",
        jenjang: "S1 Reguler",
        prodi: "Teknik Mesin"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "NAJWA RAMADHANIA BAHAR",
        jenjang: "S1 Reguler",
        prodi: "Kesehatan Masyarakat"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "PUTRI ENXI SUTEJA",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Aktuaria"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MUHAMMAD JADWA IDRIS",
        jenjang: "S1 Reguler",
        prodi: "Teknik Mesin"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "JESSICA NGAJAYA",
        jenjang: "S1 Reguler",
        prodi: "Psikologi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MUHAMMAD LUTHFI DWI ANANDA",
        jenjang: "S1 Reguler",
        prodi: "Geofisika"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MAXIMILLIAN NYLO PUTRAWAN",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Aktuaria"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ZAHRA SABRINA",
        jenjang: "S1 Reguler",
        prodi: "Kesehatan Masyarakat"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "NARISTA AULIA PUTRI",
        jenjang: "S1 Reguler",
        prodi: "Fisika"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MUHAMMAD FATHIN DIPIRIDHO GUSTI",
        jenjang: "S1 Reguler",
        prodi: "Kimia"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "FARREL OPHELIAZAKI FIRDAUS",
        jenjang: "S1 Reguler",
        prodi: "Teknik Mesin"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "DINDRA PRAMUDHITO",
        jenjang: "S1 Reguler",
        prodi: "Geologi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "JUSTIN SAMUEL PURNOMO",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Aktuaria"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "YESICHA DIA RAMADHANI",
        jenjang: "S1 Reguler",
        prodi: "Fisika"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "NABILA HANIFA",
        jenjang: "S1 Reguler",
        prodi: "Farmasi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "CHINDY AULIYA NURDIN",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Keperawatan"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MUETIARA SITI HAWA",
        jenjang: "Vokasi",
        prodi: "Administrasi Rumah Sakit"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "DAFFA SYAFITRA",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Komputer"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ALISHA CETTAPUTRI",
        jenjang: "S1 Reguler",
        prodi: "Farmasi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MUHAMMAD ADHITYA RAHMAN",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Aktuaria"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "FAYRUUZ WIDIYANTI",
        jenjang: "S1 Reguler",
        prodi: "Geografi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "SARALITA TJIA",
        jenjang: "S1 Reguler",
        prodi: "Kesehatan Masyarakat"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "KEMAL MUMTAZ HAKIM",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Keperawatan"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "JOYCELINE SALIM",
        jenjang: "S1 Reguler",
        prodi: "Teknik Biomedik"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "DIMAS ZAKI MIKARAHIL",
        jenjang: "S1 Reguler",
        prodi: "Teknik Elektro"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "JOSHUA SEBASTIAN KONDA",
        jenjang: "S1 Reguler",
        prodi: "Kesehatan Masyarakat"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "PETER NG",
        jenjang: "S1 Reguler",
        prodi: "Fisika"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ANGELO BENHANAN ABINAYA FUUN",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Komputer"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ARDELIA HUMAIDA PUTRI",
        jenjang: "S1 Reguler",
        prodi: "Studi Gizi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "VITA UTAMI KIRANA",
        jenjang: "S1 Reguler",
        prodi: "Teknik Lingkungan"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MUHAMMAD ILHAM FAUZI",
        jenjang: "S1 Reguler",
        prodi: "Farmasi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "RAFA AZKIYAUL AULA",
        jenjang: "S1 Reguler",
        prodi: "Geografi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "SIRLY RACHMATIKA",
        jenjang: "S1 Reguler",
        prodi: "Kesehatan Lingkungan"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "HILYAH FATHU CHAIRUNNISA",
        jenjang: "S1 Reguler",
        prodi: "Kesehatan Masyarakat"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "DELLA GABRIELLA",
        jenjang: "S1 Reguler",
        prodi: "Studi Gizi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ALIFIANTI MAGFIRAH HADI",
        jenjang: "S1 Reguler",
        prodi: "Kesehatan Masyarakat"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "SALSABILA RAFI AZZAHRA",
        jenjang: "S1 Reguler",
        prodi: "Farmasi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ADINDA PUTRI KHALISA",
        jenjang: "S1 Reguler",
        prodi: "Kesehatan Masyarakat"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "SORAYA AZZIZAH PAHLEVI",
        jenjang: "S1 Reguler",
        prodi: "Teknik Komputer"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "M FAUZI SETIAWAN",
        jenjang: "S1 Reguler",
        prodi: "Teknik Mesin"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "LANTIP HAMMAMUN NAJA BUSTOMI",
        jenjang: "S1 Reguler",
        prodi: "Fisika"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "AURORA GRACIA DEBORA TAMBUNAN",
        jenjang: "S1 Reguler",
        prodi: "Kesehatan Masyarakat"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "BELLA NADYA AURELIA",
        jenjang: "S1 Reguler",
        prodi: "Kesehatan Lingkungan"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "THEO SAMUEL",
        jenjang: "S1 Reguler",
        prodi: "Sistem Informasi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "NASHWA MUFIDAH",
        jenjang: "S1 Reguler",
        prodi: "Farmasi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "KAREN FELICIA SIANIPAR",
        jenjang: "S1 Reguler",
        prodi: "Kesehatan Masyarakat"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "KYNAN AKMAL DANISWARA",
        jenjang: "S1 Reguler",
        prodi: "Teknik Industri"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "RAYHAN DHARMA NARENDRA",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Kesejahteraan Sosial"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MUHAMMAD ZAKY WIRAWAN KUSTIYANA",
        jenjang: "S1 Reguler",
        prodi: "Teknik Mesin"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ACHMAD NIKMAL WATSIK MUTAWAKKIL",
        jenjang: "S1 Reguler",
        prodi: "Teknik Metalurgi & Material"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "AJMAL ALARIK HERMAWAN",
        jenjang: "S1 Reguler",
        prodi: "Farmasi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "FAUZHI INDRA PRATAMA",
        jenjang: "S1 Reguler",
        prodi: "Keselamatan & Kesehatan Kerja"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "SAFIRA BUDI RAMADHANI",
        jenjang: "S1 Reguler",
        prodi: "Sastra Cina"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "PRIANDHIKA ATHALLAH RIZKY",
        jenjang: "S1 Reguler",
        prodi: "Geofisika"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MUHAMMAD FALAH GHIVARI WIRANTO",
        jenjang: "S1 Reguler",
        prodi: "Teknik Lingkungan"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "BILQIS SALSABILA",
        jenjang: "S1 Reguler",
        prodi: "Geografi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "RADITYA AGASTA PASHA",
        jenjang: "S1 Reguler",
        prodi: "Geologi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "DESYA PUTRI RAMADHAN",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Keperawatan"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "FAIZ FEBRIANSYAH",
        jenjang: "S1 Reguler",
        prodi: "Teknik Metalurgi & Material"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "HENRI MAIKEL BAKTIAR",
        jenjang: "S1 Reguler",
        prodi: "Teknik Kimia"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "GRACE LAMRIA MARANATHA SIHOMBING",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Keperawatan"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MUHAMMAD SHAAFIQ BANAMAH",
        jenjang: "S1 Reguler",
        prodi: "Psikologi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MOH HENGKY ARILAZKA",
        jenjang: "S1 Reguler",
        prodi: "Kimia"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "KHOIRUN NISA",
        jenjang: "S1 Reguler",
        prodi: "Sastra Daerah untuk Sastra Jawa"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "HASYA ANDISHA RUSDI BACHMID",
        jenjang: "S1 Reguler",
        prodi: "Farmasi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ANTONIUS DANIEL MARULI NAINGGOLAN",
        jenjang: "S1 Reguler",
        prodi: "Sistem Informasi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "AZKA ALYA FITRIANI",
        jenjang: "S1 Reguler",
        prodi: "Farmasi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MUHAMMAD FAIZ",
        jenjang: "S1 Reguler",
        prodi: "Teknik Sipil"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "FEBRIANO RAUDA",
        jenjang: "S1 Reguler",
        prodi: "Teknik Lingkungan"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "RAZKY RIANDIKA RIADI",
        jenjang: "S1 Reguler",
        prodi: "Farmasi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "RAFSANJANI",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Komputer"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "HAUZAN ARIB ARKAN",
        jenjang: "S1 Reguler",
        prodi: "Geofisika"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "EUKEN NAFI VIRGIANTORO",
        jenjang: "S1 Reguler",
        prodi: "Psikologi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "NISRINA NAILA BIRJAMAN",
        jenjang: "S1 Reguler",
        prodi: "Biologi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "DOMINIQUE FILIRIANY TRIWIYOSO",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Administrasi Fiskal"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ANDREA RATU FELIA",
        jenjang: "S1 Reguler",
        prodi: "Statistika"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "FAHRIZA DAFFA FAUZAN",
        jenjang: "S1 Reguler",
        prodi: "Teknik Metalurgi & Material"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "DEV ARDITO YUSUF WIRATAMA",
        jenjang: "S1 Reguler",
        prodi: "Teknik Lingkungan"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "NAINA MAZAYA PUTRI",
        jenjang: "S1 Reguler",
        prodi: "Biologi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "JOSSI PRADIPTA HARTANTO",
        jenjang: "S1 Reguler",
        prodi: "Farmasi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "INDANA LAZULFA",
        jenjang: "S1 Reguler",
        prodi: "Biologi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "SETYA PURBANINGRUM AGUNG HERRY SOETJIPTO",
        jenjang: "S1 Reguler",
        prodi: "Sistem Informasi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ADINDA NAIYA VAKHROH",
        jenjang: "S1 Reguler",
        prodi: "Kimia"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "AARIFAH ALI",
        jenjang: "D4",
        prodi: "Terapi Okupasi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "KHAIRUM ALFI SYAHRIN",
        jenjang: "S1 Reguler",
        prodi: "Geografi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "FRANKLIN JOSEPH ADVENTIO NAPITUPULU",
        jenjang: "S1 Reguler",
        prodi: "Teknik Mesin"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ENZO NOVAL SATRIYO",
        jenjang: "S1 Reguler",
        prodi: "Teknik Mesin"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "JEREMIAH TIMOTHY HERLAMBANG",
        jenjang: "S1 Reguler",
        prodi: "Geologi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "CHRISHANNE GRACE NARIA SINAGA",
        jenjang: "S1 Reguler",
        prodi: "Farmasi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "KEN MANDHAGA PRADIPTAYA",
        jenjang: "S1 Reguler",
        prodi: "Teknik Industri"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ALIYYA DZAKIRA AREZTI",
        jenjang: "S1 Reguler",
        prodi: "Kesehatan Masyarakat"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MARSEAN MARCELLIANO",
        jenjang: "S1 Reguler",
        prodi: "Teknik Kimia"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "AMANDA PUTRI RIYANTI",
        jenjang: "S1 Reguler",
        prodi: "Teknik Komputer"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "BOYKE CHARISH SITUMEANG",
        jenjang: "S1 Reguler",
        prodi: "Teknik Elektro"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "NISWA SAHDA WAHYUDI",
        jenjang: "S1 Reguler",
        prodi: "Farmasi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MIKHA ANDI SUMULE",
        jenjang: "S1 Reguler",
        prodi: "Geologi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MUHAMMAD REVO VALDETIGANA",
        jenjang: "S1 Reguler",
        prodi: "Teknik Lingkungan"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ATHALLAH MIKKA IZZUHU",
        jenjang: "S1 Reguler",
        prodi: "Teknik Sipil"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "LUKAS DAVENDRA MAHESWARA",
        jenjang: "S1 Reguler",
        prodi: "Teknik Mesin"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "NIZHAM MUZAKKI",
        jenjang: "S1 Reguler",
        prodi: "Fisika"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MUHAMMAD RAIHAN RIZAL PUTRA",
        jenjang: "S1 Reguler",
        prodi: "Kimia"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "VALYA NAILATUL IZZAH",
        jenjang: "S1 Reguler",
        prodi: "Teknik Mesin"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "AQIELA NAJA LUPITA ADHIYA RAYHANI",
        jenjang: "S1 Reguler",
        prodi: "Pendidikan Dokter Gigi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "SITI JULAIKHA",
        jenjang: "S1 Reguler",
        prodi: "Farmasi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "KHESYA RUSHAFA TSAQIB",
        jenjang: "S1 Reguler",
        prodi: "Sistem Informasi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "PRAGA ALBAR PRATAMA",
        jenjang: "S1 Reguler",
        prodi: "Teknik Perkapalan"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ZAKIY NASHRUDIN WAHID",
        jenjang: "S1 Reguler",
        prodi: "Sistem Informasi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "GINOVA OCEANIA MARISI DAMANIK",
        jenjang: "S1 Reguler",
        prodi: "Pendidikan Dokter Gigi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ZAHRA KEYSHA ALYANOVA",
        jenjang: "S1 Reguler",
        prodi: "Sastra Daerah untuk Sastra Jawa"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "NAURA KHALILA",
        jenjang: "S1 Reguler",
        prodi: "Kesehatan Masyarakat"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "CHRYSILLA FREYA YUNEVA",
        jenjang: "S1 Reguler",
        prodi: "Psikologi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "BAYU MUHAMMAD SATRIO",
        jenjang: "S1 Reguler",
        prodi: "Kesehatan Masyarakat"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "NAJMA AZZAHRA",
        jenjang: "S1 Reguler",
        prodi: "Kesehatan Masyarakat"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "XAVIER RYAN ZAPUTRA",
        jenjang: "S1 Reguler",
        prodi: "Geologi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "FARHAN YUDHA SATRIA",
        jenjang: "S1 Reguler",
        prodi: "Teknik Lingkungan"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "RIZQY AMMAR GHOZALBA",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Administrasi Niaga"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "NISRINA KHONSA AZZAHRA",
        jenjang: "S1 Reguler",
        prodi: "Kesehatan Masyarakat"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "SURYA SYAHFITRA HAKIM",
        jenjang: "S1 Reguler",
        prodi: "Keselamatan & Kesehatan Kerja"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "REFANDI ARKHAN BASMOKO",
        jenjang: "S1 Reguler",
        prodi: "Pendidikan Dokter"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MUHAMMAD MUFLIH MUFAQQIH",
        jenjang: "S1 Reguler",
        prodi: "Sastra Arab"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "TORIQ FATHONI DEZI",
        jenjang: "S1 Reguler",
        prodi: "Teknik Komputer"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "FERNANDA MEHRUNISSA",
        jenjang: "S1 Reguler",
        prodi: "Teknik Kimia"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ENGGARTIASTO PRAMA NURENDRA",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Administrasi Niaga"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "GABRIEL CHRISTNOEL DAMANIK",
        jenjang: "S1 Reguler",
        prodi: "Psikologi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MUHAMMAD HABIB HAFANDI",
        jenjang: "S1 Reguler",
        prodi: "Farmasi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "DEL VANIA WIJAYA",
        jenjang: "S1 Reguler",
        prodi: "Teknologi Bioproses"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "BRIAN NUGRAHA PRAWIRA",
        jenjang: "S1 Reguler",
        prodi: "Teknik Sipil"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MUHAMMAD HILMI RAMADHAN EFFENDI",
        jenjang: "S1 Reguler",
        prodi: "Keselamatan & Kesehatan Kerja"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "AKBAR RESHAN FEKRAN MUHAMMAD",
        jenjang: "S1 Reguler",
        prodi: "Statistika"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "AHMAD ANGGARA BAYUADJI PRAWIROSOENOTO",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Komputer"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ZEA APSARI ARGIYANTI",
        jenjang: "S1 Reguler",
        prodi: "Farmasi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "PRAMUDYA YUSUF SAPUTRO",
        jenjang: "S1 Reguler",
        prodi: "Teknik Metalurgi & Material"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "DZAKIRA HANUN",
        jenjang: "S1 Reguler",
        prodi: "Pendidikan Dokter Gigi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ZASKHIA MAULIDA",
        jenjang: "S1 Reguler",
        prodi: "Biologi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MIRANDA OLIVIA PANJAITAN",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Administrasi Fiskal"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "KAYLA JOANNA IRSY KUSUMAH",
        jenjang: "S1 Reguler",
        prodi: "Teknik Komputer"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MAULIDINA YASMIN FAIZARANI",
        jenjang: "S1 Reguler",
        prodi: "Statistika"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MUHAMMAD AKHYAR FAHRURROZI",
        jenjang: "S1 Reguler",
        prodi: "Fisika"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "RAYYA NOLOJATI ARMOND",
        jenjang: "S1 Reguler",
        prodi: "Kimia"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MUHAMMAD RAFFI ALVIZAM",
        jenjang: "S1 Reguler",
        prodi: "Teknik Elektro"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "WINDY SULISTIAWATI",
        jenjang: "S1 Reguler",
        prodi: "Teknik Komputer"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "DHIAURRAHMAN GIFFARI PUTRA SOLIHIN",
        jenjang: "S1 Reguler",
        prodi: "Teknik Metalurgi & Material"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "NASHWA KHAIRUNNISA",
        jenjang: "S1 Reguler",
        prodi: "Farmasi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "NADYA RAMADHINA HARAHAP",
        jenjang: "S1 Reguler",
        prodi: "Kesehatan Masyarakat"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MARSHA AMELIA SHEEHAN",
        jenjang: "S1 Reguler",
        prodi: "Farmasi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "HAYATI AINUNPRADJA",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Keperawatan"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "PUTRI SANIA",
        jenjang: "S1 Reguler",
        prodi: "Farmasi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MUHAMMAD RIZQI ARFA HERMAWAN",
        jenjang: "S1 Reguler",
        prodi: "Teknik Sipil"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MUHAMMAD AHSAN NAZARUDIN",
        jenjang: "S1 Reguler",
        prodi: "Matematika"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "RAISYA NURUL AMALIA",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Keperawatan"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MUHAMMAD NABIL RAMADHAN",
        jenjang: "D4",
        prodi: "Manajemen Rekod dan Arsip"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "DIMAS AHMAD DHIYAURRAHMAN",
        jenjang: "S1 Reguler",
        prodi: "Teknik Elektro"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MUHAMMAD RAIHAN RAFI ARRAHMAN",
        jenjang: "S1 Reguler",
        prodi: "Teknik Elektro"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "NIKEBUENA BELIN PURBA",
        jenjang: "S1 Reguler",
        prodi: "Biologi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "FAUZAN APRIZAL RAMZI",
        jenjang: "S1 Reguler",
        prodi: "Teknik Perkapalan"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "GATAN PRANATA MANIK",
        jenjang: "S1 Reguler",
        prodi: "Kesehatan Masyarakat"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ADYANI PUTRI RAIHANAH SARWONO",
        jenjang: "S1 Reguler",
        prodi: "Sistem Informasi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "RIZQY ADAM RAMADHAN",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Aktuaria"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "HUZAHRA AZKIYA KARDI",
        jenjang: "S1 Reguler",
        prodi: "Teknik Elektro"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "NADHIA KUSUMANINGRUM",
        jenjang: "S1 Reguler",
        prodi: "Kimia"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "HARRELL HIZKIA",
        jenjang: "S1 Reguler",
        prodi: "Teknik Sipil"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ANNISA INTAN PUTRI CAHYANI",
        jenjang: "S1 Reguler",
        prodi: "Biologi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "WAHYU HIDAYAT",
        jenjang: "S1 Reguler",
        prodi: "Teknik Industri"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "AMIRA RAYNA JIBRIL",
        jenjang: "S1 Reguler",
        prodi: "Farmasi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "SYIFA ARIZONYA PRATAMA",
        jenjang: "S1 Reguler",
        prodi: "Pendidikan Dokter Gigi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "FATHAN ALFAHREZI",
        jenjang: "S1 Reguler",
        prodi: "Sistem Informasi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "NAYOMI ADELIA JINAN",
        jenjang: "S1 Reguler",
        prodi: "Farmasi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "RADITYA AMORET",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Komputer"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "GHAILAN ALFATH ULWANQOBUS",
        jenjang: "S1 Reguler",
        prodi: "Teknik Biomedik"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "KAMILA SALMA FATHIYYA",
        jenjang: "S1 Reguler",
        prodi: "Teknik Komputer"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "AMADIO JUNO TRISANTO",
        jenjang: "S1 Reguler",
        prodi: "Sistem Informasi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ADAM FIRDAUS",
        jenjang: "S1 Reguler",
        prodi: "Kesehatan Lingkungan"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "REVANA ZAHRATUNNISA",
        jenjang: "Vokasi",
        prodi: "Administrasi Rumah Sakit"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "NISAA RARAS HAFIYYA",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Administrasi Negara"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "EVAN SANTOSO",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Komputer"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "FAIKA SYAKHIRA",
        jenjang: "S1 Reguler",
        prodi: "Studi Gizi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MICHELLE VIOLETTA LALENOH",
        jenjang: "S1 Reguler",
        prodi: "Teknik Sipil"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "KEYSHA AINAYA NAZHIFA LUBIS",
        jenjang: "S1 Reguler",
        prodi: "Biologi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "SITI AYSIAH PUTRI",
        jenjang: "S1 Reguler",
        prodi: "Pendidikan Dokter Gigi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "AISYA SYIFA SYAHIRA",
        jenjang: "Vokasi",
        prodi: "Administrasi Perkantoran"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "SYAKIRA NAYLA PUTRI",
        jenjang: "Vokasi",
        prodi: "Administrasi Rumah Sakit"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MUHAMMAD DZAKY JUNADIL YAMUS",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Hubungan Internasional"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MUHAMMAD RAZAN ARKAAN AFRIANSYAH",
        jenjang: "S1 Reguler",
        prodi: "Teknik Elektro"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "SYAHILA RACHMADANI",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Keperawatan"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ALIYA HUMAIRA FASYA",
        jenjang: "S1 Reguler",
        prodi: "Farmasi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "M HAYKAL FIRDAUS",
        jenjang: "S1 Reguler",
        prodi: "Farmasi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "KHAYLA AZZAHRA",
        jenjang: "S1 Reguler",
        prodi: "Geografi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ANDREW THEODORUS CHANDRA",
        jenjang: "S1 Reguler",
        prodi: "Fisika"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ABDURRAHMAN BINTANG FAJRUL ISLAM",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Sejarah"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "HASAN AKBAR",
        jenjang: "S1 Reguler",
        prodi: "Sistem Informasi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "NUR KUSNA ABIDAH",
        jenjang: "S1 Reguler",
        prodi: "Kesehatan Masyarakat"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MUHAMMAD KHALIL NUGROHO",
        jenjang: "S1 Reguler",
        prodi: "Teknologi Bioproses"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "SILVI LAURENSIA SALIM",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Aktuaria"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MOHAMMAD KHOIRUR RIZIQ",
        jenjang: "S1 Reguler",
        prodi: "Keselamatan & Kesehatan Kerja"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "NINDYA RAMEYZA RISTJAHYADI",
        jenjang: "S1 Reguler",
        prodi: "Teknik Metalurgi & Material"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "NAILA LATISHA PUTRI NOEGRAHA",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Administrasi Niaga"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "AMMAR MUHAMMAD RAFIF",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Komputer"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "HANIFAH HUSNA",
        jenjang: "S1 Reguler",
        prodi: "Fisika"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "CARENDA HIKMA ANUGRAH",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Keperawatan"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "NAJWA SHIFA SHOFIA",
        jenjang: "S1 Reguler",
        prodi: "Kimia"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "BAGAS WICAKSONO SULASTO",
        jenjang: "S1 Reguler",
        prodi: "Teknik Sipil"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "TSURAYYA NURAFIFAH",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Administrasi Negara"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ABED DIEGO PASARIBU",
        jenjang: "S1 Reguler",
        prodi: "Teknik Metalurgi & Material"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "GUSTIA ALISA AISYAHWA",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Komunikasi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "FRANSISCA TESALONIKA RIBKA WONGSOKENONGO",
        jenjang: "S1 Reguler",
        prodi: "Matematika"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "EMMANUELLE GADING AVELLINO",
        jenjang: "S1 Reguler",
        prodi: "Biologi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "TIARA NAUTICA AZAHRA",
        jenjang: "S1 Reguler",
        prodi: "Fisika"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "AMARILLA DHIA AMAYA",
        jenjang: "S1 Reguler",
        prodi: "Sastra Cina"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "JAFAR FADIL DEWANTARA",
        jenjang: "S1 Reguler",
        prodi: "Sistem Informasi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "AMIRA BRIANA KHALISA",
        jenjang: "S1 Reguler",
        prodi: "Teknologi Bioproses"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MUHAMMAD IZAZ NAJWAN",
        jenjang: "S1 Reguler",
        prodi: "Geofisika"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "KHALISA ZAHRA SALFADILA",
        jenjang: "S1 Reguler",
        prodi: "Farmasi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ARIANDRA SANGGRAWUNI",
        jenjang: "S1 Reguler",
        prodi: "Keselamatan & Kesehatan Kerja"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ISMAHANI",
        jenjang: "S1 Reguler",
        prodi: "Sastra Jepang"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "KUKUH LAKSANA JAKA PANDHITA",
        jenjang: "S1 Reguler",
        prodi: "Teknik Perkapalan"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ANANDA NURUL RAMADHANTI",
        jenjang: "S1 Reguler",
        prodi: "Teknik Industri"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "DINDA TIARA NUR AMALIA",
        jenjang: "S1 Reguler",
        prodi: "Matematika"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "TSABITA RANSI AURELIA",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Komputer"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "NAURA AULIYA AZZAHRA",
        jenjang: "S1 Reguler",
        prodi: "Kimia"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "INDRY VICTORIA SILALAHI",
        jenjang: "D4",
        prodi: "Manajemen Rekod dan Arsip"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "FELICE CLAUDINE WIJAYA",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Aktuaria"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ELSYA NAJMI DZIA ULHAQ",
        jenjang: "S1 Reguler",
        prodi: "Teknik Lingkungan"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "RUBBY RASY RESTU GUSTI",
        jenjang: "S1 Reguler",
        prodi: "Biologi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "RAJA ZAKY ROBANI",
        jenjang: "Vokasi",
        prodi: "Administrasi Asuransi dan Aktuaria \t"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "SHANDY AUDINA KHARINA AHZA",
        jenjang: "S1 Reguler",
        prodi: "Kesehatan Lingkungan"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "JEANNETTE MIRIELLE TAMBUNAN",
        jenjang: "D4",
        prodi: "Terapi Okupasi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "QONITA NAZIFA AL FIRDAUSI",
        jenjang: "S1 Reguler",
        prodi: "Studi Gizi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "YAZID AL FARIZ HARAHAP",
        jenjang: "S1 Reguler",
        prodi: "Geofisika"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "RAHMAH AZIZAH RAHMAN",
        jenjang: "S1 Reguler",
        prodi: "Bahasa dan Kebudayaan Korea"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "IZZUDIN ABDUL RASYID",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Komputer"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MOHAMMAD NAUFANFIKRI WACHIDI",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Komputer"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "NAURA FATIN BUWANA",
        jenjang: "S1 Reguler",
        prodi: "Kimia"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "CHIARA NAURA SYIFA",
        jenjang: "S1 Reguler",
        prodi: "Teknik Elektro"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "PERMATA JUBILETA ARION LUBIS",
        jenjang: "S1 Reguler",
        prodi: "Arsitektur"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "SITI ULFA CHAIRIYAH",
        jenjang: "S1 Reguler",
        prodi: "Sastra Cina"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MUHAMMAD AZIIZ SATRIO SANDI",
        jenjang: "S1 Reguler",
        prodi: "Kesehatan Lingkungan"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "DAVINA MARIA NATALI",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Keperawatan"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "SULTHAN BAIHAQI",
        jenjang: "S1 Reguler",
        prodi: "Farmasi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "RAFIDA AZIS AL HABIB",
        jenjang: "S1 Reguler",
        prodi: "Biologi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "STEVANIE JURIKA SINAGA",
        jenjang: "S1 Reguler",
        prodi: "Farmasi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "NAMYRA NAJLAA KANAHAYA",
        jenjang: "S1 Reguler",
        prodi: "Teknik Sipil"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MUHAMMAD ATHAAYA FADHLI",
        jenjang: "S1 Reguler",
        prodi: "Teknik Sipil"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "NURHALIZAH ADINDA PUTRI",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Keperawatan"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "FERANA MAZIDA KHANSA FIRDAUS",
        jenjang: "S1 Reguler",
        prodi: "Teknik Sipil"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "PUTI AZZURA HASANAH",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Administrasi Fiskal"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MUHAMMAD RASYA AL RASYID",
        jenjang: "S1 Reguler",
        prodi: "Keselamatan & Kesehatan Kerja"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "VERDINAND BOAS MICHAEL PARESTU SINAGA",
        jenjang: "S1 Reguler",
        prodi: "Biologi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "DARREN BENARDY",
        jenjang: "D4",
        prodi: "Terapi Okupasi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "EDWARD TAN",
        jenjang: "S1 Reguler",
        prodi: "Pendidikan Dokter Gigi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "HANIFAH SAHLAH",
        jenjang: "S1 Reguler",
        prodi: "Biologi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "VAHD VUAD VALAHIN ADAM TALIB",
        jenjang: "S1 Reguler",
        prodi: "Pendidikan Dokter Gigi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "NADIA IZZATI",
        jenjang: "S1 Reguler",
        prodi: "Teknik Komputer"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "GIBRAN LEON ALQORNY ALEXANDER",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Administrasi Negara"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "SALITSA ANDANG WINAHYU",
        jenjang: "S1 Reguler",
        prodi: "Pendidikan Dokter Gigi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ZSAZSA HAFIDZAH MUMTAZH",
        jenjang: "Vokasi",
        prodi: "Administrasi Rumah Sakit"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "LEONARDO CHRISTOPHER KHONG",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Aktuaria"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MUHAMMAD IHSAN MUZHAFFIR",
        jenjang: "S1 Reguler",
        prodi: "Geologi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "NAUFAL NARARYA AYDINULLAH",
        jenjang: "S1 Reguler",
        prodi: "Sistem Informasi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "FATIMATUZZAHRA ABIDATURRAHMAN",
        jenjang: "S1 Reguler",
        prodi: "Kimia"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ZHAFIRA CELLONADA DESTRATA WIJAYANTO",
        jenjang: "S1 Reguler",
        prodi: "Sistem Informasi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ADYATAMA RIFQI HILMY NUGROHO",
        jenjang: "S1 Reguler",
        prodi: "Geografi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "CAROL ANGELIQUE AUGNINE SETIAWAN",
        jenjang: "S1 Reguler",
        prodi: "Teknik Sipil"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ANGELIQUE NATASYA B.C SIAGIAN",
        jenjang: "S1 Reguler",
        prodi: "Sistem Informasi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MUHAMMAD SYAZIDAN",
        jenjang: "S1 Reguler",
        prodi: "Bisnis Islam"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MUHAMMAD NUR ABRAR",
        jenjang: "Vokasi",
        prodi: "Periklanan Kreatif"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "SEAN RIZKY AKBAR BALADHIKA",
        jenjang: "S1 Reguler",
        prodi: "Teknik Lingkungan"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "GUSTI AVRA RAVINDRA",
        jenjang: "S1 Reguler",
        prodi: "Teknik Biomedik"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "RR AURADATUS TSAQOFAH WK",
        jenjang: "D4",
        prodi: "Fisioterapi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "SHAFIYAH",
        jenjang: "S1 Reguler",
        prodi: "Psikologi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "TITHA ANGGIA JASMINE",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Keperawatan"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "NAJWA DZAHABIYAH LARASATI",
        jenjang: "S1 Reguler",
        prodi: "Kesehatan Masyarakat"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "HIDAYATUL UMNI",
        jenjang: "S1 Reguler",
        prodi: "Kimia"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "CHRISTINE SIMANJUNTAK",
        jenjang: "S1 Reguler",
        prodi: "Teknik Industri"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "HALIFAH NOVIA RAHMAH",
        jenjang: "S1 Reguler",
        prodi: "Kesehatan Lingkungan"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "NAYLA RAISSA SALSABILA",
        jenjang: "S1 Reguler",
        prodi: "Statistika"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "DINDA FADHILA RAMADHANI",
        jenjang: "S1 Reguler",
        prodi: "Kesehatan Masyarakat"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "RAISSA PUTRI SALSABILA",
        jenjang: "S1 Reguler",
        prodi: "Teknik Kimia"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ALEXIA TALITHA CYMBELINE PURBA",
        jenjang: "S1 Reguler",
        prodi: "Teknik Biomedik"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "DZAKIYYATUNNISA ASMARANI",
        jenjang: "S1 Reguler",
        prodi: "Teknik Lingkungan"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "FAHREZA ARSYA MAULANA",
        jenjang: "S1 Reguler",
        prodi: "Teknik Elektro"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "NAURAH AFIFAH FAHIRA",
        jenjang: "S1 Reguler",
        prodi: "Farmasi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "AGIL GILANG RAMADHAN",
        jenjang: "S1 Reguler",
        prodi: "Teknik Mesin"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ANINDITA NUR AISYA",
        jenjang: "Vokasi",
        prodi: "Administrasi Asuransi dan Aktuaria \t"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "SABILA AULIA ATHOILLAH",
        jenjang: "S1 Reguler",
        prodi: "Sastra Jepang"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "BAGAS INASYAH KAMIL SHADIQ",
        jenjang: "S1 Reguler",
        prodi: "Kimia"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "NAILA AZIZAH MAHARDDIKA",
        jenjang: "S1 Reguler",
        prodi: "Arsitektur Interior"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MUHAMMAD FAJRIL MUBAROK",
        jenjang: "S1 Reguler",
        prodi: "Statistika"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MARCEL AL RASYIDI DUNAND",
        jenjang: "S1 Reguler",
        prodi: "Fisika"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "HANIFIYYAH FIRZY",
        jenjang: "S1 Reguler",
        prodi: "Psikologi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MUHAMMAD RAYYAN BASALAMAH",
        jenjang: "S1 Reguler",
        prodi: "Sistem Informasi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "FIRZA INDRA PRAWIRA",
        jenjang: "S1 Reguler",
        prodi: "Sistem Informasi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "SILMI MUJAHID ABIDIN",
        jenjang: "S1 Reguler",
        prodi: "Biologi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MUHAMMAD RAFI IDMUTHOHHAR",
        jenjang: "S1 Reguler",
        prodi: "Matematika"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ESTYA ILMA AMALIA",
        jenjang: "S1 Reguler",
        prodi: "Kimia"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MARIA BONITA",
        jenjang: "S1 Reguler",
        prodi: "Akuntansi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "NAJSWA FARADILA PUTRI",
        jenjang: "S1 Reguler",
        prodi: "Teknik Sipil"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "JOSE RYU TOARI",
        jenjang: "S1 Reguler",
        prodi: "Sistem Informasi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ZARIN FASHILA HANANIAH",
        jenjang: "S1 Reguler",
        prodi: "Arsitektur"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "KHANSA DINDA ARYA PUTRI",
        jenjang: "S1 Reguler",
        prodi: "Sistem Informasi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "NASYA MALIKA SABILILLAH",
        jenjang: "S1 Reguler",
        prodi: "Kimia"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "RAYYAN AKBAR GUMILANG",
        jenjang: "S1 Reguler",
        prodi: "Sistem Informasi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "KEZIA",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Keperawatan"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ANNISA GUNAWAN",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Aktuaria"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MUHAMMAD ZIDANIEL ARZAQ",
        jenjang: "S1 Reguler",
        prodi: "Geofisika"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "JOVAN JURIVER S.",
        jenjang: "S1 Reguler",
        prodi: "Teknik Kimia"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "RAFFA NAUFAL ALTHAF",
        jenjang: "S1 Reguler",
        prodi: "Studi Gizi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "KEANU MATEZA SUSANTO",
        jenjang: "S1 Reguler",
        prodi: "Geofisika"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "RINI ANGGRAINI",
        jenjang: "S1 Reguler",
        prodi: "Kriminologi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "NABILA PRASTIKA ARDININGRUM",
        jenjang: "S1 Reguler",
        prodi: "Biologi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MUHAMMAD ZIDAN IHTIFAZHUDDIN SUTOPO",
        jenjang: "S1 Reguler",
        prodi: "Teknik Elektro"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ERENA ALIA MAHERRANI",
        jenjang: "S1 Reguler",
        prodi: "Farmasi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "SARIFATUS SANIA",
        jenjang: "S1 Reguler",
        prodi: "Geofisika"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "EVAN VARELLINO",
        jenjang: "S1 Reguler",
        prodi: "Studi Gizi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "NIDIA NAZILA RIZKIA ARSH",
        jenjang: "S1 Reguler",
        prodi: "Matematika"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "GERRY BIMA PUTRA",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Komputer"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "RIO ARMANDO LISTYA WIJAYA",
        jenjang: "S1 Reguler",
        prodi: "Kriminologi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ERIK WILBERT",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Komputer"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "DENISE ALLYSA ARSHANTI",
        jenjang: "S1 Reguler",
        prodi: "Fisika"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "FAZZA NURRIZQY",
        jenjang: "S1 Reguler",
        prodi: "Teknik Industri"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "HALIM NAUFALDI AKMAL",
        jenjang: "S1 Reguler",
        prodi: "Teknik Kimia"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "AQSA MUHAMMAD IZRA",
        jenjang: "S1 Reguler",
        prodi: "Fisika"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MUHAMMAD FAZA AL-BANNA",
        jenjang: "S1 Reguler",
        prodi: "Sistem Informasi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "NAJWA WIRYA AZZAHRA",
        jenjang: "S1 Reguler",
        prodi: "Farmasi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "SHEVA FIORE IMRON",
        jenjang: "S1 Reguler",
        prodi: "Arsitektur Interior"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MUH. MAULANA AS SHIDDIQ",
        jenjang: "S1 Reguler",
        prodi: "Geologi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "DANIEL FRITZIE PANGGABEAN",
        jenjang: "S1 Reguler",
        prodi: "Teknik Perkapalan"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "PUTRI ANDINI",
        jenjang: "S1 Reguler",
        prodi: "Sastra Daerah untuk Sastra Jawa"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "TIARA DESRANA PUTRI",
        jenjang: "S1 Reguler",
        prodi: "Kimia"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MAYLAFAIZA FIDELLA HERMAWAN",
        jenjang: "S1 Reguler",
        prodi: "Biologi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "KHALISHA ROSELANI PRABOWO",
        jenjang: "S1 Reguler",
        prodi: "Sistem Informasi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "HAFIDZ ARSHA KABIRA",
        jenjang: "S1 Reguler",
        prodi: "Sistem Informasi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "JORDANA MOIRA",
        jenjang: "S1 Reguler",
        prodi: "Kesehatan Masyarakat"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "EMERALD CLEO ANANTA",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Administrasi Niaga"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "NAILA SHAFA RAMADHANI",
        jenjang: "S1 Reguler",
        prodi: "Pendidikan Dokter Gigi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "DERRYL HEGAR PERMANA",
        jenjang: "S1 Reguler",
        prodi: "Fisika"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ABIGAIL NASYWA AMIRAH",
        jenjang: "S1 Reguler",
        prodi: "Farmasi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "BELVA ISTINA PUTRI",
        jenjang: "D4",
        prodi: "Terapi Okupasi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "CHRISTOPHER SARAGIH",
        jenjang: "Vokasi",
        prodi: "Administrasi Asuransi dan Aktuaria \t"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "RESTI ALYCHIA SAFIRA",
        jenjang: "S1 Reguler",
        prodi: "Geologi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "RAFI AKRAM FADHILAH",
        jenjang: "S1 Reguler",
        prodi: "Farmasi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "LUTHFIANNISA NAYLAA DIAN SALSABILA",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Keperawatan"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "RAFFA DESTIAN",
        jenjang: "S1 Reguler",
        prodi: "Teknik Perkapalan"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "PRICILLA ANDREA BANGUN",
        jenjang: "S1 Reguler",
        prodi: "Psikologi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "SYAHRUL",
        jenjang: "S1 Reguler",
        prodi: "Teknik Perkapalan"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MOHAMMAD RIFKY MASKAR",
        jenjang: "S1 Reguler",
        prodi: "Teknik Perkapalan"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ARNETA VIDYA",
        jenjang: "S1 Reguler",
        prodi: "Kimia"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "RAQILLA AL-ABRAR",
        jenjang: "S1 Reguler",
        prodi: "Sistem Informasi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "NABILA KAUTSAR HILMI",
        jenjang: "D4",
        prodi: "Terapi Okupasi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "RAVAREL AQIILAH KIRANA",
        jenjang: "S1 Reguler",
        prodi: "Geofisika"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "M. FAJAR AULIA NUR",
        jenjang: "S1 Reguler",
        prodi: "Geofisika"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "TSANIA KARIMATUL ABADIAH",
        jenjang: "S1 Reguler",
        prodi: "Arkeologi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "AURELLIA ZALIKA AMARA",
        jenjang: "D4",
        prodi: "Manajemen Rekod dan Arsip"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "RADYA AISAR NURZAYD GUNAWAN",
        jenjang: "S1 Reguler",
        prodi: "Teknik Industri"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ALKHAIRANI GHITA SETYAWAN",
        jenjang: "S1 Reguler",
        prodi: "Teknik Metalurgi & Material"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "NAURAH CAHYANI",
        jenjang: "S1 Reguler",
        prodi: "Sastra Cina"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "SULTAN NAUFAL SARANA",
        jenjang: "S1 Reguler",
        prodi: "Teknik Metalurgi & Material"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "DINDA JUNIARTI LESTARI",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Keperawatan"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "AMMARA FAYZA WARDANA",
        jenjang: "S1 Reguler",
        prodi: "Biologi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MUHAMMAD FAUZAN",
        jenjang: "S1 Reguler",
        prodi: "Sistem Informasi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ZORBA ZILABA",
        jenjang: "S1 Reguler",
        prodi: "Manajemen"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "NUR ALAWIYAH",
        jenjang: "S1 Reguler",
        prodi: "Biologi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MARCELLO ROMAND HAMONANGAN MANURUNG",
        jenjang: "S1 Reguler",
        prodi: "Teknik Sipil"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "YOSFATARA MORATUA PURBA",
        jenjang: "S1 Reguler",
        prodi: "Matematika"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ZIYA ALDIN",
        jenjang: "S1 Reguler",
        prodi: "Kesehatan Masyarakat"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "NUR FATHIA KHOYROH",
        jenjang: "S1 Reguler",
        prodi: "Kimia"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ATALA FIKRI ZAKI",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Aktuaria"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "JAVA TIRTA KUSUMA",
        jenjang: "S1 Reguler",
        prodi: "Teknik Sipil"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "NAZLA AULIA YASMIN",
        jenjang: "S1 Reguler",
        prodi: "Biologi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "TSALATSA RIZQIYAH NUR AZ ZAHRA",
        jenjang: "S1 Reguler",
        prodi: "Biologi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "RR. ANINDYA KAYANA SYAHIRA",
        jenjang: "S1 Reguler",
        prodi: "Pendidikan Dokter"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "DEBY KARINA TAMPUBOLON",
        jenjang: "S1 Reguler",
        prodi: "Biologi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ANANDA MAHARANI EFENDI",
        jenjang: "S1 Reguler",
        prodi: "Teknik Perkapalan"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "AUFA ARAZI",
        jenjang: "S1 Reguler",
        prodi: "Teknik Metalurgi & Material"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "SABRINA MAULIA FIRNANDA",
        jenjang: "S1 Reguler",
        prodi: "Psikologi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MUHAMMAD RIZKY ANTARIKSA KRISNADI",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Komputer"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "FATIH ABQARY ZHAFRAN",
        jenjang: "S1 Reguler",
        prodi: "Teknik Perkapalan"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "YASER AFZAAL RAMADHAN",
        jenjang: "Vokasi",
        prodi: "Administrasi Perpajakan"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MUHAMMAD GHAZALI AL GHIFARI",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Administrasi Fiskal"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "OWEN GRANDEE",
        jenjang: "S1 Reguler",
        prodi: "Teknik Biomedik"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "RAFID MUHAMMAD ZAHRAN",
        jenjang: "S1 Reguler",
        prodi: "Teknik Mesin"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ATHIFAH MUFIDAH",
        jenjang: "S1 Reguler",
        prodi: "Matematika"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "AHMAD",
        jenjang: "S1 Reguler",
        prodi: "Teknik Perkapalan"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "CELIA CHRISTABELLE OESMAN",
        jenjang: "S1 Reguler",
        prodi: "Teknik Industri"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "AULIA ZAHRA MULYA PUTRI",
        jenjang: "S1 Reguler",
        prodi: "Kesehatan Masyarakat"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "NITIA RAHMAWATI",
        jenjang: "S1 Reguler",
        prodi: "Farmasi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "LILA MUTIARA KASBI",
        jenjang: "S1 Reguler",
        prodi: "Teknik Mesin"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "JAFFAN GIBRAN NAPITUPULU",
        jenjang: "S1 Reguler",
        prodi: "Teknik Perkapalan"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "NEZZALUNA AZZAHRA",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Komputer"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "KALLUNA NAYSILLA SYAH PUTRI",
        jenjang: "S1 Reguler",
        prodi: "Sastra Rusia"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "R. FATHI RIZAKI NUGRA ADI",
        jenjang: "S1 Reguler",
        prodi: "Teknik Perkapalan"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MUHAMMAD RIDHO FITTA SEMBIRING",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Aktuaria"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "IRIN AGUSTIANI TAMBUN",
        jenjang: "S1 Reguler",
        prodi: "Kesehatan Masyarakat"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "NABILLA ARINDANI",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Keperawatan"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "SISKA ASNI MEILANI",
        jenjang: "S1 Reguler",
        prodi: "Fisika"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "FRIDOLIN IVANO MARCIANO MANALU",
        jenjang: "Vokasi",
        prodi: "Administrasi Asuransi dan Aktuaria \t"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "CHYNTIA ALFIANA ZAENI",
        jenjang: "S1 Reguler",
        prodi: "Statistika"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "CAESAR NUR FALAH WIDIYANTO",
        jenjang: "S1 Reguler",
        prodi: "Teknik Komputer"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "AISYAH NURRAHMAH",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Keperawatan"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MUHAMMAD ZULFI SABILUN NAJWA",
        jenjang: "S1 Reguler",
        prodi: "Kesehatan Lingkungan"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MELKI YUNUS SITORUS",
        jenjang: "S1 Reguler",
        prodi: "Fisika"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "TIMMO AHMAD AQILASHAHZAD",
        jenjang: "S1 Reguler",
        prodi: "Teknik Industri"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "LALITA AMARA",
        jenjang: "S1 Reguler",
        prodi: "Pendidikan Dokter"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "RADHI ZAIDAN MILAN DARMAWAN",
        jenjang: "S1 Reguler",
        prodi: "Sastra Jepang"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "NADHIFA NIHLATUNNAJWA",
        jenjang: "Vokasi",
        prodi: "Administrasi Rumah Sakit"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "RAFFI DEWANGGA SUSANTO",
        jenjang: "S1 Reguler",
        prodi: "Sistem Informasi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ANDI FARREL RAMADHAN ASFAR",
        jenjang: "S1 Reguler",
        prodi: "Matematika"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ISABEL ANGELINA SIANTURI",
        jenjang: "S1 Reguler",
        prodi: "Pendidikan Dokter Gigi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "SHERNILA MEYLANI MANAO",
        jenjang: "S1 Reguler",
        prodi: "Kesehatan Masyarakat"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "INSHOVI AMIROH",
        jenjang: "S1 Reguler",
        prodi: "Statistika"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MUHAMMAD RIZQI FADLAN",
        jenjang: "S1 Reguler",
        prodi: "Teknik Mesin"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MUHAMAD NAFHAN ZAHIRUL HAQ",
        jenjang: "S1 Reguler",
        prodi: "Geologi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "IHSAN DZUL FADHLI ILMI",
        jenjang: "S1 Reguler",
        prodi: "Teknik Mesin"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "HASAN IZZUDDIN ALFATIH",
        jenjang: "S1 Reguler",
        prodi: "Sastra Indonesia"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MARISSA ZAHRA LATIFA HILLIARD",
        jenjang: "S1 Reguler",
        prodi: "Geofisika"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ILHAM GHAZA GUSAYFA",
        jenjang: "S1 Reguler",
        prodi: "Arsitektur"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "STEPHANIA VICTORIA PAKPAHAN",
        jenjang: "S1 Reguler",
        prodi: "Matematika"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "BUNGA AZZAHRA SURYADI",
        jenjang: "S1 Reguler",
        prodi: "Statistika"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "SOPHIE DE EDHIES",
        jenjang: "S1 Reguler",
        prodi: "Sastra Jerman"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "CRISTIAN DILLON PHILBERT",
        jenjang: "S1 Reguler",
        prodi: "Sistem Informasi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "AQMARIA RAMADHANI FAUZAN",
        jenjang: "S1 Reguler",
        prodi: "Kesehatan Lingkungan"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "PRASASTYAS RENIA WISANGGENI",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Administrasi Negara"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ZAIRA ARDIN VANESSA",
        jenjang: "S1 Reguler",
        prodi: "Pendidikan Dokter"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "WAFA NADIRA",
        jenjang: "D4",
        prodi: "Fisioterapi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "SYAKILA ADELYA ZAHRA",
        jenjang: "S1 Reguler",
        prodi: "Sastra Arab"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "WINDY AYU FATIKHA SARI",
        jenjang: "S1 Reguler",
        prodi: "Farmasi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "KANIA RAKSA RAMADHANTI",
        jenjang: "S1 Reguler",
        prodi: "Arsitektur Interior"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "NADIA AISYAH FAZILA",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Komputer"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ALYA QONITAH",
        jenjang: "D4",
        prodi: "Terapi Okupasi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "JEANNE YOLANDA CATHERYNE AMBARITA",
        jenjang: "S1 Reguler",
        prodi: "Teknik Industri"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ARINA TAZKIYANI MAULIDA",
        jenjang: "S1 Reguler",
        prodi: "Pendidikan Dokter Gigi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MAHESWARI JASHEENA",
        jenjang: "S1 Reguler",
        prodi: "Keselamatan & Kesehatan Kerja"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "NADHIRA WIDYA PUTRI",
        jenjang: "S1 Reguler",
        prodi: "Arsitektur Interior"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ALLEFKA KAUTSAR DEVANDRA",
        jenjang: "S1 Reguler",
        prodi: "Pendidikan Dokter Gigi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MEIDIANDRA KURFATIH",
        jenjang: "S1 Reguler",
        prodi: "Fisika"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "SAID WAHAB",
        jenjang: "S1 Reguler",
        prodi: "Geografi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "PUTRI AYU WULAN RAHARDJO",
        jenjang: "S1 Reguler",
        prodi: "Studi Gizi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MUHAMMAD ADITYA AQTA KUSUMA",
        jenjang: "S1 Reguler",
        prodi: "Teknik Metalurgi & Material"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "AISYAH SEPTISIA NABILA",
        jenjang: "S1 Reguler",
        prodi: "Fisika"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "AKMAL GIBRAN HAKIM",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Administrasi Niaga"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MUHAMMAD IHSAN AZMI",
        jenjang: "S1 Reguler",
        prodi: "Sistem Informasi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "NAZIHATUZ ZAHRAH",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Keperawatan"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MAYZKIA RAYSHA KUSTIWA",
        jenjang: "S1 Reguler",
        prodi: "Teknik Biomedik"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "GHASANNI ALMAS SAHIRA",
        jenjang: "S1 Reguler",
        prodi: "Matematika"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "JASMINE GABRIELLE STEVANESA",
        jenjang: "S1 Reguler",
        prodi: "Teknik Industri"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "NAEEMA YAFFA PUTRI DYRANDA",
        jenjang: "S1 Reguler",
        prodi: "Kesehatan Masyarakat"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "KEZIA MARIA AGATHA",
        jenjang: "S1 Reguler",
        prodi: "Teknik Biomedik"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "IMTIYAZUSSAOMI SALOOM",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Keperawatan"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "AMEERA CHALLISTYA WIDYARACHMA HASIBUAN",
        jenjang: "S1 Reguler",
        prodi: "Teknik Biomedik"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "VALENCIA KEIRA RAMBING",
        jenjang: "S1 Reguler",
        prodi: "Teknik Lingkungan"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "KAYLA PUTI FEBRIANE",
        jenjang: "S1 Reguler",
        prodi: "Fisika"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "CALANTHE AVI MAYRA",
        jenjang: "S1 Reguler",
        prodi: "Teknologi Bioproses"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "GIBRAN BRENA VEZORESA",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Administrasi Fiskal"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "RAFI ARYA PUTRA",
        jenjang: "S1 Reguler",
        prodi: "Teknik Elektro"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "M. ADELLA FATHIR SUPRIADI",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Komputer"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "CATHERINE NATALIA CHANDRA",
        jenjang: "S1 Reguler",
        prodi: "Studi Gizi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MUHAMMAD ARIEF SAPUTRA",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Aktuaria"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MUHAMMAD FIKRI DHARMASUTANTO",
        jenjang: "S1 Reguler",
        prodi: "Kesehatan Masyarakat"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "AZRIEL AHMAD FAHRIEZA",
        jenjang: "S1 Reguler",
        prodi: "Teknik Industri"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "THORIQ RAYYA RABBANI",
        jenjang: "S1 Reguler",
        prodi: "Arsitektur Interior"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "KHALISHAH AULIARAHMA WIJANARKO",
        jenjang: "S1 Reguler",
        prodi: "Antropologi Sosial"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "M. AZKA WAFI ASYAFA",
        jenjang: "S1 Reguler",
        prodi: "Fisika"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "CHRISTNA YOSUA ROTINSULU",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Komputer"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MAGHFIRA FITRI RAMADHANI",
        jenjang: "S1 Reguler",
        prodi: "Kimia"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MUHAMMAD REVAL",
        jenjang: "S1 Reguler",
        prodi: "Matematika"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "NURHALIZA AYUMI",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Keperawatan"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "NATHANIA FERNANDA SOTI SIMBOLON",
        jenjang: "S1 Reguler",
        prodi: "Sistem Informasi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "BIMO SUSENO",
        jenjang: "S1 Reguler",
        prodi: "Farmasi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ALI AKBAR MURTHADHA",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Komputer"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ALINA ZAHRA KURNIAWAN",
        jenjang: "S1 Reguler",
        prodi: "Teknik Lingkungan"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "SHANNON ODELIA RAHARJA",
        jenjang: "S1 Reguler",
        prodi: "Farmasi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "SYAHRAFI AHMAD PRADIKA",
        jenjang: "Vokasi",
        prodi: "Penyiaran Multimedia"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ARCHILOVINA DEVANIE",
        jenjang: "S1 Reguler",
        prodi: "Kimia"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "SADETHY ROFIFAH SYADILA",
        jenjang: "S1 Reguler",
        prodi: "Teknik Industri"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "I GUSTI NGURAH MADE ABHIPRAYA DANANJAYA",
        jenjang: "S1 Reguler",
        prodi: "Geofisika"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "DANIEL ALEXANDER",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Hukum"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "QAISYA SHOFURA RAHMAH",
        jenjang: "S1 Reguler",
        prodi: "Kimia"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "AMANDA NADIRA PUTRI",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Administrasi Fiskal"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "GIONADO GUNAWAN",
        jenjang: "S1 Reguler",
        prodi: "Sistem Informasi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "JANNAZRA KHAIRIZQIA NURDIN",
        jenjang: "S1 Reguler",
        prodi: "Fisika"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "KATHERINE ANGELA REAWILLMA",
        jenjang: "Vokasi",
        prodi: "Administrasi Asuransi dan Aktuaria \t"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "SEPTIA RAMADHANI",
        jenjang: "S1 Reguler",
        prodi: "Kimia"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "VALENTINO YESA HANBRYAN",
        jenjang: "S1 Reguler",
        prodi: "Teknik Sipil"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "SEAN JEREMY HENRY SIHOMBING",
        jenjang: "Vokasi",
        prodi: "Akuntansi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "WILDAN MUHAMMAD HAFIDZ",
        jenjang: "S1 Reguler",
        prodi: "Sistem Informasi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "PHILO PRADIPTA ADHI SATRIYA",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Komputer"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "FIRDA SALSABILA MUSTIKA DEWI",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Administrasi Negara"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "KHAYARA ALIMA DIFA",
        jenjang: "S1 Reguler",
        prodi: "Teknik Lingkungan"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "SYAHLA HUOLI RIDUAN",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Keperawatan"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MUHAMMAD AKBAR MALIK SATRIA",
        jenjang: "S1 Reguler",
        prodi: "Teknik Elektro"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "NISRINA NABILA IKHLAS",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Keperawatan"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "JESSEVAN GERARD VITO UISAN",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Komputer"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "NICHOLAS ALEXANDER HERMAN",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Hubungan Internasional"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "CHELSEA RASYA DAVINA",
        jenjang: "S1 Reguler",
        prodi: "Sastra Indonesia"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "AHSAN PARVEZ",
        jenjang: "S1 Reguler",
        prodi: "Sistem Informasi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MICHAEL LANGKAP BRAMASTA AJI WARDANA",
        jenjang: "S1 Reguler",
        prodi: "Sistem Informasi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "NAUFAL AIMAN SYAHPUTRA",
        jenjang: "S1 Reguler",
        prodi: "Kimia"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "SUBENHAR MUGIARTO",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Filsafat"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ALIEFA DIADIVA",
        jenjang: "S1 Reguler",
        prodi: "Arsitektur Interior"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "GRACE PATRICIA",
        jenjang: "S1 Reguler",
        prodi: "Pendidikan Dokter Gigi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ARDANT ABEDNEGO SIMARMATA",
        jenjang: "D4",
        prodi: "Fisioterapi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "KHALISHA ZHURIFAH SEJATI",
        jenjang: "S1 Reguler",
        prodi: "Statistika"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "DAFFA DEWANDA PUTRA",
        jenjang: "S1 Reguler",
        prodi: "Bahasa dan Kebudayaan Korea"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "YUDISTIRA PUTRA",
        jenjang: "S1 Reguler",
        prodi: "Pendidikan Dokter Gigi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "SEKAR NAJLA RAFIFAH",
        jenjang: "S1 Reguler",
        prodi: "Studi Gizi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "AVERINA LIZANDRA PURBA",
        jenjang: "S1 Reguler",
        prodi: "Matematika"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "SOFIE CINTHYA BASARIA S",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Ekonomi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "JEMIMMA JANE FENDY",
        jenjang: "S1 Reguler",
        prodi: "Studi Gizi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ANGELINE ANNA PATRICIA PAKPAHAN",
        jenjang: "S1 Reguler",
        prodi: "Kesehatan Masyarakat"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "IQBAL FIRMANSYAH",
        jenjang: "S1 Reguler",
        prodi: "Teknik Biomedik"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ARUMI FIRJA WINDRAYA",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Administrasi Fiskal"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ETHAN LAMRI",
        jenjang: "S1 Reguler",
        prodi: "Teknik Industri"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "FATCHA AZZARA DAUD",
        jenjang: "S1 Reguler",
        prodi: "Teknik Komputer"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "NADINA KHOIRUNNISA",
        jenjang: "S1 Reguler",
        prodi: "Arsitektur Interior"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MAHSA DIVY AZOLITHA",
        jenjang: "Vokasi",
        prodi: "Administrasi Asuransi dan Aktuaria \t"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "AZFAR AGA SAFARAZ",
        jenjang: "S1 Reguler",
        prodi: "Akuntansi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "RADHITYA AKILA RAHMANDIAZ",
        jenjang: "S1 Reguler",
        prodi: "Geologi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MICHAEL STEPHEN DANIEL PANJAITAN",
        jenjang: "S1 Reguler",
        prodi: "Sistem Informasi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "AROFAH BAGAS PRABOWO",
        jenjang: "S1 Reguler",
        prodi: "Matematika"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ANELLO ABSAR",
        jenjang: "S1 Reguler",
        prodi: "Statistika"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "DAFFA ISMAIL",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Komputer"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "RAMALIAN0625",
        jenjang: "S1 Reguler",
        prodi: "Kimia"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "AZMI ZAHRANI",
        jenjang: "S1 Reguler",
        prodi: "Sastra Rusia"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MAITSAA YATAQI",
        jenjang: "S1 Reguler",
        prodi: "Farmasi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "BINA CRYSTALLYN PANCAYATNI FAISAL",
        jenjang: "S1 Reguler",
        prodi: "Sastra Jerman"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ANDI AMANDA PUTRI FARID",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Keperawatan"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "BANYU PUTRO NUGROHO",
        jenjang: "S1 Reguler",
        prodi: "Matematika"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ANIFA HASHILAH",
        jenjang: "S1 Reguler",
        prodi: "Psikologi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MALIQ AKBAR EL KHOBAR",
        jenjang: "S1 Reguler",
        prodi: "Teknik Perkapalan"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "FIA NURUL HIDAYAH",
        jenjang: "S1 Reguler",
        prodi: "Geofisika"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "SITI ASIRIL MUTMA'INAH",
        jenjang: "S1 Reguler",
        prodi: "Kesehatan Masyarakat"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "CATHERINA BUNGA RAMADHANI",
        jenjang: "S1 Reguler",
        prodi: "Fisika"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MATTHEW CHRISTIAN NOEL SIDABUTAR",
        jenjang: "S1 Reguler",
        prodi: "Geofisika"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ANGGA ZIAURROHCHMAN",
        jenjang: "S1 Reguler",
        prodi: "Sistem Informasi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "NAZIEHAN LABIEB",
        jenjang: "S1 Reguler",
        prodi: "Teknik Komputer"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MUHAMMAD NADHIF MULYA",
        jenjang: "S1 Reguler",
        prodi: "Teknik Biomedik"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "RORA ZEFANI BR NADEAK",
        jenjang: "S1 Reguler",
        prodi: "Biologi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MUHAMMAD RYAN FANADI",
        jenjang: "S1 Reguler",
        prodi: "Geografi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "NURUL HASNA AWABIN",
        jenjang: "S1 Reguler",
        prodi: "Teknik Mesin"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "SHANIA OLIVIA SIANIPAR",
        jenjang: "S1 Reguler",
        prodi: "Keselamatan & Kesehatan Kerja"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "NDIRA NAURA HAYATI SUTRISNO",
        jenjang: "S1 Reguler",
        prodi: "Teknik Biomedik"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "RADEN RASYAAD SYAFRUDDIN",
        jenjang: "S1 Reguler",
        prodi: "Sastra Rusia"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "RYAN REYHAN ZUKHRI",
        jenjang: "S1 Reguler",
        prodi: "Biologi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "DELA SALWA ALFIYANI",
        jenjang: "S1 Reguler",
        prodi: "Sastra Daerah untuk Sastra Jawa"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "DOMINICIUS FRANCIS ANG GUNADI",
        jenjang: "Vokasi",
        prodi: "Administrasi Asuransi dan Aktuaria \t"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "SAMANTHA KERENHAPUKH TIURLINA TAMBUNAN",
        jenjang: "S1 Reguler",
        prodi: "Sistem Informasi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "SITI KIRANIA",
        jenjang: "S1 Reguler",
        prodi: "Studi Gizi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MUTIARA FATHIRA AGUS",
        jenjang: "S1 Reguler",
        prodi: "Farmasi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ALVITO DANISH SEPTIANO",
        jenjang: "S1 Reguler",
        prodi: "Farmasi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "SHAKA PRIYA PRASETIO",
        jenjang: "S1 Reguler",
        prodi: "Teknik Lingkungan"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "SYAHRA QURANI ISKANDAR",
        jenjang: "S1 Reguler",
        prodi: "Geofisika"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MUHAMMAD RIDHO RIZKY SAPUTRA",
        jenjang: "S1 Reguler",
        prodi: "Teknik Perkapalan"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MUHAMMAD RIZKY DWI NEGORO",
        jenjang: "S1 Reguler",
        prodi: "Farmasi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "AQILA NOOR KARIMA ZAKIY",
        jenjang: "S1 Reguler",
        prodi: "Kesehatan Masyarakat"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "DANIEL HAPOSAN BACHTIAR KAISAR JULIUS PURBA",
        jenjang: "S1 Reguler",
        prodi: "Teknik Mesin"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "TWEEDE ANGELO PANGAJENG",
        jenjang: "S1 Reguler",
        prodi: "Teknik Metalurgi & Material"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ALYSA HANIFAH IMANI",
        jenjang: "S1 Reguler",
        prodi: "Keselamatan & Kesehatan Kerja"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "FAUZAN MUHAMMAD FIRDIANA",
        jenjang: "S1 Reguler",
        prodi: "Teknik Perkapalan"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "TRISTAN YANG RUBEN JUNALA SITORUS",
        jenjang: "S1 Reguler",
        prodi: "Teknik Lingkungan"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "NAZLA SHARA ANDRAVY",
        jenjang: "S1 Reguler",
        prodi: "Psikologi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "DEYDRA ALNAYZA RAVEDEELVIA",
        jenjang: "S1 Reguler",
        prodi: "Geografi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "WIDAD MUHAMMAD RAFI",
        jenjang: "S1 Reguler",
        prodi: "Teknik Perkapalan"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "NURFITRI SYAHRANI",
        jenjang: "S1 Reguler",
        prodi: "Farmasi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "RASYAD HARIZ DAMANHURI",
        jenjang: "S1 Reguler",
        prodi: "Arsitektur Interior"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "RAMEYZA ALYA PERMANA",
        jenjang: "S1 Reguler",
        prodi: "Teknik Lingkungan"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "NABILA AZAHRA PUTRI ABDILAH",
        jenjang: "S1 Reguler",
        prodi: "Teknik Kimia"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "SYIFA ACHMADSYAH",
        jenjang: "S1 Reguler",
        prodi: "Teknik Lingkungan"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "CYRILLO PRADITYA SOEHARTO",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Komputer"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ZAHIRA ALEKA ASHARI",
        jenjang: "S1 Reguler",
        prodi: "Sastra Arab"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ALISHA DEVIANI PERMATASARI",
        jenjang: "D4",
        prodi: "Fisioterapi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "KUMARA PUDANSYAH SINAGA",
        jenjang: "D4",
        prodi: "Terapi Okupasi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "LUCIUS ALDRICH MARSADA SIMBOLON",
        jenjang: "Vokasi",
        prodi: "Akuntansi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "KEISYA ADYA REVALETA",
        jenjang: "S1 Reguler",
        prodi: "Kimia"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ADZRA ZAKIYYAH ZALFA",
        jenjang: "Vokasi",
        prodi: "Administrasi Rumah Sakit"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ZAKY RAMDHAN LESMANA",
        jenjang: "S1 Reguler",
        prodi: "Kesehatan Masyarakat"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "QONITA ALIFA FIDDARS",
        jenjang: "D4",
        prodi: "Terapi Okupasi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ADAM RAYYAN ARYASATYA",
        jenjang: "S1 Reguler",
        prodi: "Sistem Informasi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MUHAMMAD ANAS DANI",
        jenjang: "S1 Reguler",
        prodi: "Kimia"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ALINA RANSI JAMIPUTRI",
        jenjang: "S1 Reguler",
        prodi: "Teknik Elektro"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ZHAFIRA UZMA",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Komputer"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "RAFA PRADIPTA ALI WISNUTOMO",
        jenjang: "S1 Reguler",
        prodi: "Sistem Informasi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "RAFA ADRIN NANDIKA",
        jenjang: "S1 Reguler",
        prodi: "Manajemen"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "PUTU ARKANA SATRIAKUSUMA",
        jenjang: "S1 Reguler",
        prodi: "Teknik Komputer"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "NICHOLAS DYFAN HONARY",
        jenjang: "S1 Reguler",
        prodi: "Statistika"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "RIFFAT AKMAL DIFANSAH",
        jenjang: "S1 Reguler",
        prodi: "Teknik Metalurgi & Material"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "HANAN RASYA CAHYO TARANGGONO",
        jenjang: "S1 Reguler",
        prodi: "Akuntansi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MAYA ZAHRA NUR AZIZAH",
        jenjang: "S1 Reguler",
        prodi: "Farmasi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MUHAMMAD SULTHAN AFFAN",
        jenjang: "S1 Reguler",
        prodi: "Teknik Perkapalan"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "PRADNYA NURUL SAFIRA",
        jenjang: "S1 Reguler",
        prodi: "Kimia"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "KADEK PRADISTA PRABHAWANTI WIJAYA",
        jenjang: "S1 Reguler",
        prodi: "Teknik Mesin"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "BERNADETH ESTHER OKTARIA DAMANIK",
        jenjang: "S1 Reguler",
        prodi: "Sastra Jepang"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "FERNANDO KAISARAFA",
        jenjang: "S1 Reguler",
        prodi: "Biologi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "APRILIA DEWI YANI",
        jenjang: "S1 Reguler",
        prodi: "Arsitektur Interior"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "EVAN EUGENIUS MASSANG",
        jenjang: "S1 Reguler",
        prodi: "Teknik Mesin"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "HANIFAH AMALIA SURYA",
        jenjang: "S1 Reguler",
        prodi: "Kesehatan Masyarakat"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "GORGA FRIEDRIK SIMATUPANG",
        jenjang: "S1 Reguler",
        prodi: "Teknik Komputer"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "HAFIY ATHALLAH RAHVI",
        jenjang: "S1 Reguler",
        prodi: "Teknik Perkapalan"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "GYAVINKA AIMEE NAURA",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Keperawatan"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ADYA FANI",
        jenjang: "S1 Reguler",
        prodi: "Matematika"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "FARAH AQILA MAHARANI",
        jenjang: "S1 Reguler",
        prodi: "Teknik Elektro"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MUHAMMAD DAFFA AXEL GHAISAN",
        jenjang: "S1 Reguler",
        prodi: "Geografi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ALDERRYL JUAN FAUZA",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Komputer"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "PUTU ANGELICA JULIASTA PUTRI",
        jenjang: "S1 Reguler",
        prodi: "Teknik Elektro"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MAY DWI WIDHIANI",
        jenjang: "S1 Reguler",
        prodi: "Keselamatan & Kesehatan Kerja"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MARIA ELLORA DAMARKASIH",
        jenjang: "S1 Reguler",
        prodi: "Statistika"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "THERESIA BENEDICTA ARYANTI",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Aktuaria"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "AKSARA DAYKA DANURDARA",
        jenjang: "Vokasi",
        prodi: "Penyiaran Multimedia"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "KAYLA NANDYAMUTHIA YUSUF",
        jenjang: "S1 Reguler",
        prodi: "Teknik Biomedik"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MARGARET FELICIANA DAMARI",
        jenjang: "Vokasi",
        prodi: "Periklanan Kreatif"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "RAFI YUDHA HIDAYAT",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Komputer"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ANNISA AGUSTIN INDIRAWATI",
        jenjang: "S1 Reguler",
        prodi: "Farmasi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "INTAN RAHMA RAMADINA",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Keperawatan"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "NADIA FARAH ALTAIRA",
        jenjang: "S1 Reguler",
        prodi: "Biologi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MATTHEW NATHANAEL",
        jenjang: "S1 Reguler",
        prodi: "Sistem Informasi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "NAYLA NABILA FASYA",
        jenjang: "S1 Reguler",
        prodi: "Studi Gizi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "CARISSA ARAMINTA",
        jenjang: "S1 Reguler",
        prodi: "Farmasi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "GAYATRI SHALSABILLA WIDIA PUTRI",
        jenjang: "S1 Reguler",
        prodi: "Biologi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "SURYO SATRIO RAHARJO",
        jenjang: "S1 Reguler",
        prodi: "Farmasi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ANANDA SYIFA KHAIRUNNISA",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Aktuaria"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "AHMAD FADLAN AUFA GOLAR",
        jenjang: "S1 Reguler",
        prodi: "Geologi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "FAIRUS NADHIRAH LUTHFIA",
        jenjang: "S1 Reguler",
        prodi: "Kesehatan Lingkungan"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "NADIRA CHRISYA ARLITASARI",
        jenjang: "S1 Reguler",
        prodi: "Arsitektur Interior"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "FAYYAZA KHAIRUNNISA SEGORO",
        jenjang: "S1 Reguler",
        prodi: "Sistem Informasi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "BRIYAN HADI WIRYAWAN",
        jenjang: "S1 Reguler",
        prodi: "Teknik Perkapalan"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "KHADEEJA OURELYA MAHESTYA",
        jenjang: "S1 Reguler",
        prodi: "Kesehatan Masyarakat"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "SYIFA LELINNISA KIRNIANTO",
        jenjang: "S1 Reguler",
        prodi: "Teknik Industri"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "SULTAN RIZKIANSYAH PURBA TAMBAK",
        jenjang: "S1 Reguler",
        prodi: "Matematika"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "NADINE AMMARA TADJUDIN",
        jenjang: "S1 Reguler",
        prodi: "Farmasi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "NAIL AYYASY",
        jenjang: "S1 Reguler",
        prodi: "Geofisika"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "F.M. HANI REIHAN SAIQU",
        jenjang: "S1 Reguler",
        prodi: "Biologi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "SYAHIRAH NADIYA ADILA",
        jenjang: "S1 Reguler",
        prodi: "Teknik Biomedik"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "YEZI YANDI PRATAMA",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Administrasi Negara"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "NATHANAEL FREDERIK RAMYA SIMBOLON",
        jenjang: "S1 Reguler",
        prodi: "Matematika"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ASMA' MUTI' KAMILA",
        jenjang: "D4",
        prodi: "Terapi Okupasi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "RADITYA ARGANTO SAROSO",
        jenjang: "S1 Reguler",
        prodi: "Geologi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MOHAMAD HYUGA SATRIANA",
        jenjang: "S1 Reguler",
        prodi: "Biologi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MIKAIL RAHMAN",
        jenjang: "S1 Reguler",
        prodi: "Biologi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ALFRIDA MAUDRIENNE NAYFAHMA",
        jenjang: "S1 Reguler",
        prodi: "Teknologi Bioproses"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "JENDERAL FATIH ANTONI",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Ekonomi Islam"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "RICHARDO SIDIK",
        jenjang: "S1 Reguler",
        prodi: "Matematika"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "SATRIO ARDRA PRADANA",
        jenjang: "S1 Reguler",
        prodi: "Teknik Sipil"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "DENISE DEVINA JESSICA",
        jenjang: "S1 Reguler",
        prodi: "Teknik Biomedik"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "BENING AYUMI ALILATULBARIZA",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Perpustakaan"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "HASIFA ZAYSHA ALBANY",
        jenjang: "S1 Reguler",
        prodi: "Kesehatan Lingkungan"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "I KOMANG GOPAL DAVINSI",
        jenjang: "S1 Reguler",
        prodi: "Biologi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "AISHA RAHMA ALIA",
        jenjang: "S1 Reguler",
        prodi: "Kesehatan Masyarakat"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ANIS SHAFA NABILLAH",
        jenjang: "S1 Reguler",
        prodi: "Kimia"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MICHELLE AMORE SUTANTO",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Hubungan Internasional"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MUHAMMAD KHALIFAH ISLAM",
        jenjang: "S1 Reguler",
        prodi: "Fisika"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "DEEBA MASOON TAUFAN",
        jenjang: "S1 Reguler",
        prodi: "Biologi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "FELIX MANNUELA",
        jenjang: "S1 Reguler",
        prodi: "Geologi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "HASNA KHAIRUNNISA",
        jenjang: "S1 Reguler",
        prodi: "Kimia"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "KEVIN ANANTA MUHAMMAD",
        jenjang: "S1 Reguler",
        prodi: "Geologi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MUHAMMAD RIZKYANDRA",
        jenjang: "S1 Reguler",
        prodi: "Teknik Elektro"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "NADIA PUTRI SHAFINA",
        jenjang: "S1 Reguler",
        prodi: "Matematika"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "VIRALDI NARENDRA RAZALI",
        jenjang: "S1 Reguler",
        prodi: "Sistem Informasi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "AMMARA FAYYAZA ERMADI",
        jenjang: "Vokasi",
        prodi: "Penyiaran Multimedia"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "INTANIA ALVIANI PUTRI",
        jenjang: "S1 Reguler",
        prodi: "Farmasi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ELWEIK DINATA HALOHO",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Administrasi Negara"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "RAYMOND JULIUS PARDOSI",
        jenjang: "S1 Reguler",
        prodi: "Teknologi Bioproses"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "KHANSA CALISTA HENDRATNA",
        jenjang: "S1 Reguler",
        prodi: "Teknik Biomedik"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "QINTHARA ADYA KURNIAWAN",
        jenjang: "S1 Reguler",
        prodi: "Sistem Informasi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "FAIZAL CRESPO ATHALLAH",
        jenjang: "S1 Reguler",
        prodi: "Geologi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MUFTI GUSNAWAN DARMAJI",
        jenjang: "S1 Reguler",
        prodi: "Kimia"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "RAFITYAN HAIRASYADA",
        jenjang: "S1 Reguler",
        prodi: "Sastra Jepang"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MARSHA DIVINA AMARIS PUTRI GUNAWAN",
        jenjang: "S1 Reguler",
        prodi: "Sastra Inggris"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "DHIAUZIDNI ALFARIZI",
        jenjang: "S1 Reguler",
        prodi: "Farmasi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MUHAMMAD IZZAN",
        jenjang: "S1 Reguler",
        prodi: "Matematika"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MAGHFIRA HANA FAIRUZA SIPAHUTAR",
        jenjang: "S1 Reguler",
        prodi: "Kimia"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MUHAMMAD DANDY RADITYO",
        jenjang: "S1 Reguler",
        prodi: "Teknik Industri"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "NABIILAH AULIA",
        jenjang: "S1 Reguler",
        prodi: "Arsitektur"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "VALERIAN HIZKIA EMMANUEL",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Komputer"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "PRIYANKA SALWA PUTRI PANDEY",
        jenjang: "S1 Reguler",
        prodi: "Pendidikan Dokter Gigi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "HILWA RAMADHANI",
        jenjang: "S1 Reguler",
        prodi: "Sastra Inggris"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "HARIS FADILLAH",
        jenjang: "S1 Reguler",
        prodi: "Sistem Informasi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "RAZAN MUHAMMAD SALIM",
        jenjang: "S1 Reguler",
        prodi: "Sistem Informasi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "FATHIYYAH",
        jenjang: "S1 Reguler",
        prodi: "Farmasi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "EMILIO JUNINO RIZANVIDRI PAO",
        jenjang: "S1 Reguler",
        prodi: "Sistem Informasi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "FAIZAL RAMADHANI",
        jenjang: "S1 Reguler",
        prodi: "Sastra Rusia"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ZAHIRA NISRINA KINARI",
        jenjang: "Vokasi",
        prodi: "Administrasi Asuransi dan Aktuaria \t"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "JOANNE KENISA ADELINA LIMENA",
        jenjang: "S1 Reguler",
        prodi: "Psikologi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "RAISYA HANIFA",
        jenjang: "S1 Reguler",
        prodi: "Farmasi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ATHIRAH NURUSHAFHAH",
        jenjang: "S1 Reguler",
        prodi: "Kesehatan Masyarakat"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "HAZETA RAHMANI WAFDA",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Komputer"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MUHAMMAD RAFI GHALIB FIDELIGO",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Komputer"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "AMIRA RAISA KHAYRANI",
        jenjang: "S1 Reguler",
        prodi: "Teknik Biomedik"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "NUR AISHA KINANIA VISKA",
        jenjang: "S1 Reguler",
        prodi: "Kesehatan Masyarakat"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "REGITA SALSABILA",
        jenjang: "S1 Reguler",
        prodi: "Farmasi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "SHABRINA NUR MUTIA M.",
        jenjang: "S1 Reguler",
        prodi: "Sastra Cina"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MUTIARA RAHAYU",
        jenjang: "S1 Reguler",
        prodi: "Kimia"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "SATRIYO NUR HIDAYAT",
        jenjang: "S1 Reguler",
        prodi: "Statistika"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "NAJLA MUKHBITA KHAIRUNISA",
        jenjang: "S1 Reguler",
        prodi: "Arsitektur Interior"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MUHAMMAD RIZFAN NASHIFI",
        jenjang: "S1 Reguler",
        prodi: "Kesehatan Masyarakat"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ZHAAFIR ARIIQ AS SHIDQII",
        jenjang: "S1 Reguler",
        prodi: "Fisika"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "OLIVIA ERLINDA AGATHA MANALU",
        jenjang: "S1 Reguler",
        prodi: "Geologi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "RICARDO GAVINO MAHADI",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Aktuaria"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MAYZA SADZWINA NURYONO",
        jenjang: "S1 Reguler",
        prodi: "Teknik Elektro"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ATI TRI APRILIANTI",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Keperawatan"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "SAFIRA PUTRI KHOIRUNNISAA",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Keperawatan"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "AFIF RABBANI MUHAMMAD TAHIR",
        jenjang: "S1 Reguler",
        prodi: "Geografi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "NURUL KHALIDA",
        jenjang: "S1 Reguler",
        prodi: "Farmasi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "DYLAN PIRADE PONGLABBA",
        jenjang: "S1 Reguler",
        prodi: "Sistem Informasi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ARZETY ANAS AISAH",
        jenjang: "S1 Reguler",
        prodi: "Kesehatan Masyarakat"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "SYEKHAN HAKIM WIJAYA",
        jenjang: "Vokasi",
        prodi: "Administrasi Asuransi dan Aktuaria \t"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "NAA'ILA FAIRUZ ADYNDA",
        jenjang: "S1 Reguler",
        prodi: "Teknik Industri"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "JENNIFER WIDJAJA",
        jenjang: "S1 Reguler",
        prodi: "Farmasi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "FARREL ARDAN WIBOWO",
        jenjang: "S1 Reguler",
        prodi: "Teknik Lingkungan"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MUHAMMAD RAY ISLAMY",
        jenjang: "S1 Reguler",
        prodi: "Geografi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "JUNDI AHMAD NAUFAL",
        jenjang: "S1 Reguler",
        prodi: "Teknik Metalurgi & Material"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "SAHILA KHAIRATUL ATHIA",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Komputer"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "FAVIAN MUHAMMAD RASYAD RESWARA",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Komputer"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ADELIA PUTRI AZ-ZAHRA",
        jenjang: "S1 Reguler",
        prodi: "Farmasi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "GUSTI NIERA FITRI ALIFA",
        jenjang: "S1 Reguler",
        prodi: "Sistem Informasi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "RISDAN SHIDQIA KOMARA",
        jenjang: "Vokasi",
        prodi: "Administrasi Asuransi dan Aktuaria \t"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MUHAMMAD FAKHRI HAKEEM",
        jenjang: "S1 Reguler",
        prodi: "Geografi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "TISHA NADA CHOIRUNNISA",
        jenjang: "D4",
        prodi: "Fisioterapi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ZAHRA SOFYANDRI",
        jenjang: "S1 Reguler",
        prodi: "Kimia"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "FANNAN FAHMI BAHWAL",
        jenjang: "S1 Reguler",
        prodi: "Fisika"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ARYA NOVALINO PRATAMA",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Komputer"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "NAURA CEYLO SIKARINI SUWARDA",
        jenjang: "S1 Reguler",
        prodi: "Teknik Elektro"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "KYLA ADISTI MARITZA",
        jenjang: "S1 Reguler",
        prodi: "Teknik Industri"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "AGNES FEBYOLA SITORUS",
        jenjang: "S1 Reguler",
        prodi: "Kesehatan Masyarakat"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "NADINE ZAHRA ANINDYA",
        jenjang: "S1 Reguler",
        prodi: "Pendidikan Dokter Gigi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "RATRI ANINDYA PUTRI",
        jenjang: "S1 Reguler",
        prodi: "Kimia"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "SULTHAN OMAR RASHID",
        jenjang: "Vokasi",
        prodi: "Administrasi Perpajakan"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "NABIEL KHAIVA RAMADHANA",
        jenjang: "S1 Reguler",
        prodi: "Geografi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MUHAMMAD IKHSAN ZHAHIR",
        jenjang: "Vokasi",
        prodi: "Administrasi Asuransi dan Aktuaria \t"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "JEREMIA K. IMANUEL SILITONGA",
        jenjang: "S1 Reguler",
        prodi: "Geologi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "NADIVA ALVIE PUTRI JELITA",
        jenjang: "S1 Reguler",
        prodi: "Pendidikan Dokter Gigi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ANINDYRA DWI PUSPITAYUDA NENGTYAS",
        jenjang: "S1 Reguler",
        prodi: "Teknik Metalurgi & Material"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "GHOZAM MULIAWAN SHOLIHIN",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Komputer"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "DWI RAHMA AQILAH",
        jenjang: "S1 Reguler",
        prodi: "Pendidikan Dokter Gigi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "RAIDA KHOYYARA",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Komputer"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "RR. NASHITA RIETMADHANTY ANUGRAHA",
        jenjang: "S1 Reguler",
        prodi: "Psikologi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "CETTA GANTARI ARUNDATI",
        jenjang: "S1 Reguler",
        prodi: "Arsitektur Interior"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "RUSDA LINTANG TRIKINASIH",
        jenjang: "S1 Reguler",
        prodi: "Farmasi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "KELLEY KIRANA BASHIRA ABIDA",
        jenjang: "S1 Reguler",
        prodi: "Kesehatan Masyarakat"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "RIANDI FAZLI SETIAWAN",
        jenjang: "Vokasi",
        prodi: "Administrasi Asuransi dan Aktuaria \t"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "RAHCMA ANNISA ZHAFIRAH",
        jenjang: "Vokasi",
        prodi: "Administrasi Rumah Sakit"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "KENIA ALISYA MALAHAYATI",
        jenjang: "S1 Reguler",
        prodi: "Sistem Informasi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "KAYLA AKIRA MAULANA",
        jenjang: "S1 Reguler",
        prodi: "Kesehatan Masyarakat"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "SAVANA TZALTZA MILLA",
        jenjang: "S1 Reguler",
        prodi: "Farmasi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "FAIZ FADHIL ARROYYAN",
        jenjang: "S1 Reguler",
        prodi: "Pendidikan Dokter"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "TASCHA YASMINE NADA",
        jenjang: "S1 Reguler",
        prodi: "Biologi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "NICODEMUS SIMBOLON",
        jenjang: "S1 Reguler",
        prodi: "Farmasi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "KEIRA LIVANA RANGKUTI",
        jenjang: "S1 Reguler",
        prodi: "Farmasi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "INDRI PANGASTUTI",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Hubungan Internasional"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "NAUBILLA CHAERANA NISA",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Aktuaria"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "NADINE SAMIYA RAHMADHANI",
        jenjang: "S1 Reguler",
        prodi: "Farmasi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MUHAMMAD CAHYA NUHA",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Administrasi Niaga"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "KHAIRA HANIYAH RIFANI",
        jenjang: "S1 Reguler",
        prodi: "Studi Gizi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "NOOR HANIFAH ARULIYANTO",
        jenjang: "Vokasi",
        prodi: "Administrasi Asuransi dan Aktuaria \t"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "EMILIANA NAJWA ABAS",
        jenjang: "S1 Reguler",
        prodi: "Teknik Sipil"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ANNISA PUTRI SAHIRAH",
        jenjang: "S1 Reguler",
        prodi: "Arsitektur Interior"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MUHAMMAD BIMAMIRYKEL ANTRADA",
        jenjang: "S1 Reguler",
        prodi: "Teknik Perkapalan"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "EKA RISKY DEWI ANJANI",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Administrasi Negara"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ARIFA DIANTY",
        jenjang: "D4",
        prodi: "Manajemen Bisnis Pariwisata"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "DENNISA LATHIFA RAHIMA",
        jenjang: "S1 Reguler",
        prodi: "Studi Gizi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "NABILA CHRISTIANINGSIH",
        jenjang: "S1 Reguler",
        prodi: "Sastra Daerah untuk Sastra Jawa"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "SHAFA SALSABILA RUSDHIANKASA",
        jenjang: "D4",
        prodi: "Manajemen Bisnis Pariwisata"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "DANISH MUHAMMAD PUTRA AMIFTAMA",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Hubungan Internasional"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MUHAMMAD FARIS RAZAN",
        jenjang: "D4",
        prodi: "Manajemen Rekod dan Arsip"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "TASYA BENITA A. SARAGIH",
        jenjang: "Vokasi",
        prodi: "Hubungan Masyarakat"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "DAMARA FAYOLA",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Kesejahteraan Sosial"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ANNISA RAHMA AULIA",
        jenjang: "S1 Reguler",
        prodi: "Sastra Arab"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ALYSSA NINDHITAMI SETYODARMADI",
        jenjang: "S1 Reguler",
        prodi: "Sastra Cina"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "NASYILA MULYA PUTRI",
        jenjang: "S1 Reguler",
        prodi: "Manajemen"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "JOVANYA NOWELA",
        jenjang: "D4",
        prodi: "Manajemen Rekod dan Arsip"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "FERA SAJIDAH",
        jenjang: "S1 Reguler",
        prodi: "Sosiologi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "DINDA AZ ZAHRA DAMAYANTI",
        jenjang: "S1 Reguler",
        prodi: "Kesehatan Lingkungan"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "YEZAK DAMAR SALIM",
        jenjang: "D4",
        prodi: "Fisioterapi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "LAILI FADHIILAH ZAIN",
        jenjang: "S1 Reguler",
        prodi: "Sastra Daerah untuk Sastra Jawa"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ALYSSA NASYAVIRA WIBOWO",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Administrasi Fiskal"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ANGGI PATRESYA BR SEMBIRING",
        jenjang: "S1 Reguler",
        prodi: "Sastra Jerman"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "SIRHAN AJRIYA HASYA",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Administrasi Niaga"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "JUAN HENDRY",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Kesejahteraan Sosial"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "JOHANANDA HAPPY YANI",
        jenjang: "S1 Reguler",
        prodi: "Arkeologi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "AFIDLU JIHAN ULYA",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Administrasi Fiskal"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "RACHEL DEVANIA NATURE",
        jenjang: "D4",
        prodi: "Bisnis Kreatif"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "RYAN ABIEM PRAKOSO",
        jenjang: "Vokasi",
        prodi: "Penyiaran Multimedia"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "NOVIA FITRA AZIZIA",
        jenjang: "D4",
        prodi: "Produksi Media"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "NUR NABILA DITISYA",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Administrasi Niaga"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "NABILA LA'SALINA ZAMZAMI",
        jenjang: "S1 Reguler",
        prodi: "Psikologi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ENRIZTITO YOVANDRA",
        jenjang: "Vokasi",
        prodi: "Administrasi Perpajakan"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "HILMI REZKY HAKIM",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Filsafat"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "SYAHNAZ MAURA KALISA",
        jenjang: "S1 Reguler",
        prodi: "Psikologi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "RENATA ELISA PATRICIA SIMAMORA",
        jenjang: "S1 Reguler",
        prodi: "Psikologi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "DAFFA RASHID KURNIAWAN",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Administrasi Niaga"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "NABILA AYU RACHEL ARNASTA",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Administrasi Fiskal"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "DOROTHEA CHRIST DRUPADI",
        jenjang: "Vokasi",
        prodi: "Periklanan Kreatif"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MAJDUDDIN MAR'I PRATOMO",
        jenjang: "D4",
        prodi: "Manajemen Bisnis Pariwisata"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "TSAQIIFA NAZHMAA 'USHAIYYAH SANJAYA",
        jenjang: "S1 Reguler",
        prodi: "Kimia"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "REKA DEVANDRA ROESMANTORO",
        jenjang: "S1 Reguler",
        prodi: "Sastra Belanda"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ADINDA KEYSHA ARYA RAMADHANI",
        jenjang: "S1 Reguler",
        prodi: "Kimia"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "FANDY AL RASYID",
        jenjang: "S1 Reguler",
        prodi: "Antropologi Sosial"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ANANDA ZHAFIRAH",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Administrasi Negara"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "FATEKHA ZASIFA RAHMATUL HAAF",
        jenjang: "Vokasi",
        prodi: "Administrasi Perkantoran"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "HAKIM CENDIKIA SAMPUTRA",
        jenjang: "S1 Reguler",
        prodi: "Sastra Inggris"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "KENISHA ANDREANA NETHANIAH INTAN",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Administrasi Fiskal"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "VIVI ARUMITA SARI",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Administrasi Fiskal"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "DARIA MAHESWARI",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Administrasi Fiskal"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "FIKI RAMA KIANDRA",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Hukum"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "AHMAD NUGRAHA",
        jenjang: "S1 Reguler",
        prodi: "Sastra Daerah untuk Sastra Jawa"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MUTIARA NUR AINI KHARIROH",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Sejarah"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "WENDI PRATAMA",
        jenjang: "S1 Reguler",
        prodi: "Antropologi Sosial"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "DOROTHY EVANGELINE IRENE",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Administrasi Niaga"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "KAYLA MELIA TJARDA",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Filsafat"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MUHAMMAD FIKRI AUSHAF WAFA",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Administrasi Negara"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "QUINSITA NAILA",
        jenjang: "Vokasi",
        prodi: "Hubungan Masyarakat"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MONICA CICILYA KUMOWAL",
        jenjang: "S1 Reguler",
        prodi: "Statistika"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "CLARISSA FAZA AUDRINA",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Administrasi Negara"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "REYSHA ASLAMIA ZAHRA",
        jenjang: "S1 Reguler",
        prodi: "Geografi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "AGUS MUFLIH NASUTION",
        jenjang: "S1 Reguler",
        prodi: "Kimia"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "AMRU KHAIRY MIRZATA",
        jenjang: "S1 Reguler",
        prodi: "Geofisika"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "IVANNES JULANDRO",
        jenjang: "Vokasi",
        prodi: "Administrasi Asuransi dan Aktuaria \t"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "LIBERTA ARIFA JUELBA FATAH",
        jenjang: "Vokasi",
        prodi: "Periklanan Kreatif"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "KANIA SALSABILA",
        jenjang: "Vokasi",
        prodi: "Administrasi Keuangan dan Perbankan \t"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "REIKA ANASTASYA ROSELYN",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Perpustakaan"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "JOVITA RATUAURA",
        jenjang: "Vokasi",
        prodi: "Penyiaran Multimedia"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "RIZKITA THAHARA",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Administrasi Fiskal"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "KAMIILAH KARTIKA ANJANI GINTING",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Administrasi Fiskal"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "DIANDRA KAYLA SAVITRI",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Administrasi Negara"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "LULU RAFIFAH ALHAS",
        jenjang: "S1 Reguler",
        prodi: "Akuntansi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "NURUL HIDAYAH",
        jenjang: "S1 Reguler",
        prodi: "Geografi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "NICOLAWS PERNANDO SIANTURI",
        jenjang: "Vokasi",
        prodi: "Administrasi Asuransi dan Aktuaria \t"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "AUNURRAFIQ AL FARUQI",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Sejarah"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "HANA KESYA RICE MANURUNG",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Administrasi Negara"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "TAQIA KAMILLA PUTRI",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Administrasi Fiskal"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "FAYZA MEIFIRA",
        jenjang: "S1 Reguler",
        prodi: "Sastra Belanda"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "EVAN SETIAWAN",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Administrasi Niaga"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "HANANTA RAMADITYA",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Hukum"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "LUH DWI PUTRI YULIASTITI",
        jenjang: "S1 Reguler",
        prodi: "Bahasa dan Kebudayaan Korea"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "TANYA PAZ VEGA AZ ZAHRA",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Kesejahteraan Sosial"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "JANELIA DIAN LATIFA",
        jenjang: "S1 Reguler",
        prodi: "Psikologi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "RAMZI ALKAUTSAR LUBIS",
        jenjang: "S1 Reguler",
        prodi: "Antropologi Sosial"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "CALLISTA SALSABILLA MUTIARA LAMURVIE",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Administrasi Niaga"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "FERDYNANT OKTOVIANES SUGI",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Politik"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ANIDYA PADMARANI",
        jenjang: "Vokasi",
        prodi: "Periklanan Kreatif"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "NADIMA HUSEN ABDAT",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Hukum"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "VICTORIA CORRYANI SASABONE",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Kesejahteraan Sosial"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "BRILLIANT ROZZAQ WIBOWO",
        jenjang: "D4",
        prodi: "Manajemen Rekod dan Arsip"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "AHMAD ALFATSANI",
        jenjang: "S1 Reguler",
        prodi: "Sastra Arab"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MUHAMMAD SULTHAN FIRDAUS IRAWAN",
        jenjang: "S1 Reguler",
        prodi: "Keselamatan & Kesehatan Kerja"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "FINA DELLIA AMANY",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Administrasi Negara"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "GLADYS EUNIKE PRITANIA",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Hukum"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "FAHRI AKBAR AMARULLAH",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Sejarah"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ROJA DAFFASYA SUDJATMIKO",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Administrasi Fiskal"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "SYAHROZAD ZALFA NADIA",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Hubungan Internasional"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "NAYLA MONICA KELBULAN",
        jenjang: "S1 Reguler",
        prodi: "Sastra Belanda"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MALIKA ARSANDA RARASTANAYA",
        jenjang: "S1 Reguler",
        prodi: "Keselamatan & Kesehatan Kerja"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "FARREL JUSTINE",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Hukum"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MARVIN KEMAL ARMANSYAH",
        jenjang: "S1 Reguler",
        prodi: "Kriminologi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "HANNA ANEIRA HANIFA",
        jenjang: "S1 Reguler",
        prodi: "Sastra Cina"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "PUTI DINANTI",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Perpustakaan"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "INDIRA MAHARANI PUTRI",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Administrasi Fiskal"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MUHAMMAD ARIEL",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Ekonomi Islam"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "SANDIKA AGNESIA CAREVA SIGALINGGING",
        jenjang: "Vokasi",
        prodi: "Periklanan Kreatif"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "SUCI NURMALA",
        jenjang: "Vokasi",
        prodi: "Administrasi Keuangan dan Perbankan \t"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ELANG RAHDITE PAKSI",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Hukum"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ALVIN CANDRA SURYA PRATAMA",
        jenjang: "S1 Reguler",
        prodi: "Sastra Indonesia"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ZAHRA HANIFAH",
        jenjang: "S1 Reguler",
        prodi: "Sastra Jepang"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ANA RAHMADHANI",
        jenjang: "S1 Reguler",
        prodi: "Sastra Inggris"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MUHAMMAD RIVALDI KABAH",
        jenjang: "S1 Reguler",
        prodi: "Sastra Arab"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "FRANSISCA ULI AGUSTINE SIMANJUNTAK",
        jenjang: "S1 Reguler",
        prodi: "Antropologi Sosial"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "DANIA LARASATI",
        jenjang: "D4",
        prodi: "Manajemen Bisnis Pariwisata"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ZAHRA SRI RAMADIANTI",
        jenjang: "S1 Reguler",
        prodi: "Sastra Rusia"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "OLIVIA CALISTA SETIAWAN",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Administrasi Niaga"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "SYAIRA FIRDAUSY AZZHAVIRA",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Ekonomi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "NAILA AMANDA SEFULLOH",
        jenjang: "Vokasi",
        prodi: "Administrasi Perkantoran"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ZAINAH NURHAYATI",
        jenjang: "S1 Reguler",
        prodi: "Keselamatan & Kesehatan Kerja"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "NALENDRA BIMASENA DIMAS RITZKY WIWEKO",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Administrasi Fiskal"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ARTA ULY BR NAINGGOLAN",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Administrasi Niaga"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "GILBRAN RAMADHANI ZAKYA",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Administrasi Fiskal"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "LUTHFI DAFFA FRASTYAWAN",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Administrasi Negara"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MUHAMMAD SAYYID FAKHRI",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Administrasi Fiskal"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "CATRADENA ALMIZAN",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Filsafat"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ADRIAN MOECHAMADSJAH SANTOSO",
        jenjang: "S1 Reguler",
        prodi: "Sastra Jerman"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "REVALINA RAHMA ZULFANI",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Administrasi Negara"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "CAHYA MAYSHA AMARA KUSNADI",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Politik"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "RADHITYA KISWORO",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Administrasi Niaga"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "NUURI HAFIDZA QUR'ANI RIDWAN",
        jenjang: "D4",
        prodi: "Manajemen Bisnis Pariwisata"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "CINDY DEBORA BESTAIDA NADAPDAP",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Politik"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "AZIZA GANIYA CANDRANINGTYAS",
        jenjang: "D4",
        prodi: "Produksi Media"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "SABRINA AZZAHRA ABIMAYA",
        jenjang: "Vokasi",
        prodi: "Periklanan Kreatif"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ANDRIAN CAHYO NUGROHO",
        jenjang: "S1 Reguler",
        prodi: "Sastra Daerah untuk Sastra Jawa"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MAULIDA ZAHRA",
        jenjang: "S1 Reguler",
        prodi: "Biologi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "BUDHIYATNA SOFIAN",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Administrasi Fiskal"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "AURELIA MIKA AZZAHRA",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Kesejahteraan Sosial"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MELLANIA AYU TASYA",
        jenjang: "Vokasi",
        prodi: "Akuntansi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "CHRISTIANE CHARISMA NATALIE SITUMORANG",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Perpustakaan"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "BERLIAN CIPTANING HUTAMI",
        jenjang: "S1 Reguler",
        prodi: "Biologi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ALYSSA PUTRI MAHARANI",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Kesejahteraan Sosial"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "CEMERLANG NAJLA KHANSA",
        jenjang: "S1 Reguler",
        prodi: "Bisnis Islam"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ADINDA AYU LARASATI",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Administrasi Fiskal"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "LUNA MUKTI FITRI ANJANI",
        jenjang: "S1 Reguler",
        prodi: "Antropologi Sosial"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MARIA YASINTHA AYUNINGTYAS SEKARSARI WAHYONO",
        jenjang: "S1 Reguler",
        prodi: "Sastra Indonesia"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MUTIARA AUDRI KAUTSARI",
        jenjang: "D4",
        prodi: "Manajemen Rekod dan Arsip"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "NABILLA HADIYANTI",
        jenjang: "S1 Reguler",
        prodi: "Akuntansi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "A. NABILA ZAHIRA CHALYSAH",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Politik"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MUHAMMAD AFRIZA ARDYARIFQI",
        jenjang: "S1 Reguler",
        prodi: "Geografi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "LAILA ZAKIA",
        jenjang: "S1 Reguler",
        prodi: "Sastra Daerah untuk Sastra Jawa"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "NIMAS WAHYU LAKSONO",
        jenjang: "S1 Reguler",
        prodi: "Sastra Daerah untuk Sastra Jawa"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "CATHRINE OLIVIANI GINTING",
        jenjang: "S1 Reguler",
        prodi: "Psikologi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MOHAMMAD SYAHRUL ROMADHONNI",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Sejarah"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MARTHA BEATRIX MANO",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Hubungan Internasional"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MARCELLINO ISAAC",
        jenjang: "S1 Reguler",
        prodi: "Manajemen"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "JUAN SEBASTIAN PARASI HUTAJULU",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Hukum"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ELISABETH CATHARINA SITANGGANG",
        jenjang: "Vokasi",
        prodi: "Administrasi Perpajakan"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "KHALISA ULITA MARBUN",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Kesejahteraan Sosial"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "AHMAD VALIANT PRAWIRATAMA",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Filsafat"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ANNIDA RAHMA AFRILIA",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Kesejahteraan Sosial"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "AINUN NAJIBAH",
        jenjang: "S1 Reguler",
        prodi: "Sastra Daerah untuk Sastra Jawa"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MUHAMMAD ABRAR FIRDAUS",
        jenjang: "D4",
        prodi: "Manajemen Bisnis Pariwisata"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ASHA ZAHRA",
        jenjang: "S1 Reguler",
        prodi: "Sastra Perancis"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "CHRISTOPHER NICHOLAS BUDIMAN",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Ekonomi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "DEIDRE AURA VIENNA",
        jenjang: "D4",
        prodi: "Manajemen Rekod dan Arsip"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "AINIYYAH ZAHRA AQILAH",
        jenjang: "S1 Reguler",
        prodi: "Psikologi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "KHANSA LUANA",
        jenjang: "Vokasi",
        prodi: "Administrasi Perkantoran"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ANNISA JULIA ZHAPIRA ALFIRDAUS",
        jenjang: "S1 Reguler",
        prodi: "Sastra Perancis"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "FICO ALFONSIUS DJONG",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Ekonomi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "HANUM SAHITA SALSABILA",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Administrasi Negara"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "NATHANIA JESSICA PARDOSI",
        jenjang: "S1 Reguler",
        prodi: "Psikologi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ANDREA LEVINA RACHMAN",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Kesejahteraan Sosial"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MUHAMMAD FARHAN",
        jenjang: "S1 Reguler",
        prodi: "Sastra Cina"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MUHAMMAD TAQIYUDDIN S.H.",
        jenjang: "S1 Reguler",
        prodi: "Sosiologi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "R.A. SYAKIRAH NAZHIFA RIZKIANSYAH",
        jenjang: "Vokasi",
        prodi: "Administrasi Asuransi dan Aktuaria \t"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "CHRISTIAN SUSANTO",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Administrasi Negara"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "TEEJEY JOWINA LEROA GIANETTI",
        jenjang: "S1 Reguler",
        prodi: "Psikologi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "FARHAN PURNAMA",
        jenjang: "S1 Reguler",
        prodi: "Sastra Jepang"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "CAHAYA BILHAKA",
        jenjang: "S1 Reguler",
        prodi: "Sastra Inggris"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MUHAMMAD RAFI IZZA NUGRAHA",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Politik"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "NADIA PRADNYA SHINTA",
        jenjang: "S1 Reguler",
        prodi: "Psikologi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "DEVITA DWI WIDYANTI",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Ekonomi Islam"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "DINAR MUTIARA FATIHAH BUDIARKO",
        jenjang: "S1 Reguler",
        prodi: "Sastra Belanda"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "AQILA KEIRA SHOKUVA",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Sejarah"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "TEUKU FACHRI ALFARIZI",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Ekonomi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "NABIEL LATHIFA ANJRAH",
        jenjang: "S1 Reguler",
        prodi: "Sastra Jerman"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MUHAMMAD FARRAS AULIA",
        jenjang: "S1 Reguler",
        prodi: "Bisnis Islam"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "CINTYA LISTYANI",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Administrasi Fiskal"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "HASNA HUMAIRA PUTRI ALIMAH",
        jenjang: "S1 Reguler",
        prodi: "Arkeologi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "KEIRA CHIKA ZHAHIRAH",
        jenjang: "S1 Reguler",
        prodi: "Akuntansi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "RAFA ARDI PRAYATA",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Administrasi Niaga"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MUHAMMAD SYAUQI KHOIRONI",
        jenjang: "S1 Reguler",
        prodi: "Sastra Rusia"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "AFLAH MAISAPUTRA",
        jenjang: "S1 Reguler",
        prodi: "Geografi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MARCELLA PHILIA AURORA TAMBUNAN",
        jenjang: "Vokasi",
        prodi: "Penyiaran Multimedia"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "RAYRA SILVA",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Perpustakaan"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "NINDY DHIYA AYU PUSPITA",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Keperawatan"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "TERESA",
        jenjang: "Vokasi",
        prodi: "Penyiaran Multimedia"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MOHAMMAD REXADLI JUNIAGSAN",
        jenjang: "S1 Reguler",
        prodi: "Sosiologi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "SITI KHAIRUNNISA",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Keperawatan"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ALYA ZAIN EFFENDY",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Administrasi Fiskal"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "FELISYA ADINDA PUTRI",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Sejarah"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "FERNANDO DEREN MANANDA",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Administrasi Negara"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MUHAMMAD HAFIZH AL GHIFFARI",
        jenjang: "S1 Reguler",
        prodi: "Sastra Arab"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "CANDRAGITA DHIYANISA WIBOWO",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Administrasi Niaga"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "AMIRUL HAIKAL WIRA AKHLIS",
        jenjang: "S1 Reguler",
        prodi: "Teknik Sipil"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "DYVTA ISLAMY ALMIKA",
        jenjang: "S1 Reguler",
        prodi: "Manajemen"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "WILDAN TAMA NUGROHO PUTRA AKMALSYAH",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Administrasi Fiskal"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "KEISYA SHAFWA RAISA",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Hukum"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "NAAILA MAHIRA",
        jenjang: "Vokasi",
        prodi: "Hubungan Masyarakat"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "FIGRY YUDIKA",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Hukum"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "GABRIELLA JESSICA AYUSITA",
        jenjang: "S1 Reguler",
        prodi: "Kriminologi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MAHDI FARRAS MADANI",
        jenjang: "S1 Reguler",
        prodi: "Statistika"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MARIO HERMAWAN SETIADI",
        jenjang: "Vokasi",
        prodi: "Administrasi Perpajakan"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "NADIA MUMTAZ HILMIYA",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Komunikasi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "SHADRINA FAKHRANA",
        jenjang: "S1 Reguler",
        prodi: "Kesehatan Masyarakat"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "NOOR A'ISYAH",
        jenjang: "Vokasi",
        prodi: "Administrasi Perkantoran"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MUHAMMAD FARRAS FADHILAH HASAN",
        jenjang: "D4",
        prodi: "Manajemen Bisnis Pariwisata"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "RAFFIANDRA ATHAYA IHSAN",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Administrasi Niaga"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MUHAMMAD ATTAR SATYA PRATAMA",
        jenjang: "S1 Reguler",
        prodi: "Sastra Jepang"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "FADEL AL-SYAUQI DJAMASWAR",
        jenjang: "S1 Reguler",
        prodi: "Kesehatan Masyarakat"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "AMANDA PUTRI FEBRIYANTI",
        jenjang: "Vokasi",
        prodi: "Administrasi Keuangan dan Perbankan \t"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "AULIA RIZQIKA NUGROHO",
        jenjang: "S1 Reguler",
        prodi: "Antropologi Sosial"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "JOVELINE GRACE NATALIE",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Hukum"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "NAOURAHESA RAMADHANI SAR'IE",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Komunikasi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "VANESSA ANGLIVIA DIMITRY",
        jenjang: "S1 Reguler",
        prodi: "Antropologi Sosial"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "EMMA NAJMI KHAIRNA",
        jenjang: "Vokasi",
        prodi: "Penyiaran Multimedia"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MUHAMMAD FAYYAZ ALBUCHORI",
        jenjang: "S1 Reguler",
        prodi: "Antropologi Sosial"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "STEPHANIE ELIZA CLARA",
        jenjang: "S1 Reguler",
        prodi: "Akuntansi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MASTIADI PUTRA",
        jenjang: "Vokasi",
        prodi: "Administrasi Keuangan dan Perbankan \t"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "RENATA ALISYA",
        jenjang: "Vokasi",
        prodi: "Hubungan Masyarakat"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "SENYA MEGA ELISHABET",
        jenjang: "S1 Reguler",
        prodi: "Manajemen"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "KHALISHAH AHMAD NUR AQILAH",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Hukum"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MUHAMMAD ALGHIFARI ABIMANYU PRAYOGI",
        jenjang: "D4",
        prodi: "Manajemen Rekod dan Arsip"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "SYFANI HANAZAHWA WIBOWO",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Kesejahteraan Sosial"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ROSE LATIFA JO",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Politik"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MUHAMMAD FAUZAN SAALA",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Administrasi Negara"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "HABIB BURAHIM",
        jenjang: "Vokasi",
        prodi: "Administrasi Keuangan dan Perbankan \t"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "NING RATIH NEDIFA",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Ekonomi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ZAFIRA DEWIKIRANA",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Administrasi Negara"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "NI KOMANG CHEALSEA CITRA S",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Administrasi Niaga"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MICHELLE ANDRIA",
        jenjang: "S1 Reguler",
        prodi: "Sastra Belanda"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "NUR RAHMA PUTRI",
        jenjang: "S1 Reguler",
        prodi: "Kesehatan Masyarakat"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "SYAFIK AMRULLOH",
        jenjang: "Vokasi",
        prodi: "Administrasi Rumah Sakit"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "SYIFA HANA SYAHIRAH",
        jenjang: "S1 Reguler",
        prodi: "Geologi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "NAUFAL AMMAR PUTRA PRIBADI",
        jenjang: "S1 Reguler",
        prodi: "Sastra Daerah untuk Sastra Jawa"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "SHAFA'NUR HANIYYAH",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Administrasi Negara"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "UMMI AZIZA RAMANIYA REZA",
        jenjang: "D4",
        prodi: "Produksi Media"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "SYIFA YUSRA",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Politik"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "IZAAZ DZAKI PRATISTA",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Politik"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "AIKA HAYYUMI",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Perpustakaan"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "RAMA KUSWARENDRA",
        jenjang: "S1 Reguler",
        prodi: "Arkeologi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "DHANI WIDYA WIRYAWAN",
        jenjang: "S1 Reguler",
        prodi: "Sastra Inggris"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MOHAMMAD DAIVA NOVANDA",
        jenjang: "D4",
        prodi: "Produksi Media"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "RIZKY AL KODRY HASIBUAN",
        jenjang: "S1 Reguler",
        prodi: "Kesehatan Lingkungan"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "NI KOMANG AMELIA VIRAJATI PUTRI",
        jenjang: "S1 Reguler",
        prodi: "Psikologi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "DEVINA NAILAH",
        jenjang: "S1 Reguler",
        prodi: "Arkeologi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "DEDY YUSUF SETIAWAN",
        jenjang: "Vokasi",
        prodi: "Akuntansi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "FAKIH HABIB DZULFIKAR",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Ekonomi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "STEVANI SEPNOMASI HONDRO",
        jenjang: "S1 Reguler",
        prodi: "Arkeologi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "CLEODISHA NAURA AFRILYA SETIADI",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Hukum"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MARSYAH NABILA PUTRI SASMITA",
        jenjang: "S1 Reguler",
        prodi: "Studi Gizi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "GRACE ROBINTANG DYSCRESIANA",
        jenjang: "S1 Reguler",
        prodi: "Sosiologi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MUHAMMAD AQILA MULKAN",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Kesejahteraan Sosial"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "BIMO ALIF HIDAYATULLAH",
        jenjang: "Vokasi",
        prodi: "Administrasi Perpajakan"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "FANIA THURRAYA FATAH",
        jenjang: "S1 Reguler",
        prodi: "Sosiologi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "AISYA SHAFIQA",
        jenjang: "S1 Reguler",
        prodi: "Sastra Jepang"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "NAJMA SHAALIHAH",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Komunikasi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "TA'IF AL RAYYAN",
        jenjang: "S1 Reguler",
        prodi: "Kriminologi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "TABINA MULYA RIZKY",
        jenjang: "S1 Reguler",
        prodi: "Geofisika"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "RYAN ARDRI EKA PUTRA",
        jenjang: "S1 Reguler",
        prodi: "Psikologi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "CATHELEA REGITA IENA",
        jenjang: "S1 Reguler",
        prodi: "Matematika"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "WENI HANIYAH OKTOVANI",
        jenjang: "Vokasi",
        prodi: "Administrasi Rumah Sakit"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "FAIQ FAIQOH YASMIN",
        jenjang: "Vokasi",
        prodi: "Penyiaran Multimedia"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "NOVTIA ANUGRAH SIRAIT",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Kesejahteraan Sosial"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "NAJWA AININ SAKINAH",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Administrasi Negara"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "DANI WICAKSONO",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Ekonomi Islam"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "RAYYA UMMARA LUBIS",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Administrasi Negara"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "AZRIEL FARHAN ABDUROHMAN",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Politik"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "LIDWINA RIAVIERNA PRABANDARI",
        jenjang: "S1 Reguler",
        prodi: "Antropologi Sosial"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "IBNU PRAYOGA",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Administrasi Fiskal"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "CHELSEA RUTH TOGATOROP",
        jenjang: "S1 Reguler",
        prodi: "Akuntansi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "KAYARA TALITHA",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Komunikasi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "SYAFIQ RAHMATULLAH WIJAYA",
        jenjang: "Vokasi",
        prodi: "Administrasi Keuangan dan Perbankan \t"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "RAIHAN WIDYA AHMAD",
        jenjang: "S1 Reguler",
        prodi: "Sastra Daerah untuk Sastra Jawa"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "AISYA RAHMA",
        jenjang: "S1 Reguler",
        prodi: "Sastra Arab"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "GIANPAOLO HAMONANGAN SITOHANG",
        jenjang: "Vokasi",
        prodi: "Administrasi Keuangan dan Perbankan \t"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MUHAMMAD RAFAN SATRIAN",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Sejarah"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "TIARA ANDJANI PUSPITASARI",
        jenjang: "S1 Reguler",
        prodi: "Kesehatan Masyarakat"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "AZIZ HANAFI SAPUTRA",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Administrasi Fiskal"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "SORTA PARIDA MELINA",
        jenjang: "S1 Reguler",
        prodi: "Psikologi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "HAZEL ZHARFAN ANGGORO",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Administrasi Fiskal"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "LAVINA ARSYA LIYA",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Administrasi Fiskal"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "CAROLINE ELVANDRI SUPRIADI",
        jenjang: "D4",
        prodi: "Manajemen Rekod dan Arsip"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "DIMAS NUGRAHA",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Sejarah"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "HALIZA CHOLID",
        jenjang: "S1 Reguler",
        prodi: "Sastra Inggris"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "KHANSA NAZIFA N",
        jenjang: "S1 Reguler",
        prodi: "Sastra Belanda"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "AKILLA CAKRA MUKTI",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Administrasi Niaga"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MARECINTA MANNAMAGNAMAKNA WARDHANU",
        jenjang: "S1 Reguler",
        prodi: "Studi Gizi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "NABILA RAHMA PERTIWI",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Politik"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "PUTRI WINDI SRI KAHARANY",
        jenjang: "S1 Reguler",
        prodi: "Kesehatan Lingkungan"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "RATU ZEFNADALINNA RIONA BRILLIAN MANDE",
        jenjang: "S1 Reguler",
        prodi: "Antropologi Sosial"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "SKOLASTIKA RADIRA",
        jenjang: "S1 Reguler",
        prodi: "Sastra Perancis"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "AMIRA ZAHRA ARDHIARIANI",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Administrasi Negara"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "NABALAH DEFATA PUTRINDA",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Administrasi Negara"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "KEILA AZ ZAHRA",
        jenjang: "S1 Reguler",
        prodi: "Sastra Inggris"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MUHAMMAD RAYYAN TURNA",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Administrasi Fiskal"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "DEA ILMA AZZAHRA",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Administrasi Niaga"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ARGY FAWWAZ AKBAR",
        jenjang: "D4",
        prodi: "Manajemen Rekod dan Arsip"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "LEDA SHAKILA DELICIA",
        jenjang: "D4",
        prodi: "Manajemen Bisnis Pariwisata"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ASFA AZZAHRA PUTRI KURNIAWAN",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Administrasi Niaga"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ALVINA MARJORIE SUHENDRI",
        jenjang: "S1 Reguler",
        prodi: "Sastra Inggris"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MUHAMMAD FAWWAZ ALI MURTADHO",
        jenjang: "Vokasi",
        prodi: "Administrasi Keuangan dan Perbankan \t"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "FATIMAH AYU AZZAHRA",
        jenjang: "S1 Reguler",
        prodi: "Fisika"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "COLLINAUFAL RAFI EFENDI",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Politik"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "FAIZ FIROS FARID",
        jenjang: "S1 Reguler",
        prodi: "Sastra Rusia"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "FAIQ MUAWWAL",
        jenjang: "S1 Reguler",
        prodi: "Bisnis Islam"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "OLA MELINDA NUR HAPSARI",
        jenjang: "S1 Reguler",
        prodi: "Sosiologi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "RUBEN GIAN AGUSTIN",
        jenjang: "S1 Reguler",
        prodi: "Statistika"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "BONA VIDE SITOHANG",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Administrasi Fiskal"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "KAYLA FAKHIRAH YUNAZ",
        jenjang: "Vokasi",
        prodi: "Hubungan Masyarakat"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ZAHWA ZAHIRA RINDRA",
        jenjang: "Vokasi",
        prodi: "Administrasi Keuangan dan Perbankan \t"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ACHMAD YUSUF",
        jenjang: "S1 Reguler",
        prodi: "Sastra Jepang"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "SRI RAHAYU",
        jenjang: "S1 Reguler",
        prodi: "Sastra Cina"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "CINDY KAYLA HANIFAH TAMIN",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Administrasi Niaga"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ENAMELYA FARIZKA FIDA",
        jenjang: "S1 Reguler",
        prodi: "Sastra Perancis"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "AYSEL DAVITO HIDAYAT",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Administrasi Niaga"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MAOULA LOVIYEKA NUGRAHA",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Kesejahteraan Sosial"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "NADILA ANANDITA",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Administrasi Fiskal"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MUHAMMAD DAFFA",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Politik"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ADRELL NURAHMALIA KIRANA",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Hukum"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "FIRDZI FAYI KINASIH",
        jenjang: "S1 Reguler",
        prodi: "Sastra Jerman"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MUHAMMAD ZALFI ARTANABIL AFIF",
        jenjang: "S1 Reguler",
        prodi: "Manajemen"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MUHAMMAD RADITHYA IKHWANTO",
        jenjang: "S1 Reguler",
        prodi: "Manajemen"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "NAJWA AZZAUJA",
        jenjang: "S1 Reguler",
        prodi: "Bisnis Islam"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "IGNASIA RENATA ANRODRICA",
        jenjang: "S1 Reguler",
        prodi: "Kriminologi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ZAKI RAHMAN",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Ekonomi Islam"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "PUTRIANA SARI WIDYANI",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Keperawatan"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ALYA HARUMI AZZAHRA",
        jenjang: "S1 Reguler",
        prodi: "Psikologi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "NAJLA HILMIYA IFIAPUTRI",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Perpustakaan"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "TEZA TEGGAR ANDRIYAN",
        jenjang: "S1 Reguler",
        prodi: "Geofisika"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "CLARA ANINDITA WIKANINGTYAS ARIBOWO",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Administrasi Fiskal"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "FAKHIRA SAKINA HUSNA",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Politik"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MUHAMMAD ZHAV ALTHAF MAKARIM",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Hukum"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "KASIH AGATHA LOVELY PURBA",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Administrasi Negara"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "AHMAD TAUFIQ ILHAM",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Filsafat"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MUHAMMAD REZQY GHIFARI",
        jenjang: "Vokasi",
        prodi: "Akuntansi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "REZI CHAIRUNNISA",
        jenjang: "S1 Reguler",
        prodi: "Sastra Belanda"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "FAHIMA FARID",
        jenjang: "Vokasi",
        prodi: "Periklanan Kreatif"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "DZIKRA FAIZAL ABDAALA",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Administrasi Niaga"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "NAJMA MUMTAZ ISKANDAR",
        jenjang: "Vokasi",
        prodi: "Hubungan Masyarakat"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "AJI MUHAMAD BINTANG",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Administrasi Niaga"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "DESVITA ANGGRAINI NOOR",
        jenjang: "Vokasi",
        prodi: "Administrasi Rumah Sakit"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "DHEA ASHILLA LENDRA",
        jenjang: "D4",
        prodi: "Terapi Okupasi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "LOLITA DIVA PUSPITASARI",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Administrasi Niaga"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "SANIYA RAKHSYA DANISHARA",
        jenjang: "S1 Reguler",
        prodi: "Kesehatan Masyarakat"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "AZRA ARDELIA SHOFWAANA",
        jenjang: "S1 Reguler",
        prodi: "Sastra Inggris"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "SALWA ASSYIFA",
        jenjang: "Vokasi",
        prodi: "Penyiaran Multimedia"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MUHAMMAD ROISUL IMAM",
        jenjang: "S1 Reguler",
        prodi: "Sosiologi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "GRACE ESTHER SIMANGUNSONG",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Administrasi Niaga"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "KEZIA HELENA RINGU",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Administrasi Fiskal"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MOBBY RAHMAT AKBAR",
        jenjang: "S1 Reguler",
        prodi: "Sastra Jepang"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "RIDWAN AVIANDHITO PERMANA SAKTI",
        jenjang: "S1 Reguler",
        prodi: "Bahasa dan Kebudayaan Korea"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "RELIO DAFFA PAHREVI",
        jenjang: "S1 Reguler",
        prodi: "Manajemen"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MEISYA INDAH FAHIRA",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Hukum"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "SADDAM ATTALLAH JAMALUDIN",
        jenjang: "S1 Reguler",
        prodi: "Manajemen"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "NAYAKA ETHAN DAFFAPRATAMA",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Komunikasi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "HANA MUMTAZ SHALIMA",
        jenjang: "S1 Reguler",
        prodi: "Studi Gizi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "RANIYA QANITA SETIAWAN",
        jenjang: "Vokasi",
        prodi: "Administrasi Perpajakan"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "DIAMONDA IREY HAYFA ALEA",
        jenjang: "S1 Reguler",
        prodi: "Farmasi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "LIBNI SATRIA 'DELUIS",
        jenjang: "S1 Reguler",
        prodi: "Sastra Belanda"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "SAMEE HAFIYYAN FAZA",
        jenjang: "Vokasi",
        prodi: "Akuntansi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "REHUEL ONESYS MANULELO",
        jenjang: "S1 Reguler",
        prodi: "Sastra Indonesia"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "M. RAKHA ARYAGUNA",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Administrasi Negara"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "GENTA MAHATMA PUTERA",
        jenjang: "S1 Reguler",
        prodi: "Manajemen"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "BERNADETA ROSA IRVIANINGTYAS",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Administrasi Fiskal"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "RAYSHA JULINDRA PUTRI ALAM",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Administrasi Negara"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "SYAHDANIA AISYAH UMAYA SY",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Sejarah"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "SABRINA FELICIA NAULI SILALAHI",
        jenjang: "S1 Reguler",
        prodi: "Sastra Inggris"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "RADITYA IRAWAN",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Sejarah"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "KAYLA ALMA SHAVIERLA",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Kesejahteraan Sosial"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "TANGGUH HAIDARAIS CAHYOGENI",
        jenjang: "S1 Reguler",
        prodi: "Arkeologi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ABDUR RAHMAN NABIL",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Perpustakaan"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ANNISA FAUZIYYAH",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Administrasi Niaga"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "IRENE CAROLINE",
        jenjang: "S1 Reguler",
        prodi: "Akuntansi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MUHAMMAD IZZAN AL FARISI",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Ekonomi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "FILDZA ANINDITA",
        jenjang: "S1 Reguler",
        prodi: "Sastra Belanda"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "VANESIA AURORA SIRUMAPEA",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Administrasi Fiskal"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ABIMANYU RHESA REYHAN HUTAGAOL",
        jenjang: "S1 Reguler",
        prodi: "Sastra Cina"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "NADHIF ALLENDRA",
        jenjang: "S1 Reguler",
        prodi: "Sastra Jerman"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "AYU LESTARI WULAN BR GULTOM",
        jenjang: "S1 Reguler",
        prodi: "Kriminologi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MUHAMAD REYHAN IDFIANSYAH",
        jenjang: "S1 Reguler",
        prodi: "Sastra Indonesia"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "JOANNA CHRISANOVA PURBA",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Administrasi Niaga"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "FANESYA M. NOOR",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Kesejahteraan Sosial"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "DESTIN RAMADHANI",
        jenjang: "Vokasi",
        prodi: "Administrasi Perkantoran"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "SYAIMA IZZATUL JANNAH",
        jenjang: "S1 Reguler",
        prodi: "Sastra Arab"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "RAFAELA MALYA NIRWASITA SATRIO",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Ekonomi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "HAZFANI ROSYIDI AL KHATAMI",
        jenjang: "S1 Reguler",
        prodi: "Akuntansi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "NADINE DARMAWAN",
        jenjang: "D4",
        prodi: "Bisnis Kreatif"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MUHAMMAD VAHRYAN DWI SATRIA",
        jenjang: "S1 Reguler",
        prodi: "Sastra Indonesia"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "FARHAH DYRA SIREGAR",
        jenjang: "S1 Reguler",
        prodi: "Kesehatan Lingkungan"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "NADHIRA RETNA SAKINAH",
        jenjang: "D4",
        prodi: "Bisnis Kreatif"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "AZKIYA NAYLA MECCA",
        jenjang: "S1 Reguler",
        prodi: "Arkeologi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "REGISCA ALYSANDRINA",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Administrasi Niaga"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "FILDZAH ZAHIRA",
        jenjang: "S1 Reguler",
        prodi: "Sastra Perancis"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "QONITA NUR IZZATI",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Administrasi Negara"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ANIKA TRI RANA PUTRI",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Kesejahteraan Sosial"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ZAHIRA SAIDAH",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Administrasi Negara"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "FATIMAH",
        jenjang: "S1 Reguler",
        prodi: "Sastra Daerah untuk Sastra Jawa"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "TSABITHA ALMAIDAH",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Kesejahteraan Sosial"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "HARSYA SYABIL BUDIMAN",
        jenjang: "D4",
        prodi: "Manajemen Rekod dan Arsip"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "AWALUL AININ NI'MAH",
        jenjang: "S1 Reguler",
        prodi: "Sastra Daerah untuk Sastra Jawa"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "DAMA ZARITA HIKMAH",
        jenjang: "S1 Reguler",
        prodi: "Studi Gizi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "FAYYADH FAWWAZ",
        jenjang: "S1 Reguler",
        prodi: "Sosiologi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ALICIA AULIN",
        jenjang: "S1 Reguler",
        prodi: "Studi Gizi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ADIATMA FATHURAHMAN",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Administrasi Niaga"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "HALIKA MAHARANI NOVIANDRI",
        jenjang: "S1 Reguler",
        prodi: "Sastra Belanda"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "M IBRAHIM ARSYAD",
        jenjang: "Vokasi",
        prodi: "Administrasi Asuransi dan Aktuaria \t"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MARSHA ADYADIBA MAULIDA",
        jenjang: "Vokasi",
        prodi: "Administrasi Perkantoran"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ADELLA SANIKA PUTRI MASLOMAN",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Administrasi Niaga"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "RAYYA KHANSA SYAFIRA",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Administrasi Niaga"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MUHAMMAD RHAGUSTI RAMADHAN",
        jenjang: "D4",
        prodi: "Produksi Media"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MOH. DAFA ARRAHMAN",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Politik"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MAHESWARI JOANNA ELUA",
        jenjang: "S1 Reguler",
        prodi: "Sastra Rusia"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "SHARKEENAN MAHINDRARTA",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Politik"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "AURELIA RAMADIKA",
        jenjang: "S1 Reguler",
        prodi: "Sastra Belanda"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ALIYA KHAIRUNNISA",
        jenjang: "S1 Reguler",
        prodi: "Sastra Jepang"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "FATIMAH SAUSAN",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Administrasi Negara"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "KAYLA ARIANTO",
        jenjang: "S1 Reguler",
        prodi: "Kesehatan Lingkungan"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "RAJA PURBA",
        jenjang: "S1 Reguler",
        prodi: "Geografi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ADZRA LAYYINA AULIA",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Administrasi Fiskal"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "RUAS BONNA ZOLLI SIREGAR",
        jenjang: "S1 Reguler",
        prodi: "Bahasa dan Kebudayaan Korea"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ANASTASIA INDIASTINI",
        jenjang: "S1 Reguler",
        prodi: "Akuntansi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MUHAMMAD VITO EMERYARCHARD SETIAWAN",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Hukum"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "FAYHAA ALIA THAYEB SIREGAR",
        jenjang: "S1 Reguler",
        prodi: "Sastra Perancis"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "RAKHEL SHABRINA RAMADHANI SETYADI",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Sejarah"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "DALILA EFFAT AZIZA",
        jenjang: "Vokasi",
        prodi: "Periklanan Kreatif"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "CHANTIKA PUTRIA AGUSTINE",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Kesejahteraan Sosial"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ALLYA SECIONISA",
        jenjang: "Vokasi",
        prodi: "Periklanan Kreatif"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ABDUL MALIK MUSYAFFA INDARTO",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Politik"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "NASYWA ANNISA MAZAYA",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Hukum"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "KEISYA KHAIRUNNISA RIZKILLAH",
        jenjang: "Vokasi",
        prodi: "Hubungan Masyarakat"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "CHIKA NUR SISWOYO",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Administrasi Negara"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ALFONSUS MAGISTRA DEO GLORY",
        jenjang: "S1 Reguler",
        prodi: "Manajemen"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ANDREAS CASTROPASU SIBARANI",
        jenjang: "S1 Reguler",
        prodi: "Geofisika"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MUHAMMAD BAGINDO JAVA",
        jenjang: "S1 Reguler",
        prodi: "Sastra Jepang"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MUHAMMAD ADIB ANARGYA FIRDAUS",
        jenjang: "Vokasi",
        prodi: "Hubungan Masyarakat"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "TAZKIYA HANEEVA AQILAH",
        jenjang: "Vokasi",
        prodi: "Administrasi Perpajakan"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "SALSABILA NAIFAH",
        jenjang: "S1 Reguler",
        prodi: "Studi Gizi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MUHAMMAD GHIFARI AL-HAFIE",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Filsafat"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "CALLIA DIARA HARAHAP",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Politik"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MAHBUB ZEIN PUTRANTO",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Ekonomi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "NAOMI CHRISTABEL NAULI",
        jenjang: "S1 Reguler",
        prodi: "Sastra Cina"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "AYU MIRANTI",
        jenjang: "S1 Reguler",
        prodi: "Sastra Belanda"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "DEVIN ABDIEL HAFIZH",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Hukum"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "DAVID ATIYAH",
        jenjang: "Vokasi",
        prodi: "Administrasi Asuransi dan Aktuaria \t"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MILINKA SYAFIDA PUTRI ZULKARNAEN",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Administrasi Negara"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "FERDY ANANDA SETIAWAN",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Administrasi Niaga"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "GLORY LOINA CHRISSTELLA",
        jenjang: "S1 Reguler",
        prodi: "Kriminologi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "KEISHA AURELLIA ASAILLAH",
        jenjang: "S1 Reguler",
        prodi: "Sastra Daerah untuk Sastra Jawa"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "DAFFA ATHA ULLAH",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Filsafat"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "YOSEFINA ARDIASARI",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Administrasi Fiskal"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "NAILA MASITHA GUMAY",
        jenjang: "S1 Reguler",
        prodi: "Sastra Belanda"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MUHAMMAD KHANSA FAIZ RIANDIKA",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Administrasi Negara"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MUHAMMAD FAIZ GHIFARI",
        jenjang: "Vokasi",
        prodi: "Administrasi Asuransi dan Aktuaria \t"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "TESSALONICA BETRANIA LOVELYN TIRTADEVANDRA",
        jenjang: "S1 Reguler",
        prodi: "Sastra Daerah untuk Sastra Jawa"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "KAMILA ZIYA AZITA KHOLIQ",
        jenjang: "S1 Reguler",
        prodi: "Antropologi Sosial"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ANINDYA GALUH CANDRASMOERTI",
        jenjang: "S1 Reguler",
        prodi: "Geologi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ANNISA AULIA PARAGITA WAHAB",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Administrasi Negara"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ABDUL MALIK DWI JATMIKO",
        jenjang: "S1 Reguler",
        prodi: "Kriminologi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "VICTOR LOUISE NIKANOR",
        jenjang: "S1 Reguler",
        prodi: "Sastra Belanda"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "NADYA PUTRI DEWINA",
        jenjang: "S1 Reguler",
        prodi: "Sastra Daerah untuk Sastra Jawa"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "KYLA FITRI MAHARANI",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Administrasi Fiskal"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "KARINA NURUL MAHARANI",
        jenjang: "S1 Reguler",
        prodi: "Antropologi Sosial"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "DEVI RAMY FHATINAH",
        jenjang: "Vokasi",
        prodi: "Administrasi Perpajakan"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "TAWFIQA NAADHIRAH SHALEH",
        jenjang: "S1 Reguler",
        prodi: "Sastra Indonesia"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "CYNTHIA LING ADI SUTRISNA",
        jenjang: "S1 Reguler",
        prodi: "Teknik Lingkungan"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ARYAN RUBIANTO MANUSIWA",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Politik"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "PRADIPTA ARYA WIBOWO",
        jenjang: "S1 Reguler",
        prodi: "Geofisika"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "GHINA AFIFA FATCHAN",
        jenjang: "S1 Reguler",
        prodi: "Sastra Jerman"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "GIBRAN FAHREVI",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Administrasi Niaga"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "JOSHUA RAFHAEL SIPAHUTAR",
        jenjang: "S1 Reguler",
        prodi: "Fisika"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MOHAMAD RIFQI RIZALDI DJAAFAR",
        jenjang: "S1 Reguler",
        prodi: "Geologi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MEICHELLYA VAIZADINE",
        jenjang: "Vokasi",
        prodi: "Periklanan Kreatif"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ADITYA PREMA ARIEF",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Administrasi Niaga"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "FITROH TOL MUTTAQIN",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Keperawatan"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "R MUHAMAD FADHIL GIBRAN",
        jenjang: "S1 Reguler",
        prodi: "Geografi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "RELIEFYA VICI MARTYANDRA",
        jenjang: "S1 Reguler",
        prodi: "Antropologi Sosial"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "NIDA NAILAH PUTRI",
        jenjang: "S1 Reguler",
        prodi: "Geografi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ZHAFIRAH AFRAH",
        jenjang: "S1 Reguler",
        prodi: "Psikologi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ANGEL SUSANA THIORIA PANDJAITAN",
        jenjang: "S1 Reguler",
        prodi: "Manajemen"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ANDREAS SAHAT TUA HAMONANGAN",
        jenjang: "S1 Reguler",
        prodi: "Akuntansi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "INTAN ENSYURA DALIMUNTE",
        jenjang: "D4",
        prodi: "Bisnis Kreatif"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "JENNIFFER JERICA LIOE",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Administrasi Fiskal"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "RUT DIANDRA M HUTAHAEAN",
        jenjang: "S1 Reguler",
        prodi: "Sastra Perancis"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "DEOGRATIAS DEVAN SUTANTO",
        jenjang: "S1 Reguler",
        prodi: "Akuntansi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "TAZKIA NUR ALYANI",
        jenjang: "S1 Reguler",
        prodi: "Sistem Informasi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "RIBI NOVALE ARDY",
        jenjang: "S1 Reguler",
        prodi: "Arkeologi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "AHMAD MUSYAFFA AGUNG",
        jenjang: "S1 Reguler",
        prodi: "Sastra Inggris"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MUHAMMAD ZAFAR ZIKKO",
        jenjang: "S1 Reguler",
        prodi: "Sastra Jepang"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MUHAMMAD NAFIS",
        jenjang: "S1 Reguler",
        prodi: "Kesehatan Lingkungan"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "TIARA KUSUMA WARDANI",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Hukum"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "DINDA ARTHA SASIKIRANI",
        jenjang: "D4",
        prodi: "Produksi Media"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MYREL ANGGINI SIPAYUNG",
        jenjang: "S1 Reguler",
        prodi: "Antropologi Sosial"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "AHMAD RIZKI",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Administrasi Negara"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "FAWWAZ ZULFA HADAYA",
        jenjang: "Vokasi",
        prodi: "Hubungan Masyarakat"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "KENZA RADHIFA AL MAKKAH",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Hubungan Internasional"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "FITRI SITI SALMA",
        jenjang: "S1 Reguler",
        prodi: "Sastra Rusia"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "NABILA ALYA RAIHANAH",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Administrasi Fiskal"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ANANDA MIFTAHUL AZZAHRA",
        jenjang: "S1 Reguler",
        prodi: "Sastra Daerah untuk Sastra Jawa"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "NAYLA ARAMINTA PUTRI WIRAWAN",
        jenjang: "S1 Reguler",
        prodi: "Geografi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "KIRINA IRENE KENDRA",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Administrasi Fiskal"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "CHIQUITA CLARISSA DE FRETES",
        jenjang: "S1 Reguler",
        prodi: "Kesehatan Masyarakat"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "JOHANNES NICHOLA SIMATUPANG",
        jenjang: "S1 Reguler",
        prodi: "Sistem Informasi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "SARAH ISABELLE ANGIE TAMBUNAN",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Filsafat"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "RAZAN PASHA HIDAYAT",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Politik"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "SYAFFIRA RAFFELINO JAYADI",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Politik"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "REVA YULIANA PUTRI",
        jenjang: "S1 Reguler",
        prodi: "Fisika"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "HENGKY WINATA",
        jenjang: "S1 Reguler",
        prodi: "Antropologi Sosial"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "HARUMING SEKAR KINASIH",
        jenjang: "S1 Reguler",
        prodi: "Antropologi Sosial"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "KHALISHA SITI MAZAYA",
        jenjang: "S1 Reguler",
        prodi: "Bisnis Islam"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "NAOMITHA ANGEL S. NABABAN",
        jenjang: "S1 Reguler",
        prodi: "Akuntansi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "AHMAD FARIS ABDALLAH",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Administrasi Negara"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "RAHMA AAQILA",
        jenjang: "S1 Reguler",
        prodi: "Sastra Belanda"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "TIARA NURUL AFLA",
        jenjang: "Vokasi",
        prodi: "Administrasi Rumah Sakit"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "RADITYA RAFA PRAMUDYA",
        jenjang: "S1 Reguler",
        prodi: "Bisnis Islam"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MUHAMMAD IQBAL YUDIANSYAH IRWANTO",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Filsafat"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "SIDHARTA PRAJNA NUGRAHA JOEDO SAPUTRA",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Ekonomi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "DAVID ANTONIO FRANCESCO BUDHI",
        jenjang: "Vokasi",
        prodi: "Hubungan Masyarakat"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "CHARYSSA AISYA PARAMESTI",
        jenjang: "S1 Reguler",
        prodi: "Sastra Perancis"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "SARAH GHAITSA ANNAJLA",
        jenjang: "S1 Reguler",
        prodi: "Sastra Belanda"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ROULI ARTHA TURNIP",
        jenjang: "S1 Reguler",
        prodi: "Geofisika"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "AZKIYA ZULFA SALSABILA",
        jenjang: "S1 Reguler",
        prodi: "Sastra Rusia"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "SALSABILA SHAFA MARIF",
        jenjang: "S1 Reguler",
        prodi: "Kriminologi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "DIPO SYAHID RAMADHAN",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Filsafat"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "AMANDA PUTRI",
        jenjang: "S1 Reguler",
        prodi: "Sastra Cina"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ALETTA SEIZA REVANASHA",
        jenjang: "S1 Reguler",
        prodi: "Kriminologi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "KLAIDY RAHIL",
        jenjang: "S1 Reguler",
        prodi: "Antropologi Sosial"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "SASKHIA NUURUL HIDAYAT",
        jenjang: "Vokasi",
        prodi: "Penyiaran Multimedia"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "LAILUNA MUNTASHIROH",
        jenjang: "S1 Reguler",
        prodi: "Sastra Arab"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "AZAHRA NAYLILA WINDYAPUTRI",
        jenjang: "S1 Reguler",
        prodi: "Bahasa dan Kebudayaan Korea"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "AZIZZAH CAHYA QINARSIH",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Administrasi Fiskal"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "NISRINA RAMEYZA ELYA",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Administrasi Fiskal"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MUHAMMAD RAZAN DIANDRA RATMONO",
        jenjang: "S1 Reguler",
        prodi: "Teknik Perkapalan"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "RAYA ADILLA NURAMALIA",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Hukum"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "SALSABILA AMANDA PUTRI",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Keperawatan"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ASFARINA NABILA AZ-ZAHRA",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Hukum"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "M.SYAUQI YUDAN NURRAHMAN",
        jenjang: "S1 Reguler",
        prodi: "Manajemen"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ATHALIA LAKSMIDEWI",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Administrasi Negara"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "RIFQI RAMADHANI RAMLI",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Administrasi Fiskal"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "DECIANA SAHARA ATSILLAH",
        jenjang: "S1 Reguler",
        prodi: "Sosiologi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "NARAYA RAMEYZA ALYA",
        jenjang: "Vokasi",
        prodi: "Administrasi Asuransi dan Aktuaria \t"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "FAWWAZ ADZIMA RAUF",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Ekonomi Islam"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "BRIGITA CHUANES",
        jenjang: "S1 Reguler",
        prodi: "Sastra Cina"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "AHMAD FIQRI YATHIR",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Filsafat"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "KAYLA NASYWA NUGRAHA",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Administrasi Fiskal"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "GABRIEL THEODORE MANUEL",
        jenjang: "Vokasi",
        prodi: "Hubungan Masyarakat"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "AYU BAHIRA RIDWAN",
        jenjang: "S1 Reguler",
        prodi: "Sastra Arab"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "RINJANI SASIKIRANA PUTRI",
        jenjang: "S1 Reguler",
        prodi: "Psikologi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "HAUZAN FARROS PAHLEVI",
        jenjang: "S1 Reguler",
        prodi: "Sastra Daerah untuk Sastra Jawa"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ALI ZAENAL ABIDIN",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Sejarah"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "KSATRYA AISYAH AULIA RIZQI",
        jenjang: "S1 Reguler",
        prodi: "Kriminologi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ADRIEL HADISUMARTO",
        jenjang: "S1 Reguler",
        prodi: "Sosiologi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MUHAMMAD AMMER ALAQSA ADINIDAR",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Administrasi Niaga"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ANGGITA NASHWA TAUFIQA",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Hukum"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MUHAMMAD FAHMI PRASETYO",
        jenjang: "S1 Reguler",
        prodi: "Geografi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "DEWA HAMONANGAN KELGA HUTAGALUNG",
        jenjang: "S1 Reguler",
        prodi: "Sastra Rusia"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MUHAMMAD SYAUQI AFZALURAHMAN",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Politik"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "KHAYRA NAFISA",
        jenjang: "S1 Reguler",
        prodi: "Arsitektur Interior"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "RAYA GASTIADIRRIJAL ARIFIN",
        jenjang: "D4",
        prodi: "Produksi Media"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "RIZAL ARIF",
        jenjang: "S1 Reguler",
        prodi: "Sastra Daerah untuk Sastra Jawa"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MUHAMMAD YAHYA RAMADHAN",
        jenjang: "S1 Reguler",
        prodi: "Psikologi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "GANESHA MAGENTA WHISNUPUTRA",
        jenjang: "D4",
        prodi: "Manajemen Bisnis Pariwisata"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "DIMAS PRATAMA MULIA",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Hukum"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "YULIANA KARTIKA DEWI",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Administrasi Negara"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MUHAMMAD ALIFANSYAH PUTRAWAN",
        jenjang: "S1 Reguler",
        prodi: "Sastra Jepang"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "FADIL MUBAROK",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Administrasi Niaga"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "HANA NAILAH AZIZAH",
        jenjang: "S1 Reguler",
        prodi: "Sastra Arab"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "RAFIF DENIS ATMAJA",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Administrasi Niaga"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "BEATA NASTITI SETYANDAYU",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Administrasi Negara"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "NAUFAL FIQLIAN GHANIYYA",
        jenjang: "S1 Reguler",
        prodi: "Teknik Lingkungan"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "KEVIN ARVANDA MALIK SUPRIHADI",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Administrasi Niaga"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "KEMAL PRABASWARA AJI",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Hukum"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "AHMAD BASKARA SAKTI LESMANA",
        jenjang: "S1 Reguler",
        prodi: "Sastra Jepang"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "AQSA HANIYA AYYUBI",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Administrasi Negara"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "DAFFA MUSYAFFA SATRIA",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Sejarah"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "CHARINA YOANITA",
        jenjang: "Vokasi",
        prodi: "Hubungan Masyarakat"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "SHARFINA PARAMITHA",
        jenjang: "S1 Reguler",
        prodi: "Geografi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "NIRINA ANNISA ZANZABILA",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Kesejahteraan Sosial"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ANTONIUS BAGUS DEWARANGGA",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Komunikasi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "FIONA AMHEL NAULI SITINDAON",
        jenjang: "S1 Reguler",
        prodi: "Sastra Belanda"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "SANDRA LEVANA BATTI",
        jenjang: "S1 Reguler",
        prodi: "Sastra Jepang"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "FIRASYA LUBNA AFDAL",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Perpustakaan"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ANGGA KURNIA SAPUTRA",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Administrasi Niaga"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "INDIRA FAISAL",
        jenjang: "S1 Reguler",
        prodi: "Antropologi Sosial"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "DAVIN RAHARDIAN PRAMESWARA",
        jenjang: "Vokasi",
        prodi: "Penyiaran Multimedia"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "PUTRA KUSUMAH WIJAYA",
        jenjang: "S1 Reguler",
        prodi: "Antropologi Sosial"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MUHAMAD ALFIAN",
        jenjang: "D4",
        prodi: "Bisnis Kreatif"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "FEBRIYANA RACHEL CLEMENTINE",
        jenjang: "S1 Reguler",
        prodi: "Arsitektur Interior"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MARIA ISABEL ODELIA SITORUS",
        jenjang: "Vokasi",
        prodi: "Administrasi Asuransi dan Aktuaria \t"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MUHAMMAD NANDA SYAIFURROHMAN",
        jenjang: "S1 Reguler",
        prodi: "Sastra Daerah untuk Sastra Jawa"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "BASEL ZITKA DJAJADININGRAT",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Ekonomi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "YUNUARNI ANDAN NIHAN",
        jenjang: "S1 Reguler",
        prodi: "Sastra Perancis"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "GRACE ANANDA JOSEPHINE",
        jenjang: "S1 Reguler",
        prodi: "Teknik Biomedik"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "NAMIRA RAHMA AULIA",
        jenjang: "S1 Reguler",
        prodi: "Kriminologi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "NAYYARA AZZAHRA MAHDANI",
        jenjang: "S1 Reguler",
        prodi: "Keselamatan & Kesehatan Kerja"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "NAJWA DESWITA DEA PUTRI",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Administrasi Negara"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "NEILA ZULVA SURYA",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Hubungan Internasional"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "IRSYAD DZAKI PRIBADI",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Administrasi Niaga"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "RUTH JELITA SILALAHI",
        jenjang: "S1 Reguler",
        prodi: "Kesehatan Masyarakat"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "HANNAN ABIYYU ARKAN",
        jenjang: "S1 Reguler",
        prodi: "Sastra Jepang"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MUHAMMAD AIDAN GHIFARI",
        jenjang: "S1 Reguler",
        prodi: "Antropologi Sosial"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "JANET AURELL FELINA MARBUN",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Administrasi Fiskal"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ASHZIHNI FAWAZ RAI AJAR",
        jenjang: "D4",
        prodi: "Produksi Media"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "AQILLA SADINE WARANGGANI",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Filsafat"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "KALINDA AMARTYA MUKTI",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Administrasi Niaga"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ATIKA NABILA",
        jenjang: "D4",
        prodi: "Manajemen Rekod dan Arsip"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "DZIKRA TSANY ATHAYA",
        jenjang: "S1 Reguler",
        prodi: "Sastra Perancis"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ELEKTRA SHAKILA KASAMBARA",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Komunikasi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "FLORA MAI MURAWATI HUTAGAOL",
        jenjang: "S1 Reguler",
        prodi: "Sosiologi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "NADIR ZIDAN",
        jenjang: "D4",
        prodi: "Bisnis Kreatif"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "CHICO AHMAD ARDIPUTRANTO",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Ekonomi Islam"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "GHANIA MEUTIA NABILA",
        jenjang: "S1 Reguler",
        prodi: "Geografi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "NURUL KAROMATU DIANA",
        jenjang: "S1 Reguler",
        prodi: "Psikologi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "PARAMITA MAURA MAHESWARI",
        jenjang: "S1 Reguler",
        prodi: "Geografi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "GHINA FADILLAH",
        jenjang: "S1 Reguler",
        prodi: "Sastra Belanda"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MAI NA MAYRA PUTRI PARDEDE",
        jenjang: "S1 Reguler",
        prodi: "Sastra Jepang"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MUHAMMAD FARIS RESWARA",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Perpustakaan"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "RIZKI RAMADHAN PUTRA SANTOSO",
        jenjang: "Vokasi",
        prodi: "Administrasi Rumah Sakit"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "NAJWA ALIMAH",
        jenjang: "D4",
        prodi: "Terapi Okupasi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "INAYA RAHMA AZ ZAHRA",
        jenjang: "S1 Reguler",
        prodi: "Sastra Daerah untuk Sastra Jawa"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MUHAMMAD DHIMAS KUSNADI",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Hukum"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "SAKTI NUHZAN ABRAR",
        jenjang: "Vokasi",
        prodi: "Periklanan Kreatif"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "YOSSIE SARAH PATRICIA MARBUN",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Hukum"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "RAISHA XENANDA MUHARTAWAN",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Administrasi Niaga"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "KENSAN ABRARIANTO",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Administrasi Niaga"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "RASYA FAZA ZHAFIRA",
        jenjang: "D4",
        prodi: "Terapi Okupasi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "FAYYAD HAFIZ ATHALLAH",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Perpustakaan"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "BENEDIKTI SEKAR KAPILIH",
        jenjang: "S1 Reguler",
        prodi: "Sastra Inggris"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "RAKA TATHYA DAKSINAYA",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Administrasi Fiskal"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "DANIELA AMIINAH UMAR",
        jenjang: "S1 Reguler",
        prodi: "Sastra Cina"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "FATIMAH AZAHRA",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Sejarah"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "KIMIKAYLEE BAIYEWU",
        jenjang: "S1 Reguler",
        prodi: "Sastra Inggris"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "SHALOM BENEDICTA ANGGIA LUMBANTORUAN",
        jenjang: "Vokasi",
        prodi: "Penyiaran Multimedia"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "VELLYANI CHRISTINA LAWRANCE",
        jenjang: "Vokasi",
        prodi: "Hubungan Masyarakat"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "CHRISTY MAYA LUNA THERESIA SILAEN",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Administrasi Niaga"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ZAHRA NABILA AFIFATURROCHMAH",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Administrasi Negara"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "FINA FATIMATU ZAHRO",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Sejarah"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "VICKY IQBAL RAMADHAN",
        jenjang: "Vokasi",
        prodi: "Hubungan Masyarakat"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "AGNES GRACIA KRISTANIA",
        jenjang: "S1 Reguler",
        prodi: "Akuntansi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "RIVALDY HAFIZ BUANA",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Administrasi Niaga"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MOHAMMAD RAIHAN RAZZANI",
        jenjang: "S1 Reguler",
        prodi: "Akuntansi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ARJANTI HAYUNINGTYAS WIRASTUTI",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Administrasi Niaga"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ALETHA ZAHIRA RASTAM",
        jenjang: "S1 Reguler",
        prodi: "Psikologi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "VESIA AKIVA MASEO",
        jenjang: "S1 Reguler",
        prodi: "Statistika"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "RANA RAIHANA YONDHAVER",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Perpustakaan"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MUHAMMAD RAFIE NASIR LUBIS",
        jenjang: "S1 Reguler",
        prodi: "Geografi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "DAVIN MUHAMMAD ARRAJANI",
        jenjang: "S1 Reguler",
        prodi: "Geografi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "SOCA LUDIRA",
        jenjang: "Vokasi",
        prodi: "Penyiaran Multimedia"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MUHAMMAD FENDER NANDI ANTASENA",
        jenjang: "Vokasi",
        prodi: "Administrasi Perkantoran"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "RADEN GENDIS PUTERI KENCANA",
        jenjang: "S1 Reguler",
        prodi: "Sastra Jerman"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "NAJMI NURUL HAYYA ANJAINAH",
        jenjang: "S1 Reguler",
        prodi: "Sastra Jepang"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "RAMOT TIMOTHY J SIMATUPANG",
        jenjang: "Vokasi",
        prodi: "Akuntansi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "NATIAH RHAESYA KARTINI SAMBUDHY",
        jenjang: "S1 Reguler",
        prodi: "Sastra Perancis"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MUHAMMAD GUSTI AFIQ AR-RAYAN SUHARJONO",
        jenjang: "D4",
        prodi: "Produksi Media"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "DESNITA ULI NATASHA DOLOKSARIBU",
        jenjang: "Vokasi",
        prodi: "Akuntansi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "REYHAN HAFIZHA FAHREZY",
        jenjang: "Vokasi",
        prodi: "Akuntansi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "AHMAD AQIL RAFIUDDIN",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Administrasi Negara"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ANGKASA RASKAH FERNANDA",
        jenjang: "S1 Reguler",
        prodi: "Sosiologi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "LOUISA EVELINE YURIKO",
        jenjang: "S1 Reguler",
        prodi: "Bahasa dan Kebudayaan Korea"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MUHAMAD MUWAFARROZIQIN",
        jenjang: "S1 Reguler",
        prodi: "Teknik Biomedik"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ADITYA MAHENDRA PRAKASA",
        jenjang: "S1 Reguler",
        prodi: "Sosiologi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ALLEYA NATASYA ISSABEL KUSUMA",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Hukum"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "EIRYN PERMATA DEWI",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Administrasi Niaga"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "NAUVAL QUSHAYYI",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Administrasi Fiskal"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MUHAMMAD AZZAM FATHURRAHMAN",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Administrasi Niaga"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "AIASHA KHANSA MAULIDA FAKHIRAH",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Administrasi Niaga"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "RIVIANA KAYLA ANZANI IRAWAN",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Kesejahteraan Sosial"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "SAFA ALISHA FATHIYA",
        jenjang: "D4",
        prodi: "Manajemen Bisnis Pariwisata"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "AZIZI ALAUDINSYAH",
        jenjang: "S1 Reguler",
        prodi: "Sastra Daerah untuk Sastra Jawa"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "SARAH OLIVIA PUTRI WARDHANA",
        jenjang: "S1 Reguler",
        prodi: "Arsitektur Interior"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MUHAMMAD RIDHO AMIR",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Administrasi Niaga"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "TRISHA CAHYA KIRANA",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Administrasi Niaga"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ALYSSA REZA PUTRI",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Keperawatan"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "SAMY FARREL",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Ekonomi Islam"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "AZEETA BAZLINA",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Politik"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "PRASETYO ADHI WIDODO",
        jenjang: "Vokasi",
        prodi: "Administrasi Asuransi dan Aktuaria \t"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "HATISUFI WIJAYA",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Perpustakaan"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MUHAMMAD IHRAM NARADHYAPUTRA",
        jenjang: "S1 Reguler",
        prodi: "Kesehatan Masyarakat"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "AULIDA TRIANINGTYAS",
        jenjang: "S1 Reguler",
        prodi: "Sastra Inggris"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "JUANITHA RIZKA ALESSANDRA MAMUN",
        jenjang: "S1 Reguler",
        prodi: "Biologi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "YASSER RYAN ISMAIL",
        jenjang: "S1 Reguler",
        prodi: "Sosiologi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ALIA SYIFA FADHILA",
        jenjang: "S1 Reguler",
        prodi: "Sosiologi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "EVAN SIDHARTA TANJUNG",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Komunikasi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MUHAMMAD RAIHANDITO HARYOPUTRO",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Administrasi Negara"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "KYANNISA AULIA EGA PUTRI",
        jenjang: "S1 Reguler",
        prodi: "Bisnis Islam"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MUSYAFA ABDUL AZIZ TAMIN",
        jenjang: "Vokasi",
        prodi: "Administrasi Rumah Sakit"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "PUTRI ARIMBI ANINDITA",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Politik"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MUHAMMAD AZKA FIKRI",
        jenjang: "S1 Reguler",
        prodi: "Antropologi Sosial"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "INAS INDRIANI APSARI",
        jenjang: "S1 Reguler",
        prodi: "Statistika"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "JOSEPHINE FELICIA",
        jenjang: "S1 Reguler",
        prodi: "Studi Gizi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "HANA KAMILA",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Hukum"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "BANYU SENO AJI",
        jenjang: "D4",
        prodi: "Bisnis Kreatif"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "NABILA ANIRSYA SARWAHITA KINASIH",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Kesejahteraan Sosial"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "FATIH ZUHAIR RIZMAWAN",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Administrasi Negara"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MUHAMMAD FAYADH",
        jenjang: "D4",
        prodi: "Bisnis Kreatif"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MUHAMMAD RIZKY ABIMANYU PRANADA",
        jenjang: "D4",
        prodi: "Bisnis Kreatif"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ARSYI ITSNAINI ANANDYA",
        jenjang: "S1 Reguler",
        prodi: "Sastra Indonesia"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "FARAH ALIYA MUNTAZAR",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Ekonomi Islam"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "IZYAN AHZA AYMAN RASYAD",
        jenjang: "S1 Reguler",
        prodi: "Bisnis Islam"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ZIKI IZAMIL HAQ",
        jenjang: "Vokasi",
        prodi: "Hubungan Masyarakat"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "GIVA MARSYA ARDINI",
        jenjang: "S1 Reguler",
        prodi: "Kesehatan Masyarakat"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ZEA KHANSA DZAKIYYAH",
        jenjang: "Vokasi",
        prodi: "Administrasi Rumah Sakit"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MUTIARA RAHMA",
        jenjang: "S1 Reguler",
        prodi: "Sastra Indonesia"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "NINGRUM ANGGI AMIROTUSSALSABILA",
        jenjang: "S1 Reguler",
        prodi: "Sastra Inggris"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "AGUNG PRATAMA",
        jenjang: "Vokasi",
        prodi: "Administrasi Perkantoran"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "NATHANAEL RAFAEL BONARDO NAPITUPULU",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Hukum"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "RAIANA MALIQA WIDURI",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Filsafat"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ADITYA TAUFIK HIDAYAT",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Filsafat"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ANGELA DYANDRA ANINDITA FABRO",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Administrasi Negara"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MUHAMMAD BAIHAKII",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Kesejahteraan Sosial"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "AMARE MYHEART ONO",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Kesejahteraan Sosial"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "RIJAL MUSTHOFA RIFQI",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Politik"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "EDELWEIS WIDODARI YULIAPUTRI",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Komunikasi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ZSASA AMANDA DICY PUTRI",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Hukum"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "THARIQ DHIYA ULHAQ",
        jenjang: "Vokasi",
        prodi: "Akuntansi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "NAYLA ZAHRA ANINDYA",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Hukum"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "NISA FILIA SURI",
        jenjang: "D4",
        prodi: "Fisioterapi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "DESNI NURKHALIZA",
        jenjang: "S1 Reguler",
        prodi: "Sastra Rusia"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "WAFIQ AZIZAH",
        jenjang: "S1 Reguler",
        prodi: "Sastra Arab"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "KIRANA GITA ANJANI",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Administrasi Niaga"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ANARGYA PUTRA",
        jenjang: "Vokasi",
        prodi: "Administrasi Perpajakan"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "FARHANAH MUTIARA AZZAHRA",
        jenjang: "Vokasi",
        prodi: "Administrasi Perpajakan"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "INDI ALKAIDA PUTRI ZULFIAR",
        jenjang: "S1 Reguler",
        prodi: "Arkeologi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "APRILIAN HASIHOLAN SORMIN",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Administrasi Negara"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "NAYARA HANNA AQILA",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Administrasi Fiskal"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "IMROATUL HAMIDAH",
        jenjang: "Vokasi",
        prodi: "Administrasi Perpajakan"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "FITRIA SHAFIRA ALIYAH",
        jenjang: "S1 Reguler",
        prodi: "Manajemen"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MUHAMMAD AKBAR PRATAMA AULIA",
        jenjang: "S1 Reguler",
        prodi: "Sastra Cina"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "AVIDA NUR AISYAH",
        jenjang: "S1 Reguler",
        prodi: "Geofisika"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MARWAH HASANAH",
        jenjang: "S1 Reguler",
        prodi: "Sastra Jerman"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ARIATI  DEWI",
        jenjang: "Vokasi",
        prodi: "Administrasi Rumah Sakit"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "HAIFA LAKEISHA FAZA",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Administrasi Fiskal"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "KENNY HANINDHITA PRAMESWARI",
        jenjang: "S1 Reguler",
        prodi: "Psikologi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "RADEN AYU DAVIRA DANISTY PUTRI",
        jenjang: "S1 Reguler",
        prodi: "Akuntansi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ASTRID AYUDHIA FAYYAZA",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Ekonomi Islam"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "CHELSEA AULIA SYAHKIRAYNI",
        jenjang: "S1 Reguler",
        prodi: "Keselamatan & Kesehatan Kerja"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "RETNO AULIA KAMAN",
        jenjang: "S1 Reguler",
        prodi: "Akuntansi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "HALWA RATU MYIESHA",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Kesejahteraan Sosial"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MUHAMMAD RASYAD AMRULLAH",
        jenjang: "Vokasi",
        prodi: "Administrasi Perkantoran"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "SYIFA NABILAH AZZAHRA",
        jenjang: "S1 Reguler",
        prodi: "Sastra Arab"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "SHALOM SHERAFINA SEMBIRING K",
        jenjang: "Vokasi",
        prodi: "Administrasi Perkantoran"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MUHAMMAD FARHAN NAUFAL",
        jenjang: "S1 Reguler",
        prodi: "Sastra Inggris"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "VIOLETTA NAURA ADRIENNE",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Administrasi Negara"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "FACHREZI AULIA",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Kesejahteraan Sosial"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "EGALITA ZAHIRA ARFAUZAINI",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Filsafat"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "RADEN MUHAMMAD ARASY CAKRAPUTRA NUGROHO",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Hukum"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ARLIEN KHOERUNNISA AHMAD",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Administrasi Niaga"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ANYA CHARISSA",
        jenjang: "S1 Reguler",
        prodi: "Geologi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MU'ADZ",
        jenjang: "Vokasi",
        prodi: "Administrasi Rumah Sakit"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MUHAMMAD NOUVALDI ARFANSYAH",
        jenjang: "S1 Reguler",
        prodi: "Akuntansi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "GIORGIO MARCELLO SIREGAR",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Administrasi Niaga"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ALFONSO HIZKIA KALEB HUTABARAT",
        jenjang: "S1 Reguler",
        prodi: "Psikologi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "GENDIS CAHYA REGITHA",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Filsafat"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "AKILA MASKA AYUB",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Administrasi Niaga"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "RIZMA AN NAZIRA",
        jenjang: "S1 Reguler",
        prodi: "Sastra Indonesia"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ELICHIA ETHA NARIA",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Hubungan Internasional"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MUHAMMAD AQEELA AKBAR PANGGABEAN",
        jenjang: "S1 Reguler",
        prodi: "Sistem Informasi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "VANESSA MAELYN BONG",
        jenjang: "S1 Reguler",
        prodi: "Farmasi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "RAYHAN FATUR RAHMAN",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Perpustakaan"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ASHLIKA RIZKIANA ADVIANTO",
        jenjang: "Vokasi",
        prodi: "Administrasi Rumah Sakit"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "FEBRIAN ARIFIANTO WIDYADHANA",
        jenjang: "S1 Reguler",
        prodi: "Bisnis Islam"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "YOHANES SILALAHI",
        jenjang: "S1 Reguler",
        prodi: "Arkeologi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "SHAKILA ALIYASARI UTOMO",
        jenjang: "S1 Reguler",
        prodi: "Kriminologi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MUHAMMAD NASHRULLAH KHAN",
        jenjang: "S1 Reguler",
        prodi: "Bisnis Islam"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "NADYA PUTRI",
        jenjang: "S1 Reguler",
        prodi: "Kesehatan Masyarakat"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "SATRIA WIBAWA ADHIYA RAHMATULLAH",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Hukum"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "HAMIM NURYADI",
        jenjang: "S1 Reguler",
        prodi: "Sastra Arab"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "TERESYA MARETA DEWI",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Administrasi Niaga"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "LIVIA CHERYL NATASHA",
        jenjang: "S1 Reguler",
        prodi: "Sastra Rusia"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "AYSKA MUUMTAZ MAGGADING",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Administrasi Fiskal"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "INDIRA ZAHIRA KAMILA",
        jenjang: "Vokasi",
        prodi: "Penyiaran Multimedia"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "VIRA DYAH AYESHA",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Komunikasi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "SALWA ATHIYAH",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Administrasi Fiskal"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "KHAYLA RABBANI",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Administrasi Negara"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MUHAMMAD REZA ALFARIZI",
        jenjang: "S1 Reguler",
        prodi: "Teknik Perkapalan"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ARGA ZHARFAN ISMAIL",
        jenjang: "Vokasi",
        prodi: "Administrasi Rumah Sakit"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MUHAMMAD GATHAN ALTHOF",
        jenjang: "S1 Reguler",
        prodi: "Sastra Belanda"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ZAHRA DWI MAHARANI",
        jenjang: "S1 Reguler",
        prodi: "Sastra Cina"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "DIMAS WIDIYAN ANDREAS",
        jenjang: "Vokasi",
        prodi: "Administrasi Keuangan dan Perbankan \t"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "SHALYNA DHELISA AFFAN",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Komunikasi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "FELICIA REBECCA SIREGAR",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Hubungan Internasional"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "JASMINE AZZAHRA WIDYANTI",
        jenjang: "S1 Reguler",
        prodi: "Sastra Indonesia"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MARSALINA OLIVIA PUTRI",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Administrasi Niaga"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "HABIBAH JASMINE QATRUNNADA",
        jenjang: "S1 Reguler",
        prodi: "Sastra Perancis"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "VITAYA NUR KHALEEDA",
        jenjang: "D4",
        prodi: "Manajemen Rekod dan Arsip"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "FARSYA ALIFA KHAIRUNNISA",
        jenjang: "S1 Reguler",
        prodi: "Sastra Daerah untuk Sastra Jawa"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "WESLEY NICOLAUS",
        jenjang: "S1 Reguler",
        prodi: "Akuntansi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "DAFFA ALFATHAN MAJID",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Kesejahteraan Sosial"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "RESA KORENITA PEMBAYUN",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Aktuaria"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MUHAMMAD ZAHRAN ATTHORIQ",
        jenjang: "Vokasi",
        prodi: "Administrasi Perpajakan"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ZAFIRA SYIFA MAIRA",
        jenjang: "S1 Reguler",
        prodi: "Sastra Arab"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "IQBAL INDIHARSO",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Administrasi Negara"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MOH. IHSAN ANGGARA PUTRA",
        jenjang: "S1 Reguler",
        prodi: "Statistika"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ANAYA MARITZA SALEH",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Komunikasi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "SADRA ALSALAM KELUTUR",
        jenjang: "Vokasi",
        prodi: "Administrasi Perkantoran"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MUTIA ARSYIADINI",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Hubungan Internasional"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "CHELSEA MALIKA PUTRI",
        jenjang: "S1 Reguler",
        prodi: "Antropologi Sosial"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MARIA INTAN PRATIWI",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Administrasi Fiskal"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "NADYA FERISSA PUTRI",
        jenjang: "S1 Reguler",
        prodi: "Sosiologi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "HAURA KHALLISHA NAILA WANTOGIA",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Perpustakaan"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "FALISA PUTRI AZZAHRA",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Administrasi Negara"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "DAVIN ABIYU RAHATWAN",
        jenjang: "S1 Reguler",
        prodi: "Sosiologi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "NABILA KHAIRUNISA ICHWAN",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Ekonomi Islam"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "LUQMAN AL HAKEEM",
        jenjang: "Vokasi",
        prodi: "Akuntansi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "NABIL REAN ATHAILLAH",
        jenjang: "S1 Reguler",
        prodi: "Matematika"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "KHALISHA IRENA DARMAWAN",
        jenjang: "S1 Reguler",
        prodi: "Psikologi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "NABILA PUTRI KARANI",
        jenjang: "S1 Reguler",
        prodi: "Akuntansi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MUHAMMAD NAUFAL HIBATUL FADHLI",
        jenjang: "Vokasi",
        prodi: "Penyiaran Multimedia"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "JESSICA LEVINA PAAIS",
        jenjang: "S1 Reguler",
        prodi: "Sastra Rusia"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "LA ODE MUHAMMAD ZAKY AL HAFIS EMBA",
        jenjang: "Vokasi",
        prodi: "Administrasi Keuangan dan Perbankan \t"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "RADINO ARSYAD AVISYAL",
        jenjang: "Vokasi",
        prodi: "Hubungan Masyarakat"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MOHAMMAD AKHTAR RAFIF SUSILO",
        jenjang: "S1 Reguler",
        prodi: "Statistika"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "BENINGTYAS KAYANA PRAMUDITA",
        jenjang: "S1 Reguler",
        prodi: "Bahasa dan Kebudayaan Korea"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "FEIVEL ANEZKA",
        jenjang: "S1 Reguler",
        prodi: "Psikologi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "CATHERINE BLESSY YOLANDA MARPAUNG",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Ekonomi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "BASIA QUINAIAH HETHARIA",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Hukum"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MUHAMMAD HARIZ TRI WARDHANA",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Kesejahteraan Sosial"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ADELIA FEBRIANA",
        jenjang: "S1 Reguler",
        prodi: "Sastra Daerah untuk Sastra Jawa"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MUHAMAD ANDHIKA RHANDY SATRIA KESUMA",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Ekonomi Islam"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ERNITA ADZKIA AFIDA",
        jenjang: "S1 Reguler",
        prodi: "Sastra Indonesia"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "OCTA VEOLA RAHMA DHINI",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Komunikasi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "NAZWA KAYLA ARSHANTY",
        jenjang: "S1 Reguler",
        prodi: "Psikologi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ABDUL FATTAH TAUFIQURAHMAN",
        jenjang: "S1 Reguler",
        prodi: "Kriminologi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "HANUNAH",
        jenjang: "S1 Reguler",
        prodi: "Sastra Arab"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ANNISA YUFA NURZAHRA",
        jenjang: "Vokasi",
        prodi: "Penyiaran Multimedia"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "RAIFHA MAULID ASYARI",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Politik"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "KARIN RANAYA TANTO",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Administrasi Negara"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "AVICENNA PRATAMA YURISTIAWAN",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Hukum"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "BINTANG AKBAR WIJAYA",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Perpustakaan"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "NYOMAN DEWI TRIARIANA",
        jenjang: "Vokasi",
        prodi: "Administrasi Asuransi dan Aktuaria \t"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ALIKA RAISHA HIDAYAT",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Administrasi Negara"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "TAMIR GHULAM PAMUNGKAS",
        jenjang: "S1 Reguler",
        prodi: "Bisnis Islam"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "KHANAYA CALLUELLA JASMINE SAPUTRA",
        jenjang: "S1 Reguler",
        prodi: "Sosiologi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "AMELIA HAYATI",
        jenjang: "S1 Reguler",
        prodi: "Arkeologi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "AARON JANSEN KALALO",
        jenjang: "D4",
        prodi: "Manajemen Bisnis Pariwisata"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "YVONNE CHERRYLIU",
        jenjang: "S1 Reguler",
        prodi: "Sastra Inggris"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ENSYAH ALIYYAH DZAKIANI",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Administrasi Negara"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MAYA JUNITA",
        jenjang: "Vokasi",
        prodi: "Periklanan Kreatif"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MUHAMMAD ZIDAN DAMANIK",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Politik"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "AGYA NIKEN LARASATI",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Administrasi Fiskal"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MARIO JHONATAN PANDIANGAN",
        jenjang: "S1 Reguler",
        prodi: "Sosiologi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "AZZURA KALILA NAJLA",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Administrasi Fiskal"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "HARAPITRA LITUHAYU PRABASWARI SUSONGKO",
        jenjang: "S1 Reguler",
        prodi: "Farmasi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "FADIA PUTRI AMALIA",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Hukum"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "SYAKIRAH PUTRI NAILAH",
        jenjang: "Vokasi",
        prodi: "Administrasi Rumah Sakit"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "NAZMA ADWA ADIYAN",
        jenjang: "Vokasi",
        prodi: "Administrasi Rumah Sakit"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ANDI ALYA MUKHBITA RUKMAN",
        jenjang: "S1 Reguler",
        prodi: "Psikologi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "KALILA SJARAYYAN HOESIN",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Kesejahteraan Sosial"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "JEHEZKIKOLOSE BRANCO MARMULA",
        jenjang: "S1 Reguler",
        prodi: "Sastra Rusia"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MUHAMMAD FARREL KHAIRY WILDEN",
        jenjang: "D4",
        prodi: "Bisnis Kreatif"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "JIYLAAN HANIYAH",
        jenjang: "Vokasi",
        prodi: "Akuntansi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MUHAMMAD FAYYADH AKBAR ARAFAT",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Administrasi Negara"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "HUMAIRA GHASSANI",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Administrasi Niaga"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "RAYA RIZKY RABBANY",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Kesejahteraan Sosial"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ATHARYAN AHMADAFI RUKMAWAN",
        jenjang: "S1 Reguler",
        prodi: "Akuntansi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MUHAMMAD BINTANG RAMADHAN",
        jenjang: "S1 Reguler",
        prodi: "Akuntansi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "NABILA AUFA HELMI",
        jenjang: "S1 Reguler",
        prodi: "Sosiologi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MUHAMMAD BARI KHAIRUL TSABIT",
        jenjang: "S1 Reguler",
        prodi: "Antropologi Sosial"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ILHAM ADITYA WIBOWO",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Hubungan Internasional"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MUSLIQUL BALDAH",
        jenjang: "S1 Reguler",
        prodi: "Biologi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "GHANIYA AZZAHRA SRI PADMAPANI FIRMAN",
        jenjang: "D4",
        prodi: "Produksi Media"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "HERMAYNIE SYADIFA KAMILA FAUZI",
        jenjang: "S1 Reguler",
        prodi: "Arkeologi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "PANJI ISMAIL SUPANDI",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Hukum"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ADDIENA HAQQI",
        jenjang: "S1 Reguler",
        prodi: "Sastra Inggris"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "NOVAL NURFAUZI",
        jenjang: "Vokasi",
        prodi: "Akuntansi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "GABRIELA ARDHIA HIMASARI",
        jenjang: "Vokasi",
        prodi: "Administrasi Keuangan dan Perbankan \t"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "FATIA NUR FARHANAH",
        jenjang: "S1 Reguler",
        prodi: "Matematika"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "NANDITO PUTRA HENDRAWAN",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Sejarah"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MUHAMMAD RIVA ORYZIA TANJUNG",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Administrasi Negara"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "KEISHA NAULITA ANDRIENNE",
        jenjang: "Vokasi",
        prodi: "Administrasi Perpajakan"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MUHAMMAD ZAHIRUL ISYRAFI",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Hukum"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "PUTRI KHOIRUNISA",
        jenjang: "S1 Reguler",
        prodi: "Sastra Indonesia"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ALDE KALYA NUGROHO PUTRI",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Kesejahteraan Sosial"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "AMELIA DWI LESTARI MUJIONO",
        jenjang: "S1 Reguler",
        prodi: "Arkeologi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "AGATHA SERAVINA",
        jenjang: "S1 Reguler",
        prodi: "Akuntansi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "DZAKIY ACHMADHANI",
        jenjang: "S1 Reguler",
        prodi: "Akuntansi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ADIBAH AFNAN FAIZAH",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Administrasi Fiskal"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ARSHYA JATI KUSUMAWARDANA",
        jenjang: "S1 Reguler",
        prodi: "Sosiologi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MAURA SISTA LISTYANTI",
        jenjang: "S1 Reguler",
        prodi: "Geografi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "GRACE TAMARA SIAHAAN",
        jenjang: "S1 Reguler",
        prodi: "Kimia"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MUHAMMAD AKMAL RAMADHAN RAFFATRIVIAN",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Administrasi Niaga"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "JELITA PRASASTI DEWI",
        jenjang: "S1 Reguler",
        prodi: "Arsitektur Interior"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "LINDA EFRIDA EKA YUANTI",
        jenjang: "S1 Reguler",
        prodi: "Sastra Daerah untuk Sastra Jawa"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MARLOND LEANDERD BATARA",
        jenjang: "S1 Reguler",
        prodi: "Sistem Informasi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "VIANDRA GILAR RAVICO",
        jenjang: "S1 Reguler",
        prodi: "Sastra Daerah untuk Sastra Jawa"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "RADEN AJENG ALYA NURINTAN DEVINA",
        jenjang: "S1 Reguler",
        prodi: "Sastra Perancis"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "CHRISTHOPER GABRIEL SINABUTAR",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Politik"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "LEVINA CHALLISTA CIARTHA",
        jenjang: "S1 Reguler",
        prodi: "Statistika"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ADINDA BRILLIANZA GLORA PRIMA",
        jenjang: "S1 Reguler",
        prodi: "Sastra Belanda"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "HELGA TABITHA KAIRIN MANURUNG",
        jenjang: "D4",
        prodi: "Produksi Media"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "BACHTIAR RIZKI RIYADI",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Administrasi Niaga"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ALTHAF RAMZI KURNIAWAN",
        jenjang: "S1 Reguler",
        prodi: "Sastra Jerman"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "SHOFIYYA NUHA AFIFAH",
        jenjang: "S1 Reguler",
        prodi: "Sastra Indonesia"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "NUSANTARA RIZQY GEMILANG YORI PUTERA",
        jenjang: "S1 Reguler",
        prodi: "Arkeologi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "HAYA MALIHA FAHIMA",
        jenjang: "S1 Reguler",
        prodi: "Bahasa dan Kebudayaan Korea"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "DIMAS HARYO PRASOJO",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Hukum"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MUHAMMAD ARIFIN",
        jenjang: "D4",
        prodi: "Bisnis Kreatif"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "RAISYA GRACE MARTAULI SIREGAR",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Administrasi Negara"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MHD RAFA RODIANSYA DYPO",
        jenjang: "S1 Reguler",
        prodi: "Manajemen"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "LINTAR ARKAN DANISWARA",
        jenjang: "S1 Reguler",
        prodi: "Geologi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "RIVALDO PUTRA HAMZAH",
        jenjang: "S1 Reguler",
        prodi: "Manajemen"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "NABILA WASNAH NAWLYA",
        jenjang: "D4",
        prodi: "Manajemen Bisnis Pariwisata"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "SHOFY MARYAM MURSYIDA",
        jenjang: "S1 Reguler",
        prodi: "Arkeologi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MUHAMAD HISYAM AZ-ZAHRAN",
        jenjang: "S1 Reguler",
        prodi: "Fisika"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ADNAN MUHAMMAD KAUTSAR",
        jenjang: "Vokasi",
        prodi: "Administrasi Perpajakan"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "FARREL EZRA JULIO TAMPUBOLON",
        jenjang: "Vokasi",
        prodi: "Administrasi Perkantoran"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "NABILA AZ-ZAHRA",
        jenjang: "Vokasi",
        prodi: "Administrasi Perkantoran"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "NIRFAN MUHAMMAD RIFKY",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Hukum"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "AKHDAN WIRASENA",
        jenjang: "D4",
        prodi: "Produksi Media"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ATTHYA ZORA FEBRYANA",
        jenjang: "D4",
        prodi: "Bisnis Kreatif"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "SALMA SALSABILA",
        jenjang: "S1 Reguler",
        prodi: "Akuntansi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "NAURAH RAMADHANI",
        jenjang: "S1 Reguler",
        prodi: "Sastra Jerman"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "STEFANO SANDER WINATA",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Hukum"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "DIMAS ATSHILAH DWITAMA",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Administrasi Negara"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "DANADYAKSA NAUFAL WIRASANA",
        jenjang: "D4",
        prodi: "Produksi Media"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MUTIA HAMIDA RAUSHANI",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Kesejahteraan Sosial"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "SITI SARAH SYAHLA",
        jenjang: "Vokasi",
        prodi: "Akuntansi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ASHILLA FATIMA",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Perpustakaan"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "LAURA ANAMIKU KARAN GERGA",
        jenjang: "S1 Reguler",
        prodi: "Sastra Rusia"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "RAJU ALVIN PUTRA BATUARA",
        jenjang: "D4",
        prodi: "Manajemen Rekod dan Arsip"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ASKANIO SIDAN GALLA",
        jenjang: "S1 Reguler",
        prodi: "Kriminologi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "BALQIS ALIFAH HASAN",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Hukum"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ROMWELL JESAYA SOJUAON PURBA",
        jenjang: "S1 Reguler",
        prodi: "Teknik Lingkungan"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "REYNARA PUTRA PRATAMA",
        jenjang: "S1 Reguler",
        prodi: "Studi Gizi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "HILMI AZZAM NAJIYYA",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Ekonomi Islam"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "FADILLA ORIZA AQISHA",
        jenjang: "S1 Reguler",
        prodi: "Sastra Perancis"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "FARAS ABDURRAHMAN",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Hubungan Internasional"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "CHELSEA ANGELINE WINATA",
        jenjang: "S1 Reguler",
        prodi: "Sastra Cina"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "RADHITYA ABIYU HANDOKO",
        jenjang: "Vokasi",
        prodi: "Administrasi Keuangan dan Perbankan \t"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ALETTA AQEELA AZIZ",
        jenjang: "S1 Reguler",
        prodi: "Kesehatan Lingkungan"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "HANIIFAH NAHDAH",
        jenjang: "S1 Reguler",
        prodi: "Bisnis Islam"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "SARAH RAMADHANI",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Administrasi Niaga"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MUHAMMAD RIFQI PUTERA FIRMANSYAH",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Hukum"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ARFITRAH BRILIAN",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Hukum"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "TARYN JUDITHA SITORUS",
        jenjang: "S1 Reguler",
        prodi: "Teknik Elektro"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "PRANATAN UTAMA PAMBUDI WALUYO",
        jenjang: "Vokasi",
        prodi: "Administrasi Asuransi dan Aktuaria \t"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MUHAMMAD HATTA RIDHWAN DZAKY",
        jenjang: "S1 Reguler",
        prodi: "Keselamatan & Kesehatan Kerja"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "CHIKA AZALEANEIRA",
        jenjang: "S1 Reguler",
        prodi: "Arkeologi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MUHAMAD RIZKI FURQON",
        jenjang: "Vokasi",
        prodi: "Administrasi Perpajakan"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "NAILA NURAIDA",
        jenjang: "S1 Reguler",
        prodi: "Studi Gizi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "FIRMAN MAULANA",
        jenjang: "S1 Reguler",
        prodi: "Arkeologi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "FALIHAH FITRIANA ARIF",
        jenjang: "Vokasi",
        prodi: "Akuntansi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "IBRAHIM RAMIZA GUSTAV",
        jenjang: "S1 Reguler",
        prodi: "Sastra Daerah untuk Sastra Jawa"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "SHAREN SABIANI RADITHYA",
        jenjang: "S1 Reguler",
        prodi: "Psikologi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ANDREA ATHENIA LIMPELE",
        jenjang: "Vokasi",
        prodi: "Hubungan Masyarakat"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "JOANNE GRACE SIMANJUNTAK",
        jenjang: "Vokasi",
        prodi: "Periklanan Kreatif"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "SYARIFA LATIFAH",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Perpustakaan"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "RAJWA GADIZA DWI AJI",
        jenjang: "S1 Reguler",
        prodi: "Psikologi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MUHAMMAD JOVAN RAJASA",
        jenjang: "S1 Reguler",
        prodi: "Akuntansi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "KEISHA NOURAPUTRI",
        jenjang: "S1 Reguler",
        prodi: "Sosiologi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "DANENDRA APTAMAHOGRA BRATAJAYA",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Administrasi Negara"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "AYISHA FATIA ATHIFAH",
        jenjang: "S1 Reguler",
        prodi: "Bahasa dan Kebudayaan Korea"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ISMAIL ADHALILLAH",
        jenjang: "D4",
        prodi: "Bisnis Kreatif"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "NADRA IZDIHAR MUKHTAR",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Ekonomi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "AMMARA DYRA NAFISA",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Administrasi Niaga"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "NURLITA",
        jenjang: "S1 Reguler",
        prodi: "Arkeologi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MORENO HAFIZH EIGERLAND",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Politik"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "FATHAN ABDURRAHMAN KUSHARTO",
        jenjang: "S1 Reguler",
        prodi: "Teknik Perkapalan"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ALYAA DAYANGKU RAHMA",
        jenjang: "S1 Reguler",
        prodi: "Antropologi Sosial"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "KEISHA AZZAHRA",
        jenjang: "S1 Reguler",
        prodi: "Sastra Jerman"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "RASSYAD MULYO RAHARDJO",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Kesejahteraan Sosial"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MUHAMMAD AFIF BINTANG MAHAMERU",
        jenjang: "S1 Reguler",
        prodi: "Antropologi Sosial"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "DRIANDRA LARASATI ALLODYA ANDRI ASYARI",
        jenjang: "S1 Reguler",
        prodi: "Akuntansi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "VALEZKA NADIA CENDANA ARUM",
        jenjang: "S1 Reguler",
        prodi: "Sastra Indonesia"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "KHANSABRINA NABILAH NIADI",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Hukum"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "QORY FELLYCIA SIMANUNGKALIT",
        jenjang: "S1 Reguler",
        prodi: "Sastra Cina"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "AZKA AULIA LESMANA",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Administrasi Negara"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "CHALISA STIYONA DEWI",
        jenjang: "S1 Reguler",
        prodi: "Sastra Rusia"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "EARLENE DZAKIRA",
        jenjang: "S1 Reguler",
        prodi: "Sistem Informasi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "FAJAR ADITYA SUHARTO",
        jenjang: "S1 Reguler",
        prodi: "Geologi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ZARA SETIRA ANJANI",
        jenjang: "S1 Reguler",
        prodi: "Sastra Indonesia"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "HELENA FEBRIYANTI",
        jenjang: "S1 Reguler",
        prodi: "Kesehatan Lingkungan"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ARSENIO HUGO PRASETYO GULTOM",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Ekonomi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "NAOMI ARYANNA",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Administrasi Niaga"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "SITI SARAH",
        jenjang: "D4",
        prodi: "Bisnis Kreatif"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "NAYLA NURWAHIDAH RISTIANY",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Kesejahteraan Sosial"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "NASSEL AULIYA YONEZZA",
        jenjang: "S1 Reguler",
        prodi: "Teknik Lingkungan"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "SANAYA ROSSA KHAIRUNNISA",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Komunikasi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "FERELL ZAVIER ISKANDAR",
        jenjang: "S1 Reguler",
        prodi: "Manajemen"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "AZALIA RATU NANDITA",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Komunikasi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MUHAMMAD HEYZEL STHEFANO ARSYAL",
        jenjang: "S1 Reguler",
        prodi: "Geografi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "LUVENA AURELLIA HERVIANA",
        jenjang: "Vokasi",
        prodi: "Hubungan Masyarakat"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "SAMANTHA TJAHYONO",
        jenjang: "S1 Reguler",
        prodi: "Antropologi Sosial"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "FARREL MUHAMMAD ASLA",
        jenjang: "S1 Reguler",
        prodi: "Sastra Jerman"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "HANIFA FITRI YADEL",
        jenjang: "Vokasi",
        prodi: "Akuntansi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "HAUNA YAHDIYAN NUURIY",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Administrasi Niaga"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "KEITARO ABRAHAM PANE",
        jenjang: "Vokasi",
        prodi: "Periklanan Kreatif"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MAHIRA ZAHRA HUWAIDA",
        jenjang: "S1 Reguler",
        prodi: "Biologi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "LOUIS MICHAEL CHANDRA",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Sejarah"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ANINDYA ASTRI KHAIRUNNISA",
        jenjang: "S1 Reguler",
        prodi: "Sastra Indonesia"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ALYA HAZEL ANDRIANI",
        jenjang: "S1 Reguler",
        prodi: "Sastra Inggris"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ADHITYA ANWAR. AR",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Politik"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MUHAMMAD FAWWAZ RAJA PURNAMA",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Ekonomi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "GHAIDA NABILA TRIYASWORO",
        jenjang: "D4",
        prodi: "Manajemen Bisnis Pariwisata"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ZA'IM SYA'BAN SYAUQI AZ-ZIKRA",
        jenjang: "S1 Reguler",
        prodi: "Sastra Rusia"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "KALILA TITANIA PUTRI BINTANG",
        jenjang: "S1 Reguler",
        prodi: "Arkeologi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "FADYA SAOFAYURO",
        jenjang: "S1 Reguler",
        prodi: "Kesehatan Masyarakat"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "AFFAN MUHAMMAD RASHAD",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Administrasi Fiskal"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ELSAVA ROSYITA DEVIYANA",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Administrasi Fiskal"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "JAUZA ALVEDA FANPUTCI",
        jenjang: "Vokasi",
        prodi: "Administrasi Keuangan dan Perbankan \t"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "NAJMI RASYADAN SYANABIIL",
        jenjang: "Vokasi",
        prodi: "Hubungan Masyarakat"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "AZMAYRA DANYA FATHA",
        jenjang: "S1 Reguler",
        prodi: "Manajemen"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ALI ZEIDAN",
        jenjang: "S1 Reguler",
        prodi: "Antropologi Sosial"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ELLEN AMANDA SIMAMORA",
        jenjang: "Vokasi",
        prodi: "Akuntansi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ANDARA NAYLA RAMADHANI",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Filsafat"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "BERINDA ANTARI",
        jenjang: "S1 Reguler",
        prodi: "Kriminologi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "NADILA BULAN SAHRINA PUTRI",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Administrasi Niaga"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ELKIBA PATRIS RUMAMBA",
        jenjang: "D4",
        prodi: "Produksi Media"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MUHAMMAD FARIH ALBANI",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Administrasi Negara"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "NICO CHRISTIAN BONARDO MANULANG",
        jenjang: "S1 Reguler",
        prodi: "Teknik Lingkungan"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "HANIF IBNU IHSAN",
        jenjang: "S1 Reguler",
        prodi: "Geografi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "FAHIRA NABILA ARIFIN",
        jenjang: "S1 Reguler",
        prodi: "Sastra Perancis"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ADELIA ZAHWA FRAMADHANI",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Administrasi Fiskal"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "PHOENIX QODRA ISLAMI HERMANTO",
        jenjang: "S1 Reguler",
        prodi: "Akuntansi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "FASYA RIFKA AGNIA",
        jenjang: "S1 Reguler",
        prodi: "Keselamatan & Kesehatan Kerja"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ASHILA HASYA",
        jenjang: "S1 Reguler",
        prodi: "Geografi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "CALLULA REZI MAHESWARI",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Sejarah"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ISNANIAH",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Sejarah"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ADELIO DZAKWAN MARTAWILAGA",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Hukum"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "AKMAL ALGHIFFARI",
        jenjang: "S1 Reguler",
        prodi: "Sastra Arab"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ADMIRALY ARDRA KUSUMA",
        jenjang: "Vokasi",
        prodi: "Administrasi Perkantoran"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "HAIDAR MAHMOUD ROHMANOV",
        jenjang: "S1 Reguler",
        prodi: "Ilmu Komunikasi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "DAHAYU SALSABILA",
        jenjang: "D4",
        prodi: "Fisioterapi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ADINE RAHMA JULIA",
        jenjang: "S1 Reguler",
        prodi: "Farmasi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "RAHVEDI AMMAR VALENTHINO",
        jenjang: "S1 Reguler",
        prodi: "Teknik Metalurgi & Material"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "AHMAD ALIFAHMI",
        jenjang: "Vokasi",
        prodi: "Periklanan Kreatif"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "AMMAR ABDUL HAKIM",
        jenjang: "Vokasi",
        prodi: "Administrasi Perkantoran"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "NABILA ISWARA",
        jenjang: "RPL (Ekstensi)",
        prodi: "Kesehatan Masyarakat - Administrasi dan Kebijakan Kesehatan - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "JIHAN KHAFIDHOTIN NAJAH",
        jenjang: "RPL (Ekstensi)",
        prodi: "Ilmu Administrasi Fiskal"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "KEVIN IMMANUEL",
        jenjang: "RPL (Ekstensi)",
        prodi: "Manajemen - Ekstensi - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MOHAMMAD RAFIE ALTAMIS",
        jenjang: "RPL (Ekstensi)",
        prodi: "Ilmu Hukum - Ekstensi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MIFTACHUL MUJAHID",
        jenjang: "RPL (Ekstensi)",
        prodi: "Ilmu Keperawatan"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "CHIARA CHATLINA AMELINDA",
        jenjang: "RPL (Ekstensi)",
        prodi: "Manajemen - Ekstensi - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MUHAMMAD FARRAS FADLURRAHMAN",
        jenjang: "RPL (Ekstensi)",
        prodi: "Kesehatan Masyarakat - Administrasi dan Kebijakan Kesehatan - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ADLI MUHAMMAD SISWOKO",
        jenjang: "RPL (Ekstensi)",
        prodi: "Akuntansi - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "IKYUWAN PUTRINYA FEMISTA",
        jenjang: "RPL (Ekstensi)",
        prodi: "Manajemen - Ekstensi - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ALYSHA HAYFADAFANI KHAIRUNNISA",
        jenjang: "RPL (Ekstensi)",
        prodi: "Ilmu Administrasi Fiskal"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "PRADIFTA WEDI ANANTA",
        jenjang: "RPL (Ekstensi)",
        prodi: "Akuntansi - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ADRO MEDIANTORO",
        jenjang: "RPL (Ekstensi)",
        prodi: "Manajemen - Ekstensi - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ARINDA MAULIDINA",
        jenjang: "RPL (Ekstensi)",
        prodi: "Akuntansi - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "AMALIA ROOSHIDAYAH",
        jenjang: "RPL (Ekstensi)",
        prodi: "Manajemen - Ekstensi - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "AISYAH ASHARI CHELSI",
        jenjang: "RPL (Ekstensi)",
        prodi: "Akuntansi - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "FAYIZ MUHAMMAD",
        jenjang: "RPL (Ekstensi)",
        prodi: "Ilmu Administrasi Niaga"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "DHIAH RAHMAWATI",
        jenjang: "RPL (Ekstensi)",
        prodi: "Manajemen - Ekstensi - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MAHARANI APTA CANDRANINGTYAS",
        jenjang: "RPL (Ekstensi)",
        prodi: "Manajemen - Ekstensi - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ADDINA SALSABILA NURDIANTI",
        jenjang: "RPL (Ekstensi)",
        prodi: "Ilmu Administrasi Fiskal"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "DIAN VITRIA NINGSIH",
        jenjang: "RPL (Ekstensi)",
        prodi: "Akuntansi - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "BINTANG ARINTA SARI",
        jenjang: "RPL (Ekstensi)",
        prodi: "Ilmu Keperawatan"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ANGGITARA HANUM ANJANI",
        jenjang: "RPL (Ekstensi)",
        prodi: "Akuntansi - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "KHAIRUNNISAH FANANI LUBIS",
        jenjang: "RPL (Ekstensi)",
        prodi: "Ilmu Administrasi Fiskal"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ALVIRA HELENA KAMELLA KAMAL",
        jenjang: "RPL (Ekstensi)",
        prodi: "Ilmu Administrasi Niaga"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "NABILA ANITA SARI",
        jenjang: "RPL (Ekstensi)",
        prodi: "Ilmu Administrasi Negara"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "TETI ERIKAWATI",
        jenjang: "RPL (Ekstensi)",
        prodi: "Kesehatan Masyarakat - Administrasi dan Kebijakan Kesehatan - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ANDARA NIAR HARNUM SALSABILA",
        jenjang: "RPL (Ekstensi)",
        prodi: "Akuntansi - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "VINI MELYATI PUTRI",
        jenjang: "RPL (Ekstensi)",
        prodi: "Akuntansi - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "DEVITA ANGGRAINI",
        jenjang: "RPL (Ekstensi)",
        prodi: "Ilmu Keperawatan"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "DWINA KHRISMA CEVAYANTI",
        jenjang: "RPL (Ekstensi)",
        prodi: "Akuntansi - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "TARSINI",
        jenjang: "RPL (Ekstensi)",
        prodi: "Kesehatan Masyarakat - Epidemiologi - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MUHAMMAD YUNUS FIRMANSYAH",
        jenjang: "RPL (Ekstensi)",
        prodi: "Akuntansi - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "IHZA RIDHA FATHDHIEN",
        jenjang: "RPL (Ekstensi)",
        prodi: "Akuntansi - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ERINN WIDYA BUTAR BUTAR",
        jenjang: "RPL (Ekstensi)",
        prodi: "Manajemen - Ekstensi - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "RENI NURHIDAYATI",
        jenjang: "RPL (Ekstensi)",
        prodi: "Akuntansi - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ANJANI PUTRI DESMA",
        jenjang: "RPL (Ekstensi)",
        prodi: "Ilmu Administrasi Niaga"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "I DEWA GEDE VRISCHIKA SEDANAYOGA",
        jenjang: "RPL (Ekstensi)",
        prodi: "Manajemen - Ekstensi - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "RENTI ISWARINDRA",
        jenjang: "RPL (Ekstensi)",
        prodi: "Kesehatan Masyarakat - Administrasi dan Kebijakan Kesehatan - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "REZA MUHAMAD ILHAM",
        jenjang: "RPL (Ekstensi)",
        prodi: "Akuntansi - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "FADIYANI TEJA SYARIFA",
        jenjang: "RPL (Ekstensi)",
        prodi: "Manajemen - Ekstensi - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "CAMELIAH HAMDANI",
        jenjang: "RPL (Ekstensi)",
        prodi: "Manajemen - Ekstensi - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "DARA ASAKU QOLBI",
        jenjang: "RPL (Ekstensi)",
        prodi: "Akuntansi - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MERCY",
        jenjang: "RPL (Ekstensi)",
        prodi: "Akuntansi - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MAHESA MAHENDRA",
        jenjang: "RPL (Ekstensi)",
        prodi: "Ilmu Keperawatan"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MAYA PUSPITA SARI",
        jenjang: "RPL (Ekstensi)",
        prodi: "Kesehatan Masyarakat - Administrasi dan Kebijakan Kesehatan - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "DIVA MALIHA AUDREY",
        jenjang: "RPL (Ekstensi)",
        prodi: "Manajemen - Ekstensi - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ARIEF HARZANTO",
        jenjang: "RPL (Ekstensi)",
        prodi: "Ilmu Keperawatan"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "GABRIELLA TIRTANY NATHALIA",
        jenjang: "RPL (Ekstensi)",
        prodi: "Ilmu Hukum - Ekstensi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "SAFRINA AQMAR FIRZANAH",
        jenjang: "RPL (Ekstensi)",
        prodi: "Manajemen - Ekstensi - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "NETTA AN'AMTA DESLI SANATI",
        jenjang: "RPL (Ekstensi)",
        prodi: "Manajemen - Ekstensi - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "NURUL BAHRIAH RATNAPURI",
        jenjang: "RPL (Ekstensi)",
        prodi: "Ilmu Keperawatan"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MUGHNIA HUSNA LATHIFUNNISA",
        jenjang: "RPL (Ekstensi)",
        prodi: "Ilmu Keperawatan"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "RAJA SULTAN SYAH",
        jenjang: "RPL (Ekstensi)",
        prodi: "Manajemen - Ekstensi - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "RENDI APRIYANTO",
        jenjang: "RPL (Ekstensi)",
        prodi: "Ilmu Hukum - Ekstensi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "SELVYA MUQITASYARI",
        jenjang: "RPL (Ekstensi)",
        prodi: "Ilmu Keperawatan"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "SITI NURHASANAH",
        jenjang: "RPL (Ekstensi)",
        prodi: "Ilmu Keperawatan"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "FANY RAHMAN",
        jenjang: "RPL (Ekstensi)",
        prodi: "Ilmu Administrasi Fiskal"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "SOLA GRATIA VINOLA",
        jenjang: "RPL (Ekstensi)",
        prodi: "Akuntansi - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ZULKARNAIN",
        jenjang: "RPL (Ekstensi)",
        prodi: "Manajemen - Ekstensi - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "SUCI RAMDANI URBANINGRUM",
        jenjang: "RPL (Ekstensi)",
        prodi: "Akuntansi - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "AHMAD ADNAN MANAF",
        jenjang: "RPL (Ekstensi)",
        prodi: "Akuntansi - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "SUKMA WATY MANALU",
        jenjang: "RPL (Ekstensi)",
        prodi: "Ilmu Hukum - Ekstensi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "DHIYA KHAIYIRA SIREGAR",
        jenjang: "RPL (Ekstensi)",
        prodi: "Akuntansi - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "DINDA FAUZIATUL HUDA",
        jenjang: "RPL (Ekstensi)",
        prodi: "Manajemen - Ekstensi - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "NABILA PUTRI PRAMESTI",
        jenjang: "RPL (Ekstensi)",
        prodi: "Manajemen - Ekstensi - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "HASBIE",
        jenjang: "RPL (Ekstensi)",
        prodi: "Manajemen - Ekstensi - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "SONIA ANITA RAMADHAN",
        jenjang: "RPL (Ekstensi)",
        prodi: "Manajemen - Ekstensi - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "PRIHATINI PUSPA PERTIWI",
        jenjang: "RPL (Ekstensi)",
        prodi: "Kesehatan Masyarakat - Administrasi dan Kebijakan Kesehatan - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "SHERIN FITRIAN",
        jenjang: "RPL (Ekstensi)",
        prodi: "Kesehatan Masyarakat - Administrasi dan Kebijakan Kesehatan - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "AYUNI MOYA",
        jenjang: "RPL (Ekstensi)",
        prodi: "Akuntansi - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "FIRDA FIDELA ANNORA DYLLA",
        jenjang: "RPL (Ekstensi)",
        prodi: "Ilmu Administrasi Fiskal"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "RIDWAN",
        jenjang: "RPL (Ekstensi)",
        prodi: "Ilmu Keperawatan"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "DWI RAHAYU ASTUTI",
        jenjang: "RPL (Ekstensi)",
        prodi: "Ilmu Keperawatan"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "NADA ZULVA KHAIRANI",
        jenjang: "RPL (Ekstensi)",
        prodi: "Ilmu Hukum - Ekstensi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "FIKRI SEKAR AJENG",
        jenjang: "RPL (Ekstensi)",
        prodi: "Manajemen - Ekstensi - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MATTHEW SERAFINO PRATAMA PUTRA",
        jenjang: "RPL (Ekstensi)",
        prodi: "Ilmu Administrasi Niaga"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ANENA CINDITASARI",
        jenjang: "RPL (Ekstensi)",
        prodi: "Akuntansi - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "HIDAYATUL IKHSAN",
        jenjang: "RPL (Ekstensi)",
        prodi: "Ilmu Keperawatan"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "NESTI RAHAYU",
        jenjang: "RPL (Ekstensi)",
        prodi: "Kesehatan Masyarakat - Promosi Kesehatan - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "NANDARA FITRA IZZATI",
        jenjang: "RPL (Ekstensi)",
        prodi: "Manajemen - Ekstensi - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "CATUR RIZKI PINDI",
        jenjang: "RPL (Ekstensi)",
        prodi: "Kesehatan Masyarakat - Epidemiologi - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "SADDAM RAMADHAN GOTAMA",
        jenjang: "RPL (Ekstensi)",
        prodi: "Akuntansi - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "DANIEL REZEKI MARPAUNG",
        jenjang: "RPL (Ekstensi)",
        prodi: "Akuntansi - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "DIVA THALIA NUZUL RAMADHANI",
        jenjang: "RPL (Ekstensi)",
        prodi: "Ilmu Hukum - Ekstensi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "BUSTANUL ARIFIN",
        jenjang: "RPL (Ekstensi)",
        prodi: "Ilmu Administrasi Fiskal"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "NITA YUNITA SRIAYU",
        jenjang: "RPL (Ekstensi)",
        prodi: "Ilmu Administrasi Fiskal"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "RIFDA FADILLAH HAYA",
        jenjang: "RPL (Ekstensi)",
        prodi: "Akuntansi - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "LESTARI EVINA NAIBAHO",
        jenjang: "RPL (Ekstensi)",
        prodi: "Ilmu Keperawatan"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "AGTRI DARFIANI",
        jenjang: "RPL (Ekstensi)",
        prodi: "Ilmu Keperawatan"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "SHAFIRA DWI RAHMADANI",
        jenjang: "RPL (Ekstensi)",
        prodi: "Akuntansi - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "VINA AMALIA",
        jenjang: "RPL (Ekstensi)",
        prodi: "Ilmu Keperawatan"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MUTIA ANISA FILDZALIA",
        jenjang: "RPL (Ekstensi)",
        prodi: "Kesehatan Masyarakat - Administrasi dan Kebijakan Kesehatan - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "EUIS ADELIA ASSYFA",
        jenjang: "RPL (Ekstensi)",
        prodi: "Ilmu Administrasi Fiskal"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "HADID RISWANDHA MAULANA",
        jenjang: "RPL (Ekstensi)",
        prodi: "Manajemen - Ekstensi - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "NABILA SABRINA",
        jenjang: "RPL (Ekstensi)",
        prodi: "Kesehatan Masyarakat - Epidemiologi - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "NITA SAFIRA",
        jenjang: "RPL (Ekstensi)",
        prodi: "Manajemen - Ekstensi - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "TRIBUANA WAHYU SAVITRI",
        jenjang: "RPL (Ekstensi)",
        prodi: "Ilmu Keperawatan"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "FEBIOLA BOANG MANALU",
        jenjang: "RPL (Ekstensi)",
        prodi: "Manajemen - Ekstensi - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "DIONISIUS IRANG",
        jenjang: "RPL (Ekstensi)",
        prodi: "Ilmu Administrasi Negara"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "FALENTINA PUDUNG",
        jenjang: "RPL (Ekstensi)",
        prodi: "Ilmu Administrasi Negara"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ALIYA NURUL FAUZIAH",
        jenjang: "RPL (Ekstensi)",
        prodi: "Kesehatan Masyarakat - Administrasi dan Kebijakan Kesehatan - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "GABRIEL MARIA IMAKULATA RAMOS DJOKA",
        jenjang: "RPL (Ekstensi)",
        prodi: "Ilmu Administrasi Negara"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "RAIHAN FADIL DESMON",
        jenjang: "RPL (Ekstensi)",
        prodi: "Ilmu Administrasi Niaga"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "YANTI YULIANTI",
        jenjang: "RPL (Ekstensi)",
        prodi: "Ilmu Keperawatan"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "DWI OKTIWINDARI",
        jenjang: "RPL (Ekstensi)",
        prodi: "Ilmu Keperawatan"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "DYAH ANI NURUL YULITA",
        jenjang: "RPL (Ekstensi)",
        prodi: "Akuntansi - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "WIRAWAN MOEHAMMAD",
        jenjang: "RPL (Ekstensi)",
        prodi: "Ilmu Hukum - Ekstensi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "RAISA MUHAMMAD",
        jenjang: "RPL (Ekstensi)",
        prodi: "Kesehatan Masyarakat - Epidemiologi - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ALIFA HIBATILLAH RAYYANA",
        jenjang: "RPL (Ekstensi)",
        prodi: "Ilmu Hukum - Ekstensi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "RINA ARIFANI",
        jenjang: "RPL (Ekstensi)",
        prodi: "Ilmu Hukum - Ekstensi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "SRI RAHAYU",
        jenjang: "RPL (Ekstensi)",
        prodi: "Ilmu Keperawatan"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "AMANDA KAYLA RIYADI PUTRI",
        jenjang: "RPL (Ekstensi)",
        prodi: "Ilmu Hukum - Ekstensi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MIFTHAHQUL YANTIKA PUTRA",
        jenjang: "RPL (Ekstensi)",
        prodi: "Ilmu Hukum - Ekstensi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ASFAR ADITAMA",
        jenjang: "RPL (Ekstensi)",
        prodi: "Akuntansi - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ATHIYAH NABILA REZANA",
        jenjang: "RPL (Ekstensi)",
        prodi: "Manajemen - Ekstensi - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "WAYAN DYEGO SATYAWAN",
        jenjang: "RPL (Ekstensi)",
        prodi: "Ilmu Keperawatan"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "TOMY DAVIDSON",
        jenjang: "RPL (Ekstensi)",
        prodi: "Ilmu Administrasi Negara"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "RISCHA JULIANA",
        jenjang: "RPL (Ekstensi)",
        prodi: "Ilmu Keperawatan"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "YOSEFINA MELANIA",
        jenjang: "RPL (Ekstensi)",
        prodi: "Ilmu Administrasi Negara"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "FADHILAH SOPHIA LATUPONO",
        jenjang: "RPL (Ekstensi)",
        prodi: "Manajemen - Ekstensi - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "RISYA SYAROFINA NINDIA",
        jenjang: "RPL (Ekstensi)",
        prodi: "Akuntansi - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "SISILIA DOQ",
        jenjang: "RPL (Ekstensi)",
        prodi: "Ilmu Administrasi Negara"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "NURUL QOMARIAH",
        jenjang: "RPL (Ekstensi)",
        prodi: "Akuntansi - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ACHMAD ZULFIKAR ULUPUTTY",
        jenjang: "RPL (Ekstensi)",
        prodi: "Ilmu Keperawatan"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "SHABRINA EKA PUTRI",
        jenjang: "RPL (Ekstensi)",
        prodi: "Kesehatan Masyarakat - Epidemiologi - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "IMELDA DEVITA LENI",
        jenjang: "RPL (Ekstensi)",
        prodi: "Ilmu Keperawatan"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "DAYANG SERUNI LINTANG MALAECCA",
        jenjang: "RPL (Ekstensi)",
        prodi: "Ilmu Hukum - Ekstensi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MATERNUS HIRANG",
        jenjang: "RPL (Ekstensi)",
        prodi: "Ilmu Administrasi Negara"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ANNISYA PUSPITARANI",
        jenjang: "RPL (Ekstensi)",
        prodi: "Kesehatan Masyarakat - Administrasi dan Kebijakan Kesehatan - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "IKFINA NUR AINI",
        jenjang: "RPL (Ekstensi)",
        prodi: "Manajemen - Ekstensi - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "VIRA IKHWANI",
        jenjang: "RPL (Ekstensi)",
        prodi: "Akuntansi - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ALICIA INTAN KRISTY SITOMPUL",
        jenjang: "RPL (Ekstensi)",
        prodi: "Ilmu Hukum - Ekstensi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MARTIN PANOLUI",
        jenjang: "RPL (Ekstensi)",
        prodi: "Akuntansi - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "RAHMATUL KHOIRUNNISA",
        jenjang: "RPL (Ekstensi)",
        prodi: "Ilmu Keperawatan"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "PRAMES NIRA JATI",
        jenjang: "RPL (Ekstensi)",
        prodi: "Ilmu Administrasi Fiskal"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "SILAU GUDEN",
        jenjang: "RPL (Ekstensi)",
        prodi: "Ilmu Administrasi Negara"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ANASTASIA TERESA STEFANY",
        jenjang: "RPL (Ekstensi)",
        prodi: "Ilmu Hukum - Ekstensi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "NOVIA EKA SULISTIOWATI",
        jenjang: "RPL (Ekstensi)",
        prodi: "Ilmu Keperawatan"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ARDIAN YOGI ADI PRASETYO",
        jenjang: "RPL (Ekstensi)",
        prodi: "Kesehatan Masyarakat - Epidemiologi - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "NURHAYATI INDAH LESTARI",
        jenjang: "RPL (Ekstensi)",
        prodi: "Ilmu Keperawatan"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ERI LALITA DEWANTI",
        jenjang: "RPL (Ekstensi)",
        prodi: "Ilmu Keperawatan"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "BERNARDUS MARCELLO AGIEUS",
        jenjang: "RPL (Ekstensi)",
        prodi: "Akuntansi - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "AZIZAH SEPTIANI",
        jenjang: "RPL (Ekstensi)",
        prodi: "Ilmu Keperawatan"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "TITI NURKAMILA",
        jenjang: "RPL (Ekstensi)",
        prodi: "Ilmu Keperawatan"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "SAVITRI ALMIRA SYAKUR",
        jenjang: "RPL (Ekstensi)",
        prodi: "Ilmu Keperawatan"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "IBAU JAU",
        jenjang: "RPL (Ekstensi)",
        prodi: "Ilmu Administrasi Negara"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ZAHRA SINTA ADITYA",
        jenjang: "RPL (Ekstensi)",
        prodi: "Kesehatan Masyarakat - Administrasi dan Kebijakan Kesehatan - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "VERONIKA SAGALA",
        jenjang: "RPL (Ekstensi)",
        prodi: "Akuntansi - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "RANDY PUTRA",
        jenjang: "RPL (Ekstensi)",
        prodi: "Ilmu Administrasi Niaga"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "HERLINDA",
        jenjang: "RPL (Ekstensi)",
        prodi: "Kesehatan Masyarakat - Administrasi dan Kebijakan Kesehatan - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "IVANA ZEIN",
        jenjang: "RPL (Ekstensi)",
        prodi: "Manajemen - Ekstensi - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "IKHWAN ANDI MANSYUR",
        jenjang: "RPL (Ekstensi)",
        prodi: "Ilmu Hukum - Ekstensi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "DANDY ADAM",
        jenjang: "RPL (Ekstensi)",
        prodi: "Akuntansi - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "AMINI SALAMAH",
        jenjang: "RPL (Ekstensi)",
        prodi: "Akuntansi - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "RYAN PUTRA YUSENDA DALIMUNTHE",
        jenjang: "RPL (Ekstensi)",
        prodi: "Akuntansi - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ANISA DJOHAN",
        jenjang: "RPL (Ekstensi)",
        prodi: "Kesehatan Masyarakat - Administrasi dan Kebijakan Kesehatan - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "GABRIEL ADIARSA WARADHANA",
        jenjang: "RPL (Ekstensi)",
        prodi: "Manajemen - Ekstensi - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "AULIA REFIKA ZAHRA KHUSUMA",
        jenjang: "RPL (Ekstensi)",
        prodi: "Akuntansi - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "B. LIA MERDIANA",
        jenjang: "RPL (Ekstensi)",
        prodi: "Ilmu Keperawatan"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MELATI PUSPA CHANTIKA",
        jenjang: "RPL (Ekstensi)",
        prodi: "Manajemen - Ekstensi - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "INDANA RAKASHIVI",
        jenjang: "RPL (Ekstensi)",
        prodi: "Manajemen - Ekstensi - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "NADIA FATMAWATI",
        jenjang: "RPL (Ekstensi)",
        prodi: "Ilmu Keperawatan"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "YOS MELLYSA",
        jenjang: "RPL (Ekstensi)",
        prodi: "Ilmu Keperawatan"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "WIASRI MUKTIKA",
        jenjang: "RPL (Ekstensi)",
        prodi: "Akuntansi - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "SILVIA YUNITA DAMANIK",
        jenjang: "RPL (Ekstensi)",
        prodi: "Kesehatan Masyarakat - Kesehatan Reproduksi - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "DEWA AYU SUKMA SARASWATI",
        jenjang: "RPL (Ekstensi)",
        prodi: "Ilmu Keperawatan"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "BERTHA DANIA WIJAYANTI KURNIANTO",
        jenjang: "RPL (Ekstensi)",
        prodi: "Akuntansi - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "SINTA AKNES",
        jenjang: "RPL (Ekstensi)",
        prodi: "Ilmu Administrasi Negara"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "FAISAL RACHMAN AZHARI",
        jenjang: "RPL (Ekstensi)",
        prodi: "Ilmu Keperawatan"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "SYAMSUL BACHRI",
        jenjang: "RPL (Ekstensi)",
        prodi: "Akuntansi - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "HASYAHUSNAA DRUPADI DEWI",
        jenjang: "RPL (Ekstensi)",
        prodi: "Manajemen - Ekstensi - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ADISSA DAYINTA RAMADINA",
        jenjang: "RPL (Ekstensi)",
        prodi: "Ilmu Keperawatan"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "APRILIA REIKHA NURULLITA",
        jenjang: "RPL (Ekstensi)",
        prodi: "Manajemen - Ekstensi - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "FAYOLA HASNA AMARANTI",
        jenjang: "RPL (Ekstensi)",
        prodi: "Ilmu Administrasi Niaga"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "EFRAIM WALESASI",
        jenjang: "RPL (Ekstensi)",
        prodi: "Manajemen - Ekstensi - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "SALSABILA AGIL SAPUTRI",
        jenjang: "RPL (Ekstensi)",
        prodi: "Ilmu Hukum - Ekstensi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "DHENA FRISTA HAFIZHA",
        jenjang: "RPL (Ekstensi)",
        prodi: "Ilmu Hukum - Ekstensi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ZAHRAH FAKHIRAH SYAM",
        jenjang: "RPL (Ekstensi)",
        prodi: "Kesehatan Masyarakat - Promosi Kesehatan - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "DIPA NARENDRA",
        jenjang: "RPL (Ekstensi)",
        prodi: "Ilmu Hukum - Ekstensi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "FAHRI BAIHAQI",
        jenjang: "RPL (Ekstensi)",
        prodi: "Ilmu Administrasi Niaga"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "DANIEL MATTHEW SHEVCHENKO MANIK",
        jenjang: "RPL (Ekstensi)",
        prodi: "Manajemen - Ekstensi - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ANNISA ROMADHANI",
        jenjang: "RPL (Ekstensi)",
        prodi: "Kesehatan Masyarakat - Kesehatan Reproduksi - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "RETNO KUSUMAWARDANI",
        jenjang: "RPL (Ekstensi)",
        prodi: "Akuntansi - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "LOLA ARITASARI",
        jenjang: "RPL (Ekstensi)",
        prodi: "Ilmu Hukum - Ekstensi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "PUTRI FATHIMAH AZZAHRA",
        jenjang: "RPL (Ekstensi)",
        prodi: "Ilmu Administrasi Niaga"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "AZMI SHAKILA KHAIRANY",
        jenjang: "RPL (Ekstensi)",
        prodi: "Kesehatan Masyarakat - Promosi Kesehatan - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "PINTANING LARASATI",
        jenjang: "RPL (Ekstensi)",
        prodi: "Manajemen - Ekstensi - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "HISAN ANIS MATTA",
        jenjang: "RPL (Ekstensi)",
        prodi: "Ilmu Hukum - Ekstensi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "AULIA FAJRIYATI DZIKRIYAH",
        jenjang: "RPL (Ekstensi)",
        prodi: "Manajemen - Ekstensi - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "KHOIRUNNISA",
        jenjang: "RPL (Ekstensi)",
        prodi: "Akuntansi - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "CUT SYIFA YASMIN",
        jenjang: "RPL (Ekstensi)",
        prodi: "Akuntansi - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "GANIS NUR FAIZAH",
        jenjang: "RPL (Ekstensi)",
        prodi: "Ilmu Administrasi Fiskal"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "FAUZIYAH SALSABILA",
        jenjang: "RPL (Ekstensi)",
        prodi: "Akuntansi - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "RISMA AGUSTINA",
        jenjang: "RPL (Ekstensi)",
        prodi: "Ilmu Keperawatan"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "NAURA NADHIFAH",
        jenjang: "RPL (Ekstensi)",
        prodi: "Kesehatan Masyarakat - Administrasi dan Kebijakan Kesehatan - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "NDARU CAHYA DEWANTI",
        jenjang: "RPL (Ekstensi)",
        prodi: "Akuntansi - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "KEVIN DAIVA BENANDA",
        jenjang: "RPL (Ekstensi)",
        prodi: "Akuntansi - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "GRACE CLARISTA SIRAIT",
        jenjang: "RPL (Ekstensi)",
        prodi: "Akuntansi - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "GHALDA AYU LATIFAH",
        jenjang: "RPL (Ekstensi)",
        prodi: "Kesehatan Masyarakat - Promosi Kesehatan - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "FAJRUN NAJAH",
        jenjang: "RPL (Ekstensi)",
        prodi: "Ilmu Keperawatan"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "PAULUS PARLINDUNGAN NAHAMPUN",
        jenjang: "RPL (Ekstensi)",
        prodi: "Ilmu Hukum - Ekstensi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "INTAN NURAINI",
        jenjang: "RPL (Ekstensi)",
        prodi: "Ilmu Hukum - Ekstensi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "DAFFA MAHENDRA NUGRAHA",
        jenjang: "RPL (Ekstensi)",
        prodi: "Manajemen - Ekstensi - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "OTNIEL MARCEVINO",
        jenjang: "RPL (Ekstensi)",
        prodi: "Kesehatan Masyarakat - Administrasi dan Kebijakan Kesehatan - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ARDININGRUM RAMADHANI",
        jenjang: "RPL (Ekstensi)",
        prodi: "Akuntansi - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "BAGUS BUDI LAKSONO",
        jenjang: "RPL (Ekstensi)",
        prodi: "Manajemen - Ekstensi - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ILA LIA YULIANI",
        jenjang: "RPL (Ekstensi)",
        prodi: "Ilmu Keperawatan"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "INDRI LESTARI",
        jenjang: "RPL (Ekstensi)",
        prodi: "Ilmu Keperawatan"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MICHAEL HEZRON MANGANJU",
        jenjang: "RPL (Ekstensi)",
        prodi: "Ilmu Hukum - Ekstensi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "RIFDAH ANNISA AZ-ZAHRAH",
        jenjang: "RPL (Ekstensi)",
        prodi: "Kesehatan Masyarakat - Administrasi dan Kebijakan Kesehatan - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ADELIA RIZKIA SAVIRA",
        jenjang: "RPL (Ekstensi)",
        prodi: "Akuntansi - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "EKA RISMA DEWI",
        jenjang: "RPL (Ekstensi)",
        prodi: "Kesehatan Masyarakat - Promosi Kesehatan - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "RIZKA TRISNA P",
        jenjang: "RPL (Ekstensi)",
        prodi: "Akuntansi - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ANDREAS ADITAMA HUTAGAOL",
        jenjang: "RPL (Ekstensi)",
        prodi: "Ilmu Hukum - Ekstensi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MAGHVIRA LUTHFI YULIANI",
        jenjang: "RPL (Ekstensi)",
        prodi: "Manajemen - Ekstensi - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "AYUNDA SYURAYAH",
        jenjang: "RPL (Ekstensi)",
        prodi: "Ilmu Keperawatan"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ALFINA REGITA KUSUMANINGSIH",
        jenjang: "RPL (Ekstensi)",
        prodi: "Akuntansi - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "EXSA NATRILLIYANI",
        jenjang: "RPL (Ekstensi)",
        prodi: "Manajemen - Ekstensi - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "NURUL HIDAYAH",
        jenjang: "RPL (Ekstensi)",
        prodi: "Ilmu Hukum - Ekstensi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "HUWAIDA KESUMA WARDANI",
        jenjang: "RPL (Ekstensi)",
        prodi: "Manajemen - Ekstensi - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "RATU ZAHRA SAVIRA HERNAWAN",
        jenjang: "RPL (Ekstensi)",
        prodi: "Manajemen - Ekstensi - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "DEVI HERISTA BUDY PEACECA",
        jenjang: "RPL (Ekstensi)",
        prodi: "Manajemen - Ekstensi - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "I NYOMAN PANDU NATTA WIJAYA",
        jenjang: "RPL (Ekstensi)",
        prodi: "Akuntansi - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "NI PUTU MAHARANI DITHA KIRANA",
        jenjang: "RPL (Ekstensi)",
        prodi: "Akuntansi - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MALIKA YASMIN LUTHFINDAH",
        jenjang: "RPL (Ekstensi)",
        prodi: "Kesehatan Masyarakat - Administrasi dan Kebijakan Kesehatan - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "EBEN EZER",
        jenjang: "RPL (Ekstensi)",
        prodi: "Ilmu Hukum - Ekstensi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "TIAH HARDIANTI",
        jenjang: "RPL (Ekstensi)",
        prodi: "Ilmu Hukum - Ekstensi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "UWA ATIKA OKTAVIANI BANGUN",
        jenjang: "RPL (Ekstensi)",
        prodi: "Kesehatan Masyarakat - Administrasi dan Kebijakan Kesehatan - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "DEDE FIRMANSAH",
        jenjang: "RPL (Ekstensi)",
        prodi: "Manajemen - Ekstensi - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ANISA SAFITRI",
        jenjang: "RPL (Ekstensi)",
        prodi: "Manajemen - Ekstensi - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ANDI WIRAPRATAMA",
        jenjang: "RPL (Ekstensi)",
        prodi: "Ilmu Hukum - Ekstensi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "DHIAN KURNIA WATI",
        jenjang: "RPL (Ekstensi)",
        prodi: "Ilmu Keperawatan"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "RISKA MIANTI",
        jenjang: "RPL (Ekstensi)",
        prodi: "Ilmu Keperawatan"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "PEBRIARTI RISKI RAMADANI",
        jenjang: "RPL (Ekstensi)",
        prodi: "Kesehatan Masyarakat - Administrasi dan Kebijakan Kesehatan - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "WANDA AGUSTIANI",
        jenjang: "RPL (Ekstensi)",
        prodi: "Ilmu Administrasi Fiskal"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "CHINDY JANUARTI NURROHMAH",
        jenjang: "RPL (Ekstensi)",
        prodi: "Kesehatan Masyarakat - Administrasi dan Kebijakan Kesehatan - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "RIZKA QURROTA AINI",
        jenjang: "RPL (Ekstensi)",
        prodi: "Akuntansi - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "NISRINA ARDYANTI",
        jenjang: "RPL (Ekstensi)",
        prodi: "Akuntansi - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "HALIDA SURYA INDRAJATI",
        jenjang: "RPL (Ekstensi)",
        prodi: "Kesehatan Masyarakat - Promosi Kesehatan - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ANNISA MAHDATILLA",
        jenjang: "RPL (Ekstensi)",
        prodi: "Manajemen - Ekstensi - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ALODIA /LALITA KALYA",
        jenjang: "RPL (Ekstensi)",
        prodi: "Akuntansi - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "KHISA VIOLA PRINCESSA JATMIKO",
        jenjang: "RPL (Ekstensi)",
        prodi: "Akuntansi - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "PANSA ERDIKA",
        jenjang: "RPL (Ekstensi)",
        prodi: "Ilmu Administrasi Fiskal"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MUHAMMAD FAJRI",
        jenjang: "RPL (Ekstensi)",
        prodi: "Manajemen - Ekstensi - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "SITI NURMALA",
        jenjang: "S2",
        prodi: "Arkeologi - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MAHDI ALI GHAZI YUANA PUTRA",
        jenjang: "S2",
        prodi: "Teknologi Informasi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "SHIERLY LUTHFIA SHALSA",
        jenjang: "S2",
        prodi: "Psikologi - Psikologi Pendidikan - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "EKTADA BENNABI MOHAMAD",
        jenjang: "S2",
        prodi: "Ilmu Susastra (Sastra) - Sastra - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MUHAMMAD ARIEF FATHONI",
        jenjang: "S2",
        prodi: "Ilmu Hukum - Hukum Kenegaraan - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "CHAIRUNISA",
        jenjang: "S2",
        prodi: "Ilmu Kefarmasian - Farmasi Klinik - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "AGLIANA YUSMA",
        jenjang: "S2",
        prodi: "Kriminologi - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "NASYWA GHALIZA MEDINYSSA",
        jenjang: "S2",
        prodi: "Kriminologi - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "TASYA DWIVOLETTA",
        jenjang: "S2",
        prodi: "Magister Akuntansi - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "PRADANA RICARDO",
        jenjang: "S2",
        prodi: "Ilmu Linguistik - Bahasa dan Kebudayaan - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "NABILA RIZKI KILKODA",
        jenjang: "S2",
        prodi: "Teknik Kimia - Teknik Kimia - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MUHAMMAD BASKORO",
        jenjang: "S2",
        prodi: "Ilmu Kesehatan Masyarakat - Informatika Kesehatan - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "YUDHI PRASETYA",
        jenjang: "S2",
        prodi: "Teknik Elektro - Manajemen Keamanan Jaringan Informasi - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "DELVIOLA AZHARA",
        jenjang: "S2",
        prodi: "Kenotariatan - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "SITI LIRIH CHUMAIROH",
        jenjang: "S2",
        prodi: "Ilmu Gizi - Klinik - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "HASTO ARIEF NARENDRA",
        jenjang: "S2",
        prodi: "Magister Perencanaan Ekonomi dan Kebijakan Pembangunan - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "SURYA PANANGIAN MUNTHE",
        jenjang: "S2",
        prodi: "Ilmu Kimia - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "PUTRI SURYANI SAMUAL",
        jenjang: "S2",
        prodi: "Kajian Terorisme - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ARINA",
        jenjang: "S2",
        prodi: "Magister Akuntansi - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ANDINI WIDATI SANTOSO",
        jenjang: "S2",
        prodi: "Kenotariatan - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "JUAN RICHARDO NATHANIEL",
        jenjang: "S2",
        prodi: "Ilmu Hukum - Hukum Ekonomi - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MUHAMMAD IRFAN JUNAIDI",
        jenjang: "S2",
        prodi: "Teknologi Informasi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "SITI SYAFIRA ABDULLAH",
        jenjang: "S2",
        prodi: "Ilmu Administrasi - Administrasi dan Kebijakan Perpajakan - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "NUR AIMA SIAGIAN",
        jenjang: "S2",
        prodi: "Ilmu Keperawatan"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "FACHRUL RUKUA",
        jenjang: "S2",
        prodi: "Ilmu Kelautan - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ISLAM MANDA MANGGAR BUMI SUHARTO",
        jenjang: "S2",
        prodi: "Ilmu Politik - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "RAMADHANI INTAN SAGITA INDRIYANTI",
        jenjang: "S2",
        prodi: "Kenotariatan - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "SITI ATIKAH SARI",
        jenjang: "S2",
        prodi: "Ilmu Keperawatan"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "RAMDHAN FIRDAUS AMELIA",
        jenjang: "S2",
        prodi: "Teknologi Informasi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "KAWISTA ALIFA MUHAIMI WIDODO",
        jenjang: "S2",
        prodi: "Magister Akuntansi - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "CYNTHIA ROSALINA",
        jenjang: "S2",
        prodi: "Ilmu Hukum - Hukum Ekonomi - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "TASYA RATU ZALSABILAH",
        jenjang: "S2",
        prodi: "Kenotariatan - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "SHEILA OCTAVIANA",
        jenjang: "S2",
        prodi: "Ilmu Manajemen - Human Capital Management - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "FEBBIANTI MIFTA SALSABILLA",
        jenjang: "S2",
        prodi: "Ilmu Manajemen - Keuangan dan Perbankan - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "AKIFA LAILA RUSYDA",
        jenjang: "S2",
        prodi: "Ilmu Kesehatan Masyarakat - Gizi Kesehatan Masyarakat - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ANI SAMUDRA WULAN WARINGIN",
        jenjang: "S2",
        prodi: "Ilmu Hukum - Socio-Legal Studies (Hukum dan Masyarakat) - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ASTRI AMELIA",
        jenjang: "S2",
        prodi: "Kedokteran Kerja - Kedokteran Tenaga Kerja - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "STEPHANI HIZKIA SAMOSIR",
        jenjang: "S2",
        prodi: "Magister Akuntansi - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "AFU VIANTI DRIANTIKA",
        jenjang: "S2",
        prodi: "Teknik Lingkungan - Manajemen Kualitas Lingkungan - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "FEBYONA JOLEST PUTERI",
        jenjang: "S2",
        prodi: "Keselamatan & Kesehatan Kerja - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "NYOMAN AYU ARSA GAYATRI",
        jenjang: "S2",
        prodi: "Ilmu Akuntansi - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "PUTERI YULANDA",
        jenjang: "S2",
        prodi: "Magister Manajemen - Manajemen Umum - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ARVIA EARWANTAMA",
        jenjang: "S2",
        prodi: "Ilmu Perpustakaan - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ROSE MARLIANA",
        jenjang: "S2",
        prodi: "Magister Perencanaan Ekonomi dan Kebijakan Pembangunan - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "IDA BAGUS A. S SUDANA",
        jenjang: "S2",
        prodi: "Kajian Ketahanan Nasional - Kajian Stratejik Intelijen - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "TASYA PRADITHA NINGTYAS",
        jenjang: "S2",
        prodi: "Fisika Medis - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MUHAMMAD REZA AKBAR FACHREZI",
        jenjang: "S2",
        prodi: "Ilmu Hukum - Hukum Ekonomi - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "DESY NURAINI",
        jenjang: "S2",
        prodi: "Fisika Medis - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "CECILIA CHRISTINE PASARIBU",
        jenjang: "S2",
        prodi: "Ilmu Hukum - Hukum Ekonomi - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MUHAMMAD NUR SYAHBANI",
        jenjang: "S2",
        prodi: "Ilmu Hukum - Hukum Dan Sistem Peradilan Pidana - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ANDRE RIDUAN",
        jenjang: "S2",
        prodi: "Teknik Industri - Manajemen Industri - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ASYIP ABDUL MU'IZ ANNASIHI",
        jenjang: "S2",
        prodi: "Magister Manajemen - Sumber Daya Manusia - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "A.MUH.JAUSAN AZHARI AZIS HALID",
        jenjang: "S2",
        prodi: "Kenotariatan - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "YASMINA AZIZA ASTRI",
        jenjang: "S2",
        prodi: "Ilmu Administrasi - Studi E-Government - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ARI SETIAWAN",
        jenjang: "S2",
        prodi: "Ilmu Ekonomi - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MUHAMMAD LUTHFI AZMIKO",
        jenjang: "S2",
        prodi: "Magister Manajemen - Manajemen Pemasaran - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ADITYA MARDIKA SATRIYA WARDANA",
        jenjang: "S2",
        prodi: "Ilmu Lingkungan - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ANDI GUSTIAN",
        jenjang: "S2",
        prodi: "Magister Perencanaan Ekonomi dan Kebijakan Pembangunan - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "I WAYAN KRISNANDA",
        jenjang: "S2",
        prodi: "Fisika Medis - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "RIDO ARBAIN",
        jenjang: "S2",
        prodi: "Ilmu Hukum - Hukum Kekayaan Intelektual (HKI) - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "CHAEIRANI IDRIS",
        jenjang: "S2",
        prodi: "Magister Akuntansi - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "DANDI TAUFIQURROHMAN",
        jenjang: "S2",
        prodi: "Teknologi Informasi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MOCHAMAD WAHID ARIF HIDAYAH",
        jenjang: "S2",
        prodi: "Teknologi Informasi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ENGKUS KUSMAYATI",
        jenjang: "S2",
        prodi: "Arkeologi - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MUHAMMAD HIBBANI",
        jenjang: "S2",
        prodi: "Ilmu Administrasi - Administrasi Pengawasan - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "DHONY ALFIANTO",
        jenjang: "S2",
        prodi: "Ilmu Hukum - Hukum Kekayaan Intelektual (HKI) - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "FIRDA MAIRANI",
        jenjang: "S2",
        prodi: "Magister Perencanaan Ekonomi dan Kebijakan Pembangunan - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MARIA KRISTIANA",
        jenjang: "S2",
        prodi: "Ilmu Manajemen - Manajemen Strategi - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "EMILIA RAHMADANIAH UTAMI",
        jenjang: "S2",
        prodi: "Ilmu Kefarmasian - Bioteknologi dan Bahan Alam - Riset"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "HANIVIA RAHMA DIANI",
        jenjang: "S2",
        prodi: "Ilmu Hukum - Hukum Ketenagakerjaan - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "JESSICA AMANDA BINTANG SINAGA",
        jenjang: "S2",
        prodi: "Ilmu Lingkungan - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ANNISA SYAFRI",
        jenjang: "S2",
        prodi: "Ilmu Biomedik - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MUHAMMAD DLIYAUL HAQ",
        jenjang: "S2",
        prodi: "Ilmu Hukum - Hukum Kekayaan Intelektual (HKI) - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ALFONSUS KEVIN KURNIAWAN",
        jenjang: "S2",
        prodi: "Kenotariatan - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MUHAMMAD FARHAN INDRA",
        jenjang: "S2",
        prodi: "Psikologi - Psikologi Pendidikan - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "FIKRIYATUL ARIFAH",
        jenjang: "S2",
        prodi: "Ilmu Kesehatan Masyarakat - Kesehatan Reproduksi - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ARIO WICAKSONO",
        jenjang: "S2",
        prodi: "Keselamatan & Kesehatan Kerja - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "NABILA NUR AFIFAH",
        jenjang: "S2",
        prodi: "Ilmu Linguistik - Penerjemahan - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "DEASY FARAH UTARI",
        jenjang: "S2",
        prodi: "Teknologi Informasi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "AHMAD KURNIAWAN",
        jenjang: "S2",
        prodi: "Kajian Ketahanan Nasional - Kajian Stratejik Imigrasi - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "YORINA LAMBARAN",
        jenjang: "S2",
        prodi: "Kenotariatan - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "NUR FAIZEH",
        jenjang: "S2",
        prodi: "Teknik Lingkungan - Teknologi dan Rekayasa Kualitas Air - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "NURUL HIDAYAH",
        jenjang: "S2",
        prodi: "Ilmu Keperawatan"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "DIKA RUSLANINUR YADI",
        jenjang: "S2",
        prodi: "Teknik Sipil - Transportasi - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "NOVERITA WIDYASWARI",
        jenjang: "S2",
        prodi: "Kenotariatan - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "RISKA ADELLIA",
        jenjang: "S2",
        prodi: "Ilmu Keperawatan"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ERIES SETIYAWAN",
        jenjang: "S2",
        prodi: "Magister Manajemen - Manajemen Pemasaran - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "AMANDA CARRISA ASHARDIAN",
        jenjang: "S2",
        prodi: "Ilmu Komputer"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "DIMAS WAHYU INDRAJAYA",
        jenjang: "S2",
        prodi: "Ilmu Sejarah - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "AGUNG ANUGERAH PARDAMEAN",
        jenjang: "S2",
        prodi: "Kajian Ketahanan Nasional - Kajian Stratejik Imigrasi - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "VERONICA DARAJATI KUSUMA PRATIWI",
        jenjang: "S2",
        prodi: "Teknik Metalurgi & Material - Material - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "SUNARTO EFENDI",
        jenjang: "S2",
        prodi: "Ilmu Hukum - Hukum Ekonomi - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MEL FITRIA MS",
        jenjang: "S2",
        prodi: "Ilmu Kefarmasian - Farmasi Klinik - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ANGGRAENI KHUSUMA DEWI",
        jenjang: "S2",
        prodi: "Ilmu Linguistik - Pengajaran Bahasa - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "SONIA ANNISA BR KETAREN",
        jenjang: "S2",
        prodi: "Epidemiologi - Epidemiologi Terapan"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "AMALIA YASMIN CHAIRUNNISA",
        jenjang: "S2",
        prodi: "Teknik Sipil - Transportasi - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MUHAMMAD NABIL",
        jenjang: "S2",
        prodi: "Ilmu Politik - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "NUR REKA DEWI",
        jenjang: "S2",
        prodi: "Ilmu Linguistik - Penerjemahan - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "NIDA FATHIA",
        jenjang: "S2",
        prodi: "Teknik Industri - Manajemen Industri - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ANINDYA DYAH ZHAFARINA",
        jenjang: "S2",
        prodi: "Teknik Mesin - Konversi dan Konservasi Energi - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "PUTRI AFINA RIZKY",
        jenjang: "S2",
        prodi: "Ilmu Kesehatan Masyarakat - Promosi Kesehatan - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "UMAR HIFZHULHAQ SULAIMAN",
        jenjang: "S2",
        prodi: "Psikologi - Psikologi Sosial - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "RAVENDRA PRATAMA",
        jenjang: "S2",
        prodi: "Kajian Ketahanan Nasional - Kajian Stratejik Ketahanan Nasional - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "DWIKI RENDA NUGRAHA",
        jenjang: "S2",
        prodi: "Biologi - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "EVI DWI YANTI",
        jenjang: "S2",
        prodi: "Psikologi Terapan - Psikologi Anak Usia Dini - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ATIFA HASANAH",
        jenjang: "S2",
        prodi: "Arsitektur - Arsitektur & Sustainabilitas - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "SHIBGHOTULLAH SYUBBANUR ROBBANI",
        jenjang: "S2",
        prodi: "Magister Akuntansi - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MUKTI TRIWIBOWO",
        jenjang: "S2",
        prodi: "Magister Akuntansi - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "SYAFRULLAH",
        jenjang: "S2",
        prodi: "Teknik Elektro - Manajemen Energi dan Ketenagalistrikan - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "NURUL JASMINE FAUZIAH",
        jenjang: "S2",
        prodi: "Ilmu Kesehatan Masyarakat - Kebijakan dan Hukum Kesehatan - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "RADEN AL IMAN",
        jenjang: "S2",
        prodi: "Ilmu Lingkungan - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "HERMAN SAPUTRA",
        jenjang: "S2",
        prodi: "Teknik Sipil - Manajemen Konstruksi - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "DHIA FAUZIYAH SALSABILA",
        jenjang: "S2",
        prodi: "Ilmu Ekonomi - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "SAMANTHA RACHMANINDYTA",
        jenjang: "S2",
        prodi: "Kenotariatan - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MUHAMMAD KURNIA TANJAPUTRA",
        jenjang: "S2",
        prodi: "Industri Kreatif"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MARIANUS ANTONIUS MUGA",
        jenjang: "S2",
        prodi: "Magister Perencanaan Ekonomi dan Kebijakan Pembangunan - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ROHMAN DAKA",
        jenjang: "S2",
        prodi: "Ilmu Kesehatan Masyarakat - Promosi Kesehatan - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "GLORY ANDARUSARI",
        jenjang: "S2",
        prodi: "Magister Ekonomi Kependudukan dan Ketenagakerjaan"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "RIZQI ANWAR",
        jenjang: "S2",
        prodi: "Teknik Sipil - Transportasi - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MUTHIA ZAHRI MARDHIYAH HARDJANTO",
        jenjang: "S2",
        prodi: "Arkeologi - Riset"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "TASYA WIDYA KRISNADI",
        jenjang: "S2",
        prodi: "Asia Timur - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ANIS ARDIANTI",
        jenjang: "S2",
        prodi: "Ilmu Kesejahteraan Sosial - Manajemen dan Pengembangan Organisasi Kemanusiaan - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "HIKMATUN AZIZAH",
        jenjang: "S2",
        prodi: "Ilmu Susastra (Sastra) - Sastra - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "DEWI PRAMODHAWARDHANI",
        jenjang: "S2",
        prodi: "Ilmu Politik - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MAHSA ELVINA RAHMAWYANET",
        jenjang: "S2",
        prodi: "Teknologi Informasi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "NATASYA GABRIELLE CYNTHIA TESALONIKA",
        jenjang: "S2",
        prodi: "Ilmu Hukum - Hukum Ekonomi - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "WAHIDDATUL NINDYA PUTRI",
        jenjang: "S2",
        prodi: "Ilmu Gizi - Klinik - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "RINA YUNIARTY",
        jenjang: "S2",
        prodi: "Ilmu Fisika - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "LISTYA DIWASASRI",
        jenjang: "S2",
        prodi: "Kenotariatan - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ANIF MUBAROK",
        jenjang: "S2",
        prodi: "Keselamatan & Kesehatan Kerja - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "SYARIFAH AMALIA",
        jenjang: "S2",
        prodi: "Kenotariatan - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MUHAMAD AIDIL",
        jenjang: "S2",
        prodi: "Ilmu Hukum - Hukum Dan Sistem Peradilan Pidana - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "SUKREINY PAPUTUNGAN",
        jenjang: "S2",
        prodi: "Ilmu Hukum - Socio-Legal Studies (Hukum dan Masyarakat) - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "IKHBAT AJRON HASANAN WAJDI",
        jenjang: "S2",
        prodi: "Ilmu Kesejahteraan Sosial - Pembangunan Sosial, Kebijakan Sosial dan Pembangunan Lokal - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "DINDA ALIFA",
        jenjang: "S2",
        prodi: "Ilmu Lingkungan - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "JIHAN RAMADHANY GINTING MANIK",
        jenjang: "S2",
        prodi: "Ilmu Kesehatan Masyarakat - Biostatistika - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "PEBRI YANTO PANATARAN NAIBORHU",
        jenjang: "S2",
        prodi: "Magister Akuntansi - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "NIGEL DERYAN PRIBADI",
        jenjang: "S2",
        prodi: "Ilmu Hukum - Hukum Ekonomi - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "RENY ASTUTY SUMARSONO",
        jenjang: "S2",
        prodi: "Administrasi Rumah Sakit - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "SAHIDIYAH FEBRINA DWI PURWARINI",
        jenjang: "S2",
        prodi: "Ilmu Hukum - Hukum Hak Asasi Manusia dan Good Governance - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MAULIDA PITRIA",
        jenjang: "S2",
        prodi: "Kenotariatan - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "RAYHAN FADILLAH",
        jenjang: "S2",
        prodi: "Ilmu Manajemen - Keuangan dan Perbankan - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "STEPHEN VALENTINO",
        jenjang: "S2",
        prodi: "Kedokteran Kerja - Kedokteran Tenaga Kerja - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "NONA MULYANI ARONGGEAR",
        jenjang: "S2",
        prodi: "Ilmu Keperawatan"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "GHUMELAR IHAB SUHADA",
        jenjang: "S2",
        prodi: "Teknologi Informasi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "TRI JAYANTI LASTARI",
        jenjang: "S2",
        prodi: "Teknologi Informasi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "TISON HORISON HALOHO",
        jenjang: "S2",
        prodi: "Kajian Ketahanan Nasional - Kajian Stratejik Imigrasi - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "JONGGI PRASETYO PANARAS S",
        jenjang: "S2",
        prodi: "Kebijakan Publik dan Governansi - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MUHAMMAD YUSUF",
        jenjang: "S2",
        prodi: "Ilmu Akuntansi - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "JUSA JUNAEDI",
        jenjang: "S2",
        prodi: "Ilmu Perpustakaan - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "FAJAR GEMPITA",
        jenjang: "S2",
        prodi: "Kajian Ketahanan Nasional - Kajian Stratejik Imigrasi - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "HABIL MISBACHUL AMAL",
        jenjang: "S2",
        prodi: "Ilmu Politik - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "TOPAN PARISI WAKANNO",
        jenjang: "S2",
        prodi: "Antropologi - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "CECILIA MARTINELLY PUTRI",
        jenjang: "S2",
        prodi: "Administrasi Rumah Sakit - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "HANIFA GHINA NUGROHO",
        jenjang: "S2",
        prodi: "Psikologi - Psikologi Kepribadian - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "AULIA ABDILLAH RAMADHAN",
        jenjang: "S2",
        prodi: "Ilmu Kesehatan Masyarakat - Ekonomi Kesehatan - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "NALA TELIANA",
        jenjang: "S2",
        prodi: "Ilmu Kesejahteraan Sosial - Pembangunan Sosial, Kebijakan Sosial dan Pembangunan Lokal - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ANASTASIA ZEFANYA",
        jenjang: "S2",
        prodi: "Kenotariatan - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "DESFALINA ARYANI",
        jenjang: "S2",
        prodi: "Epidemiologi - Epidemiologi Komunitas - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "FAHMIRANTI WIDAZULFIA",
        jenjang: "S2",
        prodi: "Ilmu Komunikasi - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "DITE NURSYAMSI MAHMUTAMI",
        jenjang: "S2",
        prodi: "Ilmu Susastra (Sastra) - Studi Kultural - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ANITA RAHMA NILA",
        jenjang: "S2",
        prodi: "Ilmu Kesehatan Masyarakat - Kesehatan Reproduksi - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MUHAMAD NUR FAJAR",
        jenjang: "S2",
        prodi: "Ilmu Administrasi - Studi E-Government - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "SUTRISNO WIBOWO",
        jenjang: "S2",
        prodi: "Ilmu Hukum - Hukum Kenegaraan - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MUHAMMAD HIBBAN YANHASDIN",
        jenjang: "S2",
        prodi: "Teknik Sipil - Transportasi - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MICHELLE NABILA ANDAISTA BANGSU",
        jenjang: "S2",
        prodi: "Ilmu Hubungan Internasional - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "HARDWIYANI",
        jenjang: "S2",
        prodi: "Administrasi Rumah Sakit - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "RAHMAT KURNIANSYAH",
        jenjang: "S2",
        prodi: "Kenotariatan - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "NOVA LASMARIA HOTMATUA SIMBOLON",
        jenjang: "S2",
        prodi: "Administrasi Rumah Sakit - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "RENITA VIRA MAULIDINA",
        jenjang: "S2",
        prodi: "Teknik Sipil - Transportasi - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "FATIMAH FRAYA",
        jenjang: "S2",
        prodi: "Ilmu Filsafat - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ABDUL RAJAK UAR",
        jenjang: "S2",
        prodi: "Ilmu Administrasi - Inovasi dan Intrapreneurship - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "CINDY AURELLIA",
        jenjang: "S2",
        prodi: "Ilmu Komunikasi - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "LAMI TRISETIAWATI",
        jenjang: "S2",
        prodi: "Ilmu Kesehatan Masyarakat - Mutu Layanan Kesehatan - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ANDI LIZA AZZAHRA",
        jenjang: "S2",
        prodi: "Ilmu Kesehatan Masyarakat - Manajemen Pelayanan Kesehatan - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "FARRAH NURKHALIZA",
        jenjang: "S2",
        prodi: "Ilmu Kimia - Riset"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "AGAM RAMADIKA",
        jenjang: "S2",
        prodi: "Magister Manajemen - Manajemen Umum - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "I GEDE MANIK VIKANTARA",
        jenjang: "S2",
        prodi: "Ilmu Keperawatan"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "FARAH SALSABILA",
        jenjang: "S2",
        prodi: "Ilmu Hukum - Socio-Legal Studies (Hukum dan Masyarakat) - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MUHAMMAD HAFIED BUDIMAN",
        jenjang: "S2",
        prodi: "Ilmu Hukum - Hukum Dan Sistem Peradilan Pidana - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ALDO AGUSTIANUS",
        jenjang: "S2",
        prodi: "Psikologi Terapan - Psikologi Sumber Daya Manusia - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "AMMI OSA PAK PAHAN",
        jenjang: "S2",
        prodi: "Psikologi Terapan - Psikologi Anak Usia Dini - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "RICKY BAHARI HAMID",
        jenjang: "S2",
        prodi: "Teknologi Informasi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "RANDY SITORUS PANE",
        jenjang: "S2",
        prodi: "Ilmu Fisika - Riset"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "AMELYA ZERINDAPUTRI",
        jenjang: "S2",
        prodi: "Ilmu Lingkungan - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "IRDA RUSDIANA SARI",
        jenjang: "S2",
        prodi: "Teknologi Informasi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "NOVIYANA",
        jenjang: "S2",
        prodi: "Ilmu Kesehatan Masyarakat - Gizi Kesehatan Masyarakat - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "DEVA ARIANTI HERAWATI",
        jenjang: "S2",
        prodi: "Ilmu Kesehatan Masyarakat - Mutu Layanan Kesehatan - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "NURMAULI",
        jenjang: "S2",
        prodi: "Manajemen Bencana - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "CEACILIA NIKA CANDRA KUSUMA",
        jenjang: "S2",
        prodi: "Ilmu Keperawatan"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ALVIONNEZ MUTIA PUTI",
        jenjang: "S2",
        prodi: "Ilmu Politik - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ANINDHITA AULIA PUTRI",
        jenjang: "S2",
        prodi: "Ilmu Kesehatan Masyarakat - Kesehatan Reproduksi - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "SA'DA KAMALIA",
        jenjang: "S2",
        prodi: "Ilmu Linguistik - Pengajaran Bahasa - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "IRMA SOFIANI KUSMARA",
        jenjang: "S2",
        prodi: "Ilmu Keperawatan"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "SOFI HANDOKO",
        jenjang: "S2",
        prodi: "Magister Perencanaan Ekonomi dan Kebijakan Pembangunan - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "RIFKA BEBY DWIAYUNI",
        jenjang: "S2",
        prodi: "Teknik Industri - Desain dan Manajemen Sistem - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "CHOLIL UBAIDILLAH",
        jenjang: "S2",
        prodi: "Teknik Industri - Sistem Produksi dan Logistik - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "RETTY RENITASARI",
        jenjang: "S2",
        prodi: "Teknik Industri - Sistem Produksi dan Logistik - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MUHAMMAD AGUNG SURYA",
        jenjang: "S2",
        prodi: "Ilmu Kesehatan Masyarakat - Kebijakan dan Hukum Kesehatan - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "NUR AINI AGUSTIN",
        jenjang: "S2",
        prodi: "Ilmu Ekonomi - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "NADIA IZZATI",
        jenjang: "S2",
        prodi: "Magister Perencanaan Ekonomi dan Kebijakan Pembangunan - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "FATIMAH AZZAHRA",
        jenjang: "S2",
        prodi: "Ilmu Administrasi - Administrasi dan Kebijakan Perpajakan - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "DESI WAHYUNINGTIAS",
        jenjang: "S2",
        prodi: "Ilmu Administrasi - Administrasi Pengawasan - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "AGUS GUWANDI",
        jenjang: "S2",
        prodi: "Kebijakan Publik dan Governansi - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "JESSICA JOHANNA CHRISTY",
        jenjang: "S2",
        prodi: "Kenotariatan - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "NAUFAL RAIHAN GIBRAN NAINGGOLAN",
        jenjang: "S2",
        prodi: "Ilmu Filsafat - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "NICKY PUTRI",
        jenjang: "S2",
        prodi: "Teknik Industri - Manajemen Industri - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ABDULLAH OHOIULUN ALS ADI SETIAWAN",
        jenjang: "S2",
        prodi: "Teknik Sipil - Manajemen Proyek - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "DAFFA IKHLASUL AMAL",
        jenjang: "S2",
        prodi: "Teknik Metalurgi & Material - Material - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "NUR ARIFAH RAHMAH",
        jenjang: "S2",
        prodi: "Psikologi Terapan - Psikologi Sumber Daya Manusia - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "SATRIA DWI PRANOTO",
        jenjang: "S2",
        prodi: "Ilmu Keperawatan"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "RAFIQO FADHLULLAH",
        jenjang: "S2",
        prodi: "Ilmu Hubungan Internasional - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "RIDHO AGUNG PRIHAMBODO",
        jenjang: "S2",
        prodi: "Ilmu Administrasi - Administrasi dan Kebijakan Pengembangan SDM - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "KRISMAYANI",
        jenjang: "S2",
        prodi: "Ilmu Kefarmasian - Teknologi Farmasi - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MINATON NAJA",
        jenjang: "S2",
        prodi: "Ilmu Manajemen - Manajemen Strategi - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "NILNA MILCHATINA",
        jenjang: "S2",
        prodi: "Biologi - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "YUZIA MELANTIKA",
        jenjang: "S2",
        prodi: "Ilmu Keperawatan"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "RIHLAH FAHIRANTI MARSYEA WAKITO",
        jenjang: "S2",
        prodi: "Ilmu Lingkungan - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "AURA AZZAHRA",
        jenjang: "S2",
        prodi: "Ilmu Hukum - Hukum Ekonomi - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "GUNTUR KHARISMA PUTRA",
        jenjang: "S2",
        prodi: "Magister Manajemen - Manajemen Keuangan - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "FINESSA SALSABILA",
        jenjang: "S2",
        prodi: "Ilmu Linguistik - Pengajaran Bahasa - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "FEBRI KENDARI ARDHYANSAH SIAHAAN",
        jenjang: "S2",
        prodi: "Ilmu Administrasi - Administrasi dan Kebijakan Pengembangan SDM - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "PUSPITA NUR SUCIATI",
        jenjang: "S2",
        prodi: "Kenotariatan - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "JOCELYN TJAHJONO",
        jenjang: "S2",
        prodi: "Kenotariatan - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MUHAMMAD DLIYA ELRACHMAN ASHAR",
        jenjang: "S2",
        prodi: "Ilmu Hukum - Hukum Dan Sistem Peradilan Pidana - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "RESTY MUTIARA PUTRI",
        jenjang: "S2",
        prodi: "Ilmu Administrasi - Administrasi dan Kebijakan Publik - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "FRISKA LESTARI",
        jenjang: "S2",
        prodi: "Ilmu Keperawatan"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ACEP ARIEF HERMANSYAH",
        jenjang: "S2",
        prodi: "Ilmu Kesehatan Masyarakat - Ekonomi Kesehatan - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "FARISSA DWINANDA PUTRI",
        jenjang: "S2",
        prodi: "Kenotariatan - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MENUR PUSPITA IQMALA",
        jenjang: "S2",
        prodi: "Ilmu Susastra (Sastra) - Budaya Pertunjukan - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "YASMIN FAUZIAH",
        jenjang: "S2",
        prodi: "Fisika Medis - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MUHAMMAD LAZUARDI AZZURA",
        jenjang: "S2",
        prodi: "Teknik Metalurgi & Material - Material - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "SALMA SAMIA",
        jenjang: "S2",
        prodi: "Ilmu Kedokteran Gigi Dasar - Ilmu Kedokteran Gigi Forensik - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "WIDYA AKHIRA",
        jenjang: "S2",
        prodi: "Ilmu Linguistik - Pengajaran Bahasa - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MUHAMMAD IRSAN RAMADHAN",
        jenjang: "S2",
        prodi: "Ilmu Ekonomi - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "NIKO ABDURRAHMAN",
        jenjang: "S2",
        prodi: "Magister Manajemen - Manajemen Bisnis Internasional - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "PUTRI AISYAH AUFAADHIYAA",
        jenjang: "S2",
        prodi: "Biologi - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "NADIA SIRATUNNISAK",
        jenjang: "S2",
        prodi: "Ilmu Kesehatan Masyarakat - Gizi Kesehatan Masyarakat - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ADIMAS KUSUMO PRIYANTO",
        jenjang: "S2",
        prodi: "Teknik Sipil - Manajemen Proyek - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "FITRIANA RAHAYU",
        jenjang: "S2",
        prodi: "Ilmu Kesehatan Masyarakat - Kesehatan Lingkungan - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MAULIYANDRI AL HIKMAH",
        jenjang: "S2",
        prodi: "Magister Akuntansi - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "RIZKI MAISURA",
        jenjang: "S2",
        prodi: "Psikologi Terapan - Psikologi Anak Usia Dini - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "WERLYNINGSIH",
        jenjang: "S2",
        prodi: "Ilmu Keperawatan"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "BUNGA VANIA",
        jenjang: "S2",
        prodi: "Ilmu Administrasi - Administrasi dan Kebijakan Publik - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "RIDO APRIANDA",
        jenjang: "S2",
        prodi: "Magister Akuntansi - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "GRACE HANA MAWARNI",
        jenjang: "S2",
        prodi: "Magister Manajemen - Manajemen Umum - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ANNIS ALFITRIYA SYAHIDA",
        jenjang: "S2",
        prodi: "Kajian Wilayah Amerika - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "BAIQ SYOFIATUN YUHANIZA",
        jenjang: "S2",
        prodi: "Ilmu Perpustakaan - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ANDIFA KHALIDA AZZARA",
        jenjang: "S2",
        prodi: "Ilmu Lingkungan - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "CONDRO WIYONO",
        jenjang: "S2",
        prodi: "Teknologi Informasi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "SONNY SATRIYONO EDI WIBOWO",
        jenjang: "S2",
        prodi: "Industri Kreatif"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ISMA AGUSTINA HALIM",
        jenjang: "S2",
        prodi: "Magister Perencanaan Ekonomi dan Kebijakan Pembangunan - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "KURNIA RAHMAWATI",
        jenjang: "S2",
        prodi: "Teknik Sipil - Transportasi - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "AULIA BRELLIAN PRATAMA",
        jenjang: "S2",
        prodi: "Teknik Lingkungan - Teknologi dan Rekayasa Kualitas Air - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "AURORA REMBULAN PERMATASARI",
        jenjang: "S2",
        prodi: "Kenotariatan - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "HARDI NUGRAHA",
        jenjang: "S2",
        prodi: "Magister Akuntansi - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "FADHILATUL FATIHAH FIRDAUS",
        jenjang: "S2",
        prodi: "Ilmu Kefarmasian - Farmasi Klinik - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "INDRIANA SULARNI",
        jenjang: "S2",
        prodi: "Magister Akuntansi - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "YOVINIANUS YOSEPH EDISON SINAMBELA",
        jenjang: "S2",
        prodi: "Ilmu Hukum - Socio-Legal Studies (Hukum dan Masyarakat) - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "RAKHIMATULFITRIA MEKACAHYANI",
        jenjang: "S2",
        prodi: "Ilmu Komputer"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ROBBY KRISNALDO ELVIN",
        jenjang: "S2",
        prodi: "Magister Manajemen - Manajemen Keuangan - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MELLA MARDISON PUTRI",
        jenjang: "S2",
        prodi: "Ilmu Keperawatan"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "TRI WAHYUNI WULANDARI",
        jenjang: "S2",
        prodi: "Magister Akuntansi - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "KIKI HAKIKI",
        jenjang: "S2",
        prodi: "Teknik Sistem Energi - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ILHAM ISNIN DOLYANOV",
        jenjang: "S2",
        prodi: "Ilmu Kesehatan Masyarakat - Ekonomi Kesehatan - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "GHIFFAR YANUAR",
        jenjang: "S2",
        prodi: "Teknik Mesin - Konversi dan Konservasi Energi - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "IGO CAHYA NEGARA",
        jenjang: "S2",
        prodi: "Epidemiologi - Epidemiologi Komunitas - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "NANANG MAHMUD",
        jenjang: "S2",
        prodi: "Kriminologi - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "BENJAMIN REMIGIUS S. GOSAL",
        jenjang: "S2",
        prodi: "Kenotariatan - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ANISSA PERMATASARI",
        jenjang: "S2",
        prodi: "Kajian Wilayah Jepang - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "RAHMADANI PUTRI DEFA",
        jenjang: "S2",
        prodi: "Teknik Elektro - Manajemen Energi dan Ketenagalistrikan - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MUHAMMAD KURNIAWAN",
        jenjang: "S2",
        prodi: "Teknologi Informasi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "GEORGE TIMOTHY FITZGERALD HUTAGAOL",
        jenjang: "S2",
        prodi: "Ilmu Manajemen - Digital Marketing and Analytics - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "LALU BUDI SETIAWAN",
        jenjang: "S2",
        prodi: "Ilmu Hukum - Hukum Dan Sistem Peradilan Pidana - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "HENDRY DIMAS PUTRA FAJAR",
        jenjang: "S2",
        prodi: "Kedokteran Kerja - Kedokteran Tenaga Kerja - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "KEVIN HARTONO",
        jenjang: "S2",
        prodi: "Ilmu Hukum - Hukum Ekonomi - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "OLIVIA NAULI KOMALA",
        jenjang: "S2",
        prodi: "Pendidikan Kedokteran - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "LOLY SIXTEEN ORAMAHI PURBA",
        jenjang: "S2",
        prodi: "Kedokteran Kerja - Kedokteran Tenaga Kerja - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MEYFRINA KRISTIANA TARIGAN",
        jenjang: "S2",
        prodi: "Magister Manajemen - Sumber Daya Manusia - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ASTRIE NURCAHYATI AYUNINGRUM",
        jenjang: "S2",
        prodi: "Ilmu Hukum - Hukum Kenegaraan - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "HERVINO HILMAN AZMI",
        jenjang: "S2",
        prodi: "Ilmu Hukum - Hukum Ekonomi - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "AMADIKA DAFFA VERLINAN",
        jenjang: "S2",
        prodi: "Ilmu Manajemen - Manajemen Strategi - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ALFITRA DAMASTUTI",
        jenjang: "S2",
        prodi: "Psikologi - Psikologi Perkembangan - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ZHAFRAN RAFI HALIM",
        jenjang: "S2",
        prodi: "Teknik Sipil - Manajemen Konstruksi - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "RISYALMA FADIA HASAN",
        jenjang: "S2",
        prodi: "Kenotariatan - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "DHANA ADHIPRATAMA",
        jenjang: "S2",
        prodi: "Ilmu Komunikasi - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ROYYAN UMAR ARDIANSYAH",
        jenjang: "S2",
        prodi: "Kebijakan Publik dan Governansi - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "FRANANDA RUMABI",
        jenjang: "S2",
        prodi: "Ilmu Administrasi - Administrasi dan Kebijakan Niaga - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "SISILIA SARI DEWI",
        jenjang: "S2",
        prodi: "Teknologi Informasi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "APIA YEANI W",
        jenjang: "S2",
        prodi: "Ilmu Keperawatan"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MUH. IMAM SYAFII",
        jenjang: "S2",
        prodi: "Ilmu Komunikasi - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "JOHANNES",
        jenjang: "S2",
        prodi: "Teknik Sipil - Transportasi - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ADINI NADIA PUTRI",
        jenjang: "S2",
        prodi: "Magister Akuntansi - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "STACYA AMANDA PRAMITHA",
        jenjang: "S2",
        prodi: "Ilmu Kedokteran Gigi Komunitas - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "DARWIN TAMBA",
        jenjang: "S2",
        prodi: "Kajian Ilmu Kepolisian - Hukum Kepolisian - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "SYALOMITHA FEBIOLA",
        jenjang: "S2",
        prodi: "Kriminologi - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "RIFKA FADHIILAH ARJUNI",
        jenjang: "S2",
        prodi: "Psikologi Terapan - Psikologi Sumber Daya Manusia - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MUHAMMAD RIZKY AVICENNA",
        jenjang: "S2",
        prodi: "Magister Akuntansi - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MUFLIH IHSAN",
        jenjang: "S2",
        prodi: "Ilmu Politik - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MOCH YUSUF ADITYA",
        jenjang: "S2",
        prodi: "Ilmu Biomedik - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "NANI CHOLIANAWATI",
        jenjang: "S2",
        prodi: "Ilmu Lingkungan - Jalur Riset - Riset"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "USWATUN KHASANAH",
        jenjang: "S2",
        prodi: "Psikologi - Psikologi Pendidikan - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "FAISAL",
        jenjang: "S2",
        prodi: "Psikologi - Psikologi Sosial - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "CHAIRUNNISA YULFIANTI",
        jenjang: "S2",
        prodi: "Ilmu Ekonomi - Berbahasa Inggris"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ANUGRAH OKY PRATAMA",
        jenjang: "S2",
        prodi: "Ilmu Kesejahteraan Sosial - Pembangunan Sosial, Kebijakan Sosial dan Pembangunan Lokal - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "FILLAH MUTY SYAHIDAH",
        jenjang: "S2",
        prodi: "Ilmu Biomedik - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "PRISALIA AMANATUS SHOLIHAH",
        jenjang: "S2",
        prodi: "Magister Manajemen - Manajemen Pemasaran - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "JEFFRY FAUZAN",
        jenjang: "S2",
        prodi: "Magister Manajemen - Manajemen Risiko - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "HARDI YANTA",
        jenjang: "S2",
        prodi: "Ilmu Keperawatan"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "RATIH YULIANINGSIH",
        jenjang: "S2",
        prodi: "Ilmu Biomedik - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ADE PUTRA TRIYANGORO",
        jenjang: "S2",
        prodi: "Teknik Sipil - Transportasi - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "RISTA PUTRI NUR IFA",
        jenjang: "S2",
        prodi: "Fisika Medis - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "DINDA AGARITA",
        jenjang: "S2",
        prodi: "Kebijakan Publik dan Governansi - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "BETANIA SAMBOE",
        jenjang: "S2",
        prodi: "Administrasi Rumah Sakit - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "CHRISTEVEN COHEN",
        jenjang: "S2",
        prodi: "Arsitektur - Perancangan Arsitektur - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "JAMES IBRAHIM",
        jenjang: "S2",
        prodi: "Ilmu Biomedik - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "AHMAD FARHAN",
        jenjang: "S2",
        prodi: "Ilmu Administrasi - Administrasi dan Kebijakan Publik - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "JOKO SUSILO",
        jenjang: "S2",
        prodi: "Ilmu Hukum - Hukum Hak Asasi Manusia dan Good Governance - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "SITI RANIA AZZAHRA VITRI",
        jenjang: "S2",
        prodi: "Industri Kreatif"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "TAUFIQ WIDIAPUTRA",
        jenjang: "S2",
        prodi: "Ilmu Fisika - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "GAMAS GAGAH PANGESTU",
        jenjang: "S2",
        prodi: "Teknik Sipil - Transportasi - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "GIAN GIODANI GUSVERO",
        jenjang: "S2",
        prodi: "Keselamatan & Kesehatan Kerja - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ELLYN CRISDIANT",
        jenjang: "S2",
        prodi: "Ilmu Hukum - Hukum Dan Sistem Peradilan Pidana - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "FIKA AMELIA",
        jenjang: "S2",
        prodi: "Ilmu Hukum - Hukum Kenegaraan - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ELMAN RUDOLF PAKPAHAN",
        jenjang: "S2",
        prodi: "Teknik Elektro - Manajemen Energi dan Ketenagalistrikan - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MUSTIKA BALQIS",
        jenjang: "S2",
        prodi: "Teknik Lingkungan - Manajemen Kualitas Lingkungan - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "DHEA FAIRUZA ZAHIRAH",
        jenjang: "S2",
        prodi: "Teknik Kimia - Teknik Kimia - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "SEPTIA FARIL LUKMAN",
        jenjang: "S2",
        prodi: "Arsitektur - Perumahan & Pemukiman Perkotaan - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "JHON ROY NASKY SIMANJUNTAK",
        jenjang: "S2",
        prodi: "Teknik Elektro - Manajemen Telekomunikasi - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ADHI SEPTIYANTO",
        jenjang: "S2",
        prodi: "Teknik Kimia - Manajemen Keselamatan Proses - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MURNIASIH",
        jenjang: "S2",
        prodi: "Ilmu Manajemen - Digital Marketing and Analytics - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "IKA CUCU KARTIKA",
        jenjang: "S2",
        prodi: "Psikologi Terapan - Psikologi Anak Usia Dini - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "TAJU MAHADHIKARA",
        jenjang: "S2",
        prodi: "Ilmu Manajemen - Digital Marketing and Analytics - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "NAKULA SENCHAKI",
        jenjang: "S2",
        prodi: "Magister Manajemen - Manajemen Keuangan - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "LUCIA RULIASTUTI",
        jenjang: "S2",
        prodi: "Magister Manajemen - Manajemen Pemasaran - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "NOFIALDI",
        jenjang: "S2",
        prodi: "Teknologi Informasi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MARGHARET FEBIYANTI",
        jenjang: "S2",
        prodi: "Teknik Sipil - Geoteknik - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "NURCHOLIS",
        jenjang: "S2",
        prodi: "Teknik Elektro - Keamanan Siber dan Internet Masa Depan - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "FRANSISKUS XAVERIUS LEOILA",
        jenjang: "S2",
        prodi: "Teknik Elektro - Manajemen Energi dan Ketenagalistrikan - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "SITI HARTATI",
        jenjang: "S2",
        prodi: "Ilmu Manajemen - Human Capital Management - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MUHAMMAD NUR MUSLIM SHIDIQ",
        jenjang: "S2",
        prodi: "Epidemiologi - Epidemiologi Terapan"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "INTAN SUCI WULANDARI",
        jenjang: "S2",
        prodi: "Ilmu Lingkungan - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "GIFRAN GIVARY",
        jenjang: "S2",
        prodi: "Teknik Industri - Manajemen Industri - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "GEMBONG REKSA KAWULA",
        jenjang: "S2",
        prodi: "Teknik Mesin - Teknologi Keselamatan Kebakaran dan Bangunan - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "YUDHI IQBAL SYARIF",
        jenjang: "S2",
        prodi: "Psikologi - Psikologi Industri dan Organisasi - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "META CITRASARI",
        jenjang: "S2",
        prodi: "Ilmu Manajemen - Manajemen Strategi - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "FIDYA NAJLA ARISABMIKA",
        jenjang: "S2",
        prodi: "Teknik Industri - Rekayasa Data dan Kualitas - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MUHAMAD INDHI RIZQIZHA GUNAWAN",
        jenjang: "S2",
        prodi: "Ilmu Politik - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "FEBRIAN GUS SALIM",
        jenjang: "S2",
        prodi: "Kajian Ilmu Kepolisian - Hukum Kepolisian - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ENDAH RATNA SAMAPTY W",
        jenjang: "S2",
        prodi: "Ilmu Keperawatan"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "REZKY GUNA PUTRA",
        jenjang: "S2",
        prodi: "Ilmu Biomedik - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "WILLIBRORDUS ADHYATMA SUNU PARAMARTA",
        jenjang: "S2",
        prodi: "Teknik Sipil - Transportasi - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "IRFAN URANE AZIS",
        jenjang: "S2",
        prodi: "Kajian Ilmu Kepolisian - Siber - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "IMAM AGI PRATAMA",
        jenjang: "S2",
        prodi: "Ilmu Komunikasi - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ALFINA IZZA",
        jenjang: "S2",
        prodi: "Ilmu Hukum - Hukum Ekonomi - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "APRILIA SARAH KRISTINA",
        jenjang: "S2",
        prodi: "Teknik Elektro - Manajemen Energi dan Ketenagalistrikan - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "THIERRY JOSEPH BATARA",
        jenjang: "S2",
        prodi: "Ilmu Manajemen - Keuangan dan Perbankan - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "INDIS DWI AGUSTIN",
        jenjang: "S2",
        prodi: "Keselamatan & Kesehatan Kerja - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "FATIMAH PUSPARANI DEWI",
        jenjang: "S2",
        prodi: "Kenotariatan - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ABDURRAHMAN YUSUF IRSYAD",
        jenjang: "S2",
        prodi: "Ilmu Manajemen - Human Capital Management - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "REZKY IRIA BORNEO",
        jenjang: "S2",
        prodi: "Kajian Terorisme - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "NUR UMAMI SUKMA DEWI SOFYAN PUTRI",
        jenjang: "S2",
        prodi: "Teknik Sipil - Transportasi - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "THORIQ HARDIANSYAH",
        jenjang: "S2",
        prodi: "Ilmu Hukum - Hukum Kenegaraan - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ANNISA NURIL DEANTY",
        jenjang: "S2",
        prodi: "Ilmu Hukum - Hukum Kenegaraan - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "RAFII FATHURRIZQY",
        jenjang: "S2",
        prodi: "Ilmu Manajemen - Keuangan dan Perbankan - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "HAEKAL ATTAR",
        jenjang: "S2",
        prodi: "Ilmu Kesejahteraan Sosial - Manajemen dan Pengembangan Organisasi Kemanusiaan - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "TSAQIF MUHAMMAD",
        jenjang: "S2",
        prodi: "Teknik Elektro - Manajemen Energi dan Ketenagalistrikan - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "LUH KOMANG ENGGI LINDAYANI",
        jenjang: "S2",
        prodi: "Administrasi Rumah Sakit - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ELLESYE NOVRACURIE",
        jenjang: "S2",
        prodi: "Ilmu Hukum - Hukum Ekonomi - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "NEDYA SONELMA",
        jenjang: "S2",
        prodi: "Teknik Sipil - Manajemen Konstruksi - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "APRIYANTI SIJABAT",
        jenjang: "S2",
        prodi: "Ilmu Komputer"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "HANIF VIDI YUWONO",
        jenjang: "S2",
        prodi: "Ilmu Politik - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "NURRAMA DHANIA TRIWIJAYANTI",
        jenjang: "S2",
        prodi: "Magister Akuntansi - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "HARNIATI ULFAH",
        jenjang: "S2",
        prodi: "Ilmu Komunikasi - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "HIMATUL HARISAH",
        jenjang: "S2",
        prodi: "Ilmu Hukum - Hukum Ekonomi - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "D'KARA FIKRUL ISLAM MUHAMMAD",
        jenjang: "S2",
        prodi: "Ilmu Susastra (Sastra) - Sastra - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "M. RYAN FIRMANSYAH",
        jenjang: "S2",
        prodi: "Ilmu Susastra (Sastra) - Sastra - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "VISTA AGUSTI",
        jenjang: "S2",
        prodi: "Ilmu Hukum - Hukum Sumber Daya Alam - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MUHAMMAD MOZA ALTHORIQ PUTRA",
        jenjang: "S2",
        prodi: "Teknik Sipil - Transportasi - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ALFIAN MARDHY PANGESTU",
        jenjang: "S2",
        prodi: "Teknik Sipil - Transportasi - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MUHAMAD MAIGEL ALFAJAR",
        jenjang: "S2",
        prodi: "Ilmu Hukum - Hukum Dan Sistem Peradilan Pidana - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MARIA STEPHANIE DU'A BURA",
        jenjang: "S2",
        prodi: "Magister Akuntansi - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "M NAUFAL ASYRAF",
        jenjang: "S2",
        prodi: "Teknik Industri - Manajemen Industri - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "IKA AGUSTINA MAULIDZIAH",
        jenjang: "S2",
        prodi: "Teknik Sipil - Transportasi - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ANINDITHA TRI PUTRI",
        jenjang: "S2",
        prodi: "Ilmu Administrasi - Inovasi dan Intrapreneurship - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "IKBAL",
        jenjang: "S2",
        prodi: "Ilmu Komputer"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "FREDERICK BATARA SIMANGUNSONG",
        jenjang: "S2",
        prodi: "Magister Perencanaan Ekonomi dan Kebijakan Pembangunan - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "APRILIA PRATIWI",
        jenjang: "S2",
        prodi: "Teknologi Informasi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "EVA DWIYANTI LESTARI",
        jenjang: "S2",
        prodi: "Ilmu Kesehatan Masyarakat - Biostatistika - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MONA KHOIRUNNISAH",
        jenjang: "S2",
        prodi: "Teknik Sipil - Transportasi - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "JUNAEDI AKBAR",
        jenjang: "S2",
        prodi: "Ilmu Komputer"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "NAMIRAH ALISYA",
        jenjang: "S2",
        prodi: "Teknologi Informasi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ZAVIRA AULIA",
        jenjang: "S2",
        prodi: "Kenotariatan - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "SHINTIA FARAMUDHITA",
        jenjang: "S2",
        prodi: "Ilmu Manajemen - Digital Marketing and Analytics - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "SYIBLY ADAM FIRMANDA",
        jenjang: "S2",
        prodi: "Ilmu Administrasi - Administrasi dan Kebijakan Publik - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MATIUS PETRUS KABIAI",
        jenjang: "S2",
        prodi: "Ilmu Hukum - Hukum Sumber Daya Alam - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ADAM FARHANSYAH",
        jenjang: "S2",
        prodi: "Ilmu Hukum - Hukum Ekonomi - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "PRISCA JULIANA LIANTO",
        jenjang: "S2",
        prodi: "Ilmu Hukum - Hukum Dan Sistem Peradilan Pidana - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ALEXANDER WIDYASTANTO UTOMO",
        jenjang: "S2",
        prodi: "Teknik Elektro - Manajemen Telekomunikasi - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "AHMAD ANSYORI",
        jenjang: "S2",
        prodi: "Ilmu Hukum - Hukum Ekonomi - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ILYAS NURDIANSYAH YUSUF",
        jenjang: "S2",
        prodi: "Magister Perencanaan Ekonomi dan Kebijakan Pembangunan - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ETHERMAN NAINGGOLAN",
        jenjang: "S2",
        prodi: "Teknologi Informasi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "BIMO SETIO WICAKSONO",
        jenjang: "S2",
        prodi: "Teknik Kimia - Teknik Kimia - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "SHELLY NUR'AENI",
        jenjang: "S2",
        prodi: "Magister Akuntansi - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "REY LUKAS PARASI",
        jenjang: "S2",
        prodi: "Magister Akuntansi - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "GHINA ROZAN SHIDQI",
        jenjang: "S2",
        prodi: "Kriminologi - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "SAFINATUN NAJATIR RAHMAH",
        jenjang: "S2",
        prodi: "Ilmu Linguistik - Pengajaran Bahasa - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "TRI SANTO SIMANJUNTAK",
        jenjang: "S2",
        prodi: "Ilmu Hukum - Hukum Kekayaan Intelektual (HKI) - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "LAURENSIUS HANDOKO OKTAVIANUS",
        jenjang: "S2",
        prodi: "Ilmu Manajemen - Human Capital Management - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "NURUL NADIYATUN SHOLIHAH",
        jenjang: "S2",
        prodi: "Teknologi Informasi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "AHMADAN ULUL AZMI",
        jenjang: "S2",
        prodi: "Keselamatan & Kesehatan Kerja - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MOHAMMAD ALFAREZA REZWANDY RIDWAN",
        jenjang: "S2",
        prodi: "Kenotariatan - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "VALENTINO MAHENDRA WICAKSONO",
        jenjang: "S2",
        prodi: "Magister Perencanaan Ekonomi dan Kebijakan Pembangunan - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "LOKITA PURNAMASARI",
        jenjang: "S2",
        prodi: "Ilmu Hubungan Internasional - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MUHIMATUL KHOIROH",
        jenjang: "S2",
        prodi: "Ilmu Administrasi - Administrasi dan Kebijakan Publik - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "RIJAL RAMDHANI",
        jenjang: "S2",
        prodi: "Kebijakan Publik dan Governansi - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ALIFIA MICHELLE AISYAH USMAN",
        jenjang: "S2",
        prodi: "Ilmu Hukum - Socio-Legal Studies (Hukum dan Masyarakat) - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "HAFIZA UTAMI SYUKRI",
        jenjang: "S2",
        prodi: "Keselamatan & Kesehatan Kerja - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "I NYOMAN ADI WIYARNA",
        jenjang: "S2",
        prodi: "Ilmu Administrasi - Administrasi dan Kebijakan Publik - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ARLIANUS",
        jenjang: "S2",
        prodi: "Ilmu Susastra (Sastra) - Studi Kultural - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "HEDI RIZKI AMALIA",
        jenjang: "S2",
        prodi: "Ilmu Manajemen - Digital Marketing and Analytics - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "AYU MEILIASARI",
        jenjang: "S2",
        prodi: "Teknik Sipil - Manajemen Konstruksi - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "IQLIMA NATASYA SAPUTRI",
        jenjang: "S2",
        prodi: "Kenotariatan - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "AMALIA MUTHY AFIFA",
        jenjang: "S2",
        prodi: "Kenotariatan - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "KARLINA",
        jenjang: "S2",
        prodi: "Kajian Gender - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "DWI MAYANG SAGITA",
        jenjang: "S2",
        prodi: "Ilmu Susastra (Sastra) - Sastra - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "NOVIYANTI",
        jenjang: "S2",
        prodi: "Ilmu Keperawatan"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "GREGORIUS BIMO EWA DWIGO",
        jenjang: "S2",
        prodi: "Ilmu Hubungan Internasional - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MIFTHACHUL CHOLIFAH",
        jenjang: "S2",
        prodi: "Ilmu Administrasi - Administrasi dan Kebijakan Publik - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "NINDYA INDAH SAFIRA AULIARACHMI",
        jenjang: "S2",
        prodi: "Psikologi - Psikologi Sosial - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "SARAH INDAH JAYANTI",
        jenjang: "S2",
        prodi: "Ilmu Keperawatan"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "RAHMA DHIYA HUSNA",
        jenjang: "S2",
        prodi: "Ilmu Kesehatan Masyarakat - Gizi Kesehatan Masyarakat - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MEUTHIA SAFHIRA FIRDAUS",
        jenjang: "S2",
        prodi: "Ilmu Kesehatan Masyarakat - Kesehatan Lingkungan - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "NURUL SALSABILA SYAM",
        jenjang: "S2",
        prodi: "Ilmu Komputer"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "RYAN CHANDRA PERMANA PUTRA",
        jenjang: "S2",
        prodi: "Magister Manajemen - Sumber Daya Manusia - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "SHERLY GYTA",
        jenjang: "S2",
        prodi: "Magister Manajemen - Manajemen Umum - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "COLLIN ADI PRATAMA",
        jenjang: "S2",
        prodi: "Ilmu Hukum - Hukum Ekonomi - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "IVAN DELISING",
        jenjang: "S2",
        prodi: "Teknik Sistem Energi - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "OSCAR ANGANDROWA F ZEBUA",
        jenjang: "S2",
        prodi: "Kajian Ketahanan Nasional - Kajian Stratejik Imigrasi - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ESTER MUTIARA INDAH SILITONGA",
        jenjang: "S2",
        prodi: "Ilmu Keperawatan"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ANGELIA DEVI SULASTIKA",
        jenjang: "S2",
        prodi: "Ilmu Administrasi - Administrasi dan Kebijakan Publik - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "NENDEN CITRA SOFTWATUL NINGRUM",
        jenjang: "S2",
        prodi: "Teknologi Informasi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "E HARI CATUR BASUKI",
        jenjang: "S2",
        prodi: "Kedokteran Kerja - Kedokteran Tenaga Kerja - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "CHUMAIRAH DESIANA",
        jenjang: "S2",
        prodi: "Magister Perencanaan Ekonomi dan Kebijakan Pembangunan - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "IRSAL ASHARI",
        jenjang: "S2",
        prodi: "Magister Perencanaan Ekonomi dan Kebijakan Pembangunan - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "HOSYI'AH RUSDIANA",
        jenjang: "S2",
        prodi: "Teknologi Informasi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "FITRIA ANDRIANI FAKDAWER",
        jenjang: "S2",
        prodi: "Ilmu Kesehatan Masyarakat - Mutu Layanan Kesehatan - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "KHUSNUL AFIFAH ZHARAURA",
        jenjang: "S2",
        prodi: "Magister Akuntansi - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "RIMADINA MELIANINGSIH",
        jenjang: "S2",
        prodi: "Ilmu Kesejahteraan Sosial - Pengembangan Masyarakat, Penanggulangan Kemiskinan dan Tanggung Jawab Sosial Perusahaan - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "FIQIH NUR ROKHMAN",
        jenjang: "S2",
        prodi: "Magister Akuntansi - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "IQBAL TAMIMI",
        jenjang: "S2",
        prodi: "Ilmu Hukum - Hukum Ekonomi - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ADZRA KARAMINA RIVANI",
        jenjang: "S2",
        prodi: "Ilmu Administrasi - Administrasi Keuangan Daerah dan Aset Daerah - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MUHAMMAD HERDYAN SUKMANA ISMAN",
        jenjang: "S2",
        prodi: "Ilmu Administrasi - Administrasi dan Kebijakan Publik - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "YURNI BUNGA",
        jenjang: "S2",
        prodi: "Ilmu Hukum - Hukum Ekonomi - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "VAZA SABILA ANANDA RIZQY",
        jenjang: "S2",
        prodi: "Ilmu Politik - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "OLAV KEVIN SUDJA",
        jenjang: "S2",
        prodi: "Teknik Kimia - Energi dan Proses Berkelanjutan - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "NASYA PUTRI AMARANGGANA",
        jenjang: "S2",
        prodi: "Ilmu Komunikasi - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "DJOKO SAPTADI",
        jenjang: "S2",
        prodi: "Ilmu Manajemen - Human Capital Management - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "DEWI YULLIANTY",
        jenjang: "S2",
        prodi: "Magister Manajemen - Sumber Daya Manusia - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "SANDRO DANANJAYA PITOYO",
        jenjang: "S2",
        prodi: "Magister Manajemen - Manajemen Keuangan - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "REGINA KARMAN",
        jenjang: "S2",
        prodi: "Magister Akuntansi - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "HASNA NUR ALIFAH",
        jenjang: "S2",
        prodi: "Teknik Sipil - Transportasi - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ANGGIT LARAS ARDINDRA",
        jenjang: "S2",
        prodi: "Magister Manajemen - Manajemen Keuangan - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "HERMAN TUAH SITOHANG",
        jenjang: "S2",
        prodi: "Administrasi Rumah Sakit - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "AGUS SETIYO UTOMO",
        jenjang: "S2",
        prodi: "Magister Manajemen - Sumber Daya Manusia - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MOHAMMAD FIRDAUS WIJANARKO",
        jenjang: "S2",
        prodi: "Magister Manajemen - Manajemen Keuangan - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "LINMAS DITA SARI",
        jenjang: "S2",
        prodi: "Teknologi Informasi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MEILATI DWI PUTRI",
        jenjang: "S2",
        prodi: "Magister Manajemen - Sumber Daya Manusia - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "FARAH FARIHAH MARTHIA",
        jenjang: "S2",
        prodi: "Ilmu Linguistik - Penerjemahan - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MUHAMMAD FIRMAN TATAWU",
        jenjang: "S2",
        prodi: "Kajian Ketahanan Nasional - Kajian Stratejik Intelijen - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "TRI BROTO SISWOYO",
        jenjang: "S2",
        prodi: "Teknologi Informasi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "RAJENDRA ADHIWANGSA",
        jenjang: "S2",
        prodi: "Biologi - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "FARAHDIBA NOOR RACHMAT",
        jenjang: "S2",
        prodi: "Sosiologi - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "VANIE PUSPITASARI",
        jenjang: "S2",
        prodi: "Magister Manajemen - Sumber Daya Manusia - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "AVERA LASMARIYA SIMBOLON",
        jenjang: "S2",
        prodi: "Administrasi Rumah Sakit - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ERDIANSYAH PUTRA",
        jenjang: "S2",
        prodi: "Administrasi Rumah Sakit - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "LAURENSIA JEANY",
        jenjang: "S2",
        prodi: "Ilmu Biomedik - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ZEFIRA FADRYONA",
        jenjang: "S2",
        prodi: "Ilmu Komunikasi - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ZAHRA AYU QALBINA",
        jenjang: "S2",
        prodi: "Ilmu Kesehatan Masyarakat - Promosi Kesehatan - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "PRIHANDANA ADITIYANDO SUPRAPTO",
        jenjang: "S2",
        prodi: "Ilmu Administrasi - Administrasi dan Kebijakan Publik - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ABDURROHHIM S. WAHYUDI",
        jenjang: "S2",
        prodi: "Teknologi Informasi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ADITYO NUGROHO",
        jenjang: "S2",
        prodi: "Magister Manajemen - Sumber Daya Manusia - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "VIESCA SEPTIANATA",
        jenjang: "S2",
        prodi: "Ilmu Keperawatan"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "DESIANA NUR RACHMAWATI",
        jenjang: "S2",
        prodi: "Ilmu Administrasi - Administrasi dan Kebijakan Publik - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MUHAMMAD IRSYAD",
        jenjang: "S2",
        prodi: "Ilmu Hubungan Internasional - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "SYAHIRUL ALIM",
        jenjang: "S2",
        prodi: "Magister Akuntansi - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "NOVIA FATMAWATI PUTRI",
        jenjang: "S2",
        prodi: "Ilmu Kesehatan Masyarakat - Kesehatan Reproduksi - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "YOGI GUNAWAN ATMAWIJAYA",
        jenjang: "S2",
        prodi: "Teknik Mesin - Sistem Manufaktur dan Otomasi - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "KURNIA ILAHI",
        jenjang: "S2",
        prodi: "Magister Manajemen - Manajemen Keuangan - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "BEATRICE FLO YONATHAN",
        jenjang: "S2",
        prodi: "Ilmu Hukum - Hukum Ekonomi - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "DWI RANDI SULISTIYONO",
        jenjang: "S2",
        prodi: "Ilmu Hukum - Hukum Ekonomi - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "WIRZAROKA",
        jenjang: "S2",
        prodi: "Magister Perencanaan Ekonomi dan Kebijakan Pembangunan - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MOHAMMAD AFIF HANAFI",
        jenjang: "S2",
        prodi: "Teknologi Informasi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MASAIL ISHMAD MAWAQIF",
        jenjang: "S2",
        prodi: "Ilmu Hukum - Hukum Dan Sistem Peradilan Pidana - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ANINDITO DWI APRIANO",
        jenjang: "S2",
        prodi: "Magister Manajemen - Aktuaria - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "FITRAH RAMADHIAN",
        jenjang: "S2",
        prodi: "Ilmu Hukum - Hukum Ekonomi - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "AHMAD NABIL SHAHAB",
        jenjang: "S2",
        prodi: "Teknik Metalurgi & Material - Material - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ARY REZQY HAKIM",
        jenjang: "S2",
        prodi: "Kajian Ketahanan Nasional - Kajian Stratejik Imigrasi - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "YUDHI PRAYITNO",
        jenjang: "S2",
        prodi: "Matematika - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "DARMAWAN PUTRA. B",
        jenjang: "S2",
        prodi: "Teknik Sipil - Manajemen Infrastruktur - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "DEBY AMALIA",
        jenjang: "S2",
        prodi: "Teknik Sipil - Manajemen Konstruksi - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "RISTA KURNIAWAN",
        jenjang: "S2",
        prodi: "Magister Manajemen - Manajemen Keuangan - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "LIN LIN KULSUM HALIMAH",
        jenjang: "S2",
        prodi: "Teknik Mesin - Konversi dan Konservasi Energi - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "EDRICK ONGGARIO",
        jenjang: "S2",
        prodi: "Magister Akuntansi - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ARTHA NOVIYANTRI UTAMI",
        jenjang: "S2",
        prodi: "Kenotariatan - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "BENNARON SULANCANA SIDAURUK",
        jenjang: "S2",
        prodi: "Teknik Metalurgi & Material - Riset"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MUH. RIVAN SARANANI",
        jenjang: "S2",
        prodi: "Teknik Sipil - Manajemen Sumber Daya Air - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "NABILA MELIYANTI",
        jenjang: "S2",
        prodi: "Kajian Wilayah Jepang - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "NABILA ADISTRI",
        jenjang: "S2",
        prodi: "Ilmu Komunikasi - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ROMI MUHARAM",
        jenjang: "S2",
        prodi: "Kajian Ketahanan Nasional - Kajian Stratejik Imigrasi - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "DAVIS DENILO SIANIPAR",
        jenjang: "S2",
        prodi: "Epidemiologi - Epidemiologi Komunitas - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ANANDA FERDIAN PRADANA",
        jenjang: "S2",
        prodi: "Teknik Industri - Desain dan Manajemen Sistem - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "AFIFAH NUR HIDAYAH",
        jenjang: "S2",
        prodi: "Ilmu Biomedik - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MAYANDA WIDAYANA WALUYO",
        jenjang: "S2",
        prodi: "Ilmu Hubungan Internasional - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ADI SETIANSYAH",
        jenjang: "S2",
        prodi: "Teknologi Informasi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "DIANISSA YULIA RAHMA",
        jenjang: "S2",
        prodi: "Teknik Industri - Manajemen Industri - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "AZDI FAHMI",
        jenjang: "S2",
        prodi: "Ilmu Komputer"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "KAYLANITHA SYAILENDRAPUTRI",
        jenjang: "S2",
        prodi: "Ilmu Hukum - Hukum Dan Sistem Peradilan Pidana - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "INAS FARIDA",
        jenjang: "S2",
        prodi: "Ilmu Kesehatan Masyarakat - Biostatistika - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "RINDU ALIFA MAHARANI",
        jenjang: "S2",
        prodi: "Teknologi Informasi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "YADI NURYADI",
        jenjang: "S2",
        prodi: "Kenotariatan - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MUHAMMAD NURUL MUFLIKHIN",
        jenjang: "S2",
        prodi: "Ilmu Kesejahteraan Sosial - Pengembangan Masyarakat, Penanggulangan Kemiskinan dan Tanggung Jawab Sosial Perusahaan - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ABDULLAH OSAMA L H EL MENAWI",
        jenjang: "S2",
        prodi: "Ilmu Hubungan Internasional - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "BRIAN ARDIANSAH",
        jenjang: "S2",
        prodi: "Ilmu Administrasi - Administrasi dan Kebijakan Perpajakan - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "REZA AKBAR PRADHITYO",
        jenjang: "S2",
        prodi: "Kenotariatan - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "SALSABELA MULIA JUNAEDI",
        jenjang: "S2",
        prodi: "Kenotariatan - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "YASYFA MUTIARA",
        jenjang: "S2",
        prodi: "Ilmu Kesehatan Masyarakat - Gizi Kesehatan Masyarakat - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "OKTA HENDRA. P",
        jenjang: "S2",
        prodi: "Magister Perencanaan Ekonomi dan Kebijakan Pembangunan - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "AGUS PRATIKNO",
        jenjang: "S2",
        prodi: "Kajian Ketahanan Nasional - Kajian Stratejik Imigrasi - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "VESSY MILNA",
        jenjang: "S2",
        prodi: "Psikologi Terapan - Psikologi Anak Usia Dini - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "NIKEN MULYA",
        jenjang: "S2",
        prodi: "Kenotariatan - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ANDHIKA RAFGAN WICAKSONO",
        jenjang: "S2",
        prodi: "Perencanaan Wilayah dan Kota - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MUHAMMAD ADHIKA RAHMANTO",
        jenjang: "S2",
        prodi: "Ilmu Administrasi - Administrasi dan Kebijakan Publik - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ANIQOH DINAH",
        jenjang: "S2",
        prodi: "Kajian Wilayah Timur Tengah dan Islam - Kajian Islam - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "YUHA AFINA KHALISH",
        jenjang: "S2",
        prodi: "Kajian Wilayah Timur Tengah dan Islam - Politik dan Hubungan Internasional di Timur Tengah - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "PUTRI MAHARANI ALENA ZARIL",
        jenjang: "S2",
        prodi: "Ilmu Hukum - Hukum Ekonomi - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "DEDI KURNIAWAN SUSILO",
        jenjang: "S2",
        prodi: "Teknik Sipil - Transportasi - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "EKO SETIYONO",
        jenjang: "S2",
        prodi: "Magister Manajemen - Sumber Daya Manusia - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "BHIQI SATRYA ALVIANDY",
        jenjang: "S2",
        prodi: "Ilmu Politik - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "TIARA HANA PRATIWI",
        jenjang: "S2",
        prodi: "Ilmu Komunikasi - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "NIZAR",
        jenjang: "S2",
        prodi: "Ilmu Keperawatan"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "JUNAIDI",
        jenjang: "S2",
        prodi: "Ilmu Hukum - Hukum Ekonomi - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "GITA SULIKA SARI",
        jenjang: "S2",
        prodi: "Ilmu Administrasi - Administrasi dan Kebijakan Pengembangan SDM - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "VAN SATRIO WIBOWO",
        jenjang: "S2",
        prodi: "Kedokteran Kerja - Kedokteran Tenaga Kerja - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "RANGGARADIKA PRIHANDANA",
        jenjang: "S2",
        prodi: "Ilmu Hukum - Hukum Ketenagakerjaan - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ALANA MARIA",
        jenjang: "S2",
        prodi: "Ilmu Politik - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "NIA A'YUNIN",
        jenjang: "S2",
        prodi: "Teknik Industri - Manajemen Industri - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "HERLINDA",
        jenjang: "S2",
        prodi: "Teknik Sipil - Manajemen Konstruksi - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MEIVITO BAYU WICAKSONO",
        jenjang: "S2",
        prodi: "Ilmu Administrasi - Administrasi dan Kebijakan Publik - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "AYU RISTIANI",
        jenjang: "S2",
        prodi: "Ilmu Kimia - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "KHOYRUL LISTANTINING FIRDAUS",
        jenjang: "S2",
        prodi: "Ilmu Kesejahteraan Sosial - Manajemen dan Pengembangan Organisasi Kemanusiaan - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "JEFFREY Y NAPITUPULU",
        jenjang: "S2",
        prodi: "Ilmu Hukum - Hukum Ekonomi - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "PATIO ALFREDO NUGRAHA HUTABARAT",
        jenjang: "S2",
        prodi: "Ilmu Hukum - Hukum Kenegaraan - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "FAISHAL AZHIMAN SURYADI",
        jenjang: "S2",
        prodi: "Teknik Elektro - Manajemen Keamanan Jaringan Informasi - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ANASTASIA FARADILA HAKIM",
        jenjang: "S2",
        prodi: "Ilmu Administrasi - Administrasi dan Kebijakan Pengembangan SDM - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "HUSNAWATI",
        jenjang: "S2",
        prodi: "Kenotariatan - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "BUTET SRI REZEKI",
        jenjang: "S2",
        prodi: "Ilmu Hukum - Hukum Ekonomi - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "KARINA RAHMA ANDRIANI",
        jenjang: "S2",
        prodi: "Teknologi Informasi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "NAILUL DINA AFERA",
        jenjang: "S2",
        prodi: "Ilmu Administrasi - Administrasi Pengawasan - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "SHASKY JEANNE GAYATRI",
        jenjang: "S2",
        prodi: "Psikologi Terapan - Psikologi Intervensi Sosial - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MUHAMMAD ZULKIFLI",
        jenjang: "S2",
        prodi: "Ilmu Lingkungan - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "HUMAIROH ANAHDI",
        jenjang: "S2",
        prodi: "Magister Perencanaan Ekonomi dan Kebijakan Pembangunan - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ESA LISTIANA",
        jenjang: "S2",
        prodi: "Magister Manajemen - Manajemen Keuangan - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "IDHAM MINALDI",
        jenjang: "S2",
        prodi: "Ilmu Administrasi - Administrasi dan Kebijakan Publik - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "BINTANG JIHAD MAHARDHIKA",
        jenjang: "S2",
        prodi: "Kenotariatan - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "FARHAN ALDUNA",
        jenjang: "S2",
        prodi: "Kedokteran Kerja - Kedokteran Tenaga Kerja - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "FRANS DAVID TUA",
        jenjang: "S2",
        prodi: "Teknik Elektro - Manajemen Telekomunikasi - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "IKHSAN PRASETYA FITRIANSYAH",
        jenjang: "S2",
        prodi: "Ilmu Hukum - Hukum Ekonomi - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MAHARANI INAS MAHDIYYAH",
        jenjang: "S2",
        prodi: "Teknik Metalurgi & Material - Riset"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "IKE MAHLIDA PUTRI",
        jenjang: "S2",
        prodi: "Magister Perencanaan Ekonomi dan Kebijakan Pembangunan - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "BONGOT SIREGAR",
        jenjang: "S2",
        prodi: "Teknik Sipil - Transportasi - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MELYSA BR. SITEPU",
        jenjang: "S2",
        prodi: "Epidemiologi - Epidemiologi Klinik"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "DIAN NATALIA",
        jenjang: "S2",
        prodi: "Administrasi Rumah Sakit - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ANNISA RAHMI",
        jenjang: "S2",
        prodi: "Ilmu Kesehatan Masyarakat - Promosi Kesehatan - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "INDIRA PUTRI MAHARANI",
        jenjang: "S2",
        prodi: "Ilmu Hukum - Hukum Dan Sistem Peradilan Pidana - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "AMELIA FARAH SALSABILA EFRIAL",
        jenjang: "S2",
        prodi: "Ilmu Manajemen - Digital Marketing and Analytics - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MUHAMMAD FIKRI RAMADHAN",
        jenjang: "S2",
        prodi: "Ilmu Hukum - Hukum Ekonomi - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "REENA SIMANIHURUK",
        jenjang: "S2",
        prodi: "Ilmu Komputer"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "RELIF KARNADI",
        jenjang: "S2",
        prodi: "Teknik Sipil - Transportasi - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ELFYS FERDYNAN PANJAITAN",
        jenjang: "S2",
        prodi: "Ilmu Kesehatan Masyarakat - Biostatistika - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "DWI ANGGA GIANTORO PUTRA",
        jenjang: "S2",
        prodi: "Ilmu Hukum - Hukum Perdagangan Internasional - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "RIAN HENDRIS SAPUTRA",
        jenjang: "S2",
        prodi: "Teknik Sipil - Transportasi - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "NADHIRA ALYA FAIRUZ",
        jenjang: "S2",
        prodi: "Ilmu Kesehatan Masyarakat - Gizi Kesehatan Masyarakat - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "HARYADI SUSANTO",
        jenjang: "S2",
        prodi: "Magister Ekonomi Kependudukan dan Ketenagakerjaan"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "FARHAN HADI PRASETYO",
        jenjang: "S2",
        prodi: "Ilmu Ekonomi - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ANNISA PUTRI MAGFIRA",
        jenjang: "S2",
        prodi: "Perencanaan Wilayah dan Kota - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "FIRDAUS",
        jenjang: "S2",
        prodi: "Epidemiologi - Epidemiologi Terapan"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "DJOKO PRIBADYO",
        jenjang: "S2",
        prodi: "Ilmu Manajemen - Human Capital Management - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "YOHANNA MARTALINA SIRAIT",
        jenjang: "S2",
        prodi: "Ilmu Hukum - Hukum Keuangan Publik - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MUNIFAN HABIBI",
        jenjang: "S2",
        prodi: "Ilmu Administrasi - Administrasi Keuangan Daerah dan Aset Daerah - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "RAHMI HATMA HANIFA",
        jenjang: "S2",
        prodi: "Ilmu Kesehatan Masyarakat - Gizi Kesehatan Masyarakat - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ANGELLA NUR OCTAVIA WIBISONO",
        jenjang: "S2",
        prodi: "Ilmu Manajemen - Digital Marketing and Analytics - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ROSTIHANAH ISTIQO",
        jenjang: "S2",
        prodi: "Kajian Ketahanan Nasional - Kajian Stratejik Imigrasi - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "TETY NIKASIA MATANARI",
        jenjang: "S2",
        prodi: "Ilmu Keperawatan"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "RATU SALZABIELLA ARSYA MAHARANI",
        jenjang: "S2",
        prodi: "Magister Manajemen - Manajemen Umum - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "DEA FEBRIVA ASRI",
        jenjang: "S2",
        prodi: "Ilmu Politik - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "HAFIZHAH INDRIYANI R.",
        jenjang: "S2",
        prodi: "Kajian Gender - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "VISITYARI DWI SURYANI",
        jenjang: "S2",
        prodi: "Ilmu Kesehatan Masyarakat - Biostatistika - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "GRACIELA NATHASYA",
        jenjang: "S2",
        prodi: "Magister Akuntansi - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "WANDA NELWITA DAMAYANI",
        jenjang: "S2",
        prodi: "Geografi - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "AGUNG DWI LAKSONO",
        jenjang: "S2",
        prodi: "Magister Manajemen - Manajemen Keuangan - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "BELANDINA ANITA SERE SIHOMBING",
        jenjang: "S2",
        prodi: "Magister Akuntansi - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "KRISNA ABHI PADHANA",
        jenjang: "S2",
        prodi: "Ilmu Komputer"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "NIRMALA ASRIANI",
        jenjang: "S2",
        prodi: "Administrasi Rumah Sakit - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "FATHIN ABIYYU DESHA",
        jenjang: "S2",
        prodi: "Kebijakan Publik dan Governansi - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "RAFI DEVANDRA YUSMANANDA",
        jenjang: "S2",
        prodi: "Teknologi Informasi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "CLARASINTHA NINDYATAMI",
        jenjang: "S2",
        prodi: "Ilmu Biomedik - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "HAFSAH AMALIA",
        jenjang: "S2",
        prodi: "Ilmu Kesehatan Masyarakat - Biostatistika - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "VERLANTRA ARIVANDY MAHARDIKA SUBING",
        jenjang: "S2",
        prodi: "Kajian Wilayah Amerika - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ADZHOLLA HADZNA SUNGKAR",
        jenjang: "S2",
        prodi: "Ilmu Hukum - Hukum Hak Asasi Manusia dan Good Governance - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ASHFA SAMIAL HAMDA",
        jenjang: "S2",
        prodi: "Teknik Elektro - Manajemen Telekomunikasi - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "TRIANA LESTARI",
        jenjang: "S2",
        prodi: "Psikologi Terapan - Psikologi Intervensi Sosial - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "AGUS MUHDI AJI",
        jenjang: "S2",
        prodi: "Magister Perencanaan Ekonomi dan Kebijakan Pembangunan - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "IDA AYU INDIRA SARASIJA KAMAJAYA",
        jenjang: "S2",
        prodi: "Administrasi Rumah Sakit - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "SUTAN RADHIKA IZZAPUTRA A",
        jenjang: "S2",
        prodi: "Kenotariatan - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "IVAN SULISTIO PRABOWO",
        jenjang: "S2",
        prodi: "Teknik Sipil - Manajemen Proyek - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "YORIKA INDAH PRATIWI NABABAN",
        jenjang: "S2",
        prodi: "Ilmu Perpustakaan - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ANDI RUZIQNA SALSABILA",
        jenjang: "S2",
        prodi: "Industri Kreatif"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ANDI DIANDRA GARNIS PAMUSU",
        jenjang: "S2",
        prodi: "Kenotariatan - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "RUTH ROTUA AGUSTINA SITORUS",
        jenjang: "S2",
        prodi: "Ilmu Hukum - Hukum Ekonomi - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "IRNA",
        jenjang: "S2",
        prodi: "Ilmu Hukum - Hukum Hak Asasi Manusia dan Good Governance - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "YUZAR LAZUARDY",
        jenjang: "S2",
        prodi: "Teknik Industri - Sistem Produksi dan Logistik - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "RISKA JANUARSI",
        jenjang: "S2",
        prodi: "Ilmu Kesehatan Masyarakat - Kesehatan Lingkungan - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "EXAS DANIEL LUMBAN GAOL",
        jenjang: "S2",
        prodi: "Ilmu Lingkungan - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "GERRY RIZKY PUTRA EL PASEMAH",
        jenjang: "S2",
        prodi: "Psikologi - Psikologi Sosial - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "RAGIL PANGESTU",
        jenjang: "S2",
        prodi: "Kajian Ketahanan Nasional - Kajian Stratejik Imigrasi - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "IRNA RAHAYU",
        jenjang: "S2",
        prodi: "Keselamatan & Kesehatan Kerja - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ALEX MAKARIOS B.S",
        jenjang: "S2",
        prodi: "Ilmu Hukum - Hukum Ekonomi - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "YASAR ABDUL BAQI",
        jenjang: "S2",
        prodi: "Ilmu Komunikasi - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "NABILA AZZAHRA",
        jenjang: "S2",
        prodi: "Ilmu Komputer"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "CHRISTIAN GILBERD SUMOLANG",
        jenjang: "S2",
        prodi: "Kenotariatan - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "KRISTIN CITRA NAPITUPULU",
        jenjang: "S2",
        prodi: "Psikologi - Psikologi Pendidikan - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "QORI AZ-ZAHRA",
        jenjang: "S2",
        prodi: "Ilmu Kesehatan Masyarakat - Gizi Kesehatan Masyarakat - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "FENY DARWATI",
        jenjang: "S2",
        prodi: "Ilmu Administrasi - Administrasi Keuangan Daerah dan Aset Daerah - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "REZA DORIS PERDANA",
        jenjang: "S2",
        prodi: "Teknik Sipil - Transportasi - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ADITYA RASYAD HARJANTO",
        jenjang: "S2",
        prodi: "Ilmu Manajemen - Digital Marketing and Analytics - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "INDIRA FEDRA WINADINE SIREGAR",
        jenjang: "S2",
        prodi: "Ilmu Hukum - Hukum Dan Sistem Peradilan Pidana - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "JENNY DEBORAH SIANIPAR",
        jenjang: "S2",
        prodi: "Magister Manajemen - Sumber Daya Manusia - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "BLESSY EASTER SARA TANGEL",
        jenjang: "S2",
        prodi: "Ilmu Hubungan Internasional - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "BARIROTUL MUSALMATUL JANNAH",
        jenjang: "S2",
        prodi: "Ilmu Filsafat - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "TAN MUHAMAD ZIKRI",
        jenjang: "S2",
        prodi: "Ilmu Kefarmasian - Bioteknologi dan Bahan Alam - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "GABRIEL BHRAMARA WILASITA",
        jenjang: "S2",
        prodi: "Teknik Industri - Rekayasa Inovasi dan Disain - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "FARREL EVAN ALFARES",
        jenjang: "S2",
        prodi: "Ilmu Hukum - Hukum Ekonomi - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "AHMAD HIKAM WARDHANA",
        jenjang: "S2",
        prodi: "Magister Manajemen - Manajemen Keuangan - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "HANNY AYU SOEGIHWANGI",
        jenjang: "S2",
        prodi: "Administrasi Rumah Sakit - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "INAROTUL NGUYUN",
        jenjang: "S2",
        prodi: "Magister Manajemen - Manajemen Keuangan - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "AISHA FAISAL ALWINI",
        jenjang: "S2",
        prodi: "Ilmu Kesehatan Masyarakat - Kebijakan dan Hukum Kesehatan - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "LASMITA NURANA",
        jenjang: "S2",
        prodi: "Ilmu Komunikasi - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "DYAH KUSUMA DEWI",
        jenjang: "S2",
        prodi: "Ilmu Komunikasi - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MICHAEL GRACESON LOYVER SITOMPUL",
        jenjang: "S2",
        prodi: "Ilmu Hukum - Hukum Kenegaraan - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "TAMARA NATHANIA SARAGIH",
        jenjang: "S2",
        prodi: "Magister Manajemen - Manajemen Pemasaran - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MUHAMMAD ANSHORI",
        jenjang: "S2",
        prodi: "Ilmu Hukum - Hukum Ketenagakerjaan - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "FAROUQ PANCA ADITYO",
        jenjang: "S2",
        prodi: "Ilmu Fisika - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "DEWI AFRIANTI",
        jenjang: "S2",
        prodi: "Teknik Elektro - Manajemen Telekomunikasi - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ANGGA SEPTIYANA",
        jenjang: "S2",
        prodi: "Teknik Mesin - Riset"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "SITI MAHARANI NABILAH",
        jenjang: "S2",
        prodi: "Ilmu Komunikasi - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "EKA FATIMAH",
        jenjang: "S2",
        prodi: "Keselamatan & Kesehatan Kerja - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "IRWIN KURNIADI",
        jenjang: "S2",
        prodi: "Administrasi Rumah Sakit - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "NABILAH PUTRI SYAHIRAH AR",
        jenjang: "S2",
        prodi: "Ilmu Hukum - Hukum Ekonomi - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MUHAMMAD LUTHFI SHAFWAN",
        jenjang: "S2",
        prodi: "Teknik Mesin - Konversi dan Konservasi Energi - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "NGAKAN PUTU DAKSA GANAPATI",
        jenjang: "S2",
        prodi: "Administrasi Rumah Sakit - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MOCH. STIAWAN JODDY",
        jenjang: "S2",
        prodi: "Teknik Industri - Manajemen Industri - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "RESI VAUZIAH",
        jenjang: "S2",
        prodi: "Psikologi Terapan - Psikologi Anak Usia Dini - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "NUHA PRAYOGI",
        jenjang: "S2",
        prodi: "Ilmu Manajemen - Digital Marketing and Analytics - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "NIDIA MURYANI",
        jenjang: "S2",
        prodi: "Ilmu Kesehatan Masyarakat - Kesehatan Mental Komunitas dan Disabilitas - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "AFINDA PUTRI DWIASTUTI",
        jenjang: "S2",
        prodi: "Ilmu Manajemen - Manajemen Strategi - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ROSALIDIA KIFLY",
        jenjang: "S2",
        prodi: "Kenotariatan - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "DEWI SEKAR ARUM",
        jenjang: "S2",
        prodi: "Geografi - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "COVALENT ION DARGAWAN",
        jenjang: "S2",
        prodi: "Ilmu Manajemen - Digital Marketing and Analytics - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "RAHAYU LA EDY",
        jenjang: "S2",
        prodi: "Kenotariatan - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "RARAS ANASI",
        jenjang: "S2",
        prodi: "Ilmu Kesehatan Masyarakat - Biostatistika - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "RATNA MEILINA",
        jenjang: "S2",
        prodi: "Ilmu Keperawatan"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "FERDO ELFIANTO",
        jenjang: "S2",
        prodi: "Kajian Ilmu Kepolisian - MSDM Kepolisian - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "SAMUEL NICHOLAS UTAMA",
        jenjang: "S2",
        prodi: "Kajian Ilmu Kepolisian - MSDM Kepolisian - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "PAMUNGKAS TRI KUSUMO",
        jenjang: "S2",
        prodi: "Kajian Pengembangan Perkotaan - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ERIK PARULIAN SIHOTANG",
        jenjang: "S2",
        prodi: "Ilmu Kesehatan Masyarakat - Ekonomi Kesehatan - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ANDRA LOLIJA PRAMUDYA",
        jenjang: "S2",
        prodi: "Kajian Ketahanan Nasional - Kajian Stratejik Imigrasi - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MOHAMMAD REZA ANDHIKA HALIM",
        jenjang: "S2",
        prodi: "Teknik Sipil - Transportasi - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "RAUDHYA AL FIRA",
        jenjang: "S2",
        prodi: "Kenotariatan - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "HARDIYANTO KENNETH, S.H.,M.H.,M.SI.",
        jenjang: "S2",
        prodi: "Manajemen Bencana - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "YULIANTO HADIPRAMONO",
        jenjang: "S2",
        prodi: "Psikologi - Psikologi Industri dan Organisasi - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MUHAMMAD NAUFAL ASSHIDIQIE",
        jenjang: "S2",
        prodi: "Ilmu Hukum - Hukum Kenegaraan - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "AMELIA AGUSTINA",
        jenjang: "S2",
        prodi: "Magister Akuntansi - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "PUTRI QURROTA'AINI",
        jenjang: "S2",
        prodi: "Ilmu Hukum - Socio-Legal Studies (Hukum dan Masyarakat) - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "AHMAD AMIN RAIS",
        jenjang: "S2",
        prodi: "Kenotariatan - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MUHAMMAD RAFIF HIDAYATULLAH",
        jenjang: "S2",
        prodi: "Ilmu Administrasi - Administrasi dan Kebijakan Pengembangan SDM - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "PUTRI AFRA APRILIA",
        jenjang: "S2",
        prodi: "Kenotariatan - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "JUAN FELIX",
        jenjang: "S2",
        prodi: "Teknik Elektro - Elektronika dan Sistem Tertanam Cerdas - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "DEBORA DANISA KURNIASIH PERDANA SITANGGANG",
        jenjang: "S2",
        prodi: "Ilmu Komunikasi - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "BRILIAN ALGIVARY",
        jenjang: "S2",
        prodi: "Teknik Kimia - Teknik Kimia - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MUHAMMAD ALAYA",
        jenjang: "S2",
        prodi: "Ilmu Politik - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "RIZKIA LANA MAUREEN",
        jenjang: "S2",
        prodi: "Magister Perencanaan Ekonomi dan Kebijakan Pembangunan - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ADITYA PRIANTOMO",
        jenjang: "S2",
        prodi: "Magister Manajemen - Manajemen Keuangan - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "AHMAD ALIFIAN NURUDDIN.GH",
        jenjang: "S2",
        prodi: "Ilmu Hubungan Internasional - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "AULIA SHIFFA PRAMESTIA",
        jenjang: "S2",
        prodi: "Kenotariatan - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "KHALIFATURRAHMAN",
        jenjang: "S2",
        prodi: "Kajian Wilayah Timur Tengah dan Islam - Kajian Islam - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "NABILA RAHIL FIKRIYAH",
        jenjang: "S2",
        prodi: "Ilmu Susastra (Sastra) - Studi Kultural - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "CHRISTANTY",
        jenjang: "S2",
        prodi: "Ilmu Keperawatan"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ANGGIE HARDIYANTI",
        jenjang: "S2",
        prodi: "Epidemiologi - Epidemiologi Komunitas - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MUHAMMAD SAKHI RADANI",
        jenjang: "S2",
        prodi: "Kenotariatan - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "FITRIA NAJIB",
        jenjang: "S2",
        prodi: "Administrasi Rumah Sakit - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "VINA ALZAHRA",
        jenjang: "S2",
        prodi: "Ilmu Kesehatan Masyarakat - Kesehatan Lingkungan - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "SYIFA WIDYA RAHMASARI",
        jenjang: "S2",
        prodi: "Ilmu Keperawatan"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ENNI SAYEKTI",
        jenjang: "S2",
        prodi: "Ilmu Komunikasi - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "IHDA DLAIVINA LAILASEPTIANI",
        jenjang: "S2",
        prodi: "Ilmu Kedokteran Gigi Dasar - Ilmu Kedokteran Gigi Forensik - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ZULFIKAR KUSUMA AKBAR",
        jenjang: "S2",
        prodi: "Ilmu Hukum - Hukum Dan Sistem Peradilan Pidana - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "FERNANDO ANGGONO",
        jenjang: "S2",
        prodi: "Kenotariatan - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ECA DESRIANA ZAHWA",
        jenjang: "S2",
        prodi: "Ilmu Biomedik - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "FATIH NURUL IZZAH",
        jenjang: "S2",
        prodi: "Teknologi Biomedis - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "BAYU PRABOWO",
        jenjang: "S2",
        prodi: "Teknik Elektro - Tenaga Listrik dan Sistem Cerdas - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "QUINTA NADYA MADRA",
        jenjang: "S2",
        prodi: "Teknik Elektro - Elektronika dan Sistem Tertanam Cerdas - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "NAOMI PUTRI TJAHYANI",
        jenjang: "S2",
        prodi: "Matematika - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MIRANDA PUSPITA PARAPAT",
        jenjang: "S2",
        prodi: "Kenotariatan - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "HANNA FA'ADHILAH",
        jenjang: "S2",
        prodi: "Kajian Ketahanan Nasional - Kajian Stratejik Imigrasi - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "UTAMI DINI SURYANI",
        jenjang: "S2",
        prodi: "Ilmu Kesehatan Masyarakat - Manajemen Pelayanan Kesehatan - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ALISA EMMIRANI AZKA",
        jenjang: "S2",
        prodi: "Kenotariatan - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MARIA THERESIA EFIKA ROSEMARIE",
        jenjang: "S2",
        prodi: "Ilmu Komunikasi - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MUHAMMAD ROSYID RIDLO",
        jenjang: "S2",
        prodi: "Ilmu Komunikasi - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "PRESTISIA INTAN NURCAHYANI KUSUMANINGTYAS",
        jenjang: "S2",
        prodi: "Ilmu Lingkungan - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "DEMAS ABDI ISLAMEY",
        jenjang: "S2",
        prodi: "Ilmu Hukum - Hukum Hak Asasi Manusia dan Good Governance - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "EVANI NATALADI",
        jenjang: "S2",
        prodi: "Ilmu Keperawatan"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "I GUSTI NGURAH ADITIA TJANDRA ASMARA",
        jenjang: "S2",
        prodi: "Kriminologi - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MUHAMMAD ALIF TAUFIQ",
        jenjang: "S2",
        prodi: "Kenotariatan - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ALI HAMONANGAN SIAGIAN",
        jenjang: "S2",
        prodi: "Magister Perencanaan Ekonomi dan Kebijakan Pembangunan - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MELLY RISFANI",
        jenjang: "S2",
        prodi: "Ilmu Hukum - Hukum Kenegaraan - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "FAMI ISRAYUSNITA",
        jenjang: "S2",
        prodi: "Ilmu Biomedik - Riset"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ANDIKA ABDUHU",
        jenjang: "S2",
        prodi: "Ilmu Susastra (Sastra) - Sastra - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ANDIKA SATRIO ALHAFIZH",
        jenjang: "S2",
        prodi: "Ilmu Manajemen - Manajemen Strategi - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ARMINA ANALINTA",
        jenjang: "S2",
        prodi: "Ilmu Kesehatan Masyarakat - Biostatistika - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "DARA AYU WARDHANI",
        jenjang: "S2",
        prodi: "Ilmu Keperawatan"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "FOFANA DIARRA AULIA RAHMA",
        jenjang: "S2",
        prodi: "Arsitektur - Arsitektur & Sustainabilitas - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "SASKIA MAHARANI SALWA NABILI",
        jenjang: "S2",
        prodi: "Kenotariatan - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MAHESWARI DAHAYU WARDANI",
        jenjang: "S2",
        prodi: "Ilmu Hukum - Hukum Ekonomi - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "YESSI NG INDAH SANTOSA",
        jenjang: "S2",
        prodi: "Magister Manajemen - Manajemen Pemasaran - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "GABRIELA ADELINE THURANA",
        jenjang: "S2",
        prodi: "Ilmu Politik - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "SARA DWI ANJANI",
        jenjang: "S2",
        prodi: "Ilmu Linguistik - Bahasa dan Kebudayaan - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "DEWI FATIMAH ADZIR M",
        jenjang: "S2",
        prodi: "Arkeologi - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "TASYA TSALSABILLA CHAIRUNNISA",
        jenjang: "S2",
        prodi: "Kenotariatan - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "RISKA PROBO NILAWATI",
        jenjang: "S2",
        prodi: "Kebijakan Publik dan Governansi - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ANDINI FITRIASTUTI",
        jenjang: "S2",
        prodi: "Ilmu Manajemen - Digital Marketing and Analytics - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MUTIARA CIKA WIANANDA",
        jenjang: "S2",
        prodi: "Kenotariatan - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "BAGUS DWI ALFIANSYAH",
        jenjang: "S2",
        prodi: "Teknik Sipil - Transportasi - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "DEVA ANJANY PUTRI",
        jenjang: "S2",
        prodi: "Kenotariatan - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "TEUKU MUHAMMAD ARIEF MAULANA",
        jenjang: "S2",
        prodi: "Kajian Ketahanan Nasional - Kajian Stratejik Imigrasi - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MUHAMMAD ALIM ABBID FALAHYANA",
        jenjang: "S2",
        prodi: "Teknik Industri - Rekayasa Data dan Kualitas - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "CAMELIA FIKRILLAH",
        jenjang: "S2",
        prodi: "Teknologi Informasi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "SALSABILA RAHIMA DEWANI",
        jenjang: "S2",
        prodi: "Industri Kreatif"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "NURUL LATIFAH",
        jenjang: "S2",
        prodi: "Teknik Industri - Sistem Produksi dan Logistik - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "YESI FEBRIANI",
        jenjang: "S2",
        prodi: "Magister Akuntansi - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "FRANSISKA SATRIANI DAMPUT",
        jenjang: "S2",
        prodi: "Administrasi Rumah Sakit - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "VINKA PRAMESWARI",
        jenjang: "S2",
        prodi: "Ilmu Hukum - Socio-Legal Studies (Hukum dan Masyarakat) - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "KISANDANI PRIYAMBODO KUSUMOJATI",
        jenjang: "S2",
        prodi: "Ilmu Komunikasi - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ILFANDRI HAGIA",
        jenjang: "S2",
        prodi: "Teknik Sipil - Transportasi - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "SEKAR AYU CAHYANINGTYAS",
        jenjang: "S2",
        prodi: "Magister Akuntansi - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "TAMPAN FAJERO KHALIL GIBRAN",
        jenjang: "S2",
        prodi: "Teknik Elektro - Manajemen Keamanan Jaringan Informasi - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ARI WIBOWO",
        jenjang: "S2",
        prodi: "Magister Perencanaan Ekonomi dan Kebijakan Pembangunan - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "WEAN FERNANDA",
        jenjang: "S2",
        prodi: "Kajian Ketahanan Nasional - Kajian Stratejik Imigrasi - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "LUTFI AMRIZA",
        jenjang: "S2",
        prodi: "Ilmu Administrasi - Administrasi dan Kebijakan Niaga - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MADE RATNA SARASWATI",
        jenjang: "S2",
        prodi: "Administrasi Rumah Sakit - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "RAFIF NAUFAL PUTRA",
        jenjang: "S2",
        prodi: "Magister Akuntansi - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "PRASETYA DWI ATMOKO",
        jenjang: "S2",
        prodi: "Teknik Industri - Rekayasa Data dan Kualitas - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ULYA ILMI AZHARA",
        jenjang: "S2",
        prodi: "Teknik Sipil - Manajemen Konstruksi - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "YERRY SISWANTO",
        jenjang: "S2",
        prodi: "Ilmu Administrasi - Administrasi Keuangan Daerah dan Aset Daerah - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "RONNY KURNIAWAN",
        jenjang: "S2",
        prodi: "Ilmu Manajemen - Manajemen Strategi - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "DERREN DAVID CHRISTIAN HOMENTA RAMPENGAN",
        jenjang: "S2",
        prodi: "Keselamatan & Kesehatan Kerja - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "FITRI NURANI",
        jenjang: "S2",
        prodi: "Ilmu Administrasi - Administrasi dan Kebijakan Pengembangan SDM - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "REZA NURFITRI",
        jenjang: "S2",
        prodi: "Teknik Kimia - Manajemen Gas - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "AZAZ FAUZAN",
        jenjang: "S2",
        prodi: "Ilmu Hukum - Hukum Kenegaraan - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "KORNELIUS ESRAN YEHEZKIEL",
        jenjang: "S2",
        prodi: "Ilmu Hukum - Hukum Sumber Daya Alam - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "KHALILI",
        jenjang: "S2",
        prodi: "Ilmu Susastra (Sastra) - Sastra - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MUHAMMAD RIZKY SILABAN",
        jenjang: "S2",
        prodi: "Ilmu Filsafat - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "SATRIA NUR FAUZI",
        jenjang: "S2",
        prodi: "Ilmu Hukum - Hukum Kenegaraan - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "RENDIASTY PRAWINDARI",
        jenjang: "S2",
        prodi: "Magister Akuntansi - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "AZIZ ANJAR SANTOSO",
        jenjang: "S2",
        prodi: "Teknik Sipil - Manajemen Konstruksi - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "NAUFAL FADHILAH",
        jenjang: "S2",
        prodi: "Kajian Ketahanan Nasional - Kajian Stratejik Imigrasi - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "FENNY RAHAYU PRASETYANINGSIH",
        jenjang: "S2",
        prodi: "Magister Manajemen - Manajemen Umum - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "TABAH GAYUH ADITAMA",
        jenjang: "S2",
        prodi: "Ilmu Administrasi - Administrasi dan Kebijakan Pengembangan SDM - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "YOVAN GARY OTNIEL",
        jenjang: "S2",
        prodi: "Ilmu Hubungan Internasional - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "RADEN TOFAN SAIFUDIN AKBAR",
        jenjang: "S2",
        prodi: "Teknik Elektro - Manajemen Telekomunikasi - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "I MADE DYANTA ANWAR",
        jenjang: "S2",
        prodi: "Ilmu Keperawatan"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MOHAMMAD RIDHO ELHA",
        jenjang: "S2",
        prodi: "Kenotariatan - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "NORALIA ULFA",
        jenjang: "S2",
        prodi: "Ilmu Hukum - Hukum Dan Sistem Peradilan Pidana - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ARFAN AHMAD BAGUSPUTRA",
        jenjang: "S2",
        prodi: "Teknik Industri - Manajemen Industri - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "JAMAL DANI ARIFIN",
        jenjang: "S2",
        prodi: "Kajian Wilayah Eropa - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "REZKY AGUNG PRATOMO",
        jenjang: "S2",
        prodi: "Teknik Metalurgi & Material - Material - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "RIA RUMATA SIMANJUNTAK",
        jenjang: "S2",
        prodi: "Ilmu Hukum - Hukum Kenegaraan - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MUHAMAD GILANG SUKMAHAVI",
        jenjang: "S2",
        prodi: "Magister Manajemen - Manajemen Umum - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MAULITA PRIMA SARI",
        jenjang: "S2",
        prodi: "Herbal - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "CHRISTINEBELGINASAURMAULI",
        jenjang: "S2",
        prodi: "Ilmu Administrasi - Administrasi Pengawasan - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MUHAMMAD RISYAD",
        jenjang: "S2",
        prodi: "Kajian Ketahanan Nasional - Kajian Stratejik Imigrasi - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "VICTORYADO SHANDEZ JOSEPH",
        jenjang: "S2",
        prodi: "Ilmu Hubungan Internasional - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "NUR AMALA",
        jenjang: "S2",
        prodi: "Magister Akuntansi - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "SEKAR FAIRUZ DARMAWAN",
        jenjang: "S2",
        prodi: "Psikologi - Psikologi Industri dan Organisasi - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "CHRISTYANE ZABDI",
        jenjang: "S2",
        prodi: "Matematika - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "RADEN AYU NURFADHILLAH RIFQAH",
        jenjang: "S2",
        prodi: "Fisika Medis - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MUHAMMAD FAUZI",
        jenjang: "S2",
        prodi: "Kajian Ketahanan Nasional - Kajian Stratejik Imigrasi - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "BUKHORI",
        jenjang: "S2",
        prodi: "Ilmu Komunikasi - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "RIDHO MAKSUDI",
        jenjang: "S2",
        prodi: "Ilmu Lingkungan - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MARGARETA SUSILOWATI",
        jenjang: "S2",
        prodi: "Ilmu Keperawatan"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MUHAMMAD ALFAIRUZ",
        jenjang: "S2",
        prodi: "Ilmu Linguistik - Bahasa dan Kebudayaan - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ARISTAWIDYA DWI PUTRI",
        jenjang: "S2",
        prodi: "Magister Perencanaan Ekonomi dan Kebijakan Pembangunan - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "AMALIA FITRIYANA",
        jenjang: "S2",
        prodi: "Psikologi - Psikologi Pendidikan - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ASEP KURNIAWAN",
        jenjang: "S2",
        prodi: "Teknik Mesin - Konversi dan Konservasi Energi - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "AMOS PARLEMEN ZEPANYA SIHITE",
        jenjang: "S2",
        prodi: "Ilmu Administrasi - Administrasi dan Kebijakan Publik - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MUHAMMAD GAZA WIRIADI",
        jenjang: "S2",
        prodi: "Ilmu Manajemen - Human Capital Management - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "SISKA YULIANA",
        jenjang: "S2",
        prodi: "Ilmu Administrasi - Administrasi dan Kebijakan Perpajakan - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "EVI NURHAYATI",
        jenjang: "S2",
        prodi: "Ilmu Manajemen - Digital Marketing and Analytics - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ALDI LUTHFIANDA PRATAMA",
        jenjang: "S2",
        prodi: "Ilmu Administrasi - Administrasi dan Kebijakan Niaga - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "AMRAN JULIANTO TANESIB",
        jenjang: "S2",
        prodi: "Ilmu Kesehatan Masyarakat - Kesehatan Reproduksi - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MUHAMMAD RULLIE FEBIAN RANGKUTI",
        jenjang: "S2",
        prodi: "Ilmu Hukum - Hukum Kenegaraan - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MUTHAHARY HAYYURAHMAN",
        jenjang: "S2",
        prodi: "Magister Perencanaan Ekonomi dan Kebijakan Pembangunan - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ULI ELISABET PATRICIA PASARIBU",
        jenjang: "S2",
        prodi: "Kajian Ketahanan Nasional - Kajian Stratejik Ketahanan Nasional - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "EDWARD THAHIR",
        jenjang: "S2",
        prodi: "Ilmu Administrasi - Administrasi dan Kebijakan Niaga - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "KAMALUDIN RAMDAN RAMAYUDA",
        jenjang: "S2",
        prodi: "Psikologi Terapan - Psikologi Olah Raga - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "LULU DHIA KHAIRUNISA",
        jenjang: "S2",
        prodi: "Ilmu Administrasi - Inovasi dan Intrapreneurship - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "DAVI NAUFAL ASTAREKA",
        jenjang: "S2",
        prodi: "Magister Perencanaan Ekonomi dan Kebijakan Pembangunan - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "TATIK WAHYUNI",
        jenjang: "S2",
        prodi: "Ilmu Keperawatan"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "DIANDINI NATA PERTIWI",
        jenjang: "S2",
        prodi: "Ilmu Administrasi - Administrasi dan Kebijakan Niaga - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ABDULLAH TAMRIN RETTOB",
        jenjang: "S2",
        prodi: "Kenotariatan - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "NESSIA RACHMANDA PRATIWI",
        jenjang: "S2",
        prodi: "Ilmu Administrasi - Administrasi dan Kebijakan Niaga - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "GIAFIN BIBSY RAHMAULITA",
        jenjang: "S2",
        prodi: "Teknik Metalurgi & Material - Korosi - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ISNAINI DESTYFITRIANA",
        jenjang: "S2",
        prodi: "Magister Perencanaan Ekonomi dan Kebijakan Pembangunan - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "DWI RETNO MULYANINGSIH",
        jenjang: "S2",
        prodi: "Teknik Sipil - Manajemen Proyek - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "SULISTIANA R",
        jenjang: "S2",
        prodi: "Teknik Elektro - Manajemen Energi dan Ketenagalistrikan - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ENDAH ASA ALYYA",
        jenjang: "S2",
        prodi: "Magister Manajemen - Manajemen Operasi - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ARDIANSYAH",
        jenjang: "S2",
        prodi: "Industri Kreatif"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "CHRISTY OCTAVIANI",
        jenjang: "S2",
        prodi: "Ilmu Manajemen - Human Capital Management - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "NUR RIZKYANDRI RAMADHAN",
        jenjang: "S2",
        prodi: "Ilmu Administrasi - Inovasi dan Intrapreneurship - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MUTHIA IRHAMNA",
        jenjang: "S2",
        prodi: "Ilmu Administrasi - Inovasi dan Intrapreneurship - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ARISTA PUTRI PERMATASARI",
        jenjang: "S2",
        prodi: "Teknik Kimia - Teknik Kimia - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "EKA CAHYANI",
        jenjang: "S2",
        prodi: "Magister Ekonomi Kependudukan dan Ketenagakerjaan"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "IR YAP SUCI KUSWARDANI. M",
        jenjang: "S2",
        prodi: "Asia Timur - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "LAWRENCE ENRICARLO",
        jenjang: "S2",
        prodi: "Kenotariatan - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "GANJAR PEKERTI",
        jenjang: "S2",
        prodi: "Magister Manajemen - Manajemen Pemasaran - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "M AIMAN KAMIL HARAHAP",
        jenjang: "S2",
        prodi: "Psikologi - Psikologi Pendidikan - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MUHAMAD AKBAR SHODIQ",
        jenjang: "S2",
        prodi: "Ilmu Komputer"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "UTAMI SETYAWATI",
        jenjang: "S2",
        prodi: "Kenotariatan - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MUTYARA DEVIYANA",
        jenjang: "S2",
        prodi: "Teknik Industri - Sistem Produksi dan Logistik - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ISRAEL IRYAN CORINUS KREY",
        jenjang: "S2",
        prodi: "Ilmu Hukum - Hukum Kenegaraan - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "LAELA FAUZIAH",
        jenjang: "S2",
        prodi: "Ilmu Administrasi - Administrasi dan Kebijakan Niaga - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "LAILANI SYARIFAH",
        jenjang: "S2",
        prodi: "Ilmu Administrasi - Administrasi dan Kebijakan Niaga - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "DINO MARTA GEMILANG",
        jenjang: "S2",
        prodi: "Kajian Ketahanan Nasional - Kajian Stratejik Ketahanan Nasional - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "RITA ASIMA MANURUNG",
        jenjang: "S2",
        prodi: "Teknik Elektro - Manajemen Keamanan Jaringan Informasi - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MUFTIE ARIEF",
        jenjang: "S2",
        prodi: "Sosiologi - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ANDI MUH. ADHIM",
        jenjang: "S2",
        prodi: "Ilmu Hukum - Hukum Ekonomi - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MUHAMMAD ALFIANSYAH",
        jenjang: "S2",
        prodi: "Ilmu Kesehatan Masyarakat - Kebijakan dan Hukum Kesehatan - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ANTONIA LAKSMI ANDITYARINI",
        jenjang: "S2",
        prodi: "Magister Manajemen - Manajemen Pemasaran - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "RIZKA AZIZAH",
        jenjang: "S2",
        prodi: "Ilmu Komunikasi - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "NOVAL SYAHADAT",
        jenjang: "S2",
        prodi: "Manajemen Bencana - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "DESMIA RAHMADANI",
        jenjang: "S2",
        prodi: "Ilmu Akuntansi - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "DIAH SABATINI SITININGRUM",
        jenjang: "S2",
        prodi: "Ilmu Lingkungan - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "JIHAN OCTANI",
        jenjang: "S2",
        prodi: "Magister Akuntansi - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "TEDY WIDIANTO",
        jenjang: "S2",
        prodi: "Teknik Mesin - Teknologi dan Sumber Daya Maritim - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "RIZAL FAUZI",
        jenjang: "S2",
        prodi: "Ilmu Manajemen - Digital Marketing and Analytics - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "M. FAJRI DAVYZA CHANIAGO",
        jenjang: "S2",
        prodi: "Ilmu Komputer"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "BULAN KAMILLAH",
        jenjang: "S2",
        prodi: "Ilmu Kesehatan Masyarakat - Mutu Layanan Kesehatan - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "NOVIA RAMANDA HASIBUAN",
        jenjang: "S2",
        prodi: "Magister Akuntansi - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MUHAMMAD HANAFI GUNAWAN",
        jenjang: "S2",
        prodi: "Kajian Wilayah Jepang - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "FARZANA HADIFA",
        jenjang: "S2",
        prodi: "Teknologi Informasi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "RAHAYU WIDIASTUTI",
        jenjang: "S2",
        prodi: "Ilmu Keperawatan"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "AHMAD KHUMAIDI ANNAJA",
        jenjang: "S2",
        prodi: "Ilmu Kesehatan Masyarakat - Biostatistika - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "AGUNG NURHANANTO PUTRO",
        jenjang: "S2",
        prodi: "Magister Manajemen - Manajemen Keuangan - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "LUKMAN EKO CAHYONO",
        jenjang: "S2",
        prodi: "Kebijakan Publik dan Governansi - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "TIAS PINKY ANANDA",
        jenjang: "S2",
        prodi: "Kenotariatan - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "YUHANA IKA PRASTIAWATI",
        jenjang: "S2",
        prodi: "Kajian Ketahanan Nasional - Kajian Stratejik Intelijen - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "DIANITA PRATIWI",
        jenjang: "S2",
        prodi: "Ilmu Lingkungan - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "M. ALI YAFI RIZKY",
        jenjang: "S2",
        prodi: "Teknik Metalurgi & Material - Riset"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "YOSSI ANDREANO",
        jenjang: "S2",
        prodi: "Teknik Metalurgi & Material - Riset"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "RYANEKA DARMAWAN",
        jenjang: "S2",
        prodi: "Magister Perencanaan Ekonomi dan Kebijakan Pembangunan - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ALMA ATSILA",
        jenjang: "S2",
        prodi: "Keselamatan & Kesehatan Kerja - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "FAZA KHOIRINA",
        jenjang: "S2",
        prodi: "Teknik Mesin - Sistem Manufaktur dan Otomasi - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "CENDEKIA ZAHRAH CHUMAIRA",
        jenjang: "S2",
        prodi: "Kenotariatan - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "YOGA ADI PRIYANGGA",
        jenjang: "S2",
        prodi: "Teknik Sipil - Transportasi - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "GABRIELLA EKA OCTAVIA ANDRIANTI",
        jenjang: "S2",
        prodi: "Ilmu Biomedik - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MICHAEL CHRISTIAN",
        jenjang: "S2",
        prodi: "Ilmu Manajemen - Keuangan dan Perbankan - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "VALIDA ULFA SEPTIANA",
        jenjang: "S2",
        prodi: "Ilmu Kesehatan Masyarakat - Biostatistika - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "NENG ENDAH FATMAWATI",
        jenjang: "S2",
        prodi: "Ilmu Politik - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "RAHMALIZA",
        jenjang: "S2",
        prodi: "Magister Manajemen - Manajemen Keuangan - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "QURRATA AINI M NASIR",
        jenjang: "S2",
        prodi: "Kenotariatan - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "PRIMA APRIANTI",
        jenjang: "S2",
        prodi: "Administrasi Rumah Sakit - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "GHINA YUSRIYYAH SALMA",
        jenjang: "S2",
        prodi: "Teknik Lingkungan - Manajemen Kualitas Lingkungan - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "KARTIKA NUR ADJI PRAMESTI",
        jenjang: "S2",
        prodi: "Kenotariatan - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ARYO ANUGRAH HARTADI MANURUNG",
        jenjang: "S2",
        prodi: "Teknik Sipil - Manajemen Konstruksi - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "OKTAVIA ISANUR MAGHFIROH",
        jenjang: "S2",
        prodi: "Magister Akuntansi - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ZAMAKHSYARI FARID AZHAR",
        jenjang: "S2",
        prodi: "Ilmu Administrasi - Administrasi dan Kebijakan Niaga - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "SOFWATUL HANIM",
        jenjang: "S2",
        prodi: "Epidemiologi - Epidemiologi Komunitas - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "APRILIANA INDRI HAPSARI",
        jenjang: "S2",
        prodi: "Ilmu Komunikasi - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "DIAN HANDAYANI",
        jenjang: "S2",
        prodi: "Ilmu Administrasi - Administrasi dan Kebijakan Niaga - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "NANDITO AURELLIO PANJIDINATA",
        jenjang: "S2",
        prodi: "Ilmu Hukum - Hukum Ekonomi - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "TIO ARIESTA",
        jenjang: "S2",
        prodi: "Ilmu Hukum - Hukum Ekonomi - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ROMEO MATTHEW ALEXANDRO PANTOUW",
        jenjang: "S2",
        prodi: "Ilmu Komunikasi - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "AHMAD AZHAR KAMAL",
        jenjang: "S2",
        prodi: "Kajian Wilayah Jepang - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "WAHYU SURYA DARU SAPUTRA",
        jenjang: "S2",
        prodi: "Teknik Sipil - Manajemen Proyek - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "EVITA RENGGANIS",
        jenjang: "S2",
        prodi: "Ilmu Manajemen - Manajemen Strategi - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MARINA ALEXANDRA",
        jenjang: "S2",
        prodi: "Ilmu Manajemen - Digital Marketing and Analytics - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ARI WIBOWO",
        jenjang: "S2",
        prodi: "Ilmu Keperawatan"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "AXEL YAPNUARLYN",
        jenjang: "S2",
        prodi: "Magister Perencanaan Ekonomi dan Kebijakan Pembangunan - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "I DEWA GEDE YUDHA PERWIRA ADHI PRADNYANA",
        jenjang: "S2",
        prodi: "Kajian Ilmu Kepolisian - Siber - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "LISYA MUTIARA DEWI",
        jenjang: "S2",
        prodi: "Biologi - Riset"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "KHAMSYAH",
        jenjang: "S2",
        prodi: "Keselamatan & Kesehatan Kerja - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MUHAMMAD FARIZKY",
        jenjang: "S2",
        prodi: "Teknik Sipil - Transportasi - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MEISYA ADISTIA",
        jenjang: "S2",
        prodi: "Kenotariatan - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ACHYAT DAROINI",
        jenjang: "S2",
        prodi: "Ilmu Hukum - Hukum Kenegaraan - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "NATASHA LATIFATU SOLIHA",
        jenjang: "S2",
        prodi: "Ilmu Kesehatan Masyarakat - Biostatistika - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "FA ALFAREZA",
        jenjang: "S2",
        prodi: "Ilmu Biomedik - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "RIDHA ALFINS",
        jenjang: "S2",
        prodi: "Magister Manajemen - Manajemen Umum - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "EWIN YAFELLI",
        jenjang: "S2",
        prodi: "Ilmu Hukum - Hukum Perdagangan Internasional - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "RUHADI WIRAWAN",
        jenjang: "S2",
        prodi: "Industri Kreatif"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "HARRY ISMAIL",
        jenjang: "S2",
        prodi: "Kajian Terorisme - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "FIKA HARNINGTYAS",
        jenjang: "S2",
        prodi: "Teknik Sipil - Transportasi - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "FATHUR RAHIM",
        jenjang: "S2",
        prodi: "Manajemen Integritas Material - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "NURUL FAHRIZATUL ROHMAH",
        jenjang: "S2",
        prodi: "Teknik Elektro - Riset"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "AHMAD NAWWAR DARYDZAKY",
        jenjang: "S2",
        prodi: "Teknik Mesin - Konversi dan Konservasi Energi - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ANGGA PRATAMA",
        jenjang: "S2",
        prodi: "Kajian Wilayah Eropa - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MUHAMMAD TAUFIQ",
        jenjang: "S2",
        prodi: "Ilmu Politik - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "AYU MUKHIBATUL FADHILAH",
        jenjang: "S2",
        prodi: "Magister Akuntansi - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "BUNGA DEWI MAHARANI",
        jenjang: "S2",
        prodi: "Ilmu Administrasi - Administrasi dan Kebijakan Perpajakan - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "AGREVINA MUTIARA GUSTI SUHUNAN",
        jenjang: "S2",
        prodi: "Ilmu Hukum - Hukum Kekayaan Intelektual (HKI) - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "VICE ROY HALOMOAN SIREGAR",
        jenjang: "S2",
        prodi: "Teknik Industri - Manajemen Industri - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ANGGA PRATAMA",
        jenjang: "S2",
        prodi: "Teknik Elektro - Manajemen Keamanan Jaringan Informasi - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "AFIF NURFIGA IRSYAD",
        jenjang: "S2",
        prodi: "Teknik Sipil - Transportasi - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ALVINO CAHYADI",
        jenjang: "S2",
        prodi: "Ilmu Administrasi - Administrasi dan Kebijakan Pengembangan SDM - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ZAHWA SALSABILLA",
        jenjang: "S2",
        prodi: "Ilmu Komunikasi - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "RANDY HASAN BASRI ROZALI",
        jenjang: "S2",
        prodi: "Ilmu Manajemen - Keuangan dan Perbankan - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "RINA MARTINA PUSPITASARI",
        jenjang: "S2",
        prodi: "Ilmu Komunikasi - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "YULIANA DAMAYANTI",
        jenjang: "S2",
        prodi: "Ilmu Hukum - Hukum Ekonomi - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "YOBY AFIS",
        jenjang: "S2",
        prodi: "Magister Perencanaan Ekonomi dan Kebijakan Pembangunan - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "AXEL SHIRA SAPATA NEGARA",
        jenjang: "S2",
        prodi: "Teknologi Informasi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ARDIAN WARDHANA",
        jenjang: "S2",
        prodi: "Teknik Elektro - Riset"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ADLINANUR FEBRI PRIHANDIANI",
        jenjang: "S2",
        prodi: "Psikologi - Psikologi Industri dan Organisasi - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "IKHSAN APRILIAN NARO",
        jenjang: "S2",
        prodi: "Magister Manajemen - Manajemen Umum - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MOCHAMAD FACHRY PRAYOGA",
        jenjang: "S2",
        prodi: "Teknologi Informasi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "SALSABILA ALNAFISA",
        jenjang: "S2",
        prodi: "Ilmu Manajemen - Keuangan dan Perbankan - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "LISKA FEBY FITRIANI",
        jenjang: "S2",
        prodi: "Ilmu Lingkungan - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "KHARISMA DEANTARI",
        jenjang: "S2",
        prodi: "Magister Akuntansi - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "LOUISA MAYLIANI M SIREGAR",
        jenjang: "S2",
        prodi: "Ilmu Hukum - Hukum Dan Sistem Peradilan Pidana - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "TONI HERMAWAN",
        jenjang: "S2",
        prodi: "Ilmu Kesehatan Masyarakat - Mutu Layanan Kesehatan - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "AWAN GUNDITA",
        jenjang: "S2",
        prodi: "Teknologi Informasi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "IRINA PARAMITTA SARI",
        jenjang: "S2",
        prodi: "Psikologi Terapan - Psikologi Sumber Daya Manusia - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ABDURRAHMAN",
        jenjang: "S2",
        prodi: "Kebijakan Publik dan Governansi - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "JEREMI SYAFA'AT UMBU LAMBA AWANG",
        jenjang: "S2",
        prodi: "Ilmu Hukum - Hukum Kenegaraan - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "FRANKY GUSTRIONO PASARIBU",
        jenjang: "S2",
        prodi: "Teknik Metalurgi & Material - Korosi - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "DEDI PRASETIA",
        jenjang: "S2",
        prodi: "Ilmu Komunikasi - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "STEPHANIE ARIMITRY HUTAPEA",
        jenjang: "S2",
        prodi: "Kajian Ketahanan Nasional - Kajian Stratejik Imigrasi - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "HASIDIN SAMADA",
        jenjang: "S2",
        prodi: "Kebijakan Publik dan Governansi - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ALMAN PAWZY",
        jenjang: "S2",
        prodi: "Psikologi - Psikologi Sosial - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "REYNALDI GALUH MULYANA",
        jenjang: "S2",
        prodi: "Ilmu Ekonomi - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "NABILA MAHDIRANI",
        jenjang: "S2",
        prodi: "Ilmu Kesehatan Masyarakat - Kesehatan Mental Komunitas dan Disabilitas - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "KENIA KHAERUNISA HARDIANSYAH",
        jenjang: "S2",
        prodi: "Ilmu Administrasi - Administrasi dan Kebijakan Perpajakan - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MAULIDA SOLEKHAH",
        jenjang: "S2",
        prodi: "Ilmu Administrasi - Administrasi dan Kebijakan Publik - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "AURORA WINA MUTHMAINNAH",
        jenjang: "S2",
        prodi: "Ilmu Hukum - Hukum Ekonomi - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "RISKA RUSFITA PERDANA",
        jenjang: "S2",
        prodi: "Ilmu Keperawatan"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "NIA NORLYANTI",
        jenjang: "S2",
        prodi: "Ilmu Hubungan Internasional - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ZULFADILAH ZUR",
        jenjang: "S2",
        prodi: "Magister Perencanaan Ekonomi dan Kebijakan Pembangunan - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ALESSANDRO WIDJATI",
        jenjang: "S2",
        prodi: "Fisika Medis - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "JASMINE NUZULUL RAMADHANTY",
        jenjang: "S2",
        prodi: "Ilmu Hubungan Internasional - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ANDIKA WINARDI",
        jenjang: "S2",
        prodi: "Teknik Elektro - Riset"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "RACHMAT RAMADHIANSYAH",
        jenjang: "S2",
        prodi: "Teknologi Informasi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MELIKA NUR JIHAN",
        jenjang: "S2",
        prodi: "Antropologi - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "IMAM LAZUARDI NZ",
        jenjang: "S2",
        prodi: "Kenotariatan - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "RADEN RORO RAIHAN RIZKI RAMADHANI",
        jenjang: "S2",
        prodi: "Epidemiologi - Epidemiologi Klinik"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "DHEA EKA PRADANI",
        jenjang: "S2",
        prodi: "Kebijakan Publik dan Governansi - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ALIYA ZAHRA AFIFAH",
        jenjang: "S2",
        prodi: "Teknik Sipil - Transportasi - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "RISA LUTHFITA IZZATI",
        jenjang: "S2",
        prodi: "Ilmu Keperawatan"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "YOLLANDA SALSABILLAH WIBOWO",
        jenjang: "S2",
        prodi: "Ilmu Manajemen - Human Capital Management - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "WINARNO",
        jenjang: "S2",
        prodi: "Kajian Pengembangan Perkotaan - Riset"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "FIKANA MAHARDIKA CANTRI",
        jenjang: "S2",
        prodi: "Teknik Elektro - Riset"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "JOJOR SIHOTANG",
        jenjang: "S2",
        prodi: "Ilmu Keperawatan"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "HASNA IZDIHAR LATIFAH",
        jenjang: "S2",
        prodi: "Ilmu Kesehatan Masyarakat - Gizi Kesehatan Masyarakat - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "GRACE MARON MARPAUNG",
        jenjang: "S2",
        prodi: "Magister Manajemen - Manajemen Bisnis Internasional - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "SYARIFAH AULIA",
        jenjang: "S2",
        prodi: "Kenotariatan - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "FEBRIANA AYONDA",
        jenjang: "S2",
        prodi: "Kajian Gender - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MUHAMMAD RIKI FIRDAUS",
        jenjang: "S2",
        prodi: "Kajian Ilmu Kepolisian - MSDM Kepolisian - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "WARDIMAN",
        jenjang: "S2",
        prodi: "Epidemiologi - Epidemiologi Terapan"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "HANNA HARIS RIFAI",
        jenjang: "S2",
        prodi: "Ilmu Sejarah - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "PRATHAMA RIFQI SYAFITRAH",
        jenjang: "S2",
        prodi: "Teknologi Informasi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MUHAMMAD MUHTADI",
        jenjang: "S2",
        prodi: "Ilmu Hukum - Hukum Ekonomi - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "RIFKI MUBARAK",
        jenjang: "S2",
        prodi: "Teknik Sipil - Manajemen Konstruksi - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "JEANE PRISILIA POMBAELA",
        jenjang: "S2",
        prodi: "Antropologi - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "HILDA PERMATASARI",
        jenjang: "S2",
        prodi: "Teknik Sipil - Transportasi - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "RACHEL PASKARIA SIREGAR",
        jenjang: "S2",
        prodi: "Kenotariatan - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "INDAH SAFILA",
        jenjang: "S2",
        prodi: "Kajian Ketahanan Nasional - Kajian Stratejik Intelijen - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "LEONI NINDYASARI",
        jenjang: "S2",
        prodi: "Ilmu Komunikasi - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ROBBIE KURNIAWAN",
        jenjang: "S2",
        prodi: "Teknik Industri - Manajemen Industri - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "RIDA RAHMAWATI",
        jenjang: "S2",
        prodi: "Ilmu Linguistik - Pengajaran Bahasa - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MUHAMMAD IMAM MUJAHID",
        jenjang: "S2",
        prodi: "Ilmu Ekonomi - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "CHANDRA ANDRIANSYAH",
        jenjang: "S2",
        prodi: "Teknologi Informasi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "KITA RADISA",
        jenjang: "S2",
        prodi: "Ilmu Manajemen - Manajemen Strategi - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ZENI ARIFIANA MA'RIFAH",
        jenjang: "S2",
        prodi: "Ilmu Fisika - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "NIA RODEARNI LUMBANRAJA",
        jenjang: "S2",
        prodi: "Ilmu Kesehatan Masyarakat - Promosi Kesehatan - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "IBRAHIM ASKAR",
        jenjang: "S2",
        prodi: "Ilmu Politik - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "YUDHA RADITYADANA",
        jenjang: "S2",
        prodi: "Epidemiologi - Epidemiologi Klinik"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "PUTRA HUTOMO",
        jenjang: "S2",
        prodi: "Ilmu Hukum - Hukum Ekonomi - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "FARHAN MUZHAFFAR RAHMAN",
        jenjang: "S2",
        prodi: "Ilmu Linguistik - Bahasa dan Kebudayaan - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ELSA GLORIA HOSANG",
        jenjang: "S2",
        prodi: "Ilmu Kesehatan Masyarakat - Manajemen Pelayanan Kesehatan - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "AFRURSAH SATRIO BIA PRATAMA",
        jenjang: "S2",
        prodi: "Teknologi Informasi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MARRISA ARLINKHA EGA PUTRI",
        jenjang: "S2",
        prodi: "Ilmu Fisika - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "REVINDO DARMA PRATAMA",
        jenjang: "S2",
        prodi: "Teknik Industri - Sistem Produksi dan Logistik - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "NUR HIKMATTULLOH",
        jenjang: "S2",
        prodi: "Teknik Sipil - Manajemen Proyek - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "IMAM NUR FADILAH",
        jenjang: "S2",
        prodi: "Magister Akuntansi - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "YUSUF KADHAFI",
        jenjang: "S2",
        prodi: "Industri Kreatif"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "LATIFAH",
        jenjang: "S2",
        prodi: "Ilmu Administrasi - Administrasi Keuangan Daerah dan Aset Daerah - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "RADYA CANTIKA SUHARDIMAN PUTRI",
        jenjang: "S2",
        prodi: "Ilmu Linguistik - Penerjemahan - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "RAHMATUL AUVI",
        jenjang: "S2",
        prodi: "Magister Akuntansi - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "NISA NADIRA RAMADHANI",
        jenjang: "S2",
        prodi: "Magister Manajemen - Manajemen Operasi - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "SURYA YUDHA PRATIDINA",
        jenjang: "S2",
        prodi: "Teknik Industri - Rekayasa Data dan Kualitas - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "DEA CITRA KHARISMA",
        jenjang: "S2",
        prodi: "Ilmu Fisika - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MUHAMMAD IMADUDDIN ABDUR ROHIM",
        jenjang: "S2",
        prodi: "Ilmu Komputer"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "NUR IHSANA KHUSNA",
        jenjang: "S2",
        prodi: "Kenotariatan - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "AFRIZAL",
        jenjang: "S2",
        prodi: "Ilmu Kesehatan Masyarakat - Kebijakan dan Hukum Kesehatan - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "SALSABILA AMALIA",
        jenjang: "S2",
        prodi: "Ilmu Hubungan Internasional - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "RIZKY FADILAH",
        jenjang: "S2",
        prodi: "Magister Perencanaan Ekonomi dan Kebijakan Pembangunan - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "PUTU ANGELIKA BERLYANTA PUTRI",
        jenjang: "S2",
        prodi: "Ilmu Hukum - Hukum Ekonomi - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MUHAMMAD DAIROBI",
        jenjang: "S2",
        prodi: "Ilmu Manajemen - Digital Marketing and Analytics - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "LOWLY CANIA ARMYS",
        jenjang: "S2",
        prodi: "Ilmu Kesehatan Masyarakat - Manajemen Pelayanan Kesehatan - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "INDRA PUTRA PARSAORAN",
        jenjang: "S2",
        prodi: "Kenotariatan - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "KEVIN ARYA MUHAMMAD",
        jenjang: "S2",
        prodi: "Kenotariatan - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "FABIAN NATHANAEL",
        jenjang: "S2",
        prodi: "Ilmu Hubungan Internasional - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "SANJU LA OLU",
        jenjang: "S2",
        prodi: "Ilmu Kesehatan Masyarakat - Kesehatan Lingkungan - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "DWI AJENG RATRI",
        jenjang: "S2",
        prodi: "Ilmu Ekonomi - Berbahasa Inggris"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "TEMBANG MERAH SUNNY SOCIALISTA",
        jenjang: "S2",
        prodi: "Kenotariatan - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "REGINA ERMANDITA P. SIANTURI",
        jenjang: "S2",
        prodi: "Teknik Sipil - Transportasi - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "NOVITA NURAFIFAH",
        jenjang: "S2",
        prodi: "Psikologi - Psikologi Pendidikan - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "DELIANA ATTASYA WIDYASARI",
        jenjang: "S2",
        prodi: "Keselamatan & Kesehatan Kerja - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "JOVANO ABRAHAM ALFREDO APITULEY",
        jenjang: "S2",
        prodi: "Ilmu Hukum - Hukum Ekonomi - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "TJOKORDA ISTRI INTAN PARAMITHASARI",
        jenjang: "S2",
        prodi: "Magister Manajemen - Manajemen Keuangan - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "SYIFA ADHILAH",
        jenjang: "S2",
        prodi: "Psikologi - Psikologi Pendidikan - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "F YUSTI KARINI",
        jenjang: "S2",
        prodi: "Ilmu Hukum - Hukum Kenegaraan - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "TIO RAMADHA PUTRA",
        jenjang: "S2",
        prodi: "Ilmu Manajemen - Human Capital Management - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "IYAD HARYADI",
        jenjang: "S2",
        prodi: "Ilmu Administrasi - Administrasi Keuangan Daerah dan Aset Daerah - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MOCHAMAD IRSYAD MAKRUFI",
        jenjang: "S2",
        prodi: "Kajian Ketahanan Nasional - Kajian Stratejik Imigrasi - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "GILANG LANDATAMA",
        jenjang: "S2",
        prodi: "Magister Manajemen - Sumber Daya Manusia - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "JA'FAR HILMY FARHAN",
        jenjang: "S2",
        prodi: "Ilmu Komputer"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MANAZIL ADAM",
        jenjang: "S2",
        prodi: "Teknik Sipil - Transportasi - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "IRFAN MIRDA",
        jenjang: "S2",
        prodi: "Teknik Elektro - Rekayasa Data dan Intelijensi Bisnis - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "RIANDY POSMA TOBING",
        jenjang: "S2",
        prodi: "Kajian Ketahanan Nasional - Kajian Stratejik Imigrasi - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "DIAN VITA NUGRAHAENY",
        jenjang: "S2",
        prodi: "Industri Kreatif"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ANGGIE INAYAH",
        jenjang: "S2",
        prodi: "Ilmu Hukum - Hukum Kekayaan Intelektual (HKI) - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "RIAN PRIMADI SUKOCO",
        jenjang: "S2",
        prodi: "Ilmu Keperawatan"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "TOTO BACHTIAR PALOKOTO",
        jenjang: "S2",
        prodi: "Ilmu Komputer"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "FRISKA MIFTAKHUL ILMI",
        jenjang: "S2",
        prodi: "Teknik Sipil - Transportasi - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ODHA WIGARINGTYAS",
        jenjang: "S2",
        prodi: "Ilmu Kesejahteraan Sosial - Manajemen dan Pengembangan Organisasi Kemanusiaan - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MUHAMMAD KHOIRONI ISHAQ",
        jenjang: "S2",
        prodi: "Antropologi - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MERYANCE NATALIA PANGGABEAN",
        jenjang: "S2",
        prodi: "Kajian Ketahanan Nasional - Kajian Stratejik Imigrasi - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "SRI MERIANTI",
        jenjang: "S2",
        prodi: "Ilmu Hukum - Hukum Kenegaraan - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "DWI SURYANINGSIH",
        jenjang: "S2",
        prodi: "Ilmu Kesehatan Masyarakat - Gizi Kesehatan Masyarakat - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "SULFANI NUR MAWADDAH",
        jenjang: "S2",
        prodi: "Psikologi Terapan - Psikologi Anak Usia Dini - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "NUR MINNURI QALBI",
        jenjang: "S2",
        prodi: "Psikologi - Psikologi Kepribadian - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "PRINCESS RUTH IRENE",
        jenjang: "S2",
        prodi: "Kenotariatan - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ARRIDZA ADIARGO",
        jenjang: "S2",
        prodi: "Magister Akuntansi - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "DEANDRIA NABILA FERNANDA PUTRI",
        jenjang: "S2",
        prodi: "Teknik Kimia - Manajemen Keselamatan Proses - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "NERISSA ARVIANA",
        jenjang: "S2",
        prodi: "Teknologi Informasi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MOHAMMAD YUSUF",
        jenjang: "S2",
        prodi: "Teknik Sipil - Transportasi - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "FABIANTO KAMIT TUROT",
        jenjang: "S2",
        prodi: "Ilmu Politik - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "RAHMAWATI MEILANI",
        jenjang: "S2",
        prodi: "Kedokteran Kerja - Kedokteran Tenaga Kerja - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "SUCI ANGEN KINANTI",
        jenjang: "S2",
        prodi: "Ilmu Linguistik - Pengajaran Bahasa - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "SOENARTO",
        jenjang: "S2",
        prodi: "Kebijakan Publik dan Governansi - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MUHAMMAD AULIA MAJID",
        jenjang: "S2",
        prodi: "Ilmu Lingkungan - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "BAGAS FEBRY GUNAWAN",
        jenjang: "S2",
        prodi: "Teknologi Informasi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "NESYA DINDA RAHMANINGTYAS",
        jenjang: "S2",
        prodi: "Keselamatan & Kesehatan Kerja - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ATHFAL SABILAL AHMAD",
        jenjang: "S2",
        prodi: "Magister Manajemen - Sumber Daya Manusia - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "A. FARUUQ",
        jenjang: "S2",
        prodi: "Ilmu Administrasi - Administrasi dan Kebijakan Niaga - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "DIRA CHAERANI",
        jenjang: "S2",
        prodi: "Kajian Gender - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "YESICA HOTMARIA SIANTURI",
        jenjang: "S2",
        prodi: "Psikologi - Psikologi Perkembangan - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MUHAMMAD RADITYA AVIANTARA",
        jenjang: "S2",
        prodi: "Kebijakan Publik dan Governansi - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "AHMAD NUR ROHMAN",
        jenjang: "S2",
        prodi: "Ilmu Hukum - Hukum Ekonomi - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "FIRDA AYU SYAFITRI",
        jenjang: "S2",
        prodi: "Psikologi - Psikologi Sosial - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "RUTH HUTAGALUNG",
        jenjang: "S2",
        prodi: "Administrasi Rumah Sakit - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "BOBBY ILHAM RAMADHAN",
        jenjang: "S2",
        prodi: "Manajemen Bencana - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ARIESTA SICILIA",
        jenjang: "S2",
        prodi: "Arkeologi - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ANDI BASUKI",
        jenjang: "S2",
        prodi: "Ilmu Kesejahteraan Sosial - Pengembangan Masyarakat, Penanggulangan Kemiskinan dan Tanggung Jawab Sosial Perusahaan - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "M. ABIZAR ALPADRI",
        jenjang: "S2",
        prodi: "Kenotariatan - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "FADHILAH DARMA SULISTYO",
        jenjang: "S2",
        prodi: "Ilmu Administrasi - Administrasi dan Kebijakan Publik - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "SIDIK PERMANA",
        jenjang: "S2",
        prodi: "Ilmu Politik - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MUHAMMAD RIDO MANTENNA",
        jenjang: "S2",
        prodi: "Ilmu Linguistik - Bahasa dan Kebudayaan - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "LIA NOVITA",
        jenjang: "S2",
        prodi: "Ilmu Hukum - Hukum Keuangan Publik - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "REGINA LIVIANDARI",
        jenjang: "S2",
        prodi: "Ilmu Biomedik - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "TYARA ISABELLAURA CANDRA",
        jenjang: "S2",
        prodi: "Kenotariatan - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "EVA JESSICA",
        jenjang: "S2",
        prodi: "Ilmu Komunikasi - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "NINI SUHANI",
        jenjang: "S2",
        prodi: "Ilmu Keperawatan"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "HERWIKSON SITORUS",
        jenjang: "S2",
        prodi: "Industri Kreatif"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "DWI RATNA SARI",
        jenjang: "S2",
        prodi: "Ilmu Kesehatan Masyarakat - Ekonomi Kesehatan - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "SALSABILAH AULIA RAHMAN",
        jenjang: "S2",
        prodi: "Ilmu Komputer"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "BUHETI",
        jenjang: "S2",
        prodi: "Ilmu Hukum - Hukum Kenegaraan - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "IQBAL IBNU FARHAN",
        jenjang: "S2",
        prodi: "Kajian Wilayah Timur Tengah dan Islam - Kajian Islam dan Psikologi - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "KHALISHA ERFIRA SEPTIANITA",
        jenjang: "S2",
        prodi: "Ilmu Hukum - Hukum Ekonomi - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "SEPTIADI ARI NUGROHO",
        jenjang: "S2",
        prodi: "Kajian Pengembangan Perkotaan - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "DYAH PRATITASARI",
        jenjang: "S2",
        prodi: "Antropologi - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "JIMMI TARIHORAN",
        jenjang: "S2",
        prodi: "Ilmu Administrasi - Administrasi dan Kebijakan Perpajakan - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MUHAMMAD JODI PRATAMA",
        jenjang: "S2",
        prodi: "Ilmu Manajemen - Digital Marketing and Analytics - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ANUGRAHA RAMADHAN NANDIWARDHANA",
        jenjang: "S2",
        prodi: "Ilmu Hukum - Hukum Ekonomi - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "RIFKY RAMDHANI",
        jenjang: "S2",
        prodi: "Kajian Wilayah Timur Tengah dan Islam - Kajian Islam - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "NURUL SUKMAWATI CAZELLINA",
        jenjang: "S2",
        prodi: "Ilmu Kesehatan Masyarakat - Kesehatan Lingkungan - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ELIA YUSMANIAR PURBA",
        jenjang: "S2",
        prodi: "Magister Manajemen - Manajemen Umum - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "RIANTI JIHAN MAWARNI KIBAS",
        jenjang: "S2",
        prodi: "Sosiologi - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ANNA PUSPA AMARTA SARANTI",
        jenjang: "S2",
        prodi: "Ilmu Biomedik - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "VISTA KAMILANIA",
        jenjang: "S2",
        prodi: "Ilmu Kefarmasian - Bioteknologi dan Bahan Alam - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ASTI PUTRI ANUGERAH",
        jenjang: "S2",
        prodi: "Kenotariatan - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "HOLID NOVIANDI",
        jenjang: "S2",
        prodi: "Ilmu Administrasi - Administrasi dan Kebijakan Publik - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "RICH GEORGE PIETER",
        jenjang: "S2",
        prodi: "Kenotariatan - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ACHMAD FIKRI HEHANUSSA",
        jenjang: "S2",
        prodi: "Ilmu Hukum - Hukum Kenegaraan - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "NORAWATY MA'AS",
        jenjang: "S2",
        prodi: "Administrasi Rumah Sakit - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ADE MARTA SAPUTRA",
        jenjang: "S2",
        prodi: "Ilmu Administrasi - Administrasi dan Kebijakan Publik - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "I MADE ADI PRADNYA DIPUTRA",
        jenjang: "S2",
        prodi: "Fisika Medis - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "SILVANI MUSTIKA PUTRI",
        jenjang: "S2",
        prodi: "Biologi - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "NATASYA ZULNITA PUTRI",
        jenjang: "S2",
        prodi: "Ilmu Kesehatan Masyarakat - Manajemen Pelayanan Kesehatan - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ADAM ROBBY WIJAYA",
        jenjang: "S2",
        prodi: "Psikologi Terapan - Psikologi Sumber Daya Manusia - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "NUR ANISA",
        jenjang: "S2",
        prodi: "Kenotariatan - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "NEISHA ALAMANDA",
        jenjang: "S2",
        prodi: "Magister Manajemen - Sumber Daya Manusia - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "KIWINTA DIAUSSIE",
        jenjang: "S2",
        prodi: "Teknik Sistem Energi - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "KARINA INDRI MEGAH S",
        jenjang: "S2",
        prodi: "Ilmu Administrasi - Administrasi dan Kebijakan Publik - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ANISA SALSABILA",
        jenjang: "S2",
        prodi: "Ilmu Manajemen - Digital Marketing and Analytics - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "HASEENA KHALIDA FAAZA",
        jenjang: "S2",
        prodi: "Kajian Wilayah Timur Tengah dan Islam - Ekonomi dan Keuangan Syariah - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "AULIA FINTI ALDA",
        jenjang: "S2",
        prodi: "Perencanaan Wilayah dan Kota - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MUHAMMAD AULIA IBRAHIM",
        jenjang: "S2",
        prodi: "Ilmu Hukum - Hukum Dan Sistem Peradilan Pidana - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "NUR KHOLISH MAJID",
        jenjang: "S2",
        prodi: "Ilmu Kesehatan Masyarakat - Kebijakan dan Hukum Kesehatan - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "DENDY JAMES SIDABUTAR",
        jenjang: "S2",
        prodi: "Ilmu Hukum - Hukum Kenegaraan - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MELA FITRI ROSALIN",
        jenjang: "S2",
        prodi: "Teknik Industri - Sistem Produksi dan Logistik - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ANNISA PELANGI ADIELA",
        jenjang: "S2",
        prodi: "Kenotariatan - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "RINA ISTIANI",
        jenjang: "S2",
        prodi: "Ilmu Administrasi - Administrasi Pengawasan - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "KARIMA AZ'ZAHRA",
        jenjang: "S2",
        prodi: "Arsitektur - Sejarah & Teori Arsitektur - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "RIZAL CHANDRAWINATA",
        jenjang: "S2",
        prodi: "Kajian Ketahanan Nasional - Kajian Stratejik Imigrasi - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "HENDRA MULYADI",
        jenjang: "S2",
        prodi: "Teknik Sipil - Manajemen Konstruksi - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "GIFARI ANGGORO",
        jenjang: "S2",
        prodi: "Teknik Sipil - Manajemen Proyek - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "HADRIAN HANINDHITYO WIRAWAN",
        jenjang: "S2",
        prodi: "Ilmu Manajemen - Manajemen Strategi - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "CHRISTANIA PINGKAN PUTRINITA",
        jenjang: "S2",
        prodi: "Ilmu Komunikasi - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "YOHANES CRISTIAN RIVALDI LILI",
        jenjang: "S2",
        prodi: "Magister Akuntansi - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "YUFAN AMRI",
        jenjang: "S2",
        prodi: "Teknik Elektro - Manajemen Keamanan Jaringan Informasi - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "KIFAH GIBRALTAR",
        jenjang: "S2",
        prodi: "Kebijakan Publik dan Governansi - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "SYIFA MAULIDDINA",
        jenjang: "S2",
        prodi: "Ilmu Kesehatan Masyarakat - Kesehatan Lingkungan - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "REZA PANGESTU ISKANDAR",
        jenjang: "S2",
        prodi: "Perencanaan Wilayah dan Kota - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "IKHWANUL MAARIF HARAHAP",
        jenjang: "S2",
        prodi: "Ilmu Politik - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "TATI ANGGRAENI",
        jenjang: "S2",
        prodi: "Ilmu Administrasi - Administrasi dan Kebijakan Perpajakan - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ELIAN DEVINA",
        jenjang: "S2",
        prodi: "Pendidikan Kedokteran - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "FAUZI RAMADANI",
        jenjang: "S2",
        prodi: "Teknologi Biomedis - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ANDI DIFA SHAFIRA ZAHRA",
        jenjang: "S2",
        prodi: "Kenotariatan - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ALIEFAH NUR FAATIN",
        jenjang: "S2",
        prodi: "Administrasi Rumah Sakit - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "WARDANI ADI SAPUTRA",
        jenjang: "S2",
        prodi: "Keselamatan & Kesehatan Kerja - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "WIDYAWATI RATNASARIANI",
        jenjang: "S2",
        prodi: "Epidemiologi - Epidemiologi Terapan"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "KEZIA REVINA KUSUMANINGRUM",
        jenjang: "S2",
        prodi: "Psikologi Terapan - Psikologi Anak Usia Dini - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "AKHMAD RIYADI",
        jenjang: "S2",
        prodi: "Ilmu Kesehatan Masyarakat - Kesehatan Lingkungan - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "HARDINNA ZALFA CAHYANI",
        jenjang: "S2",
        prodi: "Teknik Sipil - Transportasi - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "BAGUS PANUNTUN",
        jenjang: "S2",
        prodi: "Kajian Ilmu Kepolisian - Riset"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "WULUNG PRAJADI HERSURASTO",
        jenjang: "S2",
        prodi: "Teknik Industri - Manajemen Industri - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "AHMAD IZZUDDIN",
        jenjang: "S2",
        prodi: "Magister Akuntansi - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "AGNES EVONELLA P",
        jenjang: "S2",
        prodi: "Ilmu Kefarmasian - Farmasi Klinik - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "RR. DEVI ANINDA MAYA AMALIA",
        jenjang: "S2",
        prodi: "Teknik Kimia - Manajemen Keselamatan Proses - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ABIYYU FARUQ IKBAR",
        jenjang: "S2",
        prodi: "Ilmu Hukum - Hukum Hak Asasi Manusia dan Good Governance - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "AQILLA NUR FADIA",
        jenjang: "S2",
        prodi: "Ilmu Lingkungan - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "JON FELIX GERMINIAN",
        jenjang: "S2",
        prodi: "Teknologi Informasi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "HASNA ALYA",
        jenjang: "S2",
        prodi: "Kenotariatan - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "I PUTU AGUS MERTA JAYA",
        jenjang: "S2",
        prodi: "Teknik Sipil - Transportasi - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "FARREL MAHARDHIKA FAJAR",
        jenjang: "S2",
        prodi: "Ilmu Manajemen - Manajemen Strategi - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "TRI PRASETYA ADHI PUTRA",
        jenjang: "S2",
        prodi: "Manajemen Integritas Material - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "HEBER VAN MESIPINTO MELIALA",
        jenjang: "S2",
        prodi: "Ilmu Hukum - Hukum Ekonomi - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "TIARA ANNISA ZEPHANIA",
        jenjang: "S2",
        prodi: "Ilmu Komunikasi - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "EDRINA ELFIA ROSA",
        jenjang: "S2",
        prodi: "Ilmu Kefarmasian - Teknologi Farmasi - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "DOMINGGUS REZA PRAKOSO",
        jenjang: "S2",
        prodi: "Keselamatan & Kesehatan Kerja - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "HENDRA WIJAYA",
        jenjang: "S2",
        prodi: "Kajian Pengembangan Perkotaan - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ANOM PRAMANA",
        jenjang: "S2",
        prodi: "Magister Akuntansi - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "KUKUH KRESNANDINI",
        jenjang: "S2",
        prodi: "Magister Perencanaan Ekonomi dan Kebijakan Pembangunan - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "BIMA AHMAD HAQIQIE",
        jenjang: "S2",
        prodi: "Teknik Industri - Manajemen Industri - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "REVY FAHRI FAHREZI",
        jenjang: "S2",
        prodi: "Magister Manajemen - Manajemen Keuangan - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "HEVA AULIA RAMADHANI",
        jenjang: "S2",
        prodi: "Kenotariatan - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ARBELA DANI BUDISUSILO",
        jenjang: "S2",
        prodi: "Ilmu Kimia - Riset"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "LILIS LIDIA RAJAGUKGUK",
        jenjang: "S2",
        prodi: "Ilmu Hukum - Hukum Ekonomi - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "IZZUDDIN SALEH",
        jenjang: "S2",
        prodi: "Kebijakan Publik dan Governansi - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "NAJLA RAFIFAH DALIMUNTHE",
        jenjang: "S2",
        prodi: "Ilmu Hukum - Hukum Kenegaraan - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "PRASASTI ADISTYA",
        jenjang: "S2",
        prodi: "Kenotariatan - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "RATIH SUSAN DWIJAYANTI",
        jenjang: "S2",
        prodi: "Ilmu Administrasi - Administrasi dan Kebijakan Publik - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "RIANTO HAMONANGAN",
        jenjang: "S2",
        prodi: "Ilmu Hukum - Hukum Kenegaraan - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ROBIN KUMBARA YUDA",
        jenjang: "S2",
        prodi: "Kriminologi - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "RIZKA RIMASDA",
        jenjang: "S2",
        prodi: "Magister Manajemen - Manajemen Keuangan - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "I MADE DWIPAYANA YASA",
        jenjang: "S2",
        prodi: "Ilmu Akuntansi - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "HJ. IMI CHUMAIRAH, SKM",
        jenjang: "S2",
        prodi: "Ilmu Kesehatan Masyarakat - Kebijakan dan Hukum Kesehatan - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "HANA SALSABILA PUTRI LUFTYANTARI",
        jenjang: "S2",
        prodi: "Magister Perencanaan Ekonomi dan Kebijakan Pembangunan - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ARFAN RIDWAN HARTAWAN",
        jenjang: "S2",
        prodi: "Teknik Elektro - Manajemen Keamanan Jaringan Informasi - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "SITI AYU SETIA NASTITI",
        jenjang: "S2",
        prodi: "Magister Manajemen - Aktuaria - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "KEAVIN G. CH. MUMEK",
        jenjang: "S2",
        prodi: "Kenotariatan - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MUHAMMAD ADAM KAUTSAR JANNATA",
        jenjang: "S2",
        prodi: "Ilmu Hubungan Internasional - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "BAGAS NAUFALLATHIF RUDIYONO",
        jenjang: "S2",
        prodi: "Ilmu Politik - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "SULTAN RAMBE",
        jenjang: "S2",
        prodi: "Ilmu Hukum - Hukum Dan Sistem Peradilan Pidana - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MUHAMMAD DAFFA FIRJATULLAH",
        jenjang: "S2",
        prodi: "Kenotariatan - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "KHAIRUL ARIFIN LUBIS",
        jenjang: "S2",
        prodi: "Magister Manajemen - Manajemen Keuangan - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "FASHIHATUL LISANIYAH",
        jenjang: "S2",
        prodi: "Ilmu Linguistik - Bahasa dan Kebudayaan - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ARIEL ACHMAD PRAMUDYA",
        jenjang: "S2",
        prodi: "Ilmu Linguistik - Bahasa dan Kebudayaan - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "TIARA FEBRIANI",
        jenjang: "S2",
        prodi: "Ilmu Komunikasi - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "CHIVALRY ALFATHDHIA MORAZA",
        jenjang: "S2",
        prodi: "Magister Perencanaan Ekonomi dan Kebijakan Pembangunan - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "REZA ANDREIANSYAH",
        jenjang: "S2",
        prodi: "Ilmu Hukum - Hukum Dan Sistem Peradilan Pidana - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "SERLINA",
        jenjang: "S2",
        prodi: "Ilmu Keperawatan"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "RIZKY JULRANDA",
        jenjang: "S2",
        prodi: "Ilmu Hukum - Hukum Dan Sistem Peradilan Pidana - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "FARRAS RAMADHAN",
        jenjang: "S2",
        prodi: "Magister Manajemen - Manajemen Umum - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "YOLANDA NATASIA LETARE T",
        jenjang: "S2",
        prodi: "Ilmu Komunikasi - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "DZIKRI AHMAD FAJARI",
        jenjang: "S2",
        prodi: "Magister Perencanaan Ekonomi dan Kebijakan Pembangunan - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ZULFAN ZAHAR",
        jenjang: "S2",
        prodi: "Teknik Sistem Energi - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "RIDO SONNY KARDOSO",
        jenjang: "S2",
        prodi: "Ilmu Hukum - Hukum Ekonomi - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ANNISA RAHMA PUTRI",
        jenjang: "S2",
        prodi: "Teknik Industri - Rekayasa Data dan Kualitas - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "RESA ARIANSYAH",
        jenjang: "S2",
        prodi: "Ilmu Keperawatan"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "DERRY RINALDI",
        jenjang: "S2",
        prodi: "Magister Manajemen - Manajemen Pemasaran - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "RATU ZAHRA AZQIA NUR",
        jenjang: "S2",
        prodi: "Administrasi Rumah Sakit - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MUHAMMAD HILAL PRATAMA",
        jenjang: "S2",
        prodi: "Kajian Ketahanan Nasional - Kajian Stratejik Imigrasi - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ALIEF FATHAN IHTAMMA",
        jenjang: "S2",
        prodi: "Ilmu Manajemen - Manajemen Strategi - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "CLARA BELLA ADRIANA",
        jenjang: "S2",
        prodi: "Teknik Industri - Sistem Produksi dan Logistik - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "DODY CINDUR MATO",
        jenjang: "S2",
        prodi: "Kajian Ketahanan Nasional - Kajian Stratejik Imigrasi - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ABDUL FATTAH",
        jenjang: "S2",
        prodi: "Ilmu Hukum - Socio-Legal Studies (Hukum dan Masyarakat) - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "DIAN MAYA KURNIAWATI",
        jenjang: "S2",
        prodi: "Magister Manajemen - Manajemen Risiko - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "YETTY GEORGIEN YOSEPHINE",
        jenjang: "S2",
        prodi: "Magister Manajemen - Sumber Daya Manusia - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "PUTRI SIJABAT",
        jenjang: "S2",
        prodi: "Ilmu Manajemen - Digital Marketing and Analytics - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "DICKY WAHYUDI",
        jenjang: "S2",
        prodi: "Ilmu Ekonomi - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ADHYMAZ GEORGE MARTIN SINAGA",
        jenjang: "S2",
        prodi: "Kajian Ketahanan Nasional - Kajian Stratejik Imigrasi - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "YANE MARGARETHA ANTONIO",
        jenjang: "S2",
        prodi: "Administrasi Rumah Sakit - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "RANI FERSARI DAMANIK",
        jenjang: "S2",
        prodi: "Teknologi Informasi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "TIO RAMADHAN",
        jenjang: "S2",
        prodi: "Teknologi Informasi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "LINNA ASNI ZALUKHU",
        jenjang: "S2",
        prodi: "Administrasi Rumah Sakit - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "DODI SUBRADA",
        jenjang: "S2",
        prodi: "Kajian Ilmu Kepolisian - Administrasi Kepolisian - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "DEWI MAYANG SARI",
        jenjang: "S2",
        prodi: "Ilmu Biomedik - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MOHAMAD RIZKI RAMADHAN",
        jenjang: "S2",
        prodi: "Kajian Ketahanan Nasional - Kajian Stratejik Imigrasi - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "HINDUN KHAIRUNNISA SIREGAR",
        jenjang: "S2",
        prodi: "Teknik Metalurgi & Material - Material - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "JESSICA LEONY",
        jenjang: "S2",
        prodi: "Ilmu Linguistik - Bahasa dan Kebudayaan - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ANDREW BAGUS PRIYO UTOMO",
        jenjang: "S2",
        prodi: "Magister Perencanaan Ekonomi dan Kebijakan Pembangunan - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MUHAMMAD FATHUR RIZQI ALFATHIR",
        jenjang: "S2",
        prodi: "Magister Perencanaan Ekonomi dan Kebijakan Pembangunan - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MUHAMMAD IQBAL KURNIAWAN",
        jenjang: "S2",
        prodi: "Teknologi Informasi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ULFAH MAHFUZHAH",
        jenjang: "S2",
        prodi: "Teknologi Biomedis - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "PETRUS BRAD MICHAEL",
        jenjang: "S2",
        prodi: "Ilmu Hukum - Hukum Ekonomi - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "IZATI CHOIRINA",
        jenjang: "S2",
        prodi: "Magister Manajemen - Sumber Daya Manusia - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "FRANKY JUHAR",
        jenjang: "S2",
        prodi: "Teknologi Informasi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "WAHYU FITRI YANTO",
        jenjang: "S2",
        prodi: "Teknik Lingkungan - Teknologi dan Rekayasa Kualitas Air - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MARVELLA CYNTHIA DEWI",
        jenjang: "S2",
        prodi: "Psikologi Terapan - Psikologi Anak Usia Dini - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "FRANKA RIMA AMALIA",
        jenjang: "S2",
        prodi: "Kenotariatan - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "AHMAD NASIHUDDIN",
        jenjang: "S2",
        prodi: "Magister Akuntansi - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MUH AMIN RAIS NATSIR",
        jenjang: "S2",
        prodi: "Ilmu Hukum - Hukum Dan Sistem Peradilan Pidana - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "AKHMAD FAKHRY",
        jenjang: "S2",
        prodi: "Teknik Sipil - Geoteknik - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "RATNA NINGSIH",
        jenjang: "S2",
        prodi: "Administrasi Rumah Sakit - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "FARADHILA AUSHAFIANA MANAF",
        jenjang: "S2",
        prodi: "Ilmu Kesehatan Masyarakat - Kesehatan Lingkungan - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "CLARA NIKEN LARASATI",
        jenjang: "S2",
        prodi: "Administrasi Rumah Sakit - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "SAIMA ARIFIAH",
        jenjang: "S2",
        prodi: "Ilmu Hukum - Hukum Ekonomi - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MOH. MU'ALIM",
        jenjang: "S2",
        prodi: "Ilmu Hukum - Hukum Kenegaraan - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "DANI WIRAYANTI",
        jenjang: "S2",
        prodi: "Ilmu Manajemen - Digital Marketing and Analytics - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "FEBRIAN CHANDRA WIJAYA",
        jenjang: "S2",
        prodi: "Teknik Industri - Sistem Produksi dan Logistik - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "FELIA SRI INDRIYANI",
        jenjang: "S2",
        prodi: "Teknologi Informasi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "IFTI ZUBAIDAH NAZILA SALMA",
        jenjang: "S2",
        prodi: "Kenotariatan - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MAHESTY WIDA RAHMAYANTI",
        jenjang: "S2",
        prodi: "Ilmu Administrasi - Administrasi dan Kebijakan Publik - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ANDITA CITRA PUSPITA",
        jenjang: "S2",
        prodi: "Teknik Sipil - Manajemen Proyek - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ROBBIYANI ILMA",
        jenjang: "S2",
        prodi: "Ilmu Kesehatan Masyarakat - Promosi Kesehatan - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MICHELLIE CHANDRA WIJAYA",
        jenjang: "S2",
        prodi: "Kenotariatan - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "AZKA SALSABILA RAMADHANTI",
        jenjang: "S2",
        prodi: "Magister Akuntansi - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "AULIA SHILMI RACHMANITA",
        jenjang: "S2",
        prodi: "Teknologi Informasi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "CHESIRA RIZKI AGREATIA",
        jenjang: "S2",
        prodi: "Magister Manajemen - Manajemen Umum - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "REYNALDO PANJI WICAKSONO",
        jenjang: "S2",
        prodi: "Teknik Industri - Desain dan Manajemen Sistem - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "FARHAN FABILLAH",
        jenjang: "S2",
        prodi: "Ilmu Ekonomi - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ANDY VALUTY",
        jenjang: "S2",
        prodi: "Magister Perencanaan Ekonomi dan Kebijakan Pembangunan - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "LOVIDYA HELMI",
        jenjang: "S2",
        prodi: "Magister Manajemen - Manajemen Risiko - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ASTRIANTO",
        jenjang: "S2",
        prodi: "Magister Manajemen - Manajemen Keuangan - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "SHANISA BERLIANA INDAH SARI",
        jenjang: "S2",
        prodi: "Kenotariatan - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "M. GILANG E. W. E.",
        jenjang: "S2",
        prodi: "Administrasi Rumah Sakit - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "RENNY CYNTHYA DEWI , SH",
        jenjang: "S2",
        prodi: "Kenotariatan - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "RANITA HANIN SALSABILA AGUSTINE",
        jenjang: "S2",
        prodi: "Arsitektur - Perancangan Arsitektur - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "BILQIS KHAIRUN NISA",
        jenjang: "S2",
        prodi: "Matematika - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "BAINAH RACHMA",
        jenjang: "S2",
        prodi: "Ilmu Administrasi - Studi E-Government - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "SYAHIRA AULIA DIFA",
        jenjang: "S2",
        prodi: "Teknik Kimia - Teknik Kimia - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "RESPATI ADHI PURBOYO",
        jenjang: "S2",
        prodi: "Magister Manajemen - Manajemen Umum - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "AFRIZAL FAISAL ALI",
        jenjang: "S2",
        prodi: "Teknik Sistem Energi - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ACHMAD LABANIE",
        jenjang: "S2",
        prodi: "Ilmu Manajemen - Manajemen Strategi - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "RIRIN INDRATI",
        jenjang: "S2",
        prodi: "Magister Manajemen - Manajemen Umum - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "DERI IRYAWAN",
        jenjang: "S2",
        prodi: "Teknik Kimia - Manajemen Keselamatan Proses - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MUHAMMAD HABIBURROHMAN",
        jenjang: "S2",
        prodi: "Teknik Kimia - Manajemen Keselamatan Proses - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "EFADATUS ZAKIYAH",
        jenjang: "S2",
        prodi: "Ilmu Keperawatan"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "KHANSA SURYA FADHILAH",
        jenjang: "S2",
        prodi: "Ilmu Hukum - Hukum Ketenagakerjaan - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "PUTRI RIMA JAUHARI",
        jenjang: "S2",
        prodi: "Sosiologi - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ADITYA NUR ILMAN WIBOWO",
        jenjang: "S2",
        prodi: "Teknik Industri - Manajemen Industri - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "THOMAS KUKUH YUDIANTOKO",
        jenjang: "S2",
        prodi: "Magister Manajemen - Manajemen Umum - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MOKH LUQMAN FADLLI",
        jenjang: "S2",
        prodi: "Ilmu Hukum - Hukum Kenegaraan - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "CHRISTINA AIRYUNDA PERTIWI",
        jenjang: "S2",
        prodi: "Ilmu Keperawatan"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "FATHIA NAURA ANDINI",
        jenjang: "S2",
        prodi: "Ilmu Ekonomi - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "GUSTI RYANDI ARIEF",
        jenjang: "S2",
        prodi: "Manajemen Integritas Material - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "DINDA AULIA SAVIRA",
        jenjang: "S2",
        prodi: "Magister Manajemen - Manajemen Umum - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "IBNU HAFIZH SYAM",
        jenjang: "S2",
        prodi: "Ilmu Lingkungan - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "DEYANA EFELIN",
        jenjang: "S2",
        prodi: "Ilmu Linguistik - Penerjemahan - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "AMELIA",
        jenjang: "S2",
        prodi: "Magister Perencanaan Ekonomi dan Kebijakan Pembangunan - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "YOSHUA PIETER KANSIL",
        jenjang: "S2",
        prodi: "Magister Manajemen - Manajemen Keuangan - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "VUTY DESVALIANA",
        jenjang: "S2",
        prodi: "Ilmu Administrasi - Administrasi dan Kebijakan Pengembangan SDM - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "WISNU CAHYO HANDONO",
        jenjang: "S2",
        prodi: "Kajian Ketahanan Nasional - Kajian Stratejik Ketahanan Nasional - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "FAJAR DHARMAWAN TOPO BROTO",
        jenjang: "S2",
        prodi: "Ilmu Manajemen - Digital Marketing and Analytics - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ANGGA JUSTIARACHMAN WISUDYASZ",
        jenjang: "S2",
        prodi: "Kedokteran Kerja - Kedokteran Tenaga Kerja - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "KANIA ARMIFA UTAMI SAID",
        jenjang: "S2",
        prodi: "Fisika Medis - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "DEDY ARFIANSYAH",
        jenjang: "S2",
        prodi: "Magister Perencanaan Ekonomi dan Kebijakan Pembangunan - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "BRAMANTI DWI PRASETYO",
        jenjang: "S2",
        prodi: "Teknik Kimia - Manajemen Keselamatan Proses - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MUHAMAD KHARIS FAUZI",
        jenjang: "S2",
        prodi: "Ilmu Hukum - Hukum Ekonomi Islam - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ALIYA DIANDRA",
        jenjang: "S2",
        prodi: "Keselamatan & Kesehatan Kerja - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "AZAM WAHID RAMEDA",
        jenjang: "S2",
        prodi: "Teknik Sistem Energi - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "M. RIZKY RUSMADINATA",
        jenjang: "S2",
        prodi: "Kenotariatan - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "EVANS FAUSTA PALLASIUS",
        jenjang: "S2",
        prodi: "Magister Akuntansi - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "RAHMAD HIDAYAT HADI SUBROTO",
        jenjang: "S2",
        prodi: "Teknik Elektro - Manajemen Keamanan Jaringan Informasi - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "NATANAEL ESTRADA SIMANJUNTAK",
        jenjang: "S2",
        prodi: "Ilmu Hubungan Internasional - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "INDAH WAHYUNI",
        jenjang: "S2",
        prodi: "Ilmu Susastra (Sastra) - Filologi - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "NALANI ZADA",
        jenjang: "S2",
        prodi: "Kenotariatan - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "DWI INDAH RAMADHINA HARIGUNG",
        jenjang: "S2",
        prodi: "Ilmu Hukum - Hukum Ketenagakerjaan - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MOH ALIE TRIONO",
        jenjang: "S2",
        prodi: "Magister Perencanaan Ekonomi dan Kebijakan Pembangunan - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "RHOPYZETA ANINDA EREL",
        jenjang: "S2",
        prodi: "Magister Akuntansi - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "WILLIAM EDUARD DANIEL",
        jenjang: "S2",
        prodi: "Ilmu Hukum - Hukum Ekonomi - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "FANY ZAHRA HANIFA",
        jenjang: "S2",
        prodi: "Fisika Medis - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MOHAMMAD FARHAN FAJARI",
        jenjang: "S2",
        prodi: "Ilmu Hukum - Hukum Ekonomi - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "KURNIA WAHYU NINGSIH",
        jenjang: "S2",
        prodi: "Teknologi Informasi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MUHAMMAD FAHMI",
        jenjang: "S2",
        prodi: "Kajian Wilayah Timur Tengah dan Islam - Industri Halal - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "GAMAST MUHAMMAD FAZZIRA",
        jenjang: "S2",
        prodi: "Kenotariatan - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MEYTA ROIDA R. HUTAPEA",
        jenjang: "S2",
        prodi: "Ilmu Komunikasi - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "DODY ALFAYYEDL",
        jenjang: "S2",
        prodi: "Ilmu Hukum - Hukum Ekonomi - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ANDINI DWININTA ERLANINGTYAS",
        jenjang: "S2",
        prodi: "Psikologi - Psikologi Industri dan Organisasi - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "DEDDY RACHMAN",
        jenjang: "S2",
        prodi: "Ilmu Administrasi - Administrasi dan Kebijakan Publik - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "STEFFI TAMAIKO BR SIREGAR",
        jenjang: "S2",
        prodi: "Sosiologi - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "DUDIH PURWADI",
        jenjang: "S2",
        prodi: "Manajemen Bencana - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ADHITYA GRAHA PRATAMA",
        jenjang: "S2",
        prodi: "Kajian Ketahanan Nasional - Kajian Stratejik Imigrasi - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MIA DIANA PUTRI SURYADI",
        jenjang: "S2",
        prodi: "Ilmu Administrasi - Administrasi dan Kebijakan Publik - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "DANIEL ADITAMA",
        jenjang: "S2",
        prodi: "Magister Manajemen - Manajemen Pemasaran - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "I WAYAN SURYA SEDANA",
        jenjang: "S2",
        prodi: "Administrasi Rumah Sakit - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "RISTINA ZAHRA LATHIFAH",
        jenjang: "S2",
        prodi: "Psikologi Terapan - Psikologi Intervensi Sosial - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "FARHAN HAFIZH",
        jenjang: "S2",
        prodi: "Teknik Industri - Sistem Produksi dan Logistik - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "PRAMISARI SRI SASTITI",
        jenjang: "S2",
        prodi: "Magister Perencanaan Ekonomi dan Kebijakan Pembangunan - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MURSID LAFALIANA NUARI",
        jenjang: "S2",
        prodi: "Teknik Elektro - Manajemen Energi dan Ketenagalistrikan - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MUHAMMAD SYARIF LAZUARDI",
        jenjang: "S2",
        prodi: "Ilmu Hubungan Internasional - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "AGNES YUSUF",
        jenjang: "S2",
        prodi: "Ilmu Komunikasi - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MUHAMAD YOGI",
        jenjang: "S2",
        prodi: "Teknik Industri - Manajemen Industri - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "HABZA JUSBIL AKTRO",
        jenjang: "S2",
        prodi: "Kebijakan Publik dan Governansi - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "KRISTIANI TRI LESTARI",
        jenjang: "S2",
        prodi: "Magister Manajemen - Manajemen Risiko - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ANNISA AULIANA RIYANTO",
        jenjang: "S2",
        prodi: "Ilmu Hukum - Hukum Ekonomi - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MAYA ANISSA YAMBO",
        jenjang: "S2",
        prodi: "Ilmu Hukum - Hukum Kekayaan Intelektual (HKI) - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "BURAT RAHADYAN",
        jenjang: "S2",
        prodi: "Magister Manajemen - Manajemen Keuangan - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ALMIRA ISLAMEY",
        jenjang: "S2",
        prodi: "Ilmu Hukum - Hukum Dan Sistem Peradilan Pidana - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "DIFASYAH HALILINTAR SUMADIKARA",
        jenjang: "S2",
        prodi: "Ilmu Hukum - Hukum Kenegaraan - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ANINDITA KURNIA PUTRI",
        jenjang: "S2",
        prodi: "Ilmu Hukum - Hukum Hak Asasi Manusia dan Good Governance - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "GRACE OLIVIA PALOMA RASONG",
        jenjang: "S2",
        prodi: "Ilmu Hukum - Hukum Ekonomi - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ROHILFA RIZA",
        jenjang: "S2",
        prodi: "Ilmu Administrasi - Administrasi dan Kebijakan Publik - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "KEZIA CHRISIAVINTA",
        jenjang: "S2",
        prodi: "Ilmu Kesehatan Masyarakat - Manajemen Pelayanan Kesehatan - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MUHAMMAD KAISAR JANUARDI",
        jenjang: "S2",
        prodi: "Ilmu Administrasi - Inovasi dan Intrapreneurship - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "AYU BUDIYANTI",
        jenjang: "S2",
        prodi: "Psikologi - Psikologi Kepribadian - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "AISYA SEKAR GADING PUJIANTORO",
        jenjang: "S2",
        prodi: "Magister Perencanaan Ekonomi dan Kebijakan Pembangunan - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "AQILLAH RIDHA PARAHITA",
        jenjang: "S2",
        prodi: "Psikologi - Psikologi Perkembangan - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "FADLI NUR CAHYO",
        jenjang: "S2",
        prodi: "Teknik Industri - Desain dan Manajemen Sistem - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "AISYAH FARAH NISRINA",
        jenjang: "S2",
        prodi: "Ilmu Kesehatan Masyarakat - Gizi Kesehatan Masyarakat - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "SHEILA DEVINDA PERMATASARI",
        jenjang: "S2",
        prodi: "Ilmu Manajemen - Digital Marketing and Analytics - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "CHRISTOPHER ADRIAN PERSADANTA GINTING",
        jenjang: "S2",
        prodi: "Ilmu Manajemen - Keuangan dan Perbankan - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "JOHNSON MILENIUS MANURUNG",
        jenjang: "S2",
        prodi: "Kenotariatan - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "PITRIANI",
        jenjang: "S2",
        prodi: "Ilmu Kesehatan Masyarakat - Kesehatan Reproduksi - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "DIMAS MUHAMMAD FAWWAZ",
        jenjang: "S2",
        prodi: "Manajemen Integritas Material - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "NOVIANDRI CAHYADI BASIR",
        jenjang: "S2",
        prodi: "Administrasi Rumah Sakit - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "INTAN WIDYA KUSUMANINGSIH",
        jenjang: "S2",
        prodi: "Magister Akuntansi - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "DWI UTOMO ENDRIASWORO",
        jenjang: "S2",
        prodi: "Teknik Kimia - Energi dan Proses Berkelanjutan - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "SYIFA MUHAMMAD IQBAL TSAQAUFI",
        jenjang: "S2",
        prodi: "Ilmu Hukum - Hukum Keuangan Publik - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "NOORLIA APRIANTINI",
        jenjang: "S2",
        prodi: "Sosiologi - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MAUREEN NATASHA SALIM",
        jenjang: "S2",
        prodi: "Kenotariatan - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MEILIA ISTIQOMAH",
        jenjang: "S2",
        prodi: "Ilmu Lingkungan - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "DEVI MAZIATI",
        jenjang: "S2",
        prodi: "Ilmu Manajemen - Human Capital Management - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "SETIYA PURBAYA",
        jenjang: "S2",
        prodi: "Teknik Elektro - Manajemen Keamanan Jaringan Informasi - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "PUTRI KESUMA WARDHANI",
        jenjang: "S2",
        prodi: "Biologi - Riset"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ANNISA QURROTA AINI",
        jenjang: "S2",
        prodi: "Ilmu Kimia - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "TIARA AMIMA PUTRI DEWI",
        jenjang: "S2",
        prodi: "Kajian Terorisme - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "BERLIANDO PUTRA",
        jenjang: "S2",
        prodi: "Teknik Sipil - Manajemen Proyek - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ELMIRA HASIBUAN",
        jenjang: "S2",
        prodi: "Ilmu Hukum - Hukum Ekonomi - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ANANDA PUTRI RIHENDA",
        jenjang: "S2",
        prodi: "Kenotariatan - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MELATI INDAH PUTRI HERMADI",
        jenjang: "S2",
        prodi: "Administrasi Rumah Sakit - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ANDI ARDI MANSYUR",
        jenjang: "S2",
        prodi: "Ilmu Manajemen - Manajemen Strategi - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "DEDEN FAJRI EL FIKRI",
        jenjang: "S2",
        prodi: "Magister Perencanaan Ekonomi dan Kebijakan Pembangunan - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ARI GUSTI TRI HANDAYANI",
        jenjang: "S2",
        prodi: "Kajian Ketahanan Nasional - Kajian Stratejik Imigrasi - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MARGARETHA NAZHESDA",
        jenjang: "S2",
        prodi: "Ilmu Komunikasi - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "FERNIA PARAMITHA",
        jenjang: "S2",
        prodi: "Ilmu Kesehatan Masyarakat - Mutu Layanan Kesehatan - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ALDILAH FAZY",
        jenjang: "S2",
        prodi: "Teknik Sistem Energi - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MAULA ZAKIE",
        jenjang: "S2",
        prodi: "Ilmu Manajemen - Digital Marketing and Analytics - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "PATRICIA ANINDITA PUTRI",
        jenjang: "S2",
        prodi: "Teknik Sipil - Transportasi - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "FITRI NURNAJMI MUHASIBI",
        jenjang: "S2",
        prodi: "Keselamatan & Kesehatan Kerja - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "YUDHI WIBHISANA",
        jenjang: "S2",
        prodi: "Ilmu Hukum - Socio-Legal Studies (Hukum dan Masyarakat) - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ADINDA RIZKA SYACHRONY",
        jenjang: "S2",
        prodi: "Magister Akuntansi - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ANNISA MADANINGRUM",
        jenjang: "S2",
        prodi: "Teknik Elektro - Rekayasa Data dan Intelijensi Bisnis - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "INDAH",
        jenjang: "S2",
        prodi: "Kenotariatan - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MUHAMMAD RICHFAL SHAFRIAL",
        jenjang: "S2",
        prodi: "Teknik Elektro - Manajemen Keamanan Jaringan Informasi - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "M. ALHAFIQ WAHYU NABILLAH",
        jenjang: "S2",
        prodi: "Teknik Sipil - Transportasi - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "KENIA KHAIRUNNISA",
        jenjang: "S2",
        prodi: "Magister Akuntansi - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MHD. THARIQ AS SULAIMANY",
        jenjang: "S2",
        prodi: "Ilmu Fisika - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "RIA KRISNA MULADSIH",
        jenjang: "S2",
        prodi: "Herbal - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "HASYIDAN PARAMANANDA",
        jenjang: "S2",
        prodi: "Teknologi Informasi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MELLA FEBRIANTI",
        jenjang: "S2",
        prodi: "Teknologi Biomedis - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ARIFIA MARSILA HAYATI",
        jenjang: "S2",
        prodi: "Ilmu Manajemen - Keuangan dan Perbankan - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MUTIA ULFAH",
        jenjang: "S2",
        prodi: "Administrasi Rumah Sakit - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "DINA AYU SAFITRI",
        jenjang: "S2",
        prodi: "Kenotariatan - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "NABILA AZIS ADELINA",
        jenjang: "S2",
        prodi: "Ilmu Kefarmasian - Farmakologi dan Toksikologi - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "FENDY KURNIA",
        jenjang: "S2",
        prodi: "Ilmu Manajemen - Manajemen Strategi - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ANDRE PRATAMA GINTING",
        jenjang: "S2",
        prodi: "Kajian Wilayah Amerika - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "INNY NADYATUS SA'ADAH",
        jenjang: "S2",
        prodi: "Ilmu Kimia - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ANNISA MUARIZ ISKANDAR",
        jenjang: "S2",
        prodi: "Kenotariatan - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "DIMAS GUNTORO",
        jenjang: "S2",
        prodi: "Magister Akuntansi - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "APRILYA WULANDARI",
        jenjang: "S2",
        prodi: "Magister Akuntansi - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "JASMINA ZAHRA",
        jenjang: "S2",
        prodi: "Kajian Gender - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MUHAMMAD HISYAM KHALISH",
        jenjang: "S2",
        prodi: "Teknik Sipil - Manajemen Proyek - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "CLYRA HAYUNING RUMKITASARI",
        jenjang: "S2",
        prodi: "Administrasi Rumah Sakit - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "FEMMY IMELIA PICAL",
        jenjang: "S2",
        prodi: "Epidemiologi - Epidemiologi Terapan"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "AGATHA MARELLA",
        jenjang: "S2",
        prodi: "Kenotariatan - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MUTIARA ARDIANA",
        jenjang: "S2",
        prodi: "Ilmu Biomedik - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "DIAN HAPSARI",
        jenjang: "S2",
        prodi: "Kajian Ketahanan Nasional - Kajian Stratejik Imigrasi - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "LARASATI ADWIANI",
        jenjang: "S2",
        prodi: "Ilmu Ekonomi - Berbahasa Inggris"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "FISTA SAMBUARI",
        jenjang: "S2",
        prodi: "Ilmu Hukum - Hukum Keuangan Publik - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MOHAMAD IKBAL PANGESTU",
        jenjang: "S2",
        prodi: "Ilmu Kimia - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "CHAIRUL RACHMAN FATIH",
        jenjang: "S2",
        prodi: "Ilmu Hukum - Hukum Keuangan Publik - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MAHADIST SULTHON M",
        jenjang: "S2",
        prodi: "Ilmu Hukum - Hukum Ekonomi - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "RAHMAWATI JALIH",
        jenjang: "S2",
        prodi: "Ilmu Kesehatan Masyarakat - Informatika Kesehatan - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MUHAMMAD SYAROFUL UMAM",
        jenjang: "S2",
        prodi: "Ilmu Administrasi - Administrasi dan Kebijakan Niaga - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MARGARET GABRIELLE PANGGABEAN",
        jenjang: "S2",
        prodi: "Kajian Ketahanan Nasional - Kajian Stratejik Ketahanan Nasional - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ISTIQMA AZMI ARDINA NOOR",
        jenjang: "S2",
        prodi: "Ilmu Kesehatan Masyarakat - Manajemen Pelayanan Kesehatan - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "HAZIN ILMI",
        jenjang: "S2",
        prodi: "Teknik Kimia - Manajemen Keselamatan Proses - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ALMALITA MARDIAH",
        jenjang: "S2",
        prodi: "Teknik Lingkungan - Teknologi dan Rekayasa Kualitas Air - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ABDUL SALAAM",
        jenjang: "S2",
        prodi: "Teknik Metalurgi & Material - Material - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "OVIEN NINDIA VERWIRA",
        jenjang: "S2",
        prodi: "Ilmu Administrasi - Administrasi dan Kebijakan Publik - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "SATRIYA CAHYA INDRAWAN",
        jenjang: "S2",
        prodi: "Ilmu Manajemen - Keuangan dan Perbankan - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "SYIFA ALIFIA PUTRI",
        jenjang: "S2",
        prodi: "Ilmu Administrasi - Inovasi dan Intrapreneurship - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ATHI' FIDAYATI NINGSIH",
        jenjang: "S2",
        prodi: "Kebijakan Publik dan Governansi - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "LUCIA ESTININGHARTI",
        jenjang: "S2",
        prodi: "Magister Akuntansi - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "TOROI SAUT JOHANSEN SIMAREMARE",
        jenjang: "S2",
        prodi: "Ilmu Administrasi - Inovasi dan Intrapreneurship - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "RIZKI ARI CAHYANI",
        jenjang: "S2",
        prodi: "Kenotariatan - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MUHAMMAD ASYEP SYAM'AENI",
        jenjang: "S2",
        prodi: "Ilmu Perpustakaan - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "RIZKY AGUS HARNANTO",
        jenjang: "S2",
        prodi: "Sosiologi - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "SITI ALYZA RIZQIKA NOORDIN",
        jenjang: "S2",
        prodi: "Ilmu Perpustakaan - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ADITYA HALOMOAN HASIBUAN",
        jenjang: "S2",
        prodi: "Ilmu Hukum - Hukum Kekayaan Intelektual (HKI) - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "RAHMAT IRFAN",
        jenjang: "S2",
        prodi: "Ilmu Komputer"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "FITRAH ADHITAMA",
        jenjang: "S2",
        prodi: "Kajian Ketahanan Nasional - Kajian Stratejik Imigrasi - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "NABILA PUSPA ARYANA HAIKAL",
        jenjang: "S2",
        prodi: "Teknik Industri - Sistem Produksi dan Logistik - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "WAKHIDATUL MAHARANI AFFIFAH",
        jenjang: "S2",
        prodi: "Keselamatan & Kesehatan Kerja - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ISMA SARI CHUMAIRAH",
        jenjang: "S2",
        prodi: "Administrasi Rumah Sakit - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "PRISCA CHARITY WOROTIKAN",
        jenjang: "S2",
        prodi: "Ilmu Biomedik - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "LISA ASLAMIAH",
        jenjang: "S2",
        prodi: "Ilmu Biomedik - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "REYHAN AL FAKIH RISKIAN",
        jenjang: "S2",
        prodi: "Kenotariatan - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "TORIQ FAISAL SIOLIMBONA",
        jenjang: "S2",
        prodi: "Ilmu Hukum - Hukum Ekonomi - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ASEP SA'DUDDIN SABILURRASAD",
        jenjang: "S2",
        prodi: "Ilmu Hubungan Internasional - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "IMAM PATRIA RANGGIS",
        jenjang: "S2",
        prodi: "Teknik Industri - Desain dan Manajemen Sistem - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "FEMI DIAH NUGRAHANI",
        jenjang: "S2",
        prodi: "Ilmu Lingkungan - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "YONATHAN WIRYAJAYA WILION",
        jenjang: "S2",
        prodi: "Ilmu Akuntansi - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "YUNITA SOFIA SEJA",
        jenjang: "S2",
        prodi: "Ilmu Linguistik - Penerjemahan - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "PURNAMA SRIWAHYUNI",
        jenjang: "S2",
        prodi: "Ilmu Manajemen - Human Capital Management - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "KRISTIANI SIRAIT",
        jenjang: "S2",
        prodi: "Teknologi Informasi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "GITA NURRAHMI",
        jenjang: "S2",
        prodi: "Kajian Pengembangan Perkotaan - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "SYADRINNA SALSABILLA",
        jenjang: "S2",
        prodi: "Kenotariatan - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MUHAMMAD LUTHFI",
        jenjang: "S2",
        prodi: "Ilmu Politik - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ARSYIL MUHAYMIN ADHIPUTRASYAH",
        jenjang: "S2",
        prodi: "Ilmu Manajemen - Human Capital Management - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "BETHANI PUTRI JATUSARI",
        jenjang: "S2",
        prodi: "Ilmu Kesehatan Masyarakat - Promosi Kesehatan - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "JAIDIN HORASMAN NAINGGOLAN",
        jenjang: "S2",
        prodi: "Ilmu Hukum - Hukum Kenegaraan - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ANDINI SURYA PRATIWI",
        jenjang: "S2",
        prodi: "Administrasi Rumah Sakit - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "SILVIA SILVIA",
        jenjang: "S2",
        prodi: "Magister Akuntansi - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "DENCASWO PURNOMO",
        jenjang: "S2",
        prodi: "Teknologi Informasi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ALMAIDA FIRDAUS",
        jenjang: "S2",
        prodi: "Ilmu Fisika - Riset"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "DIVA TERRY ANONA",
        jenjang: "S2",
        prodi: "Ilmu Administrasi - Administrasi dan Kebijakan Pengembangan SDM - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "IQRA SETIABUDI",
        jenjang: "S2",
        prodi: "Teknik Sipil - Transportasi - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "RAFI WIKRAMA SAHASIKA",
        jenjang: "S2",
        prodi: "Teknik Kimia - Teknik Kimia - Riset"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MARIA LESTARI OLIVIA",
        jenjang: "S2",
        prodi: "Magister Akuntansi - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "WULAN FITRIA RAMADANI",
        jenjang: "S2",
        prodi: "Ilmu Susastra (Sastra) - Filologi - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "YARITSA ADNIN MAJID",
        jenjang: "S2",
        prodi: "Teknik Industri - Rekayasa Data dan Kualitas - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "SATRIO ARIF WICAKSONO",
        jenjang: "S2",
        prodi: "Ilmu Hukum - Hukum Sumber Daya Alam - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "HAMDI",
        jenjang: "S2",
        prodi: "Teknik Elektro - Manajemen Energi dan Ketenagalistrikan - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MASITHO",
        jenjang: "S2",
        prodi: "Ilmu Keperawatan"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "BERTIN YOHANES KURNIAWAN",
        jenjang: "S2",
        prodi: "Matematika - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "SITI MALIKAH NINGSIH",
        jenjang: "S2",
        prodi: "Keselamatan & Kesehatan Kerja - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "KIRANA SHAFA RIDHA",
        jenjang: "S2",
        prodi: "Ilmu Kefarmasian - Kimia Farmasi - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "SIDNEY RIRIMASSE",
        jenjang: "S2",
        prodi: "Ilmu Hubungan Internasional - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "KATHARINA EDWINA SAPUTRI",
        jenjang: "S2",
        prodi: "Magister Manajemen - Sumber Daya Manusia - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "SUCI SARI PRATIWI",
        jenjang: "S2",
        prodi: "Ilmu Keperawatan"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "KEVIN NATHANAEL PARULIAN",
        jenjang: "S2",
        prodi: "Ilmu Hukum - Hukum Ekonomi - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MUHAMMAD IRFAN RIFQI KRESNADI",
        jenjang: "S2",
        prodi: "Ilmu Kimia - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "TRI RISKA PUTRI",
        jenjang: "S2",
        prodi: "Ilmu Lingkungan - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ACHMAD MAULANA",
        jenjang: "S2",
        prodi: "Sosiologi - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "SUCI ANNISA",
        jenjang: "S2",
        prodi: "Ilmu Administrasi - Administrasi dan Kebijakan Publik - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ALMITRA INDIRA",
        jenjang: "S2",
        prodi: "Ilmu Hukum - Hukum Ekonomi - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "RIZKIA RIHHADATUL 'AISY",
        jenjang: "S2",
        prodi: "Biologi - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "CAKTI FADHILLAH",
        jenjang: "S2",
        prodi: "Ilmu Komputer"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "DINA S. SINAGA",
        jenjang: "S2",
        prodi: "Arkeologi - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "EGIN CIPTA WIGUNA",
        jenjang: "S2",
        prodi: "Ilmu Kesehatan Masyarakat - Kesehatan Lingkungan - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "FERMI WINS KENDEKALLO",
        jenjang: "S2",
        prodi: "Arsitektur - Properti - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "AZKIAH KHODIMATUL HAQUE",
        jenjang: "S2",
        prodi: "Psikologi - Psikologi Perkembangan - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "JESSICA WINEL TIBLOLA",
        jenjang: "S2",
        prodi: "Ilmu Kesehatan Masyarakat - Gizi Kesehatan Masyarakat - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "DANA PRATIWI",
        jenjang: "S2",
        prodi: "Kebijakan Publik dan Governansi - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "HAZATRININGRUM KUSUMAWATI",
        jenjang: "S2",
        prodi: "Psikologi - Psikologi Pendidikan - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "SAKTYAWAN DWIKI PAMUNGKAS",
        jenjang: "S2",
        prodi: "Teknik Sipil - Transportasi - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "SABRINA HESIYATI LABIBA",
        jenjang: "S2",
        prodi: "Kedokteran Kerja - Kedokteran Tenaga Kerja - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "REYHAN AL FATA RAZAKI",
        jenjang: "S2",
        prodi: "Kenotariatan - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "NAUFAL NEDJA DEANDRA",
        jenjang: "S2",
        prodi: "Kenotariatan - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "JULIANA PRAMESTI DYAH KUMALASARI",
        jenjang: "S2",
        prodi: "Sosiologi - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MELATI HAFIZHA SUPARDI",
        jenjang: "S2",
        prodi: "Psikologi Terapan - Psikologi Sumber Daya Manusia - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ASTRI PARAMARTHAPUTRI",
        jenjang: "S2",
        prodi: "Kedokteran Kerja - Kedokteran Tenaga Kerja - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "RABERNIR",
        jenjang: "S2",
        prodi: "Industri Kreatif"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "NUR 'IZZATUL HIKMAH",
        jenjang: "S2",
        prodi: "Geografi - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "JESSICA VALENTINA",
        jenjang: "S2",
        prodi: "Ilmu Manajemen - Keuangan dan Perbankan - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "SITI KHOERUNNISA ALISLAMI ASSANIAH",
        jenjang: "S2",
        prodi: "Magister Ekonomi Kependudukan dan Ketenagakerjaan"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "AISHA RIZQA AULIA",
        jenjang: "S2",
        prodi: "Ilmu Kesehatan Masyarakat - Kesehatan Lingkungan - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "KETUT ARIAWATI",
        jenjang: "S2",
        prodi: "Administrasi Rumah Sakit - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "BABA DIMAS ERLANGGA",
        jenjang: "S2",
        prodi: "Ilmu Administrasi - Administrasi dan Kebijakan Publik - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "RIZKI RAMDANI",
        jenjang: "S2",
        prodi: "Teknik Mesin - Sistem Manufaktur dan Otomasi - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "NABILA PRAMESTI SHONIGIYA",
        jenjang: "S2",
        prodi: "Ilmu Hukum - Hukum Kekayaan Intelektual (HKI) - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "SINGGARE KRISANDITA",
        jenjang: "S2",
        prodi: "Keselamatan & Kesehatan Kerja - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "SYAFIRA AGNIA LILLA",
        jenjang: "S2",
        prodi: "Ilmu Administrasi - Administrasi Keuangan Daerah dan Aset Daerah - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "FITRI AVESIENA SYAHIRA",
        jenjang: "S2",
        prodi: "Psikologi - Psikologi Industri dan Organisasi - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MUHAMMAD ABID AL AKBAR",
        jenjang: "S2",
        prodi: "Kajian Wilayah Timur Tengah dan Islam - Kajian Islam - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MOHAMMAD ANDHIKA",
        jenjang: "S2",
        prodi: "Ilmu Hukum - Hukum Ekonomi - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "EKA SETIANINGSIH",
        jenjang: "S2",
        prodi: "Teknik Elektro - Rekayasa Data dan Intelijensi Bisnis - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ANNAS ABDILLAH MARTA",
        jenjang: "S2",
        prodi: "Teknologi Informasi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "NANDA BELLA HAYANA",
        jenjang: "S2",
        prodi: "Ilmu Kesehatan Masyarakat - Manajemen Kesehatan Daerah Berbasis Institusi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "KHAERUL ANSORY",
        jenjang: "S2",
        prodi: "Fisika Medis - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "NAOMI VALENTINA SIMANJUNTAK",
        jenjang: "S2",
        prodi: "Magister Manajemen - Sumber Daya Manusia - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "JOSUA SATRIA COLLINS",
        jenjang: "S2",
        prodi: "Ilmu Hukum - Hukum Kenegaraan - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "RADHWA ASMARANI NUR IBRAHIM",
        jenjang: "S2",
        prodi: "Magister Perencanaan Ekonomi dan Kebijakan Pembangunan - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "GITA RAHMA YANTI",
        jenjang: "S2",
        prodi: "Industri Kreatif"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "BIMA PUTRA BAGASKARA",
        jenjang: "S2",
        prodi: "Magister Perencanaan Ekonomi dan Kebijakan Pembangunan - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "EFRISKA GINASTI MAYANGSARI",
        jenjang: "S3",
        prodi: "Kajian Stratejik dan Global - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ARLISA YULIAWATI",
        jenjang: "S3",
        prodi: "Ilmu Komputer"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "STEFFANO ADITYA HANDOKO",
        jenjang: "S3",
        prodi: "Ilmu Kedokteran Gigi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "HADI SOETOPO",
        jenjang: "S3",
        prodi: "Ilmu Hukum - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "HERIYANTO",
        jenjang: "S3",
        prodi: "Ilmu Komputer"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "SUTEJO",
        jenjang: "S3",
        prodi: "Ilmu Keperawatan - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "INTAN ASRI NURANI",
        jenjang: "S3",
        prodi: "Ilmu Keperawatan - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ERWIN DAMAR PRASETYO",
        jenjang: "S3",
        prodi: "Ilmu Manajemen - Stratejik - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "BRAMADITA SATYA",
        jenjang: "S3",
        prodi: "Ilmu Kedokteran Gigi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "TYAS KARTIKA SARI",
        jenjang: "S3",
        prodi: "Teknik Elektro - Jalur Kuliah dan Riset"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "SOFIYETTI",
        jenjang: "S3",
        prodi: "Ilmu Kesehatan Masyarakat - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "DWI FAJAR SAPUTRA",
        jenjang: "S3",
        prodi: "Kajian Informasi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "YUSLIA NOVIANI",
        jenjang: "S3",
        prodi: "Ilmu Farmasi - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "DIAN IMAMAH ANSHAR",
        jenjang: "S3",
        prodi: "Kajian Stratejik dan Global - Riset"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "JUNAIDI",
        jenjang: "S3",
        prodi: "Epidemiologi - Epidemiologi Klinik - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "AFIF UDIN",
        jenjang: "S3",
        prodi: "Ilmu Kesehatan Masyarakat - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MARGARETA AULIA RACHMAN",
        jenjang: "S3",
        prodi: "Kajian Informasi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "RIZKY TRINANDA AKHBAR",
        jenjang: "S3",
        prodi: "Ilmu Akuntansi - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "NOVA SCORVIANA HERMINASARI",
        jenjang: "S3",
        prodi: "Antropologi - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "USEP MUTTAQIN",
        jenjang: "S3",
        prodi: "Ilmu Linguistik - Jalur Kuliah dan Riset"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "RIAN HIDAYAT",
        jenjang: "S3",
        prodi: "Ilmu Hukum - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MOH HASBI ROFIQI",
        jenjang: "S3",
        prodi: "Ilmu Politik - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MIRSA DIAH NOVIANTI",
        jenjang: "S3",
        prodi: "Teknik Industri - Jalur Kuliah dan Riset"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ERITA ISTRIANA",
        jenjang: "S3",
        prodi: "Ilmu Kesehatan Masyarakat - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ADERINA FEBRIANA",
        jenjang: "S3",
        prodi: "Antropologi - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "DONALD KASENDA",
        jenjang: "S3",
        prodi: "Ilmu Susastra (Sastra) - Jalur Kuliah dan Riset"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "RENTY ANUGERAH MAHAJI P, ST, MT",
        jenjang: "S3",
        prodi: "Teknik Industri - Jalur Kuliah dan Riset"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "RUDI SATWIKO",
        jenjang: "S3",
        prodi: "Ilmu Lingkungan"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ELSA ROSELINA",
        jenjang: "S3",
        prodi: "Kajian Informasi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "YUZI AFIF",
        jenjang: "S3",
        prodi: "Ilmu Hukum - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "PUTRI ZULKIFLI HASAN",
        jenjang: "S3",
        prodi: "Ilmu Ekonomi - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "DIAN CAHYANTI",
        jenjang: "S3",
        prodi: "Epidemiologi - Epidemiologi Klinik - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "RICO ELHANDO BADRI",
        jenjang: "S3",
        prodi: "Ilmu Manajemen - Keuangan/Perbankan - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "EKA WAHYUDI",
        jenjang: "S3",
        prodi: "Teknik Elektro - Jalur Kuliah dan Riset"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MELISA BUNGA ALTAMIRA",
        jenjang: "S3",
        prodi: "Ilmu Lingkungan"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "AGUS ALAMSYAH",
        jenjang: "S3",
        prodi: "Epidemiologi - Epidemiologi Komunitas - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "WINDA YUNIKA",
        jenjang: "S3",
        prodi: "Ilmu Hukum - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ISMA NURILLAH",
        jenjang: "S3",
        prodi: "Ilmu Hukum - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "RONALDO HEINRICH HERMAN",
        jenjang: "S3",
        prodi: "Ilmu Hukum - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MASAGUS LUKMAN SYAHRANIE",
        jenjang: "S3",
        prodi: "Sosiologi - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "I WAYAN PARNA ARIANTA",
        jenjang: "S3",
        prodi: "Ilmu Kesehatan Masyarakat - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "EKA TRIWAHYUNI",
        jenjang: "S3",
        prodi: "Teknik Kimia - Jalur Kuliah dan Riset"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MASRURI ANWAR",
        jenjang: "S3",
        prodi: "Teknik Sipil - Jalur Kuliah dan Riset"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "EVLINA SUZANNA",
        jenjang: "S3",
        prodi: "Epidemiologi - Epidemiologi Klinik - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ANWAR SALAHUDDIN",
        jenjang: "S3",
        prodi: "Kajian Stratejik dan Global - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "WARID NURDIANSYAH",
        jenjang: "S3",
        prodi: "Ilmu Kesehatan Masyarakat - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "AKHMAD SARIF",
        jenjang: "S3",
        prodi: "Teknik Elektro - Jalur Riset"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "IRMAWAN EFFENDI",
        jenjang: "S3",
        prodi: "Kajian Stratejik dan Global - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ANNY FADMAWATY",
        jenjang: "S3",
        prodi: "Ilmu Kesehatan Masyarakat - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "NURAINI FAUZIAH",
        jenjang: "S3",
        prodi: "Ilmu Kesehatan Masyarakat - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "AFRIZA FERDIANSYAH BAHONO",
        jenjang: "S3",
        prodi: "Ilmu Filsafat - Jalur Kuliah dan Riset"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "WAHYULIA CAHYANTI",
        jenjang: "S3",
        prodi: "Biologi - Riset"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "YUSUF ZALAYA",
        jenjang: "S3",
        prodi: "Ilmu Kesehatan Masyarakat - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "SAKINA NUSARIFA TANTRI",
        jenjang: "S3",
        prodi: "Ilmu Akuntansi - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "DIEN WIJAYATININGRUM",
        jenjang: "S3",
        prodi: "Ilmu Sejarah - Jalur Kuliah dan Riset"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "YOGI PRAWIRA",
        jenjang: "S3",
        prodi: "Ilmu Kedokteran - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "DESWANDRI",
        jenjang: "S3",
        prodi: "Teknik Kimia - Jalur Riset"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MELINDA SARININGSIH",
        jenjang: "S3",
        prodi: "Ilmu Susastra (Sastra) - Jalur Kuliah dan Riset"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "TRI YULI SETIANINGSIH",
        jenjang: "S3",
        prodi: "Ilmu Biomedik - Riset"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MARDIANSYAH",
        jenjang: "S3",
        prodi: "Biologi - Riset"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "BOBBY RACHMAT FITRIYANTO",
        jenjang: "S3",
        prodi: "Ilmu Administrasi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "AGUSTIN DEA PRAMESWARI",
        jenjang: "S3",
        prodi: "Ilmu Administrasi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "AHMAD IRFANDI",
        jenjang: "S3",
        prodi: "Ilmu Kesehatan Masyarakat - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "DESTRA ANDIKA PRATAMA",
        jenjang: "S3",
        prodi: "Teknik Elektro - Jalur Kuliah dan Riset"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MUHAMMAD EKO PRANOTO",
        jenjang: "S3",
        prodi: "Ilmu Farmasi - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "REZA AMARTA PRAYOGA",
        jenjang: "S3",
        prodi: "Sosiologi - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "WULANSARY",
        jenjang: "S3",
        prodi: "Antropologi - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "RIZALDI LUFTI",
        jenjang: "S3",
        prodi: "Kajian Stratejik dan Global - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "HILDA MIANITA",
        jenjang: "S3",
        prodi: "Kriminologi - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "TINNIE TIOLANI",
        jenjang: "S3",
        prodi: "Kajian Stratejik dan Global - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "SUHARIYANTO",
        jenjang: "S3",
        prodi: "Ilmu Keperawatan - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ALI AL HARKAN",
        jenjang: "S3",
        prodi: "Ilmu Komunikasi - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "DADAN WIRA LAKSANA",
        jenjang: "S3",
        prodi: "Kajian Stratejik dan Global - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "HAMZAH FADHLURAHMAN",
        jenjang: "S3",
        prodi: "Ilmu Fisika - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "NI MADE RIDLA NILASANTI PARWATA",
        jenjang: "S3",
        prodi: "Ilmu Biomedik - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "JEMMI YANSEN KASEGER",
        jenjang: "S3",
        prodi: "Ilmu Sejarah - Jalur Kuliah dan Riset"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "DEWI KARTIKASARI",
        jenjang: "S3",
        prodi: "Ilmu Bahan-bahan/Material - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "DR. AMRITA DEVI",
        jenjang: "S3",
        prodi: "Ilmu Sejarah - Jalur Kuliah dan Riset"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "INDRA JAYA",
        jenjang: "S3",
        prodi: "Ilmu Sejarah - Jalur Kuliah dan Riset"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "IR. MAURITS MANTIRI, MM",
        jenjang: "S3",
        prodi: "Ilmu Sejarah - Jalur Kuliah dan Riset"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "DHANY MARLEN",
        jenjang: "S3",
        prodi: "Kajian Informasi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "NURAENI",
        jenjang: "S3",
        prodi: "Ilmu Lingkungan"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "NIA ASHTON DESTRITY",
        jenjang: "S3",
        prodi: "Ilmu Komunikasi - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "FRANSISKA DESIANA SETYANINGSIH",
        jenjang: "S3",
        prodi: "Ilmu Komunikasi - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "PRAMESTHI WIDYA HAPSARI",
        jenjang: "S3",
        prodi: "Ilmu Gizi - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "TRY WULANDARI",
        jenjang: "S3",
        prodi: "Ilmu Manajemen - Keuangan/Perbankan - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "CINDAR HARI PRABOWO",
        jenjang: "S3",
        prodi: "Kajian Stratejik dan Global - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "KURNIA TOGAR PANDAPOTAN TANJUNG",
        jenjang: "S3",
        prodi: "Ilmu Hukum - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "WINDA ERISKA",
        jenjang: "S3",
        prodi: "Ilmu Keperawatan - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "KURNIASARI NOVITA DEWI",
        jenjang: "S3",
        prodi: "Ilmu Kesejahteraan Sosial - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "FAHMI NOOR ADLY",
        jenjang: "S3",
        prodi: "Kajian Stratejik dan Global - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "HAYU TYAS UTAMI",
        jenjang: "S3",
        prodi: "Ilmu Biomedik - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "GHUNARSA SUJATNIKA",
        jenjang: "S3",
        prodi: "Ilmu Hukum - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MOCHAMAD IQBAL",
        jenjang: "S3",
        prodi: "Ilmu Manajemen - Stratejik - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ADI PRIYONO",
        jenjang: "S3",
        prodi: "Kajian Informasi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ADI LAZUARDI",
        jenjang: "S3",
        prodi: "Ilmu Hukum - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "AIDIL AWAL",
        jenjang: "S3",
        prodi: "Ilmu Administrasi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "USMAN MANOR",
        jenjang: "S3",
        prodi: "Ilmu Sejarah - Jalur Kuliah dan Riset"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "YUSUF ROKHMAT",
        jenjang: "S3",
        prodi: "Ilmu Administrasi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "TEUKU MULIADI",
        jenjang: "S3",
        prodi: "Ilmu Gizi - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "SISKA WIWANTO HADISUTJIPTO",
        jenjang: "S3",
        prodi: "Ilmu Kedokteran Gigi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "SARI KUSUMA",
        jenjang: "S3",
        prodi: "Ilmu Gizi - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "DAMAIRIA HAYU PARMASARI",
        jenjang: "S3",
        prodi: "Ilmu Kesehatan Masyarakat - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ANISA MUSLICHA",
        jenjang: "S3",
        prodi: "Ilmu Lingkungan"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MUKTI WIBOWO",
        jenjang: "S3",
        prodi: "Ilmu Manajemen - Stratejik - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ROSWITA NILAKURNIA",
        jenjang: "S3",
        prodi: "Ilmu Lingkungan"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "IIS AFRIYANTI",
        jenjang: "S3",
        prodi: "Ilmu Komputer"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "SALMAN FARISHI",
        jenjang: "S3",
        prodi: "Teknik Metalurgi & Material - Jalur Riset"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "LUKMAN MEDRIAVIN SILALAHI",
        jenjang: "S3",
        prodi: "Teknik Elektro - Jalur Riset"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "YUNITA MAYA PUTRI",
        jenjang: "S3",
        prodi: "Ilmu Hukum - Riset"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MUTOHAROH",
        jenjang: "S3",
        prodi: "Ilmu Fisika - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ABDURRAHMAN HAMAS NAHDLY",
        jenjang: "S3",
        prodi: "Ilmu Kesejahteraan Sosial - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "SEPTIANI",
        jenjang: "S3",
        prodi: "Ilmu Kimia - Riset"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ANDRY WIBOWO",
        jenjang: "S3",
        prodi: "Kajian Stratejik dan Global - Riset"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MAYA SOFIYANI",
        jenjang: "S3",
        prodi: "Ilmu Kesehatan Masyarakat - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "SOFI MARDIAH",
        jenjang: "S3",
        prodi: "Epidemiologi - Epidemiologi Klinik - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "SURYA TRI ESTHI WIRA HUTAMA",
        jenjang: "S3",
        prodi: "Ilmu Lingkungan"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "NI LUH PUTU EKARINI",
        jenjang: "S3",
        prodi: "Ilmu Keperawatan - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "FAJRI ROSADI",
        jenjang: "S3",
        prodi: "Kajian Informasi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "NURIYA",
        jenjang: "S3",
        prodi: "Ilmu Keperawatan - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "RICO NOVIANTO HAFIDZ",
        jenjang: "S3",
        prodi: "Ilmu Hukum - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ERIKA CITRA SARI HARTANTO",
        jenjang: "S3",
        prodi: "Ilmu Susastra (Sastra) - Jalur Kuliah dan Riset"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "KIANTI RAISA DARUSMAN",
        jenjang: "S3",
        prodi: "Ilmu Kedokteran - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "USEP NUGRAHA",
        jenjang: "S3",
        prodi: "Ilmu Manajemen - Stratejik - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "TOEBAGUS GALANG WINDI PRATAMA",
        jenjang: "S3",
        prodi: "Ilmu Hukum - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "SULUH GEMBYENG CIPTADI",
        jenjang: "S3",
        prodi: "Ilmu Komunikasi - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MIFTAH FARID HANGGAWAN",
        jenjang: "S3",
        prodi: "Ilmu Hukum - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "IMAM MALIKI",
        jenjang: "S3",
        prodi: "Ilmu Komputer"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "NINING RUSMIANINGSIH",
        jenjang: "S3",
        prodi: "Ilmu Keperawatan - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "BETA ANDRI ANGGIANO ULIANSYAH",
        jenjang: "S3",
        prodi: "Ilmu Akuntansi - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "SARI WIDYA SIHWI",
        jenjang: "S3",
        prodi: "Ilmu Komputer"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "I GUSTI AGUNG NGURAH AGUNG SENTOSA",
        jenjang: "S3",
        prodi: "Ilmu Kedokteran - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "SILVIA SULISTIANI",
        jenjang: "S3",
        prodi: "Ilmu Kedokteran Gigi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "NANANG SUTISNA",
        jenjang: "S3",
        prodi: "Kajian Informasi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "DAWAM DWI JATMIKO SUWAWI",
        jenjang: "S3",
        prodi: "Ilmu Komputer"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MARNIA RANI",
        jenjang: "S3",
        prodi: "Ilmu Hukum - Riset"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "NANI ASNA DEWI",
        jenjang: "S3",
        prodi: "Ilmu Keperawatan - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "AGUSTINA SETIANINGRUM",
        jenjang: "S3",
        prodi: "Kajian Informasi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "RATNA WIJAYATRI",
        jenjang: "S3",
        prodi: "Ilmu Farmasi - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "DIMAS TRIWIBOWO",
        jenjang: "S3",
        prodi: "Ilmu Bahan-bahan/Material - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ALDRIN MP HUTABARAT",
        jenjang: "S3",
        prodi: "Ilmu Susastra (Sastra) - Jalur Kuliah dan Riset"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "PUTRI KUS WISNU WARDANI",
        jenjang: "S3",
        prodi: "Ilmu Susastra (Sastra) - Jalur Kuliah dan Riset"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "SULISTYO PUDJO H.",
        jenjang: "S3",
        prodi: "Ilmu Susastra (Sastra) - Jalur Kuliah dan Riset"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "DAYU DIAN PERWATASARI",
        jenjang: "S3",
        prodi: "Teknik Kimia - Jalur Kuliah dan Riset"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "GLENN ALLEN TIELUNG",
        jenjang: "S3",
        prodi: "Ilmu Filsafat - Jalur Kuliah dan Riset"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ROYHARDI SIAHAAN",
        jenjang: "S3",
        prodi: "Ilmu Susastra (Sastra) - Jalur Kuliah dan Riset"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "RIZKY FARMASITA BUDIASTUTI",
        jenjang: "S3",
        prodi: "Ilmu Farmasi - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "TEGUH DARMAWAN",
        jenjang: "S3",
        prodi: "Ilmu Bahan-bahan/Material - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MUHAMAD RADZI RATHOMI",
        jenjang: "S3",
        prodi: "Ilmu Komputer"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "PROFITASARI K N",
        jenjang: "S3",
        prodi: "Ilmu Kedokteran - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "KARTIKA TARWATI",
        jenjang: "S3",
        prodi: "Ilmu Linguistik - Jalur Kuliah dan Riset"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "BAGASKORO ARIF PRABOWO",
        jenjang: "S3",
        prodi: "Ilmu Hukum - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "TANTRI SUNARYO",
        jenjang: "S3",
        prodi: "Ilmu Administrasi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MUZWIR WIRATAMA",
        jenjang: "S3",
        prodi: "Ilmu Lingkungan"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "CYNTIA WULANDARI",
        jenjang: "S3",
        prodi: "Ilmu Farmasi - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ANITA PUSPITA SARI",
        jenjang: "S3",
        prodi: "Teknik Industri - Jalur Kuliah dan Riset"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "RICHARD",
        jenjang: "S3",
        prodi: "Teknik Mesin - Jalur Kuliah dan Riset"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "SYAIPUL MALIK IBRAHIM",
        jenjang: "S3",
        prodi: "Ilmu Manajemen - Stratejik - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MARATUL HAMIDAH",
        jenjang: "S3",
        prodi: "Teknik Elektro - Jalur Kuliah dan Riset"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "DENGGAN PARANGE SINURAT",
        jenjang: "S3",
        prodi: "Kajian Informasi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MEGAT NAGAINAKA",
        jenjang: "S3",
        prodi: "Ilmu Manajemen - Stratejik - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ANDI KURNIAWATI, S.H., M.H.",
        jenjang: "S3",
        prodi: "Ilmu Hukum - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ANGGI ANGGRAENI KUSUMONINGTYAS",
        jenjang: "S3",
        prodi: "Ilmu Politik - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "SRI SUSILAWATI ISLAM",
        jenjang: "S3",
        prodi: "Teknik Industri - Jalur Kuliah dan Riset"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "EMILIA KURNIASARI",
        jenjang: "S3",
        prodi: "Ilmu Sejarah - Jalur Kuliah dan Riset"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "NATASHA",
        jenjang: "S3",
        prodi: "Ilmu Ekonomi - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "SITI EKA YULIANTI",
        jenjang: "S3",
        prodi: "Teknik Kimia - Jalur Riset"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "SYAIFUL ANAS",
        jenjang: "S3",
        prodi: "Ilmu Akuntansi - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "RAKA MOMON SAPUTRA",
        jenjang: "S3",
        prodi: "Ilmu Politik - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "FERDINAND ANON BAYU AJI",
        jenjang: "S3",
        prodi: "Kajian Stratejik dan Global - Riset"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MARKUS AMINIUS GIELBERT",
        jenjang: "S3",
        prodi: "Teknik Kimia - Jalur Kuliah dan Riset"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MOHAMAD RAYMOND AKBAR",
        jenjang: "S3",
        prodi: "Ilmu Hukum - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "DARMAWATI M.R.",
        jenjang: "S3",
        prodi: "Ilmu Linguistik - Jalur Kuliah dan Riset"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ANDI PRAJA WIRA Y L",
        jenjang: "S3",
        prodi: "Ilmu Kedokteran - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "DITA PUTRI PRAMESWARI",
        jenjang: "S3",
        prodi: "Ilmu Filsafat - Jalur Kuliah dan Riset"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ARWIN ANINDYKA",
        jenjang: "S3",
        prodi: "Kajian Informasi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "LEFILIA ERLITA CHITA",
        jenjang: "S3",
        prodi: "Ilmu Hukum - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "RIFQI ALMUSAWI RAFSANJANI",
        jenjang: "S3",
        prodi: "Ilmu Fisika - Riset"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "NIKO GRATARIDARGA",
        jenjang: "S3",
        prodi: "Kajian Informasi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "FAZA DHORA NAILUFAR",
        jenjang: "S3",
        prodi: "Ilmu Politik - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "RACHMAN GIFAR",
        jenjang: "S3",
        prodi: "Ilmu Manajemen - Stratejik - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "BEN SANDRO REXI TAMA SIPAYUNG",
        jenjang: "S3",
        prodi: "Kajian Informasi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "SUDIRMAN",
        jenjang: "S3",
        prodi: "Kajian Informasi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "RAFEL SIALLAGAN",
        jenjang: "S3",
        prodi: "Ilmu Filsafat - Jalur Kuliah dan Riset"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MAINITA HIDAYATI",
        jenjang: "S3",
        prodi: "Kajian Stratejik dan Global - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "DIPTYA ANGGITA",
        jenjang: "S3",
        prodi: "Arsitektur - Jalur Kuliah dan Riset"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "SYUKRIADI",
        jenjang: "S3",
        prodi: "Teknik Elektro - Jalur Kuliah dan Riset"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "YANUAR YOGA PRASETYAWAN",
        jenjang: "S3",
        prodi: "Kajian Informasi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "SIGIT ARIANTO",
        jenjang: "S3",
        prodi: "Ilmu Fisika - Riset"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MUHAMMAD ISHAQ ISMAIL",
        jenjang: "S3",
        prodi: "Kajian Stratejik dan Global - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ELIDA SOVIANA",
        jenjang: "S3",
        prodi: "Ilmu Gizi - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "NORMA SHOLIKAH",
        jenjang: "S3",
        prodi: "Ilmu Linguistik - Jalur Kuliah dan Riset"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "UMMI YUSNITA",
        jenjang: "S3",
        prodi: "Ilmu Hukum - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "VEBRINA HANIA CHOLILY",
        jenjang: "S3",
        prodi: "Ilmu Ekonomi - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "RICKY SAPUTRA",
        jenjang: "S3",
        prodi: "Ilmu Hukum - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "HARDINA",
        jenjang: "S3",
        prodi: "Ilmu Hukum - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "KETTY SITI SALAMAH",
        jenjang: "S3",
        prodi: "Teknik Elektro - Jalur Kuliah dan Riset"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "FERISKA AJENG ANANTRI",
        jenjang: "S3",
        prodi: "Ilmu Administrasi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "HARYATI",
        jenjang: "S3",
        prodi: "Sosiologi - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MIRJA FAUZUL HAMDI",
        jenjang: "S3",
        prodi: "Ilmu Hukum - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ANDRIYANI",
        jenjang: "S3",
        prodi: "Ilmu Biomedik - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "TALHAH TAMIA SHAHAB",
        jenjang: "S3",
        prodi: "Teknik Kimia - Jalur Kuliah dan Riset"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "FARADHIBA SALSABILA",
        jenjang: "S3",
        prodi: "Ilmu Linguistik - Jalur Kuliah dan Riset"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "SAFITRY RAMANDHANY",
        jenjang: "S3",
        prodi: "Ilmu Bahan-bahan/Material - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "NUR'AINI",
        jenjang: "S3",
        prodi: "Ilmu Kedokteran Gigi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "NAZLIANSYAH",
        jenjang: "S3",
        prodi: "Ilmu Keperawatan - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "YASSER AHMED",
        jenjang: "S3",
        prodi: "Biologi - Riset"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "AKHMAD MUNIM",
        jenjang: "S3",
        prodi: "Ilmu Manajemen - Stratejik - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "IRWAN MUSTAJAB",
        jenjang: "S3",
        prodi: "Teknik Mesin - Jalur Kuliah dan Riset"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "NUGRAHA DKS.NUGRAHA",
        jenjang: "S3",
        prodi: "Kajian Stratejik dan Global - Riset"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "GODVIN TRIASTAMA SIMAMORA",
        jenjang: "S3",
        prodi: "Ilmu Hukum - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "RR AMANDA SOEBADI",
        jenjang: "S3",
        prodi: "Ilmu Kedokteran - Riset"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "DIANA MAYASARI",
        jenjang: "S3",
        prodi: "Ilmu Kedokteran - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "HANS DERMAWAN",
        jenjang: "S3",
        prodi: "Teknik Sipil - Jalur Kuliah dan Riset"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ANANTA HAGABEAN",
        jenjang: "S3",
        prodi: "Ilmu Administrasi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "SANDRA HANDAYANI SUTANTO",
        jenjang: "S3",
        prodi: "Psikologi - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "YUANNISA AISANAFI",
        jenjang: "S3",
        prodi: "Ilmu Akuntansi - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "AYU WIDYA LESTARI",
        jenjang: "S3",
        prodi: "Ilmu Keperawatan - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "RIZQY IFTITAH ALAM",
        jenjang: "S3",
        prodi: "Ilmu Keperawatan - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "A LILI EVITA",
        jenjang: "S3",
        prodi: "Ilmu Sejarah - Jalur Kuliah dan Riset"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "SASHA NAMIRA RIZA",
        jenjang: "S3",
        prodi: "Ilmu Ekonomi - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "SUSIANA HENDRO",
        jenjang: "S3",
        prodi: "Ilmu Sejarah - Jalur Kuliah dan Riset"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "KARTINI MADJID",
        jenjang: "S3",
        prodi: "Ilmu Sejarah - Jalur Kuliah dan Riset"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "PURNAMA AYU RIZKY",
        jenjang: "S3",
        prodi: "Ilmu Komunikasi - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ANDI AMALIA WILDANI",
        jenjang: "S3",
        prodi: "Ilmu Keperawatan - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "AWALUDIN",
        jenjang: "S3",
        prodi: "Kajian Stratejik dan Global - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ARI HARIYONO",
        jenjang: "S3",
        prodi: "Ilmu Bahan-bahan/Material - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "CHICO ADHIBASKARA EKANANDA HINDARTO",
        jenjang: "S3",
        prodi: "Antropologi - Riset"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "HADI NUGROHO",
        jenjang: "S3",
        prodi: "Epidemiologi - Epidemiologi Komunitas - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "INONG SRI RAHAYU",
        jenjang: "S3",
        prodi: "Ilmu Keperawatan - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "BINTORO SISWAYANTI",
        jenjang: "S3",
        prodi: "Teknik Metalurgi & Material - Jalur Kuliah dan Riset"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "I G AGUNG PUTRI A KARTIKA",
        jenjang: "S3",
        prodi: "Sosiologi - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "KARTIMAN",
        jenjang: "S3",
        prodi: "Teknik Sipil - Jalur Kuliah dan Riset"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "HAFSAH HALIDAH",
        jenjang: "S3",
        prodi: "Teknik Elektro - Jalur Riset"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "AYUSIA SABHITA KUSUMA",
        jenjang: "S3",
        prodi: "Ilmu Politik - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "YULI ANA WATI",
        jenjang: "S3",
        prodi: "Ilmu Kesejahteraan Sosial - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "SRISNA J. LAHAY",
        jenjang: "S3",
        prodi: "Ilmu Susastra (Sastra) - Jalur Kuliah dan Riset"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "SABRINA CHAIRUNNISA",
        jenjang: "S3",
        prodi: "Ilmu Komunikasi - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "TAUFAN JAYA",
        jenjang: "S3",
        prodi: "Ilmu Linguistik - Jalur Kuliah dan Riset"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "AYU SARIE ASDARYATI",
        jenjang: "S3",
        prodi: "Ilmu Administrasi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "HELMI",
        jenjang: "S3",
        prodi: "Ilmu Kedokteran - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "WAHYUDI SETIAWAN",
        jenjang: "S3",
        prodi: "Kajian Stratejik dan Global - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "CANDRA PUTRIE RAHMAWATI",
        jenjang: "S3",
        prodi: "Ilmu Linguistik - Jalur Kuliah dan Riset"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "RANA ZAINI FATHIYANA",
        jenjang: "S3",
        prodi: "Teknik Elektro - Jalur Kuliah dan Riset"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "CORAZON HANNA DUMARIA",
        jenjang: "S3",
        prodi: "Ilmu Biomedik - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "FIRMAN MUNTHAHA",
        jenjang: "S3",
        prodi: "Teknik Elektro - Jalur Kuliah dan Riset"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "RUSTAMA BERANGKET",
        jenjang: "S3",
        prodi: "Teknik Sipil - Jalur Kuliah dan Riset"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "DITA TRISNAWAN",
        jenjang: "S3",
        prodi: "Kajian Stratejik dan Global - Riset"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "DICKY TRI JATMIKO",
        jenjang: "S3",
        prodi: "Teknik Kimia - Jalur Riset"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MELLISA TOWADI",
        jenjang: "S3",
        prodi: "Ilmu Hukum - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "NI MADE AYU SUSANTHI PRADNYA PARAMITHA, S.PD.B., M.PD.",
        jenjang: "S3",
        prodi: "Ilmu Susastra (Sastra) - Jalur Kuliah dan Riset"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "NOURMAYANSA VIDYA ANGGRAINI",
        jenjang: "S3",
        prodi: "Ilmu Keperawatan - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "SEPTIANISH EKAPUTRI LAKETAU",
        jenjang: "S3",
        prodi: "Ilmu Manajemen - Stratejik - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "SUSILO WIDYATMOKO",
        jenjang: "S3",
        prodi: "Teknik Sipil - Jalur Riset"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "KSHETRA RINALDHY",
        jenjang: "S3",
        prodi: "Ilmu Kedokteran - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "SUDARMANTO",
        jenjang: "S3",
        prodi: "Ilmu Bahan-bahan/Material - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "SAUFI SALAMUN",
        jenjang: "S3",
        prodi: "Ilmu Politik - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MUHAMMAD ZAKKY AZHARI",
        jenjang: "S3",
        prodi: "Ilmu Manajemen - Pemasaran - Riset"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "FIRMAWATI",
        jenjang: "S3",
        prodi: "Ilmu Keperawatan - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MUHAMMAD NAZARUDIN",
        jenjang: "S3",
        prodi: "Ilmu Biomedik - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "NUR WULAN ADI ISMAYA",
        jenjang: "S3",
        prodi: "Ilmu Farmasi - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "FADLINATIN NAUMI",
        jenjang: "S3",
        prodi: "Ilmu Kimia - Riset"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "SRI UNTARI",
        jenjang: "S3",
        prodi: "Ilmu Kesehatan Masyarakat - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "FARIDA AZZAHRA",
        jenjang: "S3",
        prodi: "Ilmu Hukum - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ANDREE NUGROHO SARAGIH",
        jenjang: "S3",
        prodi: "Ilmu Hukum - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "GERRY METHEW NAPITUPULU",
        jenjang: "S3",
        prodi: "Teknik Metalurgi & Material - Jalur Kuliah dan Riset"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "YOGA RAHMANSYAH PRATAMA",
        jenjang: "S3",
        prodi: "Kajian Informasi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "YULI FATZIA OSSA",
        jenjang: "S3",
        prodi: "Ilmu Kedokteran Gigi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "A A SAGUNG INDRIANI OKA",
        jenjang: "S3",
        prodi: "Ilmu Gizi - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "BENI SURYADI",
        jenjang: "S3",
        prodi: "Ilmu Manajemen - Stratejik - Riset"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MUHAMMAD HARIS",
        jenjang: "Profesi",
        prodi: "Pendidikan Profesi Psikologi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "HAYDIRA PRILI ANANZA",
        jenjang: "Profesi",
        prodi: "Pendidikan Profesi Psikologi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "AURELIA CHINTYA ANGGRAINI",
        jenjang: "Profesi",
        prodi: "Pendidikan Profesi Arsitek - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "I GUSTI AGUNG AYU PERAMI RAKA SUARI",
        jenjang: "Profesi",
        prodi: "Apoteker - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "YASYFINA AFLAH WIDYARINI",
        jenjang: "Profesi",
        prodi: "Pendidikan Profesi Arsitek - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "FATHIYA NADHIFA SYDRA T",
        jenjang: "Profesi",
        prodi: "Pendidikan Profesi Psikologi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ERDI SOFYANDRA ADIKRI",
        jenjang: "Profesi",
        prodi: "Insinyur - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ROBI TUBAGUS YUNI",
        jenjang: "Profesi",
        prodi: "Insinyur - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ERIKE KHAIRUNNISA",
        jenjang: "Profesi",
        prodi: "Apoteker - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "FITRI CYNTYA NAMDES",
        jenjang: "Profesi",
        prodi: "Apoteker - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ARDHITO FAZA AKHNAF",
        jenjang: "Profesi",
        prodi: "Pendidikan Profesi Psikologi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MOH. ARDAN MAKARIM CORNY",
        jenjang: "Profesi",
        prodi: "Profesi Akuntan - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "SALSABILA RARAS PUTRI",
        jenjang: "Profesi",
        prodi: "Pendidikan Profesi Psikologi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "FINSYANI PUTRI VIRASHTRIANA",
        jenjang: "Profesi",
        prodi: "Apoteker - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "STEPHANI PUPUT PALUPI",
        jenjang: "Profesi",
        prodi: "Pendidikan Profesi Arsitek - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "FADHIILAH PUTRI KUSUMA",
        jenjang: "Profesi",
        prodi: "Pendidikan Profesi Psikologi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ALBERT",
        jenjang: "Profesi",
        prodi: "Insinyur - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ANDINI SARASWATI",
        jenjang: "Profesi",
        prodi: "Pendidikan Profesi Psikologi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "RIZKI AYU NURTOTI",
        jenjang: "Profesi",
        prodi: "Apoteker - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "SATRIA PINANDHITA",
        jenjang: "Profesi",
        prodi: "Pendidikan Profesi Arsitek - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "NINDYA RAHMASARI PUTRI",
        jenjang: "Profesi",
        prodi: "Apoteker - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ERA RAHMANIAH KESUMA PUSPITA WARGA DALEM",
        jenjang: "Profesi",
        prodi: "Pendidikan Profesi Arsitek - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "DAVIN PRADIPTA",
        jenjang: "Profesi",
        prodi: "Insinyur - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ANDREAS NOPRATHA MASIEH",
        jenjang: "Profesi",
        prodi: "Pendidikan Profesi Arsitek - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ALIFIA ANDRARINI",
        jenjang: "Profesi",
        prodi: "Pendidikan Profesi Psikologi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MUALIMIN, S.SI",
        jenjang: "Profesi",
        prodi: "Insinyur - RPL"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ERMANU RAHMADHIAN SATRIO",
        jenjang: "Profesi",
        prodi: "Profesi Akuntan - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ANGELINA GABRIELLA SULIYANTO",
        jenjang: "Profesi",
        prodi: "Pendidikan Profesi Psikologi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "M. IQBAL PUTRA PRATAMA",
        jenjang: "Profesi",
        prodi: "Pendidikan Profesi Arsitek - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "FAHMA ADDINNI",
        jenjang: "Profesi",
        prodi: "Apoteker - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "DWIKI HENDRAPUTRA",
        jenjang: "Profesi",
        prodi: "Pendidikan Profesi Psikologi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "EKA PUTRA SANTOSO",
        jenjang: "Profesi",
        prodi: "Insinyur - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "GRACE AUGUSTIA KEELTJES",
        jenjang: "Profesi",
        prodi: "Pendidikan Profesi Psikologi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "FAZA SYAMILLA FAUZIANI",
        jenjang: "Profesi",
        prodi: "Pendidikan Profesi Psikologi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "R. HARYO BRIANTAMA",
        jenjang: "Profesi",
        prodi: "Insinyur - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "REZA FEBRIANO",
        jenjang: "Profesi",
        prodi: "Insinyur - RPL"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MUHAMMAD FIKRI",
        jenjang: "Profesi",
        prodi: "Pendidikan Profesi Psikologi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "JAUZY ANBIYA",
        jenjang: "Profesi",
        prodi: "Insinyur - RPL"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ACHMAD PRAYOGA HARY PUTRA",
        jenjang: "Profesi",
        prodi: "Insinyur - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "AUDRIA PUTRI SALSABILA SYARIF",
        jenjang: "Profesi",
        prodi: "Pendidikan Profesi Psikologi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "FAHMI TAUFIKURRAHMAN BADRUZZAMAN",
        jenjang: "Profesi",
        prodi: "Pendidikan Profesi Psikologi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "DENNY CHANDRA IRAWAN",
        jenjang: "Profesi",
        prodi: "Insinyur - RPL"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "DIANA ANDRIANI",
        jenjang: "Profesi",
        prodi: "Apoteker - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "OLIVIA REYNATA PUTRI",
        jenjang: "Profesi",
        prodi: "Profesi Akuntan - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ANIDYA GHAISANI",
        jenjang: "Profesi",
        prodi: "Pendidikan Profesi Psikologi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "JOHAN HANSEL SALUSU",
        jenjang: "Profesi",
        prodi: "Insinyur - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ARUMDIPTA GINITRI",
        jenjang: "Profesi",
        prodi: "Apoteker - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "BENEDICTA SHARON",
        jenjang: "Profesi",
        prodi: "Pendidikan Profesi Psikologi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "PUTRIANA RACHMAWATI",
        jenjang: "Profesi",
        prodi: "Apoteker - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "SALMAA RAMADHANI",
        jenjang: "Profesi",
        prodi: "Pendidikan Profesi Psikologi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "PUTI K GEBRIECYA",
        jenjang: "Profesi",
        prodi: "Pendidikan Profesi Psikologi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ABEL SUDARMO",
        jenjang: "Profesi",
        prodi: "Insinyur - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MUHLAS HANIF WIGANANDA",
        jenjang: "Profesi",
        prodi: "Insinyur - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "HANA FADIA GAYATRI UTOMO",
        jenjang: "Profesi",
        prodi: "Pendidikan Profesi Psikologi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "IKE SUYANTI",
        jenjang: "Profesi",
        prodi: "Insinyur - RPL"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "JOCELYN ODELIA LUMBAN TOBING",
        jenjang: "Profesi",
        prodi: "Pendidikan Profesi Psikologi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "VANESSA",
        jenjang: "Profesi",
        prodi: "Profesi Akuntan - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "AGHNIA NUR HAMIDAH",
        jenjang: "Profesi",
        prodi: "Pendidikan Profesi Psikologi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MUHAMMAD AYSAR ILMAN NAFI",
        jenjang: "Profesi",
        prodi: "Pendidikan Profesi Arsitek - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MUHAMMAD ZIEBANKAHN SANUSI MUCHJIDI",
        jenjang: "Profesi",
        prodi: "Pendidikan Profesi Arsitek - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "AUDREY EUNIKE CASHYMIRA",
        jenjang: "Profesi",
        prodi: "Pendidikan Profesi Psikologi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "NIKHEN ABIRA UFIYA",
        jenjang: "Profesi",
        prodi: "Apoteker - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "FAIRUZ KHAIRUNISSA FIGARNIA",
        jenjang: "Profesi",
        prodi: "Pendidikan Profesi Psikologi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "KOMING SAWITRI DEWI",
        jenjang: "Profesi",
        prodi: "Pendidikan Profesi Arsitek - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "LAILATUL NURSAKINAH",
        jenjang: "Profesi",
        prodi: "Pendidikan Profesi Psikologi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "AZALIA SYAFITRI FARISAH NABILA",
        jenjang: "Profesi",
        prodi: "Pendidikan Profesi Psikologi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "RIFDAH JAZILAH",
        jenjang: "Profesi",
        prodi: "Apoteker - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "KETUT INDAH SUKIANI DEWI",
        jenjang: "Profesi",
        prodi: "Pendidikan Profesi Psikologi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "RAKHMAN SOPIYAN",
        jenjang: "Profesi",
        prodi: "Insinyur - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "AZELIA AYU LESTARI",
        jenjang: "Profesi",
        prodi: "Pendidikan Profesi Arsitek - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "NINDYA PUSPITASARI",
        jenjang: "Profesi",
        prodi: "Pendidikan Profesi Psikologi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "YOSHUA DARAMENTA TARIGAN",
        jenjang: "Profesi",
        prodi: "Pendidikan Profesi Arsitek - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "RIFDA AMIRA MULIKA",
        jenjang: "Profesi",
        prodi: "Pendidikan Profesi Psikologi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "SARI ULFAYANA",
        jenjang: "Profesi",
        prodi: "Insinyur - RPL"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "PATRIA UFAIRA APRINA",
        jenjang: "Profesi",
        prodi: "Insinyur - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "CHRISTIAN ANDO GEDE SATRIA",
        jenjang: "Profesi",
        prodi: "Pendidikan Profesi Arsitek - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MUHAMMAD AIDIL",
        jenjang: "Profesi",
        prodi: "Insinyur - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "DENDANG BELANTARA",
        jenjang: "Profesi",
        prodi: "Pendidikan Profesi Arsitek - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "I GUSTI AGUNG SAWITRI SHINTYA DEWI",
        jenjang: "Profesi",
        prodi: "Pendidikan Profesi Arsitek - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "NAFLAH DAFFA KIRANA",
        jenjang: "Profesi",
        prodi: "Pendidikan Profesi Arsitek - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "NADIYAH ARIFAH",
        jenjang: "Profesi",
        prodi: "Apoteker - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ARIS RYANT KURNIAWAN",
        jenjang: "Profesi",
        prodi: "Pendidikan Profesi Arsitek - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "WANDA GUSTINA UTAMI",
        jenjang: "Profesi",
        prodi: "Insinyur - RPL"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ANUGERAH T AGUNG",
        jenjang: "Profesi",
        prodi: "Insinyur - RPL"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ZULFIKAR EL FAHMI",
        jenjang: "Profesi",
        prodi: "Pendidikan Profesi Arsitek - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "RAFY ADHIYARSHA SASTRANEGARA",
        jenjang: "Profesi",
        prodi: "Pendidikan Profesi Arsitek - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "AYU FRIZTYANA PUTRI",
        jenjang: "Profesi",
        prodi: "Pendidikan Profesi Psikologi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "KHUSNUL FUADAH",
        jenjang: "Profesi",
        prodi: "Pendidikan Profesi Arsitek - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "NAURA THIFALDHIA CHRISSANDI",
        jenjang: "Profesi",
        prodi: "Pendidikan Profesi Psikologi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ABRAR MIRANDHA",
        jenjang: "Profesi",
        prodi: "Insinyur - RPL"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "FATIMAH DZURRIYAH SHALIHAH",
        jenjang: "Profesi",
        prodi: "Pendidikan Profesi Arsitek - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ARIQ ANANTA WIGUNA",
        jenjang: "Profesi",
        prodi: "Insinyur - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "NILAM NURAENI",
        jenjang: "Profesi",
        prodi: "Profesi Akuntan - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "AZRIANSYAH ITHAKARI",
        jenjang: "Profesi",
        prodi: "Pendidikan Profesi Arsitek - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ARIO WICAKSONO",
        jenjang: "Profesi",
        prodi: "Insinyur - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "WAHYU ADI SYAPUTRA",
        jenjang: "Profesi",
        prodi: "Apoteker - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "OLIVIA JASMINE",
        jenjang: "Profesi",
        prodi: "Pendidikan Profesi Arsitek - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "AMI ANDARI",
        jenjang: "Profesi",
        prodi: "Apoteker - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "GLAN ARYAPUTRA PRABAWA",
        jenjang: "Profesi",
        prodi: "Pendidikan Profesi Arsitek - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "NURUL FALYADHIA AMIRAZANNA",
        jenjang: "Profesi",
        prodi: "Pendidikan Profesi Psikologi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "RIAN ARTHA PRIMA",
        jenjang: "Profesi",
        prodi: "Insinyur - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "AMIRA QONITA ALHUMAIRA",
        jenjang: "Profesi",
        prodi: "Pendidikan Profesi Psikologi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "AZALEA ASTINA YUTARI",
        jenjang: "Profesi",
        prodi: "Pendidikan Profesi Psikologi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "FARAHDILLA",
        jenjang: "Profesi",
        prodi: "Pendidikan Profesi Psikologi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "IFFAH MUTHI'AH",
        jenjang: "Profesi",
        prodi: "Pendidikan Profesi Psikologi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "BRIGITA SANTIKA MAHESWARI DANUSUBROTO",
        jenjang: "Profesi",
        prodi: "Pendidikan Profesi Psikologi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "PRATIWI DIRANTI",
        jenjang: "Profesi",
        prodi: "Pendidikan Profesi Psikologi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "INDRA DAVIT NURCAHYANTO",
        jenjang: "Profesi",
        prodi: "Insinyur - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MUHAMMAD FIKRI PRATAMA",
        jenjang: "Profesi",
        prodi: "Pendidikan Profesi Arsitek - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "CITRA AJENG PRAMESTHI",
        jenjang: "Profesi",
        prodi: "Pendidikan Profesi Arsitek - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "HANIFA FAIZAH RAMADHANI",
        jenjang: "Profesi",
        prodi: "Pendidikan Profesi Psikologi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ARTIKA ESNAWATY S",
        jenjang: "Profesi",
        prodi: "Profesi Akuntan - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "NADHIRA RAHMA AFINA",
        jenjang: "Profesi",
        prodi: "Pendidikan Profesi Psikologi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ALYA RANIA SURAYA",
        jenjang: "Profesi",
        prodi: "Pendidikan Profesi Psikologi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "PRISMA RIASHUDA PRAKOSA",
        jenjang: "Profesi",
        prodi: "Insinyur - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "KHANSA NABILA ANJANI",
        jenjang: "Profesi",
        prodi: "Pendidikan Profesi Psikologi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "GABRIELLA SINTA RIWUT",
        jenjang: "Profesi",
        prodi: "Pendidikan Profesi Psikologi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "GABRIELA ANASTASYA AUDRENIA PRATIWI",
        jenjang: "Profesi",
        prodi: "Pendidikan Profesi Psikologi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "FAJRI SAPUTRA",
        jenjang: "Profesi",
        prodi: "Insinyur - RPL"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MUHAMMAD ILHAM M",
        jenjang: "Profesi",
        prodi: "Profesi Akuntan - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "RAISSA FATIKHA",
        jenjang: "Profesi",
        prodi: "Pendidikan Profesi Psikologi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "FARHAN ARMUNANTO WIRIOSAPUTRO",
        jenjang: "Profesi",
        prodi: "Insinyur - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "AYU FEBRIANA AMIRA HADI",
        jenjang: "Profesi",
        prodi: "Pendidikan Profesi Psikologi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "YADHI G. MAKARIOS SAGALA",
        jenjang: "Profesi",
        prodi: "Profesi Akuntan - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "SHEILA MAHARANI EB",
        jenjang: "Profesi",
        prodi: "Pendidikan Profesi Arsitek - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "DITA FATIMAH ALZAHRA",
        jenjang: "Profesi",
        prodi: "Apoteker - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MALYA NADIRASHANTI SALIMA",
        jenjang: "Profesi",
        prodi: "Pendidikan Profesi Arsitek - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "SONA JESMIN MERLIN",
        jenjang: "Profesi",
        prodi: "Pendidikan Profesi Psikologi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "SITI ANNISA",
        jenjang: "Profesi",
        prodi: "Apoteker - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "REYNANDO BAGASKORO",
        jenjang: "Profesi",
        prodi: "Insinyur - RPL"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ALFA RULLAH GABRIEL ONIBALA",
        jenjang: "Profesi",
        prodi: "Insinyur - RPL"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "HILMI ALFARUQI",
        jenjang: "Profesi",
        prodi: "Apoteker - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "DWI LAKSMANA",
        jenjang: "Profesi",
        prodi: "Insinyur - RPL"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ABDURRAHMAN GAFUR",
        jenjang: "Profesi",
        prodi: "Insinyur - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ORIZA SATIVA",
        jenjang: "Profesi",
        prodi: "Insinyur - RPL"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "TONY SUPARDI",
        jenjang: "Profesi",
        prodi: "Insinyur - RPL"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ADHIMAS ARYASATYA HANURA",
        jenjang: "Profesi",
        prodi: "Insinyur - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "OZANA NOVONE RANAR PRASSENO",
        jenjang: "Profesi",
        prodi: "Pendidikan Profesi Arsitek - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "TOSINA SAGALA",
        jenjang: "Profesi",
        prodi: "Pendidikan Profesi Psikologi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "STEPHANIE SALIM",
        jenjang: "Profesi",
        prodi: "Pendidikan Profesi Psikologi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "FATIMAH SHOFA ULHAQ",
        jenjang: "Profesi",
        prodi: "Pendidikan Profesi Psikologi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "YOGA SATRIO",
        jenjang: "Profesi",
        prodi: "Insinyur - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "DWI ANTO NUGROHO",
        jenjang: "Profesi",
        prodi: "Insinyur - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MATTHEW F. H. SIHOMBING",
        jenjang: "Profesi",
        prodi: "Profesi Akuntan - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "SIMON MULIAWAN PANDAPOTAN LUBIS",
        jenjang: "Profesi",
        prodi: "Profesi Akuntan - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "REZKY AKBAR TRI NOVAN",
        jenjang: "Profesi",
        prodi: "Pendidikan Profesi Psikologi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "KARIMA SEPTIANI KRISTYANINGSIH",
        jenjang: "Profesi",
        prodi: "Pendidikan Profesi Psikologi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "RIZLA CHANDRA RIZKY",
        jenjang: "Profesi",
        prodi: "Insinyur - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "RETNO PUTRI WULANDARI RAHADI",
        jenjang: "Profesi",
        prodi: "Pendidikan Profesi Arsitek - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "SUCIPTA LAKSONO",
        jenjang: "Profesi",
        prodi: "Insinyur - RPL"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MONICA THERESA ANDRADJADI",
        jenjang: "Profesi",
        prodi: "Pendidikan Profesi Arsitek - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ANDY TOBING",
        jenjang: "Profesi",
        prodi: "Pendidikan Profesi Arsitek - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ALFIN JULIAN KRISTIAN",
        jenjang: "Profesi",
        prodi: "Insinyur - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "RIDA ANNISA",
        jenjang: "Profesi",
        prodi: "Pendidikan Profesi Arsitek - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "YUSRIZAL KARUNIA",
        jenjang: "Profesi",
        prodi: "Profesi Akuntan - Khusus"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "SYABRINA MIFTAHUL NUR'AINI",
        jenjang: "Profesi",
        prodi: "Apoteker - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "RIZKI CANDRA",
        jenjang: "Profesi",
        prodi: "Pendidikan Profesi Arsitek - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "CAHYU CANTIKA AMIRANTI",
        jenjang: "Profesi",
        prodi: "Pendidikan Profesi Psikologi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "RAHMADAANII",
        jenjang: "Profesi",
        prodi: "Pendidikan Profesi Psikologi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "FATHIMAH AULIARISYA ASHRI",
        jenjang: "Profesi",
        prodi: "Pendidikan Profesi Psikologi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "FRANZESKA TYANA AYU",
        jenjang: "Profesi",
        prodi: "Pendidikan Profesi Psikologi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "NAILA DWIFATHA",
        jenjang: "Profesi",
        prodi: "Pendidikan Profesi Psikologi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "AQIILAH AMANDRI YUSUF",
        jenjang: "Profesi",
        prodi: "Pendidikan Profesi Psikologi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "SITI AMIRA ANASTASIA",
        jenjang: "Profesi",
        prodi: "Pendidikan Profesi Psikologi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "AULIA ARKAN WICAKSONO",
        jenjang: "Profesi",
        prodi: "Pendidikan Profesi Arsitek - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "DUTA DEWANGGA HANDANA",
        jenjang: "Profesi",
        prodi: "Pendidikan Profesi Arsitek - Reguler"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "ZAHRA ASYIFA A. WIBOWO",
        jenjang: "Profesi",
        prodi: "Pendidikan Profesi Psikologi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "DHEA AZZAHRA LESMANA",
        jenjang: "Profesi",
        prodi: "Pendidikan Profesi Psikologi"
    },
    {
        fakultas: "",
        npm: "24XXXXXXXX",
        nama: "MICHELLE TALI SUKMA WIJAYA",
        jenjang: "Profesi",
        prodi: "Pendidikan Profesi Psikologi"
    }
];